/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/cms/totostoleti/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 176);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(183);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOCAL_TEST_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ROUTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TOPIC_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TOPICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SUBTOPIC_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TAG_MEMORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ITEM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HOME_TOPIC_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MAIN_SECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TIMELINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HOME_RESIZE_LIMITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESIZE_LIMITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SCHOOL_PART_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return VYSILANI_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DIACRITIC_MAP; });
var LOCAL_TEST_DATE='2019-04-01T10:00:00.000+01:00';var PATH={FRAME:'//player.ceskatelevize.cz',DATA: false?'/data/':'/cms/totostoleti/data/',SCHOOL: false?'/data/school/':'/cms/totostoleti/data/school/',IMG: false?'/img/':'/cms/totostoleti/img/'};var ACTIONS={CHANGE_CATEGORY:'CHANGE_CATEGORY',CHANGE_TOPIC:'CHANGE_TOPIC',CHANGE_SUBTOPIC:'CHANGE_SUBTOPIC',CHANGE_SORTING:'CHANGE_SORTING',DETAIL_ACTIVE:'DETAIL_ACTIVE',DETAIL_INTRO_PLAYED:'DETAIL_INTRO_PLAYED',SAVE_LAST_LOCATION:'SAVE_LAST_LOCATION',RESIZE_GRID:'RESIZE_GRID',RESIZE_WIDTH:'RESIZE_WIDTH',MENU_SWITCH:'MENU_SWITCH',MENU_OVERLAY:'MENU_OVERLAY',SHOW_UP_BTN:'SHOW_UP_BTN'};var ROUTING={HOME:'/',ABOUT:'/o-projektu',ARCHIVE_LIST:'/seznam-archiv',TAG:'/tag',MAP:'/mapa',CATEGORY:'/c',DETAIL:'/detail',VYSILANI:'/ve-vysilani',SCHOOL:'/ve-skole',SCHOOL_DETAIL:'/ve-skole-detail'};var TOPIC_ALL='vše';var TOPICS=[TOPIC_ALL,'politika','společnost','hospodářství','kultura a vzdělávání','sport'];var SUBTOPIC_ALL='vše';var TAG_MEMORY='pamětníci';var ITEM_TYPE={VIDEO:'v',MEMORY:'m',ARTICLE:'a',INFOGRAPHIC:'i',MAP:'p',VYSILANI:'vs',SPECIAL:'s',// todo - remove - for old homepage
CATEGORY:'c',SCHOOL_SHEET:'sch'};var HOME_TOPIC_ID=100;var MAIN_SECTIONS=[{range:'1918-1929',title:'Vlastní stát!',video:'30101',bgColor:'faf7ef'},{range:'1929-1938',title:'Opevněné Československo',video:'30102',bgColor:'fbf9ef'},{range:'1938-1945',title:'Protektorát',video:'30103',bgColor:'ebeae8'},{range:'1945-1955',title:'Se Stalinem za zády',video:'30104',bgColor:'f9f8ed'},{range:'1956-1968',title:'Tání a zase mráz',video:'30105',bgColor:'f4eee9'},{range:'1969-1989',title:'Od tanků k perestrojce',video:'30106',bgColor:'f5f5f5'},{range:'1990-2004',title:'Nové obzory',video:'30107',bgColor:'f5f5e9'},{range:'2004-2018',title:'Kam dál?',video:'30108',bgColor:'f7f4f8'}];var TIMELINE=[1918,1929,1938,1945,1956,1969,1990,2004,2018];var HOME_RESIZE_LIMITS={MENU:220,GRID:[[1710,4],[1350,3],[1020,2]]};var RESIZE_LIMITS={MENU_OVERLAY:950,GRID:[[1660,4],[1345,3],[760,2]]};var SCHOOL_PART_TYPE={TEXT:'text',IMAGE:'image',VIDEO:'video',BULLETS:'bullets',GALLERY:'gallery',ARTICLE:'article',DOWNLOAD:'download'};var VYSILANI_FILTERS=[{id:0,name:'Vše'},{id:1,name:'Publicistika'},{id:2,name:'Dokument'},{id:3,name:'Sport'},{id:4,name:'Film'},{id:5,name:'Ostatní'}];var DIACRITIC_MAP=[{base:'A',letters:'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},{base:'AA',letters:'\uA732'},{base:'AE',letters:'\xC6\u01FC\u01E2'},{base:'AO',letters:'\uA734'},{base:'AU',letters:'\uA736'},{base:'AV',letters:'\uA738\uA73A'},{base:'AY',letters:'\uA73C'},{base:'B',letters:'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},{base:'C',letters:'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E'},{base:'D',letters:'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},{base:'DZ',letters:'\u01F1\u01C4'},{base:'Dz',letters:'\u01F2\u01C5'},{base:'E',letters:'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},{base:'F',letters:'F\u24BB\uFF26\u1E1E\u0191\uA77B'},{base:'G',letters:'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},{base:'H',letters:'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},{base:'I',letters:'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},{base:'J',letters:'J\u24BF\uFF2A\u0134\u0248'},{base:'K',letters:'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},{base:'L',letters:'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},{base:'LJ',letters:'\u01C7'},{base:'Lj',letters:'\u01C8'},{base:'M',letters:'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},{base:'N',letters:'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},{base:'NJ',letters:'\u01CA'},{base:'Nj',letters:'\u01CB'},{base:'O',letters:'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C'},{base:'OI',letters:'\u01A2'},{base:'OO',letters:'\uA74E'},{base:'OU',letters:'\u0222'},{base:'OE',letters:'\x8C\u0152'},{base:'oe',letters:'\x9C\u0153'},{base:'P',letters:'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},{base:'Q',letters:'Q\u24C6\uFF31\uA756\uA758\u024A'},{base:'R',letters:'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},{base:'S',letters:'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},{base:'T',letters:'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},{base:'TZ',letters:'\uA728'},{base:'U',letters:'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},{base:'V',letters:'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},{base:'VY',letters:'\uA760'},{base:'W',letters:'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},{base:'X',letters:'X\u24CD\uFF38\u1E8A\u1E8C'},{base:'Y',letters:'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},{base:'Z',letters:'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},{base:'a',letters:'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},{base:'aa',letters:'\uA733'},{base:'ae',letters:'\xE6\u01FD\u01E3'},{base:'ao',letters:'\uA735'},{base:'au',letters:'\uA737'},{base:'av',letters:'\uA739\uA73B'},{base:'ay',letters:'\uA73D'},{base:'b',letters:'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},{base:'c',letters:'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184'},{base:'d',letters:'d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},{base:'dz',letters:'\u01F3\u01C6'},{base:'e',letters:'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},{base:'f',letters:'f\u24D5\uFF46\u1E1F\u0192\uA77C'},{base:'g',letters:'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},{base:'h',letters:'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},{base:'hv',letters:'\u0195'},{base:'i',letters:'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},{base:'j',letters:'j\u24D9\uFF4A\u0135\u01F0\u0249'},{base:'k',letters:'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},{base:'l',letters:'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},{base:'lj',letters:'\u01C9'},{base:'m',letters:'m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},{base:'n',letters:'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},{base:'nj',letters:'\u01CC'},{base:'o',letters:'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275'},{base:'oi',letters:'\u01A3'},{base:'ou',letters:'\u0223'},{base:'oo',letters:'\uA74F'},{base:'p',letters:'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},{base:'q',letters:'q\u24E0\uFF51\u024B\uA757\uA759'},{base:'r',letters:'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},{base:'s',letters:'s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},{base:'t',letters:'t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},{base:'tz',letters:'\uA729'},{base:'u',letters:'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},{base:'v',letters:'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},{base:'vy',letters:'\uA761'},{base:'w',letters:'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},{base:'x',letters:'x\u24E7\uFF58\u1E8B\u1E8D'},{base:'y',letters:'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},{base:'z',letters:'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(207)();
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return initHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return videoImageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getVideoSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getTagData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getItemData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getVideoData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMapMarkersData; });
/* unused harmony export initDiacriticMap */
/* unused harmony export replaceDiacritic */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return search; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getHomeLineData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHomeTopicLineData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getHomeProgramLineData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isIOs; });
/* unused harmony export getVysilaniObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getVysilaniData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSchoolList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getSchoolSheet; });
/* unused harmony export getMapMarkers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_info_json__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_info_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_info_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_homepage_json__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_homepage_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__data_homepage_json__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// todo - solve external loading
// ---------------------------------------------------
// Hash
// ---------------------------------------------------
var hashInited=false;var hash='';var fetchHash=function fetchHash(){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(window.location.href.indexOf('specialy')===-1?'/player':'/specialy/totostoleti/player').then(function(response){hash=response.data.split('vApp')[1].split('"')[1];// repeat in given interval
setTimeout(function(){fetchHash();},1000*60*30);}).catch(function(error){console.log(error);// todo - solve error state
hash='2ff0e916016e248d7ea926fec199595af7b4b545';});};var initHash=function initHash(){if(window.hash){hash=window.hash;}// todo - review implementation
if(!hashInited){hashInited=true;fetchHash();}};// todo - review implementation
var getHash=function getHash(){return hash;};// ---------------------------------------------------
// Video images
// ---------------------------------------------------
// todo - review implementation
var videoImageUrl=function videoImageUrl(videoData){// bonus
if(videoData.bonus&&videoData.bonus.length>0){return'//decko.ceskatelevize.cz/cms/ct-src/video/b'+encodeURIComponent(videoData.bonus)+'/uni.jpg';}var cleanedIdec=videoData.idec.replace(/\s/g,'').replace(/\//g,'');// image url - from xml api - now for 've-vysilani'
// todo maybe implement even for normal videos -
// when/if info and main data will be merged by export
if(videoData.imageURL){return videoData.imageURL.replace('140','512');}// index
if(videoData.index&&videoData.index.length>0){return'//img.ceskatelevize.cz/ivysilani/indexes/photos/w512/'+cleanedIdec.substring(0,3)+'/'+cleanedIdec+'/'+videoData.index+'.jpg';}// sidp
if(videoData.sidp&&videoData.sidp.length>0){return'//imgct.ceskatelevize.cz/cache/w512/upload/program/porady/'+videoData.sidp+'/foto/uni_'+cleanedIdec+'.jpg';}// default
return'';};// ---------------------------------------------------
// Video source
// ---------------------------------------------------
var getVideoSource=function getVideoSource(videoData){if(videoData.bonus&&videoData.bonus.length>0){return __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].FRAME+'/?hash='+getHash()+'&bonus='+videoData.bonus+'&origin=noads&autoStart=true';}if(videoData.index&&videoData.index.length>0){return __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].FRAME+'/?hash='+getHash()+'&IDEC='+videoData.idec+'&index='+videoData.index+'&origin=noads&autoStart=true';}// todo - revise - now for 've-vysilani' - shouldn't be idec replace/parsing be added to all cases?
return __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].FRAME+'/?hash='+getHash()+'&IDEC='+videoData.idec.replace('%2F','')+'&origin=noads&autoStart=true';};// ---------------------------------------------------
// Main data
// ---------------------------------------------------
var tagList=[];var mapMarkersData=[];var markersPositions=[];// for parsing
// note - all implementations are temporary
// and should be updated once external data fetch is implemented
var getCategoryData=function getCategoryData(categoryId){return Object.entries(__WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json___default.a).filter(function(item){return String(item[1].category)===categoryId;});};var getTagData=function getTagData(tag){return Object.entries(__WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json___default.a).filter(function(item){return item[1].tags.indexOf(tag)!==-1;});};var getItemData=function getItemData(itemId){return new Promise(function(resolve,reject){if(itemId.indexOf(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].VYSILANI)===0){getVysilaniData().then(function(data){resolve(data.data[itemId]);}).catch(function(){// todo - solve error state
reject();});}else{resolve(__WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json___default.a[itemId]);}});};var getVideoData=function getVideoData(){return Object.entries(__WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json___default.a).filter(function(item){return item[1].type===__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].VIDEO&&item[1].idec.length>0;});};var getTagList=function getTagList(){return new Promise(function(resolve){// todo - raw implementation
if(tagList.length===0){// set list
Object.entries(__WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json___default.a).forEach(function(item){item[1].tags.forEach(function(tag){if(!tagList.includes(tag)){tagList.push(tag);}});});}tagList.sort(function(a,b){return a.localeCompare(b);});resolve(tagList);});};var checkMarkerPosition=function checkMarkerPosition(item){// todo - maybe do during parsing and not on user side
var newItem=[].concat(_toConsumableArray(item));var gpsn=Number(newItem[1].gpsn);var gpse=Number(newItem[1].gpse);var gpsString=gpsn+'-'+gpse;while(markersPositions.includes(gpsString)){gpsn+=0.0005;gpse+=0.0005;gpsString=gpsn+'-'+gpse;}markersPositions.push(gpsString);newItem[1].gpsn=gpsn;newItem[1].gpse=gpse;return newItem;};var getMapMarkersData=function getMapMarkersData(){return new Promise(function(resolve){// todo - raw implementation
if(mapMarkersData.length===0){// set list
Object.entries(__WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json___default.a).forEach(function(item){if(item[1].gpsn.length>0&&item[1].gpse.length>0){mapMarkersData.push(checkMarkerPosition(item));}});}resolve(mapMarkersData);});};// ---------------------------------------------------
// Diacritic replace
// ---------------------------------------------------
var diacriticsMapInited=false;var diacriticsMap={};var initDiacriticMap=function initDiacriticMap(){if(!diacriticsMapInited){diacriticsMapInited=true;for(var i=0;i<__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DIACRITIC_MAP */].length;i+=1){var letters=__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DIACRITIC_MAP */][i].letters;for(var j=0;j<letters.length;j+=1){diacriticsMap[letters[j]]=__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DIACRITIC_MAP */][i].base;}}}};var replaceDiacritic=function replaceDiacritic(value){initDiacriticMap();// note - not ideal - maybe call right after app init
return value.replace(/[^\u0000-\u007E]/g,function(a){return diacriticsMap[a]||a;});};// ---------------------------------------------------
// Main data - Search
// ---------------------------------------------------
var search=function search(term){var parsedTerm=replaceDiacritic(term.toUpperCase());var result=[];var match=[];// get matches
Object.entries(__WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json___default.a).forEach(function(item){var pos=replaceDiacritic(item[1].title.toUpperCase()).indexOf(parsedTerm);if(pos!==-1){match.push({pos:pos,item:item});}});// sort
match.sort(function(x,y){return x.pos-y.pos;});// get first
for(var i=0;i<Math.min(match.length,10);i+=1){result.push(match[i].item);}return result;};// ---------------------------------------------------
// Info data
// ---------------------------------------------------
// note - temporary - should be updated once external data fetch is implemented
var getInfo=function getInfo(videoId){if(__WEBPACK_IMPORTED_MODULE_3__data_info_json___default.a[videoId]){return __WEBPACK_IMPORTED_MODULE_3__data_info_json___default.a[videoId];}return{};};// ---------------------------------------------------
// Homepage data
// ---------------------------------------------------
// todo - add some week auto-change algorithm
var homeLineData={};var homeTopicLineData=null;var getHomeLineData=function getHomeLineData(categoryId){if(!homeLineData[categoryId]){var lineData=[];var videos=[];var articles=[];var categoryData=getCategoryData(categoryId.toString());// todo - probably seed-randomise before picking - use week 'id' as seed
// todo - temp solution - add some 'seed' based
for(var i=0;i<categoryData.length;i+=1){var data=categoryData[i];if(data[1].type===__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].VIDEO||data[1].type===__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].MEMORY){videos.push(data);}else if(data[1].type===__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].ARTICLE){articles.push(data);}// check end
if(videos.length>=8&&articles.length>=2){break;}}// concat
lineData=videos.splice(0,8).concat(articles.splice(0,2));// randomise order
// todo - temp solution
lineData.sort(function(x,y){var a=x[1].title;var b=y[1].title;if(a<b){return-1;}if(a>b){return 1;}return 0;});// done
homeLineData[categoryId]=lineData;}return homeLineData[categoryId];};// todo - needs to be reworked as promise when all data loading will be from external sources
var getHomeTopicLineData=function getHomeTopicLineData(date){if(!homeTopicLineData){var topicId=0;for(var d=0;d<__WEBPACK_IMPORTED_MODULE_4__data_homepage_json___default.a.data.length;d+=1){var currentYear=new Date().getFullYear();var testDate=new Date(currentYear+'-'+__WEBPACK_IMPORTED_MODULE_4__data_homepage_json___default.a.data[d].date+'T00:00:00.000+01:00');if(testDate<=date){topicId=d;}}var topicData=__WEBPACK_IMPORTED_MODULE_4__data_homepage_json___default.a.data[topicId];var lineData=[];for(var i=0;i<topicData.lineData.length;i+=1){var itemId=topicData.lineData[i];lineData.push([itemId,__WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json___default.a[itemId]]);}topicData.lineData=lineData;homeTopicLineData=topicData;}return homeTopicLineData;};// ---------------------------------------------------
// Homepage program data
// ---------------------------------------------------
var programTips=null;var getHomeProgramLineData=function getHomeProgramLineData(){return new Promise(function(resolve,reject){if(programTips){// already loaded
resolve(programTips);}else{// load
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('//stoleti.strangevillage.com/data/tips-week.json').then(function(response){if(response.data){programTips=response.data.tips;resolve(programTips);}else{reject();}}).catch(function(error){reject(error);});}});};// ---------------------------------------------------
// iOS
// ---------------------------------------------------
// todo - temp solution
var isIOs=function isIOs(){return /iPad|iPhone|iPod/.test(navigator.platform);};// ---------------------------------------------------
// Ve Vysilani
// ---------------------------------------------------
var veVysilaniData=null;// for details
var veVysilaniArray=null;// for list
var getVysilaniObject=function getVysilaniObject(){return{data:veVysilaniData,array:veVysilaniArray};};var getVysilaniData=function getVysilaniData(){return new Promise(function(resolve,reject){if(veVysilaniData){resolve(getVysilaniObject());}else{__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('//stoleti.strangevillage.com/data/vysilani.json').then(function(response){if(response.data){veVysilaniData=response.data;veVysilaniArray=Object.entries(veVysilaniData);resolve(getVysilaniObject());}else{reject();}}).catch(function(error){reject(error);});}});};// ---------------------------------------------------
// School
// ---------------------------------------------------
var schoolList=null;var schoolSheetsPool={};var getSchoolList=function getSchoolList(){return new Promise(function(resolve,reject){if(schoolList){resolve(schoolList);}else{__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].SCHOOL+'list.json').then(function(response){if(response.data&&response.data.sheets){schoolList=response.data.sheets;resolve(schoolList);}else{reject();}}).catch(function(error){reject(error);});}});};var getSchoolSheet=function getSchoolSheet(sheetId){return new Promise(function(resolve,reject){if(schoolSheetsPool[sheetId]){resolve(schoolSheetsPool[sheetId]);}else{__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].SCHOOL+'sheets/'+sheetId+'.json').then(function(response){if(response.data){schoolSheetsPool[sheetId]=response.data;resolve(schoolSheetsPool[sheetId]);}else{reject();}}).catch(function(error){reject(error);});}});};// ---------------------------------------------------
// Maps
// ---------------------------------------------------
// todo - temp qick implementation - revise + maybe move somewhere else
var checkMarker=function checkMarker(category,itemData){return(// todo maybe even filter by main category first
itemData.gpsn.length>0&&itemData.gpse.length>0&&itemData.category===category);};var getMapMarkers=function getMapMarkers(category){return Object.entries(__WEBPACK_IMPORTED_MODULE_2__data_toto_100_leti_json___default.a).filter(function(item){return checkMarker(category,item[1]);});};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(333), __esModule: true };

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(126);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(127);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(361);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(365);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(127);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(126);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
var MAP = (exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = (exports.MARKER =
  "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_WITH_LABEL = (exports.MARKER_WITH_LABEL =
  "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var RECTANGLE = (exports.RECTANGLE =
  "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYLINE = (exports.POLYLINE =
  "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYGON = (exports.POLYGON =
  "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var CIRCLE = (exports.CIRCLE =
  "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var KML_LAYER = (exports.KML_LAYER =
  "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DIRECTIONS_RENDERER = (exports.DIRECTIONS_RENDERER =
  "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var HEATMAP_LAYER = (exports.HEATMAP_LAYER =
  "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var FUSION_TABLES_LAYER = (exports.FUSION_TABLES_LAYER =
  "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var ANCHOR = (exports.ANCHOR =
  "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_WINDOW = (exports.INFO_WINDOW =
  "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var OVERLAY_VIEW = (exports.OVERLAY_VIEW =
  "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var GROUND_LAYER = (exports.GROUND_LAYER =
  "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DRAWING_MANAGER = (exports.DRAWING_MANAGER =
  "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var SEARCH_BOX = (exports.SEARCH_BOX =
  "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_CLUSTERER = (exports.MARKER_CLUSTERER =
  "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_BOX = (exports.INFO_BOX =
  "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var TRAFFIC_LAYER = (exports.TRAFFIC_LAYER =
  "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var STREET_VIEW_PANORAMA = (exports.STREET_VIEW_PANORAMA =
  "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var BICYCLING_LAYER = (exports.BICYCLING_LAYER =
  "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _bind2 = __webpack_require__(49)

var _bind3 = _interopRequireDefault(_bind2)

var _isFunction2 = __webpack_require__(50)

var _isFunction3 = _interopRequireDefault(_isFunction2)

var _reduce3 = __webpack_require__(418)

var _reduce4 = _interopRequireDefault(_reduce3)

var _forEach2 = __webpack_require__(494)

var _forEach3 = _interopRequireDefault(_forEach2)

var _lowerFirst2 = __webpack_require__(496)

var _lowerFirst3 = _interopRequireDefault(_lowerFirst2)

var _has2 = __webpack_require__(503)

var _has3 = _interopRequireDefault(_has2)

exports.construct = construct
exports.componentDidMount = componentDidMount
exports.componentDidUpdate = componentDidUpdate
exports.componentWillUnmount = componentWillUnmount

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
/* eslint-disable no-param-reassign */
function rdcUncontrolledAndControlledProps(acc, value, key) {
  if ((0, _has3.default)(acc.prevProps, key)) {
    var match = key.match(/^default(\S+)/)
    if (match) {
      var unprefixedKey = (0, _lowerFirst3.default)(match[1])
      if (!(0, _has3.default)(acc.nextProps, unprefixedKey)) {
        acc.nextProps[unprefixedKey] = acc.prevProps[key]
      }
    } else {
      acc.nextProps[key] = acc.prevProps[key]
    }
  }
  return acc
}

function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
  ;(0, _forEach3.default)(updaterMap, function(fn, key) {
    var nextValue = nextProps[key]
    if (nextValue !== prevProps[key]) {
      fn(instance, nextValue)
    }
  })
}

function construct(propTypes, updaterMap, prevProps, instance) {
  var _reduce2 = (0, _reduce4.default)(
      propTypes,
      rdcUncontrolledAndControlledProps,
      {
        nextProps: {},
        prevProps: prevProps,
      }
    ),
    nextProps = _reduce2.nextProps

  applyUpdaterToNextProps(
    updaterMap,
    {
      /* empty prevProps for construct */
    },
    nextProps,
    instance
  )
}

function componentDidMount(component, instance, eventMap) {
  registerEvents(component, instance, eventMap)
}

function componentDidUpdate(
  component,
  instance,
  eventMap,
  updaterMap,
  prevProps
) {
  component.unregisterAllEvents()
  applyUpdaterToNextProps(updaterMap, prevProps, component.props, instance)
  registerEvents(component, instance, eventMap)
}

function componentWillUnmount(component) {
  component.unregisterAllEvents()
}

function registerEvents(component, instance, eventMap) {
  var registeredList = (0, _reduce4.default)(
    eventMap,
    function(acc, googleEventName, onEventName) {
      if ((0, _isFunction3.default)(component.props[onEventName])) {
        acc.push(
          google.maps.event.addListener(
            instance,
            googleEventName,
            component.props[onEventName]
          )
        )
      }
      return acc
    },
    []
  )

  component.unregisterAllEvents = (0, _bind3.default)(
    _forEach3.default,
    null,
    registeredList,
    unregisterEvent
  )
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered)
}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeTopic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeSubtopic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeCategorySorting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return detailActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return saveLastLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return detailIntroPlayed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return gridUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return widthUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return menuOverlayUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return showUpBtnUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return menuSwitch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
// ---------------------------------------------------
// Category
// ---------------------------------------------------
var fetchCategoryData=function fetchCategoryData(categoryId){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].CHANGE_CATEGORY,categoryId:categoryId,data:__WEBPACK_IMPORTED_MODULE_1__api__["a" /* getCategoryData */](categoryId)};};var resetCategoryData=function resetCategoryData(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].CHANGE_CATEGORY,categoryId:'',data:[]};};var changeTopic=function changeTopic(topic){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].CHANGE_TOPIC,topic:topic};};var changeSubtopic=function changeSubtopic(subtopic){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].CHANGE_SUBTOPIC,subtopic:subtopic};};var changeCategorySorting=function changeCategorySorting(sorting){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].CHANGE_SORTING,sorting:sorting};};// ---------------------------------------------------
// Detail
// ---------------------------------------------------
var detailActive=function detailActive(isActive){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].DETAIL_ACTIVE,isActive:isActive};};// todo - revise with whole "modal detail" stuff - maybe not ideal
var saveLastLocation=function saveLastLocation(lastLocation){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].SAVE_LAST_LOCATION,lastLocation:lastLocation};};var detailIntroPlayed=function detailIntroPlayed(category){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].DETAIL_INTRO_PLAYED,category:category};};// ---------------------------------------------------
// Resize
// ---------------------------------------------------
var gridUpdate=function gridUpdate(grid){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].RESIZE_GRID,grid:grid};};var widthUpdate=function widthUpdate(width){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].RESIZE_WIDTH,width:width};};var menuOverlayUpdate=function menuOverlayUpdate(menuOverlay){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].MENU_OVERLAY,menuOverlay:menuOverlay};};var showUpBtnUpdate=function showUpBtnUpdate(showUpBtn){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].SHOW_UP_BTN,showUpBtn:showUpBtn};};var menuSwitch=function menuSwitch(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].MENU_SWITCH};};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(138);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(223);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(229);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(233);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(235);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(69);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(237);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(239);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(241);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(242);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(115);
var isBuffer = __webpack_require__(251);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(75)('wks');
var uid = __webpack_require__(46);
var Symbol = __webpack_require__(22).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatText; });
var STICKY_CASES=['a','A','k','K','v','V','ve','Ve','o','O','i','I','na','Na','z','Z','za','Za','the','The'];// todo - set array of breaking words and do replace loop
var formatText=function formatText(text){var tempString=text;for(var i=0;i<STICKY_CASES.length;i+=1){var rex=new RegExp(' '+STICKY_CASES[i]+' ','g');tempString=tempString.replace(rex,' '+STICKY_CASES[i]+'\xA0');}return tempString;};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var core = __webpack_require__(18);
var ctx = __webpack_require__(76);
var hide = __webpack_require__(31);
var has = __webpack_require__(26);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(32);
var IE8_DOM_DEFINE = __webpack_require__(124);
var toPrimitive = __webpack_require__(77);
var dP = Object.defineProperty;

exports.f = __webpack_require__(25) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(34)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(371),
    getValue = __webpack_require__(376);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(227);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var createDesc = __webpack_require__(39);
module.exports = __webpack_require__(25) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(132);
var defined = __webpack_require__(73);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(73);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    getRawTag = __webpack_require__(372),
    objectToString = __webpack_require__(373);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_TextHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ItemsHelper__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListItem_css__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ListItem_css__);
var getLink=function getLink(linkUrl,style,linkContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'list-item',style:style,href:linkUrl,target:'_blank',rel:'noopener noreferrer'},linkContent);};var ListItem=function ListItem(_ref){var grid=_ref.grid,itemData=_ref.itemData;var mainData=itemData[1];var route='';var showDate=true;var look=__WEBPACK_IMPORTED_MODULE_4__utils_ItemsHelper__["a" /* getItemLook */](mainData);// route
switch(mainData.type){case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].VIDEO:case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].MEMORY:case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].ARTICLE:case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].INFOGRAPHIC:case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].MAP:case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].VYSILANI:route=__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* ROUTING */].DETAIL+'/'+itemData[0];break;case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].SCHOOL_SHEET:route=__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* ROUTING */].SCHOOL_DETAIL+'/'+mainData.id;break;case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].CATEGORY:route=__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* ROUTING */].CATEGORY+'/'+mainData.categoryId;break;case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].SPECIAL:if(mainData.link.type==='link'){route=mainData.link.path;}break;default:}// todo - 3 switches are not ideal - maybe somehow merge into one
// extra
switch(mainData.type){case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].SCHOOL_SHEET:case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].VYSILANI:showDate=false;break;default:}// title class
var titleClass='title';if(mainData.title.length>60){titleClass=titleClass+' longest';}else if(mainData.title.length>40){titleClass=titleClass+' long';}// content
var linkContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'thumb',src:look.imgUrl,alt:mainData.title}),look.ico.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico',src:__WEBPACK_IMPORTED_MODULE_5__constants__["g" /* PATH */].IMG+'ico/ico-'+look.ico+'.png',alt:'Otev\u0159\xEDt'})),showDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date'},mainData.timeline),mainData.channel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-time'},mainData.date+' - '+mainData.time+' '+mainData.channel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:titleClass},__WEBPACK_IMPORTED_MODULE_3__utils_TextHelper__["a" /* formatText */](mainData.title)));// size
var style={width:100/grid+'%'};// link
if(route.length>0){// todo - article ios hotfix - revise
if(mainData.type===__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].ARTICLE&&__WEBPACK_IMPORTED_MODULE_2__api__["q" /* isIOs */]()){return getLink(mainData.link,style,linkContent);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'list-item',style:style,to:route},linkContent);}// redirect
return getLink(mainData.link.path,style,linkContent);};/* harmony default export */ __webpack_exports__["a"] = (ListItem);

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(131);
var enumBugKeys = __webpack_require__(81);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(86),
    createWrap = __webpack_require__(377),
    getHolder = __webpack_require__(91),
    replaceHolders = __webpack_require__(54);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    isObject = __webpack_require__(28);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(88),
    isObject = __webpack_require__(28);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    isObjectLike = __webpack_require__(36);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(423),
    baseKeys = __webpack_require__(430),
    isArrayLike = __webpack_require__(57);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(50),
    isLength = __webpack_require__(92);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(437),
    listCacheDelete = __webpack_require__(438),
    listCacheGet = __webpack_require__(439),
    listCacheHas = __webpack_require__(440),
    listCacheSet = __webpack_require__(441);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(60);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(455);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(55);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(184);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(70);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(17);
var normalizeHeaderName = __webpack_require__(254);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(116);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(116);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(253)))

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(75)('keys');
var uid = __webpack_require__(46);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(18);
var global = __webpack_require__(22);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(45) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(336);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(33);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(32);
var dPs = __webpack_require__(343);
var enumBugKeys = __webpack_require__(81);
var IE_PROTO = __webpack_require__(74)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(125)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(346).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(24).f;
var has = __webpack_require__(26);
var TAG = __webpack_require__(20)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(20);


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var core = __webpack_require__(18);
var LIBRARY = __webpack_require__(45);
var wksExt = __webpack_require__(83);
var defineProperty = __webpack_require__(24).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(41),
    overRest = __webpack_require__(368),
    setToString = __webpack_require__(136);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(88),
    baseLodash = __webpack_require__(90);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(447),
    mapCacheDelete = __webpack_require__(454),
    mapCacheGet = __webpack_require__(456),
    mapCacheHas = __webpack_require__(457),
    mapCacheSet = __webpack_require__(458);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(19),
    isSymbol = __webpack_require__(55);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(179);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(100);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(195);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(189);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(197);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37), __webpack_require__(196)(module)))

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(210);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(104);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(213);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(108);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(67);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(29);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(112);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(71);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(232)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);
var settle = __webpack_require__(255);
var buildURL = __webpack_require__(257);
var parseHeaders = __webpack_require__(258);
var isURLSameOrigin = __webpack_require__(259);
var createError = __webpack_require__(117);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(260);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(261);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(256);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getItemLook; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(1);
// todo - review class position + name - added in kind of rush
var getItemLook=function getItemLook(itemData){var itemLook={ico:'',imgUrl:''};switch(itemData.type){case __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].VIDEO:case __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].MEMORY:case __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].VYSILANI:itemLook.ico='play';itemLook.imgUrl=__WEBPACK_IMPORTED_MODULE_0__api__["s" /* videoImageUrl */](itemData);break;case __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].ARTICLE:itemLook.ico='read';itemLook.imgUrl=__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].IMG+'articles/'+itemData.image_id+'.jpg';break;case __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].INFOGRAPHIC:itemLook.ico='stats';itemLook.imgUrl=__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].DATA+'infographic/thumbs/'+itemData.image_id+'.jpg';break;case __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].MAP:itemLook.ico='map';itemLook.imgUrl=__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].DATA+'maps/thumbs/'+itemData.image_id+'.jpg';break;case __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].CATEGORY:itemLook.imgUrl=__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].IMG+'homepage/'+itemData.categoryId+'.jpg';break;case __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].SPECIAL:itemLook.imgUrl=__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].IMG+'homepage/'+itemData.id+'.jpg';break;case __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ITEM_TYPE */].SCHOOL_SHEET:itemLook.imgUrl=__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].SCHOOL+'img/'+itemData.id+'/cover.jpg';break;default:}return itemLook;};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _withScriptjs = __webpack_require__(332)

Object.defineProperty(exports, "withScriptjs", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withScriptjs).default
  },
})

var _withGoogleMap = __webpack_require__(406)

Object.defineProperty(exports, "withGoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withGoogleMap).default
  },
})

var _GoogleMap = __webpack_require__(407)

Object.defineProperty(exports, "GoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMap).default
  },
})

var _Circle = __webpack_require__(505)

Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default
  },
})

var _Marker = __webpack_require__(506)

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default
  },
})

var _Polyline = __webpack_require__(507)

Object.defineProperty(exports, "Polyline", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polyline).default
  },
})

var _Polygon = __webpack_require__(508)

Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default
  },
})

var _Rectangle = __webpack_require__(509)

Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default
  },
})

var _InfoWindow = __webpack_require__(510)

Object.defineProperty(exports, "InfoWindow", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoWindow).default
  },
})

var _OverlayView = __webpack_require__(511)

Object.defineProperty(exports, "OverlayView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayView).default
  },
})

var _GroundOverlay = __webpack_require__(524)

Object.defineProperty(exports, "GroundOverlay", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroundOverlay).default
  },
})

var _DirectionsRenderer = __webpack_require__(525)

Object.defineProperty(exports, "DirectionsRenderer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DirectionsRenderer).default
  },
})

var _FusionTablesLayer = __webpack_require__(526)

Object.defineProperty(exports, "FusionTablesLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FusionTablesLayer).default
  },
})

var _KmlLayer = __webpack_require__(527)

Object.defineProperty(exports, "KmlLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KmlLayer).default
  },
})

var _TrafficLayer = __webpack_require__(528)

Object.defineProperty(exports, "TrafficLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrafficLayer).default
  },
})

var _StreetViewPanorama = __webpack_require__(529)

Object.defineProperty(exports, "StreetViewPanorama", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StreetViewPanorama).default
  },
})

var _BicyclingLayer = __webpack_require__(530)

Object.defineProperty(exports, "BicyclingLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BicyclingLayer).default
  },
})

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(26);
var toObject = __webpack_require__(38);
var IE_PROTO = __webpack_require__(74)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(25) && !__webpack_require__(34)(function () {
  return Object.defineProperty(__webpack_require__(125)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
var document = __webpack_require__(22).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(337), __esModule: true };

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(339);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(351);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(341)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(129)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(45);
var $export = __webpack_require__(23);
var redefine = __webpack_require__(130);
var hide = __webpack_require__(31);
var Iterators = __webpack_require__(40);
var $iterCreate = __webpack_require__(342);
var setToStringTag = __webpack_require__(82);
var getPrototypeOf = __webpack_require__(123);
var ITERATOR = __webpack_require__(20)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(31);


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(26);
var toIObject = __webpack_require__(35);
var arrayIndexOf = __webpack_require__(344)(false);
var IE_PROTO = __webpack_require__(74)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(80);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(78);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(131);
var hiddenKeys = __webpack_require__(81).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(48);
var createDesc = __webpack_require__(39);
var toIObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(77);
var has = __webpack_require__(26);
var IE8_DOM_DEFINE = __webpack_require__(124);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(25) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(369),
    shortOut = __webpack_require__(140);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 139 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(41),
    metaMap = __webpack_require__(142);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(143);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(145),
    composeArgsRight = __webpack_require__(146),
    countHolders = __webpack_require__(380),
    createCtor = __webpack_require__(52),
    createRecurry = __webpack_require__(147),
    getHolder = __webpack_require__(91),
    reorder = __webpack_require__(395),
    replaceHolders = __webpack_require__(54),
    root = __webpack_require__(15);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(381),
    setData = __webpack_require__(151),
    setWrapToString = __webpack_require__(152);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(142),
    noop = __webpack_require__(382);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(88),
    baseLodash = __webpack_require__(90);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(141),
    shortOut = __webpack_require__(140);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(387),
    insertWrapDetails = __webpack_require__(388),
    setToString = __webpack_require__(136),
    updateWrapDetails = __webpack_require__(389);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(400),
    isObject = __webpack_require__(28),
    isSymbol = __webpack_require__(55);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 155 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(100);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(420),
    createBaseEach = __webpack_require__(433);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(425),
    isObjectLike = __webpack_require__(36);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(15),
    stubFalse = __webpack_require__(426);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(161)(module)))

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(427),
    baseUnary = __webpack_require__(428),
    nodeUtil = __webpack_require__(429);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(58),
    stackClear = __webpack_require__(442),
    stackDelete = __webpack_require__(443),
    stackGet = __webpack_require__(444),
    stackHas = __webpack_require__(445),
    stackSet = __webpack_require__(446);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(459),
    isObjectLike = __webpack_require__(36);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(460),
    arraySome = __webpack_require__(463),
    cacheHas = __webpack_require__(464);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(170),
    toKey = __webpack_require__(63);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(19),
    isKey = __webpack_require__(95),
    stringToPath = __webpack_require__(483),
    toString = __webpack_require__(171);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(486);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(170),
    isArguments = __webpack_require__(159),
    isArray = __webpack_require__(19),
    isIndex = __webpack_require__(53),
    isLength = __webpack_require__(92),
    toKey = __webpack_require__(63);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(175),
    eq = __webpack_require__(60);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(137);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(177);
module.exports = __webpack_require__(182);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(178).enable();
  window.Promise = __webpack_require__(180);
}

// fetch() polyfill for making API calls.
__webpack_require__(181);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(64);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(96);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(96);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configureStore__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Root__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Polyfills__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Polyfills__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
var store=Object(__WEBPACK_IMPORTED_MODULE_2__configureStore__["a" /* default */])();__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Root__["a" /* default */],{store:store}),document.getElementById('root'));

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(64),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(64),r=__webpack_require__(185);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(186);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_reducers_index__ = __webpack_require__(202);
var configureStore=function configureStore(){var middlewares=[];// NOTE - disabled in production
if(false){middlewares.push(createLogger());}return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__redux_reducers_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined,middlewares));};/* harmony default export */ __webpack_exports__["a"] = (configureStore);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(192);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(190);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(99);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(194);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(101);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dataCategory__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dataDetail__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resize__ = __webpack_require__(205);
var programme=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({dataCategory:__WEBPACK_IMPORTED_MODULE_1__dataCategory__["a" /* default */],dataDetail:__WEBPACK_IMPORTED_MODULE_2__dataDetail__["a" /* default */],resize:__WEBPACK_IMPORTED_MODULE_3__resize__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (programme);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(1);
var initState={category:'',topic:'',subtopic:'',sorting:0,// 0,1 - name, 2,3 - date
data:[],visibleData:[]};var dataCategory=function dataCategory(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].CHANGE_CATEGORY:return Object.assign({},state,{category:action.categoryId,topic:__WEBPACK_IMPORTED_MODULE_0__constants__["o" /* TOPIC_ALL */],subtopic:__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SUBTOPIC_ALL */],data:action.data,visibleData:action.data});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].CHANGE_TOPIC:return Object.assign({},state,{topic:action.topic,subtopic:__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SUBTOPIC_ALL */],visibleData:state.data.filter(function(item){return action.topic===__WEBPACK_IMPORTED_MODULE_0__constants__["o" /* TOPIC_ALL */]||item[1].topic.indexOf(action.topic)!==-1;})});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].CHANGE_SUBTOPIC:return Object.assign({},state,{subtopic:action.subtopic});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].CHANGE_SORTING:return Object.assign({},state,{sorting:action.sorting});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (dataCategory);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(1);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initState={active:false,lastLocation:'/',introPlayed:[]};var dataDetail=function dataDetail(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].DETAIL_ACTIVE:return Object.assign({},state,{active:action.isActive});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].SAVE_LAST_LOCATION:return Object.assign({},state,{lastLocation:action.lastLocation});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].DETAIL_INTRO_PLAYED:return Object.assign({},state,{introPlayed:[].concat(_toConsumableArray(state.introPlayed),[action.category])});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (dataDetail);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(1);
// todo - maybe rename to sometning more universal
var getInitDate=function getInitDate(){var actualDate=null;if(false){// local debug
actualDate=new Date(LOCAL_TEST_DATE);}else if(window.fakeDate!==null&&typeof window.fakeDate!=='undefined'){// test fake
actualDate=new Date(window.fakeDate);}else{// normal - server date
actualDate=new Date(window.date);}return actualDate;};var initState={grid:4,width:0,showUpBtn:false,menuVisible:false,menuOverlay:false,date:getInitDate()};var resize=function resize(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].RESIZE_GRID:return Object.assign({},state,{grid:action.grid});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].RESIZE_WIDTH:return Object.assign({},state,{width:action.width});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].MENU_SWITCH:return Object.assign({},state,{menuVisible:!state.menuVisible});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].MENU_OVERLAY:return Object.assign({},state,{menuVisible:state.menuVisible&&action.menuOverlay?false:state.menuVisible,menuOverlay:action.menuOverlay});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTIONS */].SHOW_UP_BTN:return Object.assign({},state,{showUpBtn:action.showUpBtn});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (resize);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_App__ = __webpack_require__(246);
var Root=function Root(_ref){var store=_ref.store;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App_App__["a" /* default */],null)));};Root.propTypes={store:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Root);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(208);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(67);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(106);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(221);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(107);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(107);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(108);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(222);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(67);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(69);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(69);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(230);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(70);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(110);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(234);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(236);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(114);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(238);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(70);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(240);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(71);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(114);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(71);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(244);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(112);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SideMenu_SideMenu__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Timeline_Timeline__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBox_SearchBox__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CategoryPage_CategoryPage__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ItemDetail_ItemDetail__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_Stats__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Home_Home__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__About_About__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Tag_Tag__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ArchiveList_ArchiveList__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CtHead_CtHead__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__App_css__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__School_School__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__SchoolDetail_SchoolDetail__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Vysilani_Vysilani__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Map_Map__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ToTopBtn_ToTopBtn__ = __webpack_require__(536);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.state={homeInit:true// for init home menu hide
};_this.handleScroll=_this.handleScroll.bind(_this);_this.handleResize=_this.handleResize.bind(_this);return _this;}// -------------------------------------------------------
// Component
// -------------------------------------------------------
_createClass(App,[{key:'componentWillMount',value:function componentWillMount(){this.categoryScroll=0;// note - revise scroll stuff
__WEBPACK_IMPORTED_MODULE_8__api__["p" /* initHash */]();}},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('scroll',this.handleScroll);window.addEventListener('resize',this.handleResize);// init
this.handleResize();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.detailActive&&!this.props.detailActive){window.scrollTo(0,this.categoryScroll);}else if(prevProps.location.pathname===__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].HOME&&this.props.location.pathname!==__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].HOME){// on redirect from home - for home -> category swap
window.scrollTo(0,0);}// try track route change event
if(this.props.location!==prevProps.location){__WEBPACK_IMPORTED_MODULE_9__utils_Stats__["a" /* trackEvent */]('section',this.props.location.pathname);}// try show menu
this.checkMenu();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.handleScroll);window.removeEventListener('resize',this.handleResize);}// -------------------------------------------------------
// Menu
// -------------------------------------------------------
},{key:'checkMenu',value:function checkMenu(){// show main menu on init and different page than home
if(this.state.homeInit&&this.props.location.pathname!==__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].HOME&&this.props.location.pathname.indexOf(__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].DETAIL)===-1){this.setState({homeInit:false});if(!this.props.menuVisible&&!this.props.menuOverlay){this.props.menuSwitchDispatch();}}}// -------------------------------------------------------
// Scroll
// -------------------------------------------------------
},{key:'handleScroll',value:function handleScroll(){if(!this.props.detailActive){this.categoryScroll=document.documentElement.scrollTop;}}// -------------------------------------------------------
// Resize
// -------------------------------------------------------
},{key:'handleResize',value:function handleResize(){var winW=Math.max(document.documentElement.clientWidth,window.innerWidth||0);var grid=1;for(var i=0;i<__WEBPACK_IMPORTED_MODULE_15__constants__["h" /* RESIZE_LIMITS */].GRID.length;i+=1){if(winW>__WEBPACK_IMPORTED_MODULE_15__constants__["h" /* RESIZE_LIMITS */].GRID[i][0]){grid=__WEBPACK_IMPORTED_MODULE_15__constants__["h" /* RESIZE_LIMITS */].GRID[i][1];break;}}// try update
if(grid!==this.props.grid){// todo - is it needed?
this.props.gridUpdate(grid);}// try menu overlay
var overlay=false;if(winW<__WEBPACK_IMPORTED_MODULE_15__constants__["h" /* RESIZE_LIMITS */].MENU_OVERLAY){overlay=true;}if(overlay!==this.props.menuOverlay){this.props.menuOverlayUpdate(overlay);}// try update width
if(winW!==this.props.width){// todo - is it needed?
this.props.widthUpdate(winW);}}// -------------------------------------------------------
// Render
// -------------------------------------------------------
},{key:'render',value:function render(){var _props=this.props,detailActive=_props.detailActive,categoryId=_props.categoryId,menuVisible=_props.menuVisible,menuOverlay=_props.menuOverlay,menuSwitchDispatch=_props.menuSwitchDispatch,location=_props.location;// try bg pattern
var pageStyle={};if(categoryId.length>0){var bgPattern=__WEBPACK_IMPORTED_MODULE_15__constants__["g" /* PATH */].IMG+'pattern/pattern-'+categoryId+'.png';pageStyle={backgroundImage:'url('+bgPattern+')',backgroundRepeat:'repeat',backgroundColor:'#'+__WEBPACK_IMPORTED_MODULE_15__constants__["f" /* MAIN_SECTIONS */][categoryId].bgColor};}else if(location.pathname===__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].HOME){pageStyle.background='linear-gradient(#fdfbf8 , #f9efe3 18%)';}// menu style
pageStyle.marginLeft=!menuVisible||menuOverlay?0:220;pageStyle.transition='margin-left 0.2s';// wrap style - for school sheets
// todo - revise - make easier to expand
var wrapStyle=location.pathname.indexOf(__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].SCHOOL_DETAIL)!==-1||location.pathname===__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].HOME?'wrap-full':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'main-wrap',className:detailActive?'disabled':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__CtHead_CtHead__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'menu-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-menu',onClick:function onClick(){return menuSwitchDispatch();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15__constants__["g" /* PATH */].IMG+'ico/ico-menu.png',alt:'Menu'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Timeline_Timeline__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SearchBox_SearchBox__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SideMenu_SideMenu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'app-content',style:pageStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'app-content-wrap',className:wrapStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].HOME,component:__WEBPACK_IMPORTED_MODULE_10__Home_Home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].ABOUT,component:__WEBPACK_IMPORTED_MODULE_11__About_About__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].CATEGORY+'/:categoryId',component:__WEBPACK_IMPORTED_MODULE_6__CategoryPage_CategoryPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].TAG+'/:tag',component:__WEBPACK_IMPORTED_MODULE_12__Tag_Tag__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].ARCHIVE_LIST,component:__WEBPACK_IMPORTED_MODULE_13__ArchiveList_ArchiveList__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].SCHOOL,component:__WEBPACK_IMPORTED_MODULE_18__School_School__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].SCHOOL_DETAIL+'/:sheetId/:anchor?',component:__WEBPACK_IMPORTED_MODULE_19__SchoolDetail_SchoolDetail__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].VYSILANI,component:__WEBPACK_IMPORTED_MODULE_20__Vysilani_Vysilani__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].MAP,component:__WEBPACK_IMPORTED_MODULE_21__Map_Map__["a" /* default */]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ToTopBtn_ToTopBtn__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* ROUTING */].DETAIL+'/:detailId',component:__WEBPACK_IMPORTED_MODULE_7__ItemDetail_ItemDetail__["a" /* default */]}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{detailActive:state.dataDetail.active,categoryId:state.dataCategory.category,grid:state.resize.grid,width:state.resize.width,menuVisible:state.resize.menuVisible,menuOverlay:state.resize.menuOverlay};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{gridUpdate:function gridUpdate(grid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__redux_actions__["g" /* gridUpdate */])(grid));},widthUpdate:function widthUpdate(width){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__redux_actions__["m" /* widthUpdate */])(width));},menuSwitchDispatch:function menuSwitchDispatch(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__redux_actions__["i" /* menuSwitch */])());},menuOverlayUpdate:function menuOverlayUpdate(menuOverlay){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__redux_actions__["h" /* menuOverlayUpdate */])(menuOverlay));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(App)));

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SideMenu_css__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SideMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SideMenu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions__ = __webpack_require__(14);
var SideMenu=function SideMenu(_ref){var menuVisible=_ref.menuVisible,menuOverlay=_ref.menuOverlay,switchMenu=_ref.switchMenu;var menuItems=__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* MAIN_SECTIONS */].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{key:item.range,className:'btn-category',activeClassName:'selected',to:__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* ROUTING */].CATEGORY+'/'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico',src:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].IMG+'ico/link/ico-link-'+index+'.png',alt:item.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},item.range),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},item.title.toUpperCase()));});// base styles
var imgLinkStyle={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].IMG+'menu/menu-sheet.png)'};// menu style
var menuStyle={width:menuVisible?220:0};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'side-menu',style:menuStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'side-menu-wrap',onClick:function onClick(){if(menuOverlay){switchMenu();}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* ROUTING */].HOME},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo',src:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].IMG+'menu/menu-logo.png',alt:'Logo Toto100let\xED'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-category-wrap'},menuItems),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'img-link tv',href:'//www.ceskatelevize.cz/specialy/totostoleti/program-68',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-in',style:imgLinkStyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'img-link vysilani',to:__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* ROUTING */].VYSILANI},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imgLinkStyle,className:'link-in'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'img-link anniversary',href:'//www.ceskatelevize.cz/porady/vyroci/',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-in',style:imgLinkStyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'img-link memory',to:__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* ROUTING */].TAG+'/'+__WEBPACK_IMPORTED_MODULE_3__constants__["l" /* TAG_MEMORY */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imgLinkStyle,className:'link-in'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'img-link school',to:__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* ROUTING */].SCHOOL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imgLinkStyle,className:'link-in'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'img-link map',to:__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* ROUTING */].MAP},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imgLinkStyle,className:'link-in'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'img-link about',to:__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* ROUTING */].ABOUT},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imgLinkStyle,className:'link-in'}))));};var mapStateToProps=function mapStateToProps(state){return{menuVisible:state.resize.menuVisible,menuOverlay:state.resize.menuOverlay};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{switchMenu:function switchMenu(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions__["i" /* menuSwitch */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SideMenu)));

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(250);

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);
var bind = __webpack_require__(115);
var Axios = __webpack_require__(252);
var defaults = __webpack_require__(72);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(119);
axios.CancelToken = __webpack_require__(267);
axios.isCancel = __webpack_require__(118);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(72);
var utils = __webpack_require__(17);
var InterceptorManager = __webpack_require__(262);
var dispatchRequest = __webpack_require__(263);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(117);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);
var transformData = __webpack_require__(264);
var isCancel = __webpack_require__(118);
var defaults = __webpack_require__(72);
var isAbsoluteURL = __webpack_require__(265);
var combineURLs = __webpack_require__(266);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(119);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = {"m-0-1":{"id":"1","title":"Sokolovny, aby se děti netoulaly venku","topic":["společnost"],"subtopic":[""],"tags":["pamětníci","sport"],"date":"* 19. prosince 1923 v Brně","timeline":"","gpsn":"","gpse":"","name":"Miroslav Jandásek","desc":"Čemu se podivovaly zahraniční návštěvy, když viděly všesokolský slet? A jak se stavěly za první republiky sokolovny bez státních dotací? O tom hovoří celoživotní Sokol a důležitý činovník tohoto spolku Miroslav Jandásek.","bonus":"30129","link":"http://www.pametnaroda.cz/witness/index/id/3647/#cs_3647","type":"m","category":0},"m-0-2":{"id":"2","title":"Jak se formovaly československé legie?","topic":["politika"],"subtopic":["boj o nezávislost"],"tags":["armáda","legionáři","Maďarsko","politika","pamětníci"],"date":"* 6. května 1927 v Košicích","timeline":"","gpsn":"","gpse":"","name":"Stanislav Husa","desc":"Češi a Slováci nesloužili v první světové válce ve stejné armádě. Slováci byli většinou v maďarské armádě, zatímco Češi v rakouské. Jak se podařilo, aby se zformovaly společné československé oddíly, a kdo na tom měl největší podíl? Poslechněte si vyprávění Stanislava Husy, syna českého legionáře a odbojáře.","bonus":"30123","link":"http://www.pametnaroda.cz/witness/index/id/5258/#cs_5258","type":"m","category":0},"m-1-1":{"id":"1","title":"Na Volyni na národnosti nezáleželo","topic":["společnost"],"subtopic":["menšiny"],"tags":["menšiny","pamětníci"],"date":"* 1. 5. 1927 na Volyni","timeline":"","gpsn":"","gpse":"","name":"Jaroslav Sitar","desc":"Život na mnohonárodnostní Volyni probíhal ve 30. letech poklidně a čeští žáci chodili do tříd spolu s Poláky, Židy i Ukrajinci. S příchodem války to už ale neplatilo. Poslechněte si vyprávění volyňského Čecha Jaroslava Sitara, který byl svědkem pogromů Židů a později se s československou armádou účastnil bojů na Dukle.","bonus":"30145","link":"","type":"m","category":1},"m-1-2":{"id":"2","title":"Pošlou skauti Němce domů?","topic":["společnost"],"subtopic":[""],"tags":["pamětníci","skauting"],"date":"* 16. května 1928 v Praze","timeline":"","gpsn":"","gpse":"","name":"Ludvík Armbruster","desc":"Skauting za první republiky neznamenal pouze stanování v přírodě. I ti nejmladší členové oddílu byli vedeni k vlastenectví a přípravě na nadcházející válku. O tom, jak prožívali bojové hry a jak se těšili na uplatnění svých partyzánských schopností, vykládá bývalý skaut a význačný teolog Ludvík Armbruster.","bonus":"30113","link":"http://www.pametnaroda.cz/witness/index/id/6","type":"m","category":1},"m-1-3":{"id":"3","title":"Turismus v roce 1937? Do Krkonoš už raději ne","topic":["společnost"],"subtopic":[""],"tags":["menšiny","1937","Němci","Sudety","pamětníci"],"date":"* 9. února 1927 v Praze","timeline":"","gpsn":"","gpse":"","name":"Olga Fialová","desc":"Spousta Čechů vycházela se sudetskými Němci bezproblémově a pravidelně podnikala výlety do pohraničí. Na konci 30. let se však společenská nálada razantně změnila. Proč rodina Olgy Fialové přestala jezdit do Krkonoš a proč se necítila vítána ani v Tatrách? Poslechněte si vzpomínky překladatelky a dcery jednoho z hlavních organizátorů poválečných odsunů.","bonus":"30119","link":"http://www.pametnaroda.cz/witness/index/id/5318/#cs_5318","type":"m","category":1},"m-1-4":{"id":"4","title":"Peroutkovcům se Voskovec a Werich nelíbil","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["žurnalistika","studenti","umění","média","pamětníci"],"date":"* 24. září 1919 v Praze","timeline":"","gpsn":"","gpse":"","name":"Staša Fleischmannová","desc":"Mladá kultura byl časopis stejnojmenného levicového spolku studentů, který na konci 30. let psal o avantgardní kultuře a stavěl se proti fašismu. Poslechněte si, jak na atmosféru kolem časopisu vzpomíná Staša Fleischmannová, fotografka a pozdější členka odboje, která se stýkala se špičkou prvorepublikové kultury.","bonus":"30120","link":"http://www.pametnaroda.cz/witness/index/id/1719/#cs_1719","type":"m","category":1},"m-1-5":{"id":"5","title":"Mezi Němci se nám žilo dobře","topic":["společnost"],"subtopic":["menšiny"],"tags":["menšiny","Němci","Sudety","pamětníci"],"date":"* 1920 v Teplicích","timeline":"","gpsn":"","gpse":"","name":"Hanuš Kotek","desc":"Mnozí Češi za první republiky žili mezi Němci zcela přirozeně, chodili do německých škol a nevnímali, že by byli něčím odlišní. Na klidné soužití i na eskalování národnostních sporů vzpomíná Hanuš Kotek, veterán druhé světové války, který se jako člen britských jednotek účastnil invaze v Normandii.","bonus":"30138","link":"http://www.pametnaroda.cz/witness/index/id/448","type":"m","category":1},"m-2-1":{"id":"1","title":"V nočních košilích při německé razii","topic":["politika"],"subtopic":["perzekuce"],"tags":["protektorát","odboj","pamětníci","1942"],"date":"* 5. ledna 1930","timeline":"","gpsn":"","gpse":"","name":"Jiří Fabinger","desc":"Po atentátu na říšského protektora Reinharda Heydricha v roce 1942 probíhaly razie neustále. Německé jednotky v noci obsazovaly pražské ulice, prohledávaly dům za domem a vyrážely dveře. Poslechněte si osobní zkušenost novináře a redaktora Jiřího Fabingera. ","bonus":"30118","link":"http://www.pametnaroda.cz/witness/index/id/5597/#cs_5597","type":"m","category":2},"m-2-2":{"id":"2","title":"Romem během války","topic":["společnost"],"subtopic":["holocaust"],"tags":["holocaust","Romové","menšiny","pamětníci","rasismus"],"date":"* 6. března 1937 v Brně","timeline":"","gpsn":"","gpse":"","name":"Karel Holomek","desc":"Mít romskou krev za druhé světové války znamenalo transport do koncentračního tábora. V nebezpečí byly i děti ze smíšených manželství. Jak mohly uniknout nacistům a kdo jim pomáhal? Poslechněte si, jak na tuto zkušenost vzpomíná Karel Holomek, český romský aktivista a politik.","bonus":"30122","link":"http://www.pametnaroda.cz/witness/index/id/1632/#cs_1632","type":"m","category":2},"m-2-3":{"id":"3","title":"Z italského partyzána francouzským tankistou","topic":["politika"],"subtopic":["odboj"],"tags":["armáda","válka","pamětníci"],"date":"* 30. dubna 1924 v Úpici","timeline":"","gpsn":"","gpse":"","name":"Bedřich Jiránek","desc":"Aby se za okupace vyhnul totálnímu nasazení, přidal se Bedřich Jiránek k vládnímu vojsku. V roce 1944 přeběhl v Itálii k partyzánům, se kterými odešel do Francie a přihlásil se do cizinecké legie. Jak probíhal výcvik a komu se říkalo „mrtvolkáři“? Poslechněte si vyprávění bývalého tankisty, který se účastnil osvobozování Československa.","bonus":"30130","link":"http://www.pametnaroda.cz/witness/index/id/2249/#cs_2249","type":"m","category":2},"m-2-4":{"id":"4","title":"Prezidenta si v učebnici přelepte fotkou nového...","topic":["politika"],"subtopic":[""],"tags":["politika","prezident","pamětníci"],"date":"* 2. června 1932 ve Skalici","timeline":"","gpsn":"","gpse":"","name":"Anton Tomík","desc":"Vyhlášení Slovenského štátu v roce 1939 nedalo mnoho prostoru k přípravám a ve školních učebnicích se narychlo přelepovaly fotografie prezidentů. Vzpomíná Anton Tomík, který jako neprávem odsouzený vězeň prošel uranovými doly na Jáchymovsku. ","bonus":"30149","link":"http://www.pametnaroda.cz/witness/index/id/5808/#cs_5808","type":"m","category":2},"m-3-1":{"id":"1","title":"Únor 1948 očima školáka: vítězství nebo prohra?","topic":["politika"],"subtopic":["únor 1948"],"tags":["politika","1948","pamětníci"],"date":"* 18. října 1937 v Praze","timeline":"","gpsn":"","gpse":"","name":"František Halas","desc":"Jak mohl vnímat únorový převrat v roce 1948 žák páté třídy? Diplomat a církevní historik František Halas vzpomíná, jak někteří členové jeho rodiny jásali, zatímco jiní byli zdrceni.","bonus":"30121","link":"http://www.pametnaroda.cz/witness/index/id/5888/#cs_5888","type":"m","category":3},"m-3-2":{"id":"2","title":"Nepřijat na VŠ: pro socialistické zemědělství neperspektivní","topic":["společnost"],"subtopic":[""],"tags":["politika","1949","vzdělávání","perzekuce","pamětníci"],"date":"* 9. července 1928 na samotě Hájka poblíž Lubence","timeline":"","gpsn":"","gpse":"","name":"František Škarda","desc":"Rok 1948 znamenal změnu pro všechny uchazeče na vysoké školy. Správný třídní původ začal být důležitější než znalosti. Dobře si na to pamatuje František Škarda, který byl jakožto syn statkáře shledán nevyhovujícím pro podmínky budoucího socialistického zemědělství.","bonus":"30146","link":"http://www.pametnaroda.cz/witness/index/id/5204/#cs_5204","type":"m","category":3},"m-3-3":{"id":"3","title":"Z vojenského soudce dělníkem","topic":["politika"],"subtopic":["únor 1948"],"tags":["armáda","1948","perzekuce","pamětníci"],"date":"* 17. října 1936 v Košicích","timeline":"","gpsn":"","gpse":"","name":"Vladimír Šuman","desc":"Zatímco před válkou platilo, že příslušníci armády mají být apolitičtí, po změně režimu v roce 1948 začali dostávat přihlášky ke vstupu do strany. Odmítnutí mohlo mít vážné důsledky. Bývalý náměstek ministra obrany Vladimír Šuman vzpomíná, jak se z jeho otce, vojenského soudce, stal dělník v pivovaru.","bonus":"30148","link":"http://www.pametnaroda.cz/witness/index/id/5155/#cs_5155","type":"m","category":3},"m-3-4":{"id":"4","title":"Emigrace 1948: Pět dní pěšky k hranici","topic":["společnost"],"subtopic":[""],"tags":["hranice","1948","železná opona","emigrace","hranice","pamětníci"],"date":"* 2. srpna 1930 v Praze","timeline":"","gpsn":"","gpse":"","name":"Svatava Vynal","desc":"Když Svatavě Vynal nebylo v roce 1948 umožněno vycestovat do Filadelfie, kde získala studijní stipendium, rozhodla se emigrovat. Spolu se svým prabratrancem a jeho dvěma kamarády šli pět dní a nocí skrze zakázané pásmo. Poslechněte si, jak se vyhýbali českým hlídkám a jak je přivítali na druhé straně hranice.","bonus":"30152","link":"http://www.pametnaroda.cz/witness/index/id/4844/#cs_4844","type":"m","category":3},"m-3-5":{"id":"5","title":"Namísto bunkrů hájovny","topic":["politika"],"subtopic":[""],"tags":["armáda","perzekuce","pamětníci"],"date":"* 22. prosince 1931 v Praze","timeline":"","gpsn":"","gpse":"","name":"Miloš Pokorný","desc":"Jak se stalo, že v 50. letech rostly uprostřed polí hájovny? A kdo je stavěl? O maskování českých bunkrů, které prováděli tak zvaní černí baroni, hovoří bývalý příslušník pomocného technického praporu, emigrant a nakladatel Miloš Pokorný.","bonus":"30141","link":"http://www.pametnaroda.cz/witness/index/id/5017/#cs_5017","type":"m","category":3},"m-3-6":{"id":"6","title":"Řádění poválečných Revolučních gard","topic":["společnost"],"subtopic":[""],"tags":["odsun","Němci","menšiny","pamětníci"],"date":"* 19. června 1931 v Jihlavě","timeline":"","gpsn":"","gpse":"","name":"Ludmila Sedláková","desc":"Na konci druhé světové války byla Jihlava plná německých uprchlíků a ve městě panoval zmatek. Situace se chopily Revoluční gardy, ozbrojené jednotky českých dobrovolníků, které na Němcích začaly páchat násilí včetně poprav. Poslechněte si, jak na jejich řádění vzpomíná Ludmila Sedláková.","bonus":"30144","link":"http://www.pametnaroda.cz/witness/index/id/5097/#cs_5097","type":"m","category":3},"m-3-7":{"id":"7","title":"Schovávali jezuité zbraně pod oltářem?","topic":["politika"],"subtopic":["nespravedlivě odsouzení"],"tags":["1950","pamětníci","církev","perzekuce"],"date":"* 16. května 1928 v Praze","timeline":"","gpsn":"","gpse":"","name":"Ludvík Armbruster","desc":"O půlnoci 13. dubna roku 1950 bušili na dveře jezuitské koleje v Děčíně příslušníci SNB a přikázali všem přítomným, aby se shromáždili v jídelně. Začala Akce K, která násilně likvidovala mužské řeholní řády po celé republice. Kam komunisté jezuity odvezli a co se snažili najít v jejich internátě? Poslechněte si osobní zkušenost bývalého děkana Katolické teologické fakulty Ludvíka Armbrustera.","bonus":"30111","link":"http://www.pametnaroda.cz/witness/index/id/6","type":"m","category":3},"m-3-8":{"id":"8","title":"Brutální vyšetřovací praktiky 50. let","topic":["politika"],"subtopic":["nespravedlivě odsouzení"],"tags":["pamětníci","perzekuce","odboj"],"date":"* 13. července 1935 v Praze","timeline":"","gpsn":"","gpse":"","name":"Miroslav Kopt","desc":"Když byl Miroslav Kopt v 50. letech zatčen za organizování odbojových akcí, rozhodl se nevypovídat. Ve vazbě byl podroben několikadenním vyčerpávajícím výslechům a surovému bití. Poslechněte si, jak na brutální vyšetřovací praktiky vzpomíná politický vězeň, který se čtyřicet let angažoval v protikomunistickém odboji.","bonus":"30137","link":"http://www.pametnaroda.cz/witness/index/id/1196/#cs_1196","type":"m","category":3},"m-4-1":{"id":"1","title":"Mobilizace? Soudruhu, nech to bejt…","topic":["politika"],"subtopic":["srpen 1968"],"tags":["armáda","Varšavská smlouva","pamětníci","1968"],"date":"* 4. února 1937 v Bratislavě","timeline":"","gpsn":"","gpse":"","name":"Antonín Černý","desc":"Když byli obyvatelé Ostravy ráno 21. srpna roku 1968 probuzeni projíždějícími polskými tanky, někteří čekali, že nastane mobilizace. Jedním z nich byl i Antonín Černý, pozdější disident a spoluvězeň Václava Havla. Poslechněte si, jak na jeho telefonát reagovala krajská vojenská správa.","bonus":"30116","link":"http://www.pametnaroda.cz/witness/index/id/4495/#cs_4495","type":"m","category":4},"m-4-2":{"id":"2","title":"Naděje a skepse pražského jara","topic":["hospodářství"],"subtopic":["pražské jaro"],"tags":["pražské jaro","hospodářství","pamětníci","1968"],"date":"* 1935","timeline":"","gpsn":"","gpse":"","name":"Josef Šubrt ","desc":"Pražské jaro přineslo naději, že o možnostech uplatnění přestane rozhodovat stranická příslušnost, a že na jednotlivá místa nastoupí skuteční odborníci, kteří rozumí své profesi. O tom, jak se nepodařilo tuto vizi naplnit, vypráví Josef Šubrt, bývalý letecký konstruktér.","bonus":"30147","link":"http://www.pametnaroda.cz/witness/index/id/6172","type":"m","category":4},"m-4-3":{"id":"3","title":"Z prázdnin domů kolem tanků","topic":["politika"],"subtopic":["srpen 1968"],"tags":["1968","Varšavská smlouva","armáda","pamětníci"],"date":"* 6. prosince 1954 v Rokycanech","timeline":"","gpsn":"","gpse":"","name":"Vlasta Vasková","desc":"V srpnu 1968 byla spousta dětí na táborech a o invazi vojsk Varšavské smlouvy nevěděla. Z chování vedoucích však mohly tušit, že došlo k něčemu vážnému. Poslechněte si, jak na návrat z takovýchto letních prázdnin vzpomíná Vlasta Vasková, pozdější skupinová vedoucí v Pionýru.","bonus":"30151","link":"http://www.pametnaroda.cz/witness/index/id/7139/#cs_7139","type":"m","category":4},"m-5-1":{"id":"1","title":"Šeptaná pravda a normalizační mantry","topic":["společnost"],"subtopic":["studenti"],"tags":["normalizace","underground","pamětníci"],"date":"* 13. února 1961 v Praze","timeline":"","gpsn":"","gpse":"","name":"Martin Komárek","desc":"V atmosféře normalizace si jen málokdo dovolil mluvit na veřejnosti tak, jako to dělal doma či v hospodě. Opakování oficiální rétoriky umožňovalo studium a klidný život bez střetů se státní mocí. Jak se člověk vyrovnával s touto hrou na socialismus, rozebírá novinář a poslanec Martin Komárek.","bonus":"30136","link":"http://www.pametnaroda.cz/witness/index/id/6200/#cs_6200","type":"m","category":5},"m-5-2":{"id":"2","title":"Jak přežít normalizaci? Přemýšlet a rozhlížet se.","topic":["společnost"],"subtopic":["nástup normalizace"],"tags":["normalizace","vzdělávání","pamětníci","1968"],"date":"* 27. října 1942 v Plzni","timeline":"","gpsn":"","gpse":"","name":"Vilém Lederer","desc":"Srpnové události roku 1968 vzbudily ve společnosti ohromnou vlnu emocí. To, jak se s nimi člověk vypořádal, záleželo také na jeho okolí a rodině. Lékař Vilém Lederer vzpomíná, jak mu otec pomohl svou racionalitou a zkušeností překonat období normalizace.","bonus":"30139","link":"http://www.pametnaroda.cz/witness/index/id/6150/#cs_6150","type":"m","category":5},"m-5-3":{"id":"3","title":"Jak se vyrovnat s normalizací? Neparticipovat!","topic":["společnost"],"subtopic":["nástup normalizace"],"tags":["normalizace","pamětníci","underground"],"date":"* 1962 v Hořovicích u Berouna","timeline":"","gpsn":"","gpse":"","name":"Roman Cajthaml","desc":"Komunistický režim 70. let občany pouze neomezoval, ale nutil je na procesu normalizace participovat. Ať už šlo o prvomájové průvody nebo volby, všichni se museli účastnit. Na to, jak se těmto povinnostem snažil vyhýbat, vzpomíná Roman Cajthaml, který později strávil dva roky ve vězení za útěk z povinné vojenské služby.","bonus":"30115","link":"http://www.pametnaroda.cz/witness/index/id/6152/#cs_6152","type":"m","category":5},"m-5-4":{"id":"4","title":"Jiří Schelinger chtěl podepsat Chartu 77","topic":["společnost"],"subtopic":["Charta 77"],"tags":["pamětníci","hudba","Charta 77"],"date":"* 9. července 1943 v Praze","timeline":"","gpsn":"","gpse":"","name":"František Ringo Čech","desc":"Jiří Schelinger Chartu 77 podepsat chtěl, ale nakonec to neudělal. Kdo mu podepsání rozmluvil a jak se k jeho protirežimnímu smýšlení stavěli spoluhráči z kapely? Poslechněte si vyprávění hudebníka Františka Ringo Čecha.","bonus":"30117","link":"http://www.pametnaroda.cz/witness/index/id/6436/#cs_6436","type":"m","category":5},"m-5-5":{"id":"5","title":"Byli veksláci skutečně zloději?","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","normalizace","pamětníci"],"date":"* 1960","timeline":"","gpsn":"","gpse":"","name":"Vít Chaloupka","desc":"Za minulého režimu bylo vekslování zakázané, ale často tolerované. Jak viděli tuto nelegální činnost samotní veksláci a proč se nepovažovali za zloděje? Vzpomíná dietolog a fitness konzultant Vít Chaloupka.","bonus":"30125","link":"","type":"m","category":5},"m-5-6":{"id":"6","title":"Zametač s kapsami  plnými valut","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","normalizace","pamětníci"],"date":"* 1960","timeline":"","gpsn":"","gpse":"","name":"Vít Chaloupka","desc":"Když musel Vít Chaloupka v 80. letech zametat v livreji před pražským hotelem Evropa, bylo mu trapně a někteří kolemjdoucí se mu smáli. Utěšovalo jej ale, že měl všechny kapsy nacpané valutami. Poslechněte si vzpomínky bývalého kulturisty a veksláka.","bonus":"30126","link":"","type":"m","category":5},"m-5-7":{"id":"7","title":"Rada estébáka: Svůj názor si nech pro sebe","topic":["politika"],"subtopic":[""],"tags":["normalizace","perzekuce","pamětníci"],"date":"* 20. května 1950 v Plzni, † 2016 v Praze","timeline":"","gpsn":"","gpse":"","name":"Jaromír Ulč","desc":"Normalizace byla pro mnohé přirozenou realitou, vůči které není třeba se stavět. Co si tito lidé mysleli o svobodomyslných iniciativách a o zavírání disidentů? Poslechněte si názor Jaromíra Ulče, někdejšího pracovníka Státní bezpečnosti.","bonus":"30150","link":"http://www.pametnaroda.cz/witness/index/id/2082/#cs_2082","type":"m","category":5},"m-6-1":{"id":"1","title":"Havel se nechtěl stát prezidentem","topic":["politika"],"subtopic":["Havel"],"tags":["politika","prezident","1989","pamětníci"],"date":"* 28. července 1954 v Praze","timeline":"","gpsn":"","gpse":"","name":"Michael Kocáb","desc":"Navržení Václava Havla na prezidenta v roce 1989 se nejprve nesetkalo s velkým přijetím, a to ani ze strany samotného nominovaného. Proč se Havel nechtěl stát hlavou republiky, kdo jej přemlouval a jakou roli v tom sehrála jeho žena Olga? O tom vypráví Havlův blízký spolupracovník a jeden ze zakladatelů Občanského fóra Michael Kocáb.","bonus":"30131","link":"","type":"m","category":6},"m-6-2":{"id":"2","title":"Obyčejný bunkr nebo sklad jaderných hlavic?","topic":["společnost"],"subtopic":[""],"tags":["jádro","armáda","Varšavská smlouva","pamětníci","1991"],"date":"* 28. července 1954 v Praze","timeline":"","gpsn":"","gpse":"","name":"Michael Kocáb","desc":"Během odsunu sovětských vojsk z Československa v roce 1991 dostala zodpovědná parlamentní komise tip na sklad s jadernými hlavicemi, jejichž přítomnost na našem území Rusové popírali. Jak se ke kontrole skladu postavila česká armáda? A proč nebyli pyrotechnici schopni urazit visací zámek na dveřích? Vypráví člen komise a Havlův blízký spolupracovník Michael Kocáb.","bonus":"30132","link":"","type":"m","category":6},"m-6-3":{"id":"3","title":"Je polistopadové životní prostředí lepší?","topic":["hospodářství"],"subtopic":[""],"tags":["ekologie","pamětníci"],"date":"* 22. října 1945 ve Varnsdorfu","timeline":"","gpsn":"","gpse":"","name":"Martin Říha","desc":"Je současný stav životního prostředí lepší než před rokem 1989? Která opatření se nepodařilo prosadit a jakou roli v tom sehrála změna politické situace? Vzpomíná architekt Martin Říha, jeden z prvních náměstků na ministerstvu životního prostředí.","bonus":"30142","link":"http://www.pametnaroda.cz/witness/index/id/6775","type":"m","category":6},"m-6-4":{"id":"4","title":"Privatizaci ovládla hrstka vyvolených","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","pamětníci"],"date":"* 5. března 1953 v Praze","timeline":"","gpsn":"","gpse":"","name":"Jan Ruml","desc":"Privatizaci v 90. letech provázela spousta problémů. Kdo z ní nejvíce profitoval a proč chyběl řádný právní rámec? Na to, jak proti jejímu průběhu protestoval u Václava Klause, vzpomíná Jan Ruml, někdejší ministr vnitra a aktivista v oblasti lidských práv.","bonus":"30143","link":"http://www.pametnaroda.cz/witness/index/id/3408/#cs_3408","type":"m","category":6},"i-0-1":{"id":"1","title":"Národnostní menšiny v průběhu století","topic":["společnost"],"subtopic":["menšiny"],"tags":["infografika","menšiny","Slovensko","Němci","Maďarsko","Sudety"],"date":"1918","timeline":"","gpsn":"","gpse":"","image_id":"2","type":"i","category":0},"i-0-2":{"id":"2","title":"Čím se posledních sto let jezdilo?","topic":["společnost"],"subtopic":[""],"tags":["infografika","automobil","doprava"],"date":"1922","timeline":"","gpsn":"","gpse":"","image_id":"8","type":"i","category":0},"i-1-1":{"id":"1","title":"Naděje dožití: Žijeme téměř o 30 let déle!","topic":["společnost"],"subtopic":[""],"tags":["infografika"],"date":"1929","timeline":"","gpsn":"","gpse":"","image_id":"4","type":"i","category":1},"i-2-1":{"id":"1","title":"Nejsilnější politické strany v různých dobách","topic":["politika"],"subtopic":[""],"tags":["infografika","politika","volby"],"date":"1938","timeline":"","gpsn":"","gpse":"","image_id":"1","type":"i","category":2},"i-3-1":{"id":"1","title":"Náboženské vyznání","topic":["společnost"],"subtopic":[""],"tags":["infografika","církev"],"date":"1945","timeline":"","gpsn":"","gpse":"","image_id":"7","type":"i","category":3},"i-4-1":{"id":"1","title":"Vzdělání: Jsme chytřejší?","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["infografika","vzdělávání"],"date":"1956","timeline":"","gpsn":"","gpse":"","image_id":"5","type":"i","category":4},"i-5-1":{"id":"1","title":"Osobní automobily: Podívejte se na počty osobních automobilů ","topic":["společnost"],"subtopic":[""],"tags":["infografika","hospodářství","technika","automobil","doprava"],"date":"1969","timeline":"","gpsn":"","gpse":"","image_id":"6","type":"i","category":5},"i-5-2":{"id":"2","title":"Za socialismu k moři","topic":["společnost"],"subtopic":[""],"tags":["infografika","volný čas"],"date":"1980","timeline":"","gpsn":"","gpse":"","image_id":"9","type":"i","category":5},"i-7-1":{"id":"1","title":"Počet obyvatel","topic":["společnost"],"subtopic":[""],"tags":["infografika"],"date":"2004","timeline":"","gpsn":"","gpse":"","image_id":"3","type":"i","category":7},"i-7-2":{"id":"2","title":"České legendy světového sportu","topic":["sport"],"subtopic":[""],"tags":["infografika","sport"],"date":"2012","timeline":"","gpsn":"","gpse":"","image_id":"10","type":"i","category":7},"a-0-1":{"id":"1","title":"Masaryk a Peroutka: Mistr a jeho kritik?","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["Masaryk","žurnalistika","média"],"date":"1924","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1509394-masaryk-a-peroutka-mistr-a-jeho-kritik","image_id":"1","image_source":"ČTK","type":"a","category":0},"a-0-2":{"id":"2","title":"Zachránila Masaryka náhoda, nebo práce rozvědky?","topic":["politika"],"subtopic":[""],"tags":["prezident","Masaryk","atentát"],"date":"1921","timeline":"1921","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1128969-zachranila-masaryka-pred-atentatem-nahoda-nebo-prace-rozvedky","image_id":"2","image_source":"ČTK","type":"a","category":0},"a-0-3":{"id":"3","title":"Jan Masaryk","topic":["politika"],"subtopic":[""],"tags":["Masaryk","politika","atentát","komunismus"],"date":"1925","timeline":"1886-1948","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1436335-jan-masaryk","image_id":"3","image_source":"ČT","type":"a","category":0},"a-0-4":{"id":"4","title":"Masaryk a velká pětka","topic":["politika"],"subtopic":["zakladatelé"],"tags":["Masaryk","Československo","prezident","1921"],"date":"1920","timeline":"1921-1925","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1447201-masaryk-a-velka-petka","image_id":"4","image_source":"Wikipedia","type":"a","category":0},"a-0-5":{"id":"5","title":"První republiku vyhlásila pětice „mužů 28. října“","topic":["politika"],"subtopic":["zakladatelé"],"tags":["politika","Československo","1918","volby","Rašín","Švehla","Masaryk"],"date":"1918","timeline":"1918","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1436443-prvni-republiku-vyhlasila-petice-muzu-28-rijna","image_id":"5","image_source":"ČT24","type":"a","category":0},"a-0-6":{"id":"6","title":"První zákony Československa zrušily šlechtické tituly","topic":["politika"],"subtopic":[""],"tags":["šlechta","1918"],"date":"1918","timeline":"1918","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1430610-zruseni-slechtickych-titulu-patrilo-mezi-prvni-pravni-normy-ceskoslovenska","image_id":"6","image_source":"Wikipedia","type":"a","category":0},"a-0-7":{"id":"7","title":"Založen Československý červený kříž","topic":["společnost"],"subtopic":[""],"tags":["zdravotnictví","1919"],"date":"1919","timeline":"1919","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1422049-zalozen-ceskoslovensky-cerveny-kriz","image_id":"8","image_source":"ČT24","type":"a","category":0},"a-0-8":{"id":"8","title":"Byla podepsána Pittsburská dohoda","topic":["politika"],"subtopic":["boj o nezávislost"],"tags":["politika","USA","emigrace","1918"],"date":"1918","timeline":"1918","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1453068-byla-podepsana-pittsburska-dohoda","image_id":"9","image_source":"ČT24","type":"a","category":0},"a-0-9":{"id":"9","title":"Washingtonská deklarace položila základy ČSR","topic":["politika"],"subtopic":["boj o nezávislost"],"tags":["politika","USA","emigrace","1918"],"date":"1918","timeline":"1918","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1437515-washingtonska-deklarace-polozila-zaklady-csr","image_id":"10","image_source":"Wikipedia","type":"a","category":0},"a-0-10":{"id":"10","title":"Kavalír českého dějepisectví, Josef Pekař","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["věda","vzdělávání"],"date":"1925","timeline":"1870-1937","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1461970-kavalir-ceskeho-dejepisectvi-josef-pekar","image_id":"11","image_source":"bez autora/vlastníka","type":"a","category":0},"a-0-11":{"id":"11","title":"Laurina s Klementem vystřídal Emil Škoda","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","automobil","doprava","1926"],"date":"1926","timeline":"1926","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1267019-laurina-s-klementem-vystridal-emil-skoda","image_id":"12","image_source":"Škoda Auto","type":"a","category":0},"a-0-12":{"id":"12","title":"Astronom Štefánik zažil hvězdnou vojenskou kariéru","topic":["politika"],"subtopic":["zakladatelé"],"tags":["věda","armáda","Štefánik","legionáři","armáda"],"date":"1919","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1328316-astronom-stefanik-zazil-hvezdnou-vojenskou-karieru","image_id":"13","image_source":"ČT 24","type":"a","category":0},"a-0-13":{"id":"13","title":"Podkarpatská Rus v rámci Československa vzkvétala","topic":["společnost"],"subtopic":[""],"tags":["menšiny","Podkarpatská Rus","hospodářství"],"date":"1919","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/1386214-podkarpatska-rus-v-ramci-ceskoslovenska-vzkvetala","image_id":"16","image_source":"ČT24","type":"a","category":0},"a-0-14":{"id":"14","title":"Poetismus vznikl na půdě Devětsilu Karla Teigeho","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["literatura","umění","1920"],"date":"1920","timeline":"1920","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1313074-literarni-smer-poetismus-vznikl-na-pude-devetsilu-karla-teigeho","image_id":"17","image_source":"Wikipedia","type":"a","category":0},"a-0-15":{"id":"15","title":"KVÍZ: Co si pamatujete ze školy o vzniku První republiky?","topic":["politika"],"subtopic":["boj o nezávislost"],"tags":["politika","Československo"],"date":"1918","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/veda/2286520-kviz-co-si-pamatujete-ze-skoly-o-vzniku-prvni-republiky","image_id":"18","image_source":"ČTK","type":"a","category":0},"a-0-16":{"id":"16","title":"Milada Petříková: první česká inženýrka a architektka","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["architektura","vzdělávání","stavby","feminismus"],"date":"1921","timeline":"1895-1985","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1575514-milada-petrikova-byla-prvni-ceskou-inzenyrkou-a-architektkou","image_id":"19","image_source":"ČT24","type":"a","category":0},"a-1-1":{"id":"1","title":"TGM: Čtyři prezidentské volby a každá úplně jiná","topic":["politika"],"subtopic":[""],"tags":["Masaryk","prezident","volby","politika"],"date":"1927","timeline":"1918-1935","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1113014-tgm-ctyri-prezidentske-volby-a-kazda-uplne-jina","image_id":"21","image_source":"ČTK","type":"a","category":1},"a-1-2":{"id":"2","title":"Poslední předválečné volby vyhráli henleinovci a hlinkovci","topic":["politika"],"subtopic":[""],"tags":["volby","1935","válka","nacismus","menšiny","Sudety","Němci","Slovensko"],"date":"1935","timeline":"1935","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1338091-posledni-predvalecne-volby-vyhrali-henleinovci-a-hlinkovci","image_id":"22","image_source":"ČTK, foto SdP - Getty","type":"a","category":1},"a-1-3":{"id":"3","title":"Karel Poláček, milovník židovských anekdot","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["umění","literatura"],"date":"1931","timeline":"1892-1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ct24/kultura/1360657-karel-polacek-milovnik-zidovskych-anekdot","image_id":"23","image_source":"ČT24","type":"a","category":1},"a-1-4":{"id":"4","title":"Ivan Olbracht - stálice českých čítanek","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["umění","literatura"],"date":"1933","timeline":"1882-1952","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1429171-ivan-olbracht-stalice-ceskych-citanek","image_id":"24","image_source":"Wiki a ČT24","type":"a","category":1},"a-1-5":{"id":"5","title":"Křehká a lyrická Nataša Gollová","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["film","umění"],"date":"1932","timeline":"1912-1988","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1188572-krehka-a-lyricka-natasa-gollova","image_id":"25","image_source":"ČT24","type":"a","category":1},"a-1-6":{"id":"6","title":"Roztomilý člověk Hugo Haas","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["film","umění"],"date":"1937","timeline":"1901-1968","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1284158-roztomily-clovek-hugo-haas","image_id":"26","image_source":"ČT","type":"a","category":1},"a-1-7":{"id":"7","title":"Závodnici Junkové se dodnes žádná v rychlosti nevyrovná","topic":["sport"],"subtopic":[""],"tags":["sport","automobil"],"date":"1933","timeline":"1900-1994","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1055533-legendarni-junkove-se-dodnes-zadna-zavodnice-v-rychlosti-nevyrovna","image_id":"27","image_source":"ČTK","type":"a","category":1},"a-1-8":{"id":"8","title":"Židenický puč měl být signálem k převratu","topic":["politika"],"subtopic":[""],"tags":["fašismus","1933","konflikt"],"date":"1933","timeline":"1933","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/1465106-zidenicky-puc-mel-byt-signalem-k-prevratu","image_id":"28","image_source":"Klub vojenské historie","type":"a","category":1},"a-1-9":{"id":"9","title":"Zimní stadion na Štvanici sloužil sportu téměř osmdesát let","topic":["sport"],"subtopic":[""],"tags":["sport","hokej","architektura","stavby","1932"],"date":"1932","timeline":"1932","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/1136410-zimni-stadion-na-stvanici-slouzil-sportu-temer-osmdesat-let","image_id":"29","image_source":"ČTK","type":"a","category":1},"a-1-10":{"id":"10","title":"Česká zbrojovka - zbraně pro celé dvacáté století","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","armáda","1937"],"date":"1937","timeline":"1937","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/1194035-ceska-zbrojovka-zbrane-pro-cele-dvacate-stoleti","image_id":"30","image_source":"ČT24","type":"a","category":1},"a-1-11":{"id":"11","title":"Josef Bican - červenobílá legenda, které nepřála doba","topic":["sport"],"subtopic":[""],"tags":["sport","fotbal"],"date":"1937","timeline":"1913-2001","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1204142-josef-bican-cervenobila-legenda-ktere-neprala-doba","image_id":"31","image_source":"ČTK","type":"a","category":1},"a-1-12":{"id":"12","title":"První semafor zastavil Pražany uprostřed Václaváku","topic":["společnost"],"subtopic":[""],"tags":["doprava","1930"],"date":"1930","timeline":"1930","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ct24/domaci/1360803-prvni-semafor-zastavil-prazany-uprostred-vaclavaku","image_id":"32","image_source":"ČT24","type":"a","category":1},"a-1-13":{"id":"13","title":"(Ne)obyčejný život Karla Čapka začal před 125 lety","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["literatura","umění"],"date":"1938","timeline":"1890-1938","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1650262-neobycejny-zivot-karla-capka-zacal-pred-125-lety","image_id":"33","image_source":"ČTK","type":"a","category":1},"a-1-14":{"id":"14","title":"Beneš s Čechy prošel dramatickou první půlkou 20. století","topic":["politika"],"subtopic":[""],"tags":["prezident","Beneš","zakladatelé"],"date":"1935","timeline":"1884-1948","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1077469-benes-prezident-ktery-s-cechy-prosel-dramatickou-prvni-pulkou-20-stoleti","image_id":"34","image_source":"ČTK","type":"a","category":1},"a-1-15":{"id":"15","title":"Ruzyně už „odbavila“ tramvaj, raketoplán i sovětské tanky","topic":["společnost"],"subtopic":[""],"tags":["doprava","letectví","technika","1937"],"date":"1937","timeline":"1937","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2077005-ruzyne-uz-odbavila-tramvaj-raketoplan-i-sovetske-tanky-ted-slavi-osmdesatiny","image_id":"35","image_source":"ČTK","type":"a","category":1},"a-1-16":{"id":"16","title":"Prohlédněte si předchůdce dnešních autobusů","topic":["společnost"],"subtopic":[""],"tags":["doprava","technika"],"date":"1937","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1978695-dopravni-podnik-vyrazuje-stare-autobusy-prohlednete-si-jejich-historicke-predchudce","image_id":"36","image_source":"archiv Dopravního podniku hl. m. Prahy","type":"a","category":1},"a-1-17":{"id":"17","title":"Zemřel slavný romanopisec Alois Jirásek","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["literatura","umění","pohřeb","1930"],"date":"1930","timeline":"1930","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1349822-alois-jirasek-slavny-spisovatel-pro-nedobrovolne-ctenare","image_id":"37","image_source":"ČT24, wikipedia","type":"a","category":1},"a-1-18":{"id":"18","title":"1931: Návštěvníky přivítala v pražské ZOO vlčice Lotta","topic":["společnost"],"subtopic":[""],"tags":["1931","volný čas"],"date":"1931","timeline":"1931","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/1920002-prazska-zoo-slavi-85-vyroci-pokrtila-mlade-zirafy-i-hrabace","image_id":"38","image_source":"ČTK","type":"a","category":1},"a-1-19":{"id":"19","title":"Světová hospodářská krize optikou první republiky","topic":["společnost"],"subtopic":[""],"tags":["krize","hospodářství","1932","demonstrace"],"date":"1932","timeline":"1932","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1461985-svetova-hospodarska-krize-optikou-prvni-republiky","image_id":"39","image_source":"bez autora/vlastníka","type":"a","category":1},"a-1-20":{"id":"20","title":"Smrt TGM","topic":["společnost"],"subtopic":[""],"tags":["Masaryk","prezident","pohřeb"],"date":"1937","timeline":"1937","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2240131-pred-80-lety-se-narodil-taticek-i-prezident-osvoboditel-tgm","image_id":"40","image_source":"ČTK, ČT24","type":"a","category":1},"a-1-21":{"id":"21","title":"Povstání sudetských Němců jako cesta k Mnichovu","topic":["společnost"],"subtopic":["krize 1938"],"tags":["menšiny","Němci","1938","Sudety","nacismus"],"date":"1938","timeline":"1938","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1075893-puc-henleinovcu-moc-nesvedl-proslapnul-ale-cesticku-do-mnichova","image_id":"41","image_source":"Deutsches Bundesarchiv, ČTK, Wikipedie","type":"a","category":1},"a-1-22":{"id":"22","title":"Václav Vojtěch jako první Čech stanul na území Antarktidy","topic":["společnost"],"subtopic":[""],"tags":["1929","cestování"],"date":"1929","timeline":"1929","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1424140-vaclav-vojtech-jako-prvni-cech-stanul-na-uzemi-antarktidy","image_id":"14","image_source":"ČT24","type":"a","category":1},"a-1-23":{"id":"23","title":"Pražská zoo se za 80 let změnila","topic":["společnost"],"subtopic":[""],"tags":["1931","volný čas"],"date":"1931","timeline":"1931","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/1256009-prazska-zoo-se-za-80-let-zmenila","image_id":"15","image_source":"ČT 24","type":"a","category":1},"a-2-1":{"id":"1","title":"17. listopad 1939: Gestapo si předvolalo 15 studentů","topic":["společnost"],"subtopic":[""],"tags":["nacismus","protektorát","studenti","vzdělávání","1939"],"date":"1939","timeline":"1939","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/2306863-dramaticky-17-listopad-1939-zazvonil-telefon-a-gestapo-si-predvolalo-15-studentu","image_id":"42","image_source":"wikipedia ","type":"a","category":2},"a-2-2":{"id":"2","title":"Pohřeb Jana Opletala se změnil v protestní demonstraci","topic":["společnost"],"subtopic":[""],"tags":["pohřeb","nacismus","1939","konflikt","protektorát","studenti"],"date":"1939","timeline":"1939","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2304232-pohreb-ktery-rozzuril-nacisty-rozlouceni-s-opletalem-se-zmenilo-v-protestni","image_id":"43","image_source":"ČT24/ČTK","type":"a","category":2},"a-2-3":{"id":"3","title":"Smrt si říká Osvětim","topic":["společnost"],"subtopic":["holocaust"],"tags":["holocaust","antisemitismus","menšiny","nacismus","Židé"],"date":"1940","timeline":"1940-1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/1495492-smrt-si-rika-osvetim","image_id":"44","image_source":"Janek Skarzynski, Zdroj: ISIFA/AFP","type":"a","category":2},"a-2-4":{"id":"4","title":"Skleněný palác. Před 75 lety byla otevřena Bílá labuť","topic":["společnost"],"subtopic":[""],"tags":["hospodářství","architektura","1939"],"date":"1939","timeline":"1939","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/1416578-skleneny-palac-pred-75-lety-byla-otevrena-bila-labut","image_id":"45","image_source":"foto ČTK","type":"a","category":2},"a-2-5":{"id":"5","title":"František Fajtl – válečný letec a muž s plnovousem","topic":["politika"],"subtopic":["odboj"],"tags":["odboj","armáda","válka","letectví"],"date":"1942","timeline":"1912-2006","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1151882-frantisek-fajtl-valecny-letec-a-muz-s-plnovousem","image_id":"46","image_source":"foto ČT24, Isifa","type":"a","category":2},"a-2-6":{"id":"6","title":"Vypálení Lidic - symbol nacistické hrůzovlády","topic":["politika"],"subtopic":["odboj"],"tags":["odboj","1942","válka","nacismus"],"date":"1942","timeline":"1942","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1451909-vypaleni-lidic-symbol-nacisticke-hruzovlady","image_id":"47","image_source":"ČT24","type":"a","category":2},"a-2-7":{"id":"7","title":"Emil Hácha – pro většinu lidí zrádce a pronacistický aktivista","topic":["politika"],"subtopic":["politická jednání"],"tags":["prezident","protektorát"],"date":"1939","timeline":"1872-1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1333185-emil-hacha-pro-vetsinu-lidi-zradce-a-pronacisticky-aktivista","image_id":"48","image_source":"ČTK","type":"a","category":2},"a-2-8":{"id":"8","title":"Konec Konráda Henleina – již jako válečný zločinec si podřezal žíly","topic":["politika"],"subtopic":[""],"tags":["nacismus","Němci","Sudety"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/1455523-konec-konrada-henleina-jiz-jako-valecny-zlocinec-si-podrezal-zily","image_id":"50","image_source":"Getty, Wikimedia","type":"a","category":2},"a-2-9":{"id":"9","title":"Praha se ke konci války stala obětí útoku spojeneckých vojsk","topic":["politika"],"subtopic":[""],"tags":["válka","1945"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1347471-praha-se-ke-konci-valky-stala-obeti-utoku-spojeneckych-vojsk","image_id":"51","image_source":"spvd.cz","type":"a","category":2},"a-2-10":{"id":"10","title":"Podolský most byl strategickou spojnicí, zažil i válečná zvěrstva","topic":["společnost"],"subtopic":[""],"tags":["válka","architektura","stavby","doprava"],"date":"1942","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/2233030-podolsky-most-spojuje-brehy-vltavy-uz-75-let-byl-strategickou-spojnici-zazil-i","image_id":"52","image_source":"ČTK","type":"a","category":2},"a-2-11":{"id":"11","title":"Němci se za Heydricha mstili v Mauthausenu, zavraždili tam stovky Čechů","topic":["politika"],"subtopic":[""],"tags":["perzekuce","válka"],"date":"1942","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/2282791-nemci-se-za-heydricha-mstili-v-mauthausenu-pred-75-lety-tam-zavrazdili-tri-stovky-cechu","image_id":"53","image_source":"ČTK/DPA","type":"a","category":2},"a-2-12":{"id":"12","title":"Parašutisté v pravoslavném chrámu odolávali více než 800 nacistů","topic":["politika"],"subtopic":["odboj"],"tags":["protektorát","odboj","armáda","1942"],"date":"1942","timeline":"1942","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2155074-curdova-zrada-privedla-800-nacistu-se-samopaly-pred-pravoslavny-chram-parasutiste-se","image_id":"54","image_source":"ČTK, ČT24","type":"a","category":2},"a-2-13":{"id":"13","title":"Češi za heydrichiády na náměstích odsuzovali „hanebný atentát“","topic":["politika"],"subtopic":[""],"tags":["protektorát","1942"],"date":"1942","timeline":"1942","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2153457-cesi-za-heydrichiady-na-namestich-odsuzovali-hanebny-atentat-z-donuceni-i-dobrovolne","image_id":"55","image_source":"ČTK","type":"a","category":2},"a-2-14":{"id":"14","title":"Bitva o Británii: Hrdinný odpor za Kanálem podpořili i českoslovenští piloti","topic":["politika"],"subtopic":[""],"tags":["letectví","armáda","odboj","válka","1940"],"date":"1940","timeline":"1940","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2177101-vyroci-slavne-bitvy-o-britanii-hrdinny-odpor-za-kanalem-podporili-i-ceskoslovensti","image_id":"56","image_source":"Wikipedia","type":"a","category":2},"a-2-15":{"id":"15","title":"Na Škodovy závody cílil britský nálet. Operace Canonbury ale selhala","topic":["společnost"],"subtopic":[""],"tags":["letectví","armáda","válka","hospodářství","1942"],"date":"1942","timeline":"1942","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2100905-na-skodovy-zavody-pred-75-lety-cilil-britsky-nalet-operace-canonbury-ale-selhala","image_id":"57","image_source":"ČT24","type":"a","category":2},"a-2-16":{"id":"16","title":"Narodili se v koncentračním táboře nebo v transportu...","topic":["společnost"],"subtopic":[""],"tags":["holocaust","antisemitismus","válka","Židé"],"date":"1941","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1975159-narodili-se-v-koncentracnim-tabore-nebo-v-transportu-ted-se-schazeji-jako-pratele","image_id":"58","image_source":"Reuters, ČT","type":"a","category":2},"a-2-17":{"id":"17","title":"2200 barikád a 30 tisíc bojovníků - takový byl konec války v Praze","topic":["politika"],"subtopic":["odboj"],"tags":["protektorát","válka","armáda","1945"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/1524412-2200-barikad-a-30-tisic-bojovniku-takovy-byl-konec-valky-v-praze","image_id":"59","image_source":"archiv Jaroslava Čvančary","type":"a","category":2},"a-2-18":{"id":"18","title":"Za svobodu Olomouce zaplatilo životem 300 rudoarmějců","topic":["politika"],"subtopic":[""],"tags":["protektorát","válka","armáda","1945"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/1526534-za-svobodu-olomouce-zaplatilo-zivotem-300-rudoarmejcu","image_id":"60","image_source":"Vlastivědné muzeum Olomouc a Státní okresní archiv","type":"a","category":2},"a-2-19":{"id":"19","title":"Rudá armáda osvobozovala osvobozené město","topic":["politika"],"subtopic":[""],"tags":["protektorát","válka","armáda","1945"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1526406-ruda-armada-osvobozovala-osvobozene-mesto","image_id":"61","image_source":"ČTK","type":"a","category":2},"a-2-20":{"id":"20","title":"Květen 1945 psal příběhy svobodné Plzně","topic":["politika"],"subtopic":[""],"tags":["protektorát","válka","armáda","1945"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1521772-kveten-1945-psal-pribehy-svobodne-plzne","image_id":"62","image_source":"ČT24","type":"a","category":2},"a-2-21":{"id":"21","title":"Frank chtěl protesty utopit v moři krve, český národ přesto povstal","topic":["politika"],"subtopic":[""],"tags":["protektorát","válka","armáda","1945"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1524730-frank-chtel-protesty-utopit-v-mori-krve-cesky-narod-presto-povstal","image_id":"63","image_source":"VHÚ","type":"a","category":2},"a-2-22":{"id":"22","title":"Příběhy amerických pilotů sestřelených u nás na konci války","topic":["politika"],"subtopic":[""],"tags":["válka","armáda","letectví","1945"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/1516790-pribehy-americkych-pilotu-sestrelenych-u-nas-na-konci-valky","image_id":"64","image_source":"Katalog výstavy - Martin Veselý","type":"a","category":2},"a-2-23":{"id":"23","title":"15. března 1939 začalo nejtemnější období české historie","topic":["politika"],"subtopic":[""],"tags":["protektorát","1939"],"date":"1939","timeline":"1939","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1725937-15-brezna-1939-zacalo-nejtemnejsi-obdobi-ceske-historie","image_id":"178","image_source":"ČTK","type":"a","category":2},"a-3-1":{"id":"1","title":"Benešův dekret o konfiskaci majetku se setkal s kritikou","topic":["politika"],"subtopic":["politická jednání"],"tags":["Němci","menšiny","1945–1946"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1334202-benesuv-dekret-o-konfiskaci-majetku-se-setkal-s-kritikou","image_id":"49","image_source":"ČT24","type":"a","category":3},"a-3-2":{"id":"2","title":"Smrt Jana Masaryka zůstává dodnes zahalena tajemstvím","topic":["politika"],"subtopic":[""],"tags":["1948","Masaryk","politika"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1460946-smrt-jana-masaryka-zustava-dodnes-zahalena-tajemstvim","image_id":"65","image_source":"ČT","type":"a","category":3},"a-3-3":{"id":"3","title":"Tůma: Beneš v únoru 1948 věřil v kompromis","topic":["politika"],"subtopic":["únor 1948"],"tags":["1948","Beneš","politika","komunismus","demonstrace"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1046554-tuma-benes-v-unoru-1948-moznosti-mel-veril-ale-v-kompromis","image_id":"66","image_source":"ČTK,","type":"a","category":3},"a-3-4":{"id":"4","title":"Křesťanská duše Přemysla Pittera","topic":["společnost"],"subtopic":[""],"tags":["církev","perzekuce","emigrace"],"date":"1951","timeline":"1895-1976","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1261722-krestanska-duse-premysla-pittera","image_id":"67","image_source":"ČT24","type":"a","category":3},"a-3-5":{"id":"5","title":"60. výročí Marshallova plánu","topic":["hospodářství"],"subtopic":[""],"tags":["železná opona","hospodářství","1948"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1462033-60-vyroci-marshallova-planu","image_id":"68","image_source":"ČT24","type":"a","category":3},"a-3-6":{"id":"6","title":"František Hrubín byl mámivý melodik","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["umění","literatura"],"date":"1948","timeline":"1910-1971","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1282010-frantisek-hrubin-byl-mamivy-melodik","image_id":"69","image_source":"Divadlo Viola","type":"a","category":3},"a-3-7":{"id":"7","title":"Komunisté ale epidemiologa Rašku o zásluhy připravili","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["zdravotnictví","vzdělávání","věda"],"date":"1952","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/veda/2309554-cech-ktery-porazil-nestovice-komuniste-ale-epidemiologa-rasku-o-zasluhy-pripravili","image_id":"70","image_source":"ČTK","type":"a","category":3},"a-3-8":{"id":"8","title":"Píka toho moc věděl, a tak musel zemřít","topic":["politika"],"subtopic":["nespravedlivě odsouzení"],"tags":["proces","perzekuce","1949","armáda"],"date":"1949","timeline":"1949","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1455622-pika-toho-moc-vedel-a-tak-musel-zemrit","image_id":"71","image_source":"ČTK","type":"a","category":3},"a-3-9":{"id":"9","title":"Ke Gottwaldově smrti: „Ať žije husitsky a gottwaldovsky pevný lid!“","topic":["politika"],"subtopic":["umírání soudruhů"],"tags":["pohřeb","prezident","1953"],"date":"1953","timeline":"1953","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1460517-tisk-ke-gottwaldove-smrti-zije-husitsky-a-gottwaldovsky-pevny-lid","image_id":"72","image_source":"ČTK","type":"a","category":3},"a-3-10":{"id":"10","title":"Smrt Stalina: Smutek, strach, radost i plané naděje","topic":["politika"],"subtopic":["umírání soudruhů"],"tags":["pohřeb","1953"],"date":"1953","timeline":"1953","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/1461390-smrt-stalina-smutek-strach-radost-i-plane-nadeje","image_id":"73","image_source":"Wikipedia","type":"a","category":3},"a-3-11":{"id":"11","title":"Zátopek zahájil v Helsinkách zlatou cestu k nesmrtelnosti","topic":["sport"],"subtopic":[""],"tags":["sport","olympiáda","1952"],"date":"1952","timeline":"1952","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1157295-zatopek-zahajil-v-helsinkach-trojnasobne-zlatou-cestu-k-nesmrtelnosti","image_id":"74","image_source":"ČTK","type":"a","category":3},"a-3-12":{"id":"12","title":"Tragický konec mistrů světa z roku 1949","topic":["sport"],"subtopic":["nespravedlivě odsouzení"],"tags":["sport","hokej","1949","proces","perzekuce"],"date":"1949","timeline":"1949","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/sport/hokej/31169-tragicky-konec-mistru-sveta-z-roku-1949/","image_id":"75","image_source":"ČTK","type":"a","category":3},"a-3-13":{"id":"13","title":"PTP měly vyřešit problém s „politicky nespolehlivými“ branci","topic":["politika"],"subtopic":[""],"tags":["armáda","perzekuce"],"date":"1950","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1320299-ptp-mely-vyresit-problem-s-politicky-nespolehlivymi-branci","image_id":"76","image_source":"Wikimedia","type":"a","category":3},"a-3-14":{"id":"14","title":"Spartakiády a sokolské slety měly mnoho společného","topic":["sport"],"subtopic":[""],"tags":["sport","volný čas","politika","propaganda"],"date":"1955","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1806548-spartakiady-a-sokolske-slety-mely-mnoho-spolecneho","image_id":"78","image_source":"wikipedia","type":"a","category":3},"a-3-15":{"id":"15","title":"Sběr bylin už neslouží k budování socialismu, ale k přivýdělku","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství"],"date":"1950","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1032232-sber-bylin-uz-neslouzi-k-budovani-socialismu-ale-k-privydelku","image_id":"79","image_source":"ČTK","type":"a","category":3},"a-3-16":{"id":"16","title":"Udal agenta Dvořáčka Kundera, nebo Dlask?","topic":["společnost"],"subtopic":[""],"tags":["literatura","Stb","perzekuce","1950","emigrace"],"date":"1950","timeline":"1950","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1437312-udal-agenta-dvoracka-kundera-nebo-dlask-historici-budou-dal-badat","image_id":"80","image_source":"ČTK","type":"a","category":3},"a-3-17":{"id":"17","title":"Poválečné volby: Trumfy byly na straně komunistů","topic":["společnost"],"subtopic":[""],"tags":["volby","politika","1946"],"date":"1946","timeline":"1946","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1263457-povalecne-volby-trumfy-byly-na-strane-komunistu","image_id":"81","image_source":"ČT24","type":"a","category":3},"a-3-18":{"id":"18","title":"Zápotockého lež připravila půdu pro velkou peněžní loupež","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","1953","demonstrace"],"date":"1953","timeline":"1953","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1452319-zapotockeho-lez-pripravila-pudu-pro-velkou-penezni-loupez","image_id":"82","image_source":"isifa","type":"a","category":3},"a-3-19":{"id":"19","title":"Stalinův pomník – „fronta na maso“ stál na Letné pouhých sedm let","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1955","umění","sochařství","propaganda","pomník"],"date":"1955","timeline":"1955","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1338924-stalinuv-pomnik-fronta-na-maso-stal-na-letne-pouhych-sedm-let","image_id":"83","image_source":"wikipedia","type":"a","category":3},"a-3-20":{"id":"20","title":"Televize napouští česká akvária už 60 let","topic":["společnost"],"subtopic":[""],"tags":["média","televize","1953"],"date":"1953","timeline":"1953","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1101728-televize-napousti-ceska-akvaria-uz-60-let","image_id":"84","image_source":"ČT","type":"a","category":3},"a-3-21":{"id":"21","title":"První justiční vražda: Heliodor Píka byl popraven roku 1949","topic":["politika"],"subtopic":["nespravedlivě odsouzení"],"tags":["proces","perzekuce","1949","armáda"],"date":"1949","timeline":"1949","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1824113-heliodor-pika-byl-popraven-pred-67-lety-sveho-zalobce-osvobodil-z-gulagu","image_id":"85","image_source":"ČTK","type":"a","category":3},"a-3-22":{"id":"22","title":"Jak zemřel Jan Masaryk? Ze tří scénářů je nejpravděpodobnější vražda","topic":["politika"],"subtopic":[""],"tags":["1948","Masaryk","politika"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/veda/1906649-jak-zemrel-jan-masaryk-ze-tri-scenaru-je-nejpravdepodobnejsi-vrazda","image_id":"177","image_source":"ČT","type":"a","category":3},"a-4-1":{"id":"1","title":"Československo se před 60 lety stalo členem atomového klubu","topic":["hospodářství"],"subtopic":[""],"tags":["jádro","věda","technika","energetika","1957"],"date":"1957","timeline":"1957","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/veda/2248174-jaderna-veverka-ceskoslovensko-se-pred-60-lety-stalo-clenem-atomoveho-klubu","image_id":"86","image_source":"ÚJV Řež","type":"a","category":4},"a-4-2":{"id":"2","title":"Legendární tramvaj T3 začala brázdit pražské ulice před 55 lety","topic":["společnost"],"subtopic":[""],"tags":["technika","doprava","1962"],"date":"1962","timeline":"1962","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2309707-legendarni-tramvaj-t3-zacala-brazdit-prazske-ulice-pred-55-lety","image_id":"87","image_source":"ČTK","type":"a","category":4},"a-4-3":{"id":"3","title":"Čáslavská: Zlatá šedesátá ve stínu tragédie","topic":["sport"],"subtopic":[""],"tags":["sport","1968","olympiáda","perzekuce"],"date":"1968","timeline":"1942-2016","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1175117-caslavska-zlata-sedesata-ve-stinu-tragedie","image_id":"88","image_source":"ČTK","type":"a","category":4},"a-4-4":{"id":"4","title":"Fotbalová legenda Masopust byl gentleman na hřišti","topic":["sport"],"subtopic":[""],"tags":["sport","fotbal"],"date":"1962","timeline":"1931-2015","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/sport/fotbal/114876-fotbalova-legenda-masopust-byl-gentleman-na-hristi/","image_id":"89","image_source":"Klub přátel Jiřího Masopusta","type":"a","category":4},"a-4-5":{"id":"5","title":"Přijata byla nová „socialistická“ Ústava ČSSR","topic":["politika"],"subtopic":[""],"tags":["politika","1960"],"date":"1960","timeline":"1960","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1330372-prijata-byla-nova-socialisticka-ustava-cssr","image_id":"90","image_source":"ČT24","type":"a","category":4},"a-4-6":{"id":"6","title":"Vynálezce semtexu se od 70. let musel živit manuální prací","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["věda","hospodářství"],"date":"1964","timeline":"1964","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/1559660-vynalezce-semtexu-se-od-70-let-musel-zivit-manualni-praci","image_id":"92","image_source":"ČTK","type":"a","category":4},"a-4-7":{"id":"7","title":"„Embéčko“ drželo krok se světem. Na dlouhou dobu ale bylo poslední","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","automobil","1964","doprava"],"date":"1964","timeline":"1964","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/1042871-embecko-drzelo-krok-se-svetem-na-dlouhou-dobu-ale-bylo-posledni","image_id":"94","image_source":"ČTK","type":"a","category":4},"a-4-8":{"id":"8","title":"Moskevský protokol pohřbil všechny naděje","topic":["politika"],"subtopic":["srpen 1968"],"tags":["Sovětský svaz","okupace","Varšavská smlouva","1968","pražské jaro","politika"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1446155-moskevsky-protokol-pohrbil-vsechny-nadeje","image_id":"96","image_source":"ČT24","type":"a","category":4},"a-4-9":{"id":"9","title":"Pět životů Pavla Tigrida","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1951","železná opona","emigrace","média"],"date":"1960","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2285623-pet-zivotu-pavla-tigrida-symbol-protikomunistickeho-exilu-se-narodil-presne-pred-sto","image_id":"97","image_source":"ČTK","type":"a","category":4},"a-4-10":{"id":"10","title":"Profesor Heyrovský: První Čech, který dostal Nobelovu cenu","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["věda","1959"],"date":"1959","timeline":"1959","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/veda/2065912-prvni-cech-ktery-dostal-nobelovu-cenu-profesor-heyrovsky-zmenil-chemii-a-proslavil-nasi","image_id":"98","image_source":"Wikipedia","type":"a","category":4},"a-4-11":{"id":"11","title":"Panelstory: Nedoceněná sídliště jsou fenoménem svého druhu","topic":["společnost"],"subtopic":[""],"tags":["stavby","architektura"],"date":"1960","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/2272960-panelstory-lovestory-nedocenena-sidliste-jsou-fenomenem-sveho-druhu","image_id":"99","image_source":"Jaromír Čejka","type":"a","category":4},"a-4-12":{"id":"12","title":"Rozsviťte lampiony. Jak se v Československu slavila VŘSR","topic":["společnost"],"subtopic":[""],"tags":["propaganda"],"date":"1967","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2293069-rozsvitte-lampiony-jak-se-v-ceskoslovensku-slavila-vrsr","image_id":"100","image_source":"ČTK","type":"a","category":4},"a-4-13":{"id":"13","title":"Experimenty Vladimíra Boudníka - umění ulice a továrny","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["umění"],"date":"1959","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/2167114-umeni-z-tovarny-vystava-predstavuje-experimenty-vladimira-boudnika","image_id":"101","image_source":"Muzeum hlavního města Prahy","type":"a","category":4},"a-4-14":{"id":"14","title":"Z „vejtřasky“ je pětašedesátiletá dáma. Šarm ale neztratila","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","automobil","1952","doprava"],"date":"1952","timeline":"1952","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2039376-z-vejtrasky-je-petasedesatileta-dama-sarm-ale-neztratila","image_id":"102","image_source":"ČTK","type":"a","category":4},"a-4-15":{"id":"15","title":"1962: Při letecké havárii zahynulo u Brna 13 lidí","topic":["společnost"],"subtopic":[""],"tags":["letectví","doprava"],"date":"1962","timeline":"1962","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/2269471-pred-55-lety-zahynulo-pri-letecke-havarii-u-brna-13-lidi-kvuli-mlze-narazil-pilot-do","image_id":"103","image_source":"ČT24","type":"a","category":4},"a-4-16":{"id":"16","title":"Češi by měli být za rok 1968 vděční, uvedla ruská televize","topic":["politika"],"subtopic":["srpen 1968"],"tags":["demonstrace","okupace","Varšavská smlouva","pražské jaro","Sovětský svaz"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/2310328-cesi-meli-byt-vdecni-za-rok-1968-uvedla-ruska-televize-prekrucujete-minulost-kontroval","image_id":"104","image_source":"ČTK","type":"a","category":4},"a-4-17":{"id":"17","title":"Otto Jelinek: krasobruslařem, podnikatelem, politikem, ministrem","topic":["společnost"],"subtopic":[""],"tags":["sport","emigrace","politika"],"date":"","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1338088-otto-jelinek-krasobruslarem-podnikatelem-politikem-ministrem","image_id":"77","image_source":"krajane.radio.cz","type":"a","category":4},"a-4-18":{"id":"18","title":"Bruselský sen: Expo 58 patřilo Československu","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1958","výstava","umění","kultura"],"date":"1958","timeline":"1958","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1457255-bruselsky-sen-expo-58-patrilo-ceskoslovensku","image_id":"179","image_source":"ČT24","type":"a","category":4},"a-4-19":{"id":"19","title":"Zakázali mi dělat i tu uklízečku, vzpomíná Věra Čáslavská","topic":["sport"],"subtopic":[""],"tags":["sport","1968","olympiáda","perzekuce"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1687549-zakazali-mi-delat-i-tu-uklizecku-vzpomina-vera-caslavska","image_id":"181","image_source":"ČT24","type":"a","category":4},"a-5-1":{"id":"1","title":"Čtvrtstoletí od poslední popravy, tečky za pochmurnou historií","topic":["politika"],"subtopic":[""],"tags":["politika"],"date":"1989","timeline":"1989","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1050208-ctvrtstoleti-od-posledni-popravy-tecky-za-pochmurnou-historii","image_id":"106","image_source":"ČTK","type":"a","category":5},"a-5-2":{"id":"2","title":"Gorbačovova perestrojka nebyla třeba. V ČSSR jsme plánovali vlastní","topic":["politika"],"subtopic":[""],"tags":["poltika","komunismus","Sovětský svaz"],"date":"1987","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2006881-jakes-gorbacovova-perestrojka-nebyla-zapotrebi-v-ceskoslovensku-jsme-planovali","image_id":"107","image_source":"ČTK","type":"a","category":5},"a-5-3":{"id":"3","title":"Na Jakeše a další členy KSČ míří trestní oznámení kvůli zabíjení u hranic","topic":["politika"],"subtopic":[""],"tags":["politika","hranice"],"date":"1989","timeline":"1965-1989","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2248732-na-jakese-a-dalsi-cleny-vedeni-ksc-miri-trestni-oznameni-kvuli-zabijeni-u-hranic","image_id":"108","image_source":"ČTK","type":"a","category":5},"a-5-4":{"id":"4","title":"Zaniklá krajina severozápadních Čech: Těžba uhlí ji změnila navždy","topic":["hospodářství"],"subtopic":[""],"tags":["těžba","hospodářství"],"date":"1972","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/2278174-zanikla-krajina-severozapadnich-cech-tezba-uhli-ji-zmenila-navzdy#articlewithopenedgallery","image_id":"109","image_source":"ČT24","type":"a","category":5},"a-5-5":{"id":"5","title":"Kotva nebo Thermal. Pocta stavbám Věry Machoninové","topic":["společnost"],"subtopic":[""],"tags":["architektura","umění","stavby"],"date":"1970","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1628740-kotva-nebo-thermal-architekti-poctili-ohrozene-stavby-very-machoninove#articlewithopenedgallery","image_id":"110","image_source":"ČTK","type":"a","category":5},"a-5-6":{"id":"6","title":"Jak se budovalo Československo uměním a designem","topic":["společnost"],"subtopic":[""],"tags":["umění","architektura"],"date":"1969","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1622069-jak-se-budovalo-ceskoslovensko-umenim-a-designem#articlewithopenedgallery","image_id":"111","image_source":"Národní galerie","type":"a","category":5},"a-5-7":{"id":"7","title":"Labská bouda: Přesně dekádu po ničivém požáru vyrostla nová","topic":["společnost"],"subtopic":[""],"tags":["architektura","stavby","1975"],"date":"1975","timeline":"1975","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/1614220-dvojite-vyroci-labske-boudy-presne-dekadu-po-nicivem-pozaru-vyrostla-nova#articlewithopenedgallery","image_id":"112","image_source":"Wikimedia, KRNAP, ČTK","type":"a","category":5},"a-5-8":{"id":"8","title":"Smrt Brežněva - první díl seriálu sovětských pohřbů","topic":["politika"],"subtopic":[""],"tags":["politika","Sovětský svaz","pohřeb","1982"],"date":"1982","timeline":"1982","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/1136004-smrt-brezneva-prvni-dil-serialu-sovetskych-pohrbu","image_id":"113","image_source":"ČT24","type":"a","category":5},"a-5-9":{"id":"9","title":"Češi zdolali Nanga Parbat - jednu z nejobávanějších hor","topic":["společnost"],"subtopic":[""],"tags":["cestování","sport","1971"],"date":"1971","timeline":"1971","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1160450-cesi-zdolali-nanga-parbat-jednu-z-nejobavanejsich-hor","image_id":"114","image_source":"ČT24","type":"a","category":5},"a-5-10":{"id":"10","title":"D1: nejstarší a nejdelší dálnice v Česku","topic":["společnost"],"subtopic":[""],"tags":["doprava","stavby","1980"],"date":"1980","timeline":"1980","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1305580-d1-nejstarsi-a-nejdelsi-dalnice-v-cesku","image_id":"115","image_source":"ČT24","type":"a","category":5},"a-5-11":{"id":"11","title":"Suchdolská letecká tragédie se dostala i do seriálu","topic":["společnost"],"subtopic":[""],"tags":["letectví","doprava","1975"],"date":"1975","timeline":"1975","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1436044-suchdolska-letecka-tragedie-se-dostala-i-do-serialu-autenticke-zabery-ale-neexistuji","image_id":"116","image_source":"ČT24","type":"a","category":5},"a-5-12":{"id":"12","title":"Humor Miloslava Šimka bavil generace diváků","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["umění","divadlo"],"date":"1970","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1351045-humor-miloslava-simka-bavil-generace-divaku","image_id":"117","image_source":"ČT","type":"a","category":5},"a-5-13":{"id":"13","title":"Kotva je tu stále pro vás","topic":["společnost"],"subtopic":[""],"tags":["stavby","architektura","hospodářství","1975"],"date":"1975","timeline":"1975","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ct24/ekonomika/1356251-kotva-je-tu-stale-pro-vas","image_id":"118","image_source":"ČT24","type":"a","category":5},"a-5-14":{"id":"14","title":"Běžný občan si mohl poprvé v ČSSR vybrat z bankomatu","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","1989"],"date":"1989","timeline":"1989","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ct24/ekonomika/1370072-bezny-obcan-si-mohl-poprve-v-ceskoslovensku-vybrat-z-bankomatu","image_id":"119","image_source":"ČT24","type":"a","category":5},"a-5-15":{"id":"15","title":"Zahájení výroby Škody 100/110 nezpozdil ani ničivý požár","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","1969","automobil"],"date":"1969","timeline":"1969","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1389245-zahajeni-vyroby-skody-100110-nezpozdil-ani-nicivy-pozar","image_id":"120","image_source":"foto ČT24, wikipedia","type":"a","category":5},"a-5-16":{"id":"16","title":"Kapsy plné marek. Bojovali jsme proti komunismu, tvrdí veksláci","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","normalizace"],"date":"1984","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2307742-meli-kapsy-plne-dolaru-a-marek-bojovali-jsme-proti-komunismu-tvrdi-vekslaci-z","image_id":"122","image_source":"ČT, Post Bellum","type":"a","category":5},"a-5-17":{"id":"17","title":"Československý ministr plánoval s teroristy atentát, který překazila StB","topic":["politika"],"subtopic":[""],"tags":["politika","1981"],"date":"1981","timeline":"1981","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2127858-ceskoslovensky-ministr-planoval-s-arabskymi-teroristy-atentat-ktery-prekazila-az-stb","image_id":"123","image_source":"ČTK","type":"a","category":5},"a-5-18":{"id":"18","title":"Filozof Jan Patočka věděl, že jsou věci, pro které stojí za to trpět","topic":["kultura a vzdělávání"],"subtopic":["Charta 77"],"tags":["Charta 77","věda","vzdělávání"],"date":"1977","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2055770-kacirsky-filozof-jan-patocka-vedel-ze-jsou-veci-pro-ktere-stoji-za-trpet","image_id":"124","image_source":"ČTK, ČT","type":"a","category":5},"a-5-19":{"id":"19","title":"Remek strávil ve vesmíru osm dní","topic":["společnost"],"subtopic":[""],"tags":["vesmír","věda","technika","letectví","1978"],"date":"1978","timeline":"1978","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1461787-remek-stravil-ve-vesmiru-osm-dni","image_id":"125","image_source":"ČT24","type":"a","category":5},"a-5-20":{"id":"20","title":"KGB sledovala dění v čele KSČ, po roce 1968 politikům nevěřila","topic":["politika"],"subtopic":["nástup normalizace"],"tags":["politika","Sovětský svaz"],"date":"1973","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1021905-kgb-sledovala-deni-v-cele-ksc-po-roce-1968-politikum-neverila","image_id":"126","image_source":"isifa, ČT24","type":"a","category":5},"a-5-21":{"id":"21","title":"Most: město, které pohltil hlad po uhlí","topic":["hospodářství"],"subtopic":[""],"tags":["těžba","hospodářství"],"date":"1982","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/relax/1053983-most-mesto-ktere-pohltil-hlad-po-uhli","image_id":"127","image_source":"ČT24","type":"a","category":5},"a-5-22":{"id":"22","title":"Perestrojka: Gorbačov poprvé navštívil Prahu","topic":["politika"],"subtopic":[""],"tags":["politika","Sovětský svaz","1987"],"date":"1987","timeline":"1987","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/1179813-perestrojka-gorbacov-poprve-navstivil-prahu-cechy-a-slovaky-ale-zklamal","image_id":"128","image_source":"ČTK","type":"a","category":5},"a-5-23":{"id":"23","title":"Charta 77: Komu tím sloužili? Socialismu ne….","topic":["společnost"],"subtopic":["Charta 77"],"tags":["Charta 77","underground"],"date":"1977","timeline":"1977","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1200397-charta-77-komu-tim-slouzili-socialismu-ne","image_id":"129","image_source":"ČT24","type":"a","category":5},"a-5-24":{"id":"24","title":"1977: Výbuch na Dole Čs. armády nepřežilo 31 havířů","topic":["společnost"],"subtopic":[""],"tags":["těžba","hospodářství","1977"],"date":"1977","timeline":"1977","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/2062050-1977-z-horniku-zbyly-jen-znamky-vybuch-na-dole-cs-armady-neprezilo-31-haviru","image_id":"130","image_source":"ČTK","type":"a","category":5},"a-5-25":{"id":"25","title":"Metro A slaví narozeniny, výročí připomněla historická souprava","topic":["společnost"],"subtopic":[""],"tags":["doprava","stavby","1978"],"date":"1978","timeline":"1978","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/2208532-metro-a-slavi-narozeniny-vyroci-pripomina-historicka-souprava","image_id":"131","image_source":"ČTK","type":"a","category":5},"a-5-26":{"id":"26","title":"Tým chirurga Kočandrle v Československu poprvé transplantoval srdce","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["zdravotnictví","věda"],"date":"1984","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2072402-zemrel-chirurg-kocandrle-vedl-tym-ktery-v-ceskoslovensku-poprve-transplantoval-srdce","image_id":"132","image_source":"ČTK","type":"a","category":5},"a-5-27":{"id":"27","title":"Další živá pochodeň - Jan Zajíc","topic":["politika"],"subtopic":["živé pochodně"],"tags":["sebeupálení","1969","Varšavská smlouva"],"date":"1969","timeline":"1969","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1419787-dalsi-ziva-pochoden-jan-zajic","image_id":"91","image_source":"ČT24","type":"a","category":5},"a-5-28":{"id":"28","title":"Palachova oběť je velmi silná součást našich dějin, řekl Sobotka","topic":["politika"],"subtopic":["živé pochodně"],"tags":["pohřeb","sebeupálení","1969","Varšavská smlouva"],"date":"1969","timeline":"1969","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2014432-od-palachovy-obeti-uplynulo-48-let-je-velmi-silna-soucast-ceskych-dejin-rekl-sobotka","image_id":"93","image_source":"ČTK","type":"a","category":5},"a-5-29":{"id":"29","title":"Smutné osudy idealistů z Pražského jara 1968","topic":["politika"],"subtopic":["nástup normalizace"],"tags":["KSČ","normalizace","pražské jaro"],"date":"1969","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1445843-smutne-osudy-idealistu-z-prazskeho-jara-1968","image_id":"95","image_source":"ČT24","type":"a","category":5},"a-5-30":{"id":"30","title":"Před abdikací jmenoval Husák první vládu s nekomunistickou většinou","topic":["politika"],"subtopic":[""],"tags":["prezident","politika"],"date":"1989","timeline":"1989","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ct24/domaci/1368148-pred-svou-abdikaci-jmenoval-husak-prvni-vladu-s-nekomunistickou-vetsinou","image_id":"141","image_source":"ČT24","type":"a","category":5},"a-5-31":{"id":"31","title":"Listopad 1989 – i mezi komunisty byly rozdíly","topic":["politika"],"subtopic":[""],"tags":["1989","politika"],"date":"1989","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1373531-listopad-1989-i-mezi-komunisty-byly-rozdily","image_id":"146","image_source":"ČT24","type":"a","category":5},"a-6-1":{"id":"1","title":"Věčnost skončila před 25 lety: Fotografie konce sovětské okupace","topic":["politika"],"subtopic":[""],"tags":["politika","armáda","Varšavská smlouva","Sovětský svaz","1991"],"date":"1991","timeline":"1991","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1824179-vecnost-skoncila-pred-25-lety-fotografie-ukazuji-konec-sovetske-okupace","image_id":"133","image_source":"Dana Kyndrová","type":"a","category":6},"a-6-2":{"id":"2","title":"Krásné i strašlivé žižkovské věži je pětadvacet. A dál poutá pozornost","topic":["společnost"],"subtopic":[""],"tags":["architektura","stavby","1992"],"date":"1992","timeline":"1992","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/2037936-krasne-i-straslive-zizkovske-vezi-je-petadvacet-a-dal-pouta-pozornost#articlewithopenedgallery","image_id":"134","image_source":"ČTK","type":"a","category":6},"a-6-3":{"id":"3","title":"Akce v utajení: Úředníci kolkovali bankovky ve dne v noci","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","1993"],"date":"1993","timeline":"1993","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/1463639-akce-v-utajeni-urednici-kolkovali-bankovky-ve-dne-v-noci","image_id":"135","image_source":"ČNB","type":"a","category":6},"a-6-4":{"id":"4","title":"Československo se připojilo k internetu - počátky byly pomalé","topic":["společnost"],"subtopic":[""],"tags":["technika","internet","1991"],"date":"1991","timeline":"1991","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/media/1421167-ceskoslovensko-se-pripojilo-k-internetu-pocatky-byly-pomale","image_id":"136","image_source":"ČT24","type":"a","category":6},"a-6-5":{"id":"5","title":"Kupónová privatizace: Udělat z každého Čecha akcionáře","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","1991"],"date":"1991","timeline":"1991","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/1240293-kuponova-privatizace-experiment-ktery-mel-udelat-z-kazdeho-cecha-akcionare","image_id":"137","image_source":"ČT24, isifa","type":"a","category":6},"a-6-6":{"id":"6","title":"Jak se Gottwaldov přejmenoval zpátky na Zlín","topic":["společnost"],"subtopic":[""],"tags":["politika","1990"],"date":"1990","timeline":"1990","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ct24/regiony/1367121-jak-se-gottwaldov-prejmenoval-zpatky-na-zlin","image_id":"138","image_source":"ČT24","type":"a","category":6},"a-6-7":{"id":"7","title":"Ústecká Matiční ulice - spor mezi Čechy a Romy","topic":["společnost"],"subtopic":[""],"tags":["menšiny","rasismus","1999"],"date":"1999","timeline":"1999","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1379881-ustecka-maticni-ulice-spor-mezi-cechy-a-romy","image_id":"139","image_source":"ČT24","type":"a","category":6},"a-6-8":{"id":"8","title":"Kupónová privatizace: Geniální, nebo jen sporný tah? ","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","1991"],"date":"1991","timeline":"1991","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/1947632-genialni-nebo-jen-sporny-tah-pred-ctvrtstoletim-zacala-kuponova-privatizace","image_id":"140","image_source":"ČTK","type":"a","category":6},"a-6-9":{"id":"9","title":"Tištěné Zlaté stránky končí, pohřbil je internet","topic":["společnost"],"subtopic":[""],"tags":["technika","internet","1992"],"date":"1992","timeline":"1992","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/1008654-tistene-zlate-stranky-konci-pohrbil-je-internet","image_id":"142","image_source":"Mediatel","type":"a","category":6},"a-6-10":{"id":"10","title":"Kauza přípravy vraždy Sabiny Slonkové","topic":["politika"],"subtopic":[""],"tags":["politka","2002"],"date":"2002","timeline":"2002","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1447391-kauza-pripravy-vrazdy-sabiny-slonkove","image_id":"143","image_source":"ČT24","type":"a","category":6},"a-6-11":{"id":"11","title":"Konec společného státu: Klaus s Mečiarem rozdělili federaci","topic":["politika","Slovensko"],"subtopic":["strany a vlády"],"tags":["politika","Slovensko","1992"],"date":"1992","timeline":"1992","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1428375-klaus-s-meciarem-nakonec-rozdelili-federaci-kapitola-spolecneho-statu-uzavrena","image_id":"144","image_source":"ČTK","type":"a","category":6},"a-6-12":{"id":"12","title":"Demokracii pomáhali budovat studenti, disidenti i herci","topic":["politika"],"subtopic":[""],"tags":["politika"],"date":"1989","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ct24/domaci/1373342-rodici-se-demokracii-pomahali-budovat-nejen-studenti-ale-i-disidenti-a-herci","image_id":"145","image_source":"ČT24","type":"a","category":6},"a-6-13":{"id":"13","title":"Vystěhování Romů ze Vsetína se zřejmě nevyplatilo","topic":["společnost"],"subtopic":[""],"tags":["menšiny","rasismus","2006"],"date":"2006","timeline":"2006","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1264859-vystehovani-romu-ze-vsetina-se-zrejme-nevyplatilo","image_id":"147","image_source":"ČT24","type":"a","category":6},"a-6-14":{"id":"14","title":"Členství v NATO je pro Česko nadějí i závazkem","topic":["politika"],"subtopic":[""],"tags":["politika","armáda","NATO","1999"],"date":"1999","timeline":"1999","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1417417-clenstvi-v-nato-je-pro-cesko-nadeji-i-zavazkem","image_id":"148","image_source":"ČT24","type":"a","category":6},"a-6-15":{"id":"15","title":"Češi měli problém plně podpořit letecké útoky na Jugoslávii","topic":["politika"],"subtopic":[""],"tags":["politika","armáda","NATO","1999"],"date":"1999","timeline":"1999","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/archiv/1415885-cesi-meli-problem-plne-podporit-letecke-utoky-na-jugoslavii","image_id":"149","image_source":"ČT24","type":"a","category":6},"a-6-16":{"id":"16","title":"Soud udělil Koženému deset let ve vězení","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","2010"],"date":"2010","timeline":"2010","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1330580-soud-udelil-kozenemu-deset-let-ve-vezeni","image_id":"150","image_source":"ČT24","type":"a","category":6},"a-6-17":{"id":"17","title":"Čeští politici na pohřbu Dubčeka mlčeli","topic":["politika"],"subtopic":[""],"tags":["politika","pohřeb","1992"],"date":"1992","timeline":"1992","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2296714-s-dubcekem-umiralo-i-ceskoslovensko-cesti-politici-na-pohrbu-mlceli","image_id":"151","image_source":"ČTK","type":"a","category":6},"a-6-18":{"id":"18","title":"Mečiar: Česká delegace nám dala lekci","topic":["politika"],"subtopic":["strany a vlády"],"tags":["politika","1992"],"date":"1992","timeline":"1992","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2220892-meciar-ceska-delegace-nam-dala-lekci-byl-v-ni-jeden-dobry-jeden-zly-a-klaus","image_id":"152","image_source":"ČTK","type":"a","category":6},"a-6-19":{"id":"19","title":"Leksellův gama nůž zachránil život dvanáctiletému chlapci","topic":["společnost"],"subtopic":[""],"tags":["zdravotnictví","věda","1992"],"date":"1992","timeline":"1992","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1138164-lekselluv-gama-nuz-zachranil-zivot-dvanactiletemu-chlapci","image_id":"153","image_source":"homolka.cz","type":"a","category":6},"a-6-20":{"id":"20","title":"1992: Zemřel kardinál Tomášek","topic":["společnost"],"subtopic":[""],"tags":["církev","1992"],"date":"1992","timeline":"1992","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2201221-od-smrti-kardinala-tomaska-uplynulo-ctvrt-stoleti-doba-je-jina-jeho-vyznam-ale","image_id":"154","image_source":"ČTK","type":"a","category":6},"a-6-21":{"id":"21","title":"Opoziční smlouva 15 let poté: Signatáři podpisů nelitují","topic":["politika"],"subtopic":["strany a vlády"],"tags":["politika","volby","1998"],"date":"1998","timeline":"1998","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1086775-opozicni-smlouva-15-let-pote-signatari-podpisu-nelituji","image_id":"180","image_source":"Zdroj: ČTK, autor: Thomová-Mauerová Judita","type":"a","category":6},"a-7-1":{"id":"1","title":"ČR je velmocí v nanovláknech. Díky zarputilosti jednoho vědce","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["hospodářství","věda","technika"],"date":"2005","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/veda/2275525-ceska-republika-se-stala-velmoci-v-nanovlaknech-diky-zarputilosti-jednoho-vedce","image_id":"155","image_source":"Oldřich Jirsák, HPC","type":"a","category":7},"a-7-2":{"id":"2","title":"Nejen lithium. Pod ČR leží pozoruhodné nerostné bohatství","topic":["hospodářství"],"subtopic":[""],"tags":["těžba","hospodářství"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/2280223-cesko-nema-jen-lithium-zabodovat-muze-i-lozisky-wolframu-nebo-tantalu","image_id":"156","image_source":"ČTK","type":"a","category":7},"a-7-3":{"id":"3","title":"Propojení Odry, Labe a Dunaje má jasnější kontury","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","doprava","stavby","ekologie"],"date":"2017","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/regiony/2137392-propojeni-odry-labe-a-dunaje-ma-jasnejsi-kontury","image_id":"157","image_source":"DPA","type":"a","category":7},"a-7-4":{"id":"4","title":"CzechTek 2005 na Tachovsku - zásah, který vyvolal silnou vlnu kritiky","topic":["společnost"],"subtopic":[""],"tags":["politika","hudba","2005"],"date":"2005","timeline":"2005","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/1446599-czechtek-2005-na-tachovsku-zasah-ktery-vyvolal-silnou-vlnu-kritiky","image_id":"158","image_source":"ČT24","type":"a","category":7},"a-7-5":{"id":"5","title":"Vepřín v Letech bude zbourán. Vláda definitivně schválila jeho odkup","topic":["společnost"],"subtopic":[""],"tags":["menšiny","holocaust","2017"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2216758-vlada-schvalila-odkup-veprina-v-letech-kde-staval-koncentracni-tabor","image_id":"159","image_source":"ČTK","type":"a","category":7},"a-7-6":{"id":"6","title":"Brutalismus na odstřel: Transgas za památku neprohlásí","topic":["společnost"],"subtopic":[""],"tags":["architektura","umění","stavby","2017"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/2309662-brutalismus-na-odstrel-ministerstvo-kultury-transgas-za-pamatku-neprohlasi","image_id":"160","image_source":"ČTK","type":"a","category":7},"a-7-7":{"id":"7","title":"Češi, setřete slzu, o půlnoci končí poslední haléře","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","finance","2008"],"date":"2008","timeline":"2008","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/1443552-cesi-setrete-slzu-o-pulnoci-konci-posledni-halere","image_id":"161","image_source":"ČT24","type":"a","category":7},"a-7-8":{"id":"8","title":"Petr Pavel bude novým šéfem Vojenského výboru NATO","topic":["společnost"],"subtopic":[""],"tags":["armáda","NATO","2014"],"date":"2014","timeline":"2014","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/1016992-petr-pavel-bude-novym-sefem-vojenskeho-vyboru-nato","image_id":"162","image_source":"ČT24","type":"a","category":7},"a-7-9":{"id":"9","title":"Jíst, pít, pochlubit se na síti. Cestovatelské nadšení mění hotely","topic":["společnost"],"subtopic":[""],"tags":["internet","cestování"],"date":"2015","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/2312674-jist-pit-pochlubit-se-na-siti-cestovatelske-nadseni-milenialu-meni-pristup-hotelu","image_id":"163","image_source":"ČTK/AP","type":"a","category":7},"a-7-10":{"id":"10","title":"Velitel divize NATO: Zrušení vojny byla chyba","topic":["společnost"],"subtopic":[""],"tags":["armáda","NATO"],"date":"2005","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2312650-zruseni-vojny-byla-strategicka-chyba-narodni-hrdost-cechu-je-mala-rika-velitel-divize","image_id":"164","image_source":"ČT24","type":"a","category":7},"a-7-11":{"id":"11","title":"Internet zažívá nájezd seniorů","topic":["společnost"],"subtopic":[""],"tags":["internet"],"date":"2017","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/media/2308546-internet-zaziva-najezd-senioru-prudce-roste-i-jejich-aktivita-na-socialnich-sitich","image_id":"165","image_source":"ČSÚ","type":"a","category":7},"a-7-12":{"id":"12","title":"Čínskou návštěvu oslavil i Krteček","topic":["společnost"],"subtopic":[""],"tags":["film","politika","Čína"],"date":"2016","timeline":"2016","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1739569-cinskou-navstevu-oslavil-i-krtecek-podle-famu-je-prodej-figurky-nestastny","image_id":"166","image_source":"ČTK","type":"a","category":7},"a-7-13":{"id":"13","title":"Z Česka vyrazil první přímý nákladní vlak do Číny","topic":["hospodářství"],"subtopic":[""],"tags":["Čína","politika","doprava","hospodářství","2017"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/2185507-z-ceska-vyrazil-prvni-primy-nakladni-vlak-do-ciny-spoji-prahu-s-mestem-i-wu","image_id":"167","image_source":"ČTK","type":"a","category":7},"a-7-14":{"id":"14","title":"Blob není. A rejnok? Architekt Kaplický zemřel před 5 lety","topic":["společnost"],"subtopic":[""],"tags":["architektura","stavby","2006"],"date":"2006","timeline":"2006","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/1053656-blob-neni-a-rejnok-architekt-kaplicky-zemrel-pred-5-lety","image_id":"168","image_source":"ČTK","type":"a","category":7},"a-7-15":{"id":"15","title":"Soudkyně dala Ztohoven za výměnu standarty podmínky","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["umění","politika","2017"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2077275-soudkyne-dala-ztohoven-za-vymenu-standarty-podminky-byt-sama-s-rozsudkem-nesouhlasi","image_id":"169","image_source":"ČTK","type":"a","category":7},"a-7-16":{"id":"16","title":"Podíl hotovostních plateb v Česku bude zřejmě dále klesat","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","finance","2017"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/2109680-podil-hotovostnich-plateb-v-cesku-bude-zrejme-dale-klesat-odhaduje-komercni-banka","image_id":"170","image_source":"ČTK","type":"a","category":7},"a-7-17":{"id":"17","title":"Věra Jourová: Me Too. I já jsem byla obětí sexuálního násilí.","topic":["společnost"],"subtopic":[""],"tags":["feminismus","2017"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/svet/2277712-i-ja-jsem-byla-obeti-sexualniho-nasili-rekla-eurokomisarka-jourova-podporila-soucasnou","image_id":"171","image_source":"ČTK","type":"a","category":7},"a-7-18":{"id":"18","title":"Prague Pride: „Zbytečný festival“ upozorňuje na diskriminaci gayů","topic":["společnost"],"subtopic":[""],"tags":["menšiny","2017"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2204245-v-praze-startuje-prague-pride-zbytecny-festival-letos-upozornuje-na-diskriminaci-gayu","image_id":"172","image_source":"ČTK","type":"a","category":7},"a-7-19":{"id":"19","title":"Zemřel kardinál Miloslav Vlk. Pohřben bude v katedrále sv. Víta","topic":["společnost"],"subtopic":[""],"tags":["církev","2017"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2040054-zemrel-kardinal-miloslav-vlk-pohrben-bude-v-krypte-katedraly-sv-vita","image_id":"173","image_source":"ČTK","type":"a","category":7},"a-7-20":{"id":"20","title":"Sedláček: Z fondů EU opravujeme školy, ale eura se bojíme","topic":["hospodářství"],"subtopic":[""],"tags":["Evropská unie","hospodářství","finance"],"date":"2006","timeline":"","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/ekonomika/2153166-z-evropskych-fondu-opravujeme-skoly-ale-eura-se-bojime-kritizuje-ekonom-sedlacek","image_id":"174","image_source":"ČT24","type":"a","category":7},"a-7-21":{"id":"21","title":"Poslední soudní slovo: Madona z Veveří nepatří státu, ale církvi","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["umění","církev"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/2064274-posledni-soudni-slovo-madona-z-veveri-nepatri-statu-ale-cirkvi","image_id":"175","image_source":"ČTK","type":"a","category":7},"a-7-22":{"id":"22","title":"Pithart: Češi ztrácí schopnost žít s jinými","topic":["společnost"],"subtopic":[""],"tags":["2017","politika","Slovensko"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2314135-pithart-petadvacet-let-po-rozpadu-ceskoslovenska-ztraci-cesi-schopnost-zit-s-jinymi","image_id":"176","image_source":"ČTK","type":"a","category":7},"a-7-23":{"id":"23","title":"Nepiš dál. Marta Kubišová se loučí, nestačí jen Modlitba","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["umění","hudba","perzekuce","Charta 77","1968"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/kultura/2290486-nepis-dal-marta-kubisova-se-louci-naposled-uslysi-jeji-zpev-rodne-mesto","image_id":"105","image_source":"youtube","type":"a","category":7},"a-7-24":{"id":"24","title":"Zrušení ministra pro lidská práva","topic":["společnost"],"subtopic":[""],"tags":["společnost","menšiny","2017"],"date":"2017","timeline":"2017","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2342344-zrusenim-ministra-pro-lidska-prava-dala-vlada-najevo-ze-ji-tema-nezajima-tvrdi","image_id":"182","image_source":"","type":"a","category":7},"a-7-25":{"id":"25","title":"Ledecká má zlatý double z Pchjongčchangu","topic":[""],"subtopic":[""],"tags":["sport","olympiáda","2018"],"date":"2018","timeline":"2018","gpsn":"","gpse":"","link":"https://sport.ceskatelevize.cz/clanek/olympijske-hry/pchjongcchang-2018/ledecka-dosahla-na-olympijskou-nesmrtelnost-ma-zlaty-double-z-pchjongcchangu/5bca239659841d79e18ab7a8","image_id":"183","image_source":"ČTK/AP","type":"a","category":7},"a-7-26":{"id":"26","title":"Po celodenním maratonu má Babišova druhá vláda důvěru","topic":[""],"subtopic":[""],"tags":["politika","2018"],"date":"2018","timeline":"2018","gpsn":"","gpse":"","link":"https://ct24.ceskatelevize.cz/domaci/2534680-po-celodennim-maratonu-ma-babisova-druha-vlada-duveru","image_id":"184","image_source":"ČTK","type":"a","category":7},"a-7-27":{"id":"27","title":"Skončil XVI. všesokolský slet, zúčastnilo se na 15 tisíc cvičenců","topic":[""],"subtopic":[""],"tags":["sport","2018"],"date":"2018","timeline":"2018","gpsn":"","gpse":"","link":"https://sport.ceskatelevize.cz/clanek/ostatni/xvi-vsesokolsky-slet-je-minulosti-v-edenu-zarilo-na-15-tisic-cvicencu/5bca0f7559841d79e18a9b7e","image_id":"185","image_source":"ČTK","type":"a","category":7},"v-0-1":{"id":"1","title":"Masaryk: mýtus nebo kult?","topic":["politika"],"subtopic":["zakladatelé"],"tags":["politik","prezident","Masaryk","1918"],"date":"1918","timeline":"1918–1937","gpsn":"","gpse":"","desc":"Tomáš Garrigue Masaryk - netradiční pohled na politika a prezidenta, jenž byl jedněmi milován a druhými zatracován.","index":"557574","idec":"400 213 10001/1005","bonus":"","sidp":"","director":"Večeřa Jaroslav","type":"v","category":0},"v-0-2":{"id":"2","title":"Sedmidenní válka o Těšínsko","topic":["politika"],"subtopic":["boj o nezávislost"],"tags":["Polsko","1919","armáda","konflikt"],"date":"1919","timeline":"1918–1920","gpsn":"49.7461331","gpse":"18.6261314","desc":"Bohatá průmyslová oblast Těšínska na pomezí Československa a Polska sehrála v historii významnou roli. Spory o toto území vyvrcholily v roce 1919 tzv. Sedmidenní valkou. Proč šlo o tak problematické území a jak byl spor vyřešen?","index":"558143","idec":"209 452 80140/0034","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":0},"v-0-3":{"id":"3","title":"Muži 28. října","topic":["politika"],"subtopic":["zakladatelé"],"tags":["politika","1918","Švehla","Rašín"],"date":"1918","timeline":"1918","gpsn":"50.0876194","gpse":"14.4282411","desc":"V Pánském českém klubu v pražském Obecním domě se dne 28. října 1918 sešla pětice mužů, aby vytvořila první dokument samostatného československého státu. Tímto prvním zákonem nový stát převzal moc a jeho autoři později vstoupili ve známost jako Muži 28.října.","index":"558563","idec":"207 562 23051/0001","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":0},"v-0-4":{"id":"4","title":"Českoslovenští legionáři","topic":["politika"],"subtopic":["boj o nezávislost"],"tags":["armáda","legionáři"],"date":"1918","timeline":"1918–1929","gpsn":"","gpse":"","desc":"Úspěchy legionářů, předchůdců stálé československé armády, fakticky umožnily spojenectví Francie a ČSR, a získaly mladému státu mezinárodní prestiž. Jaká však byla jejich úloha v mladé republice?","index":"558570","idec":"214 411 03322/0011","bonus":"","sidp":"","director":"Karadžos Charilaos, Podlipný Jiří","type":"v","category":0},"v-0-5":{"id":"5","title":"Kadaňský masakr","topic":["společnost"],"subtopic":["menšiny"],"tags":["Němci","armáda","demonstrace","1919","Sudety","konflikt"],"date":"1919","timeline":"1919","gpsn":"50.3759833","gpse":"13.2713078","desc":"Nově založené Československo bylo mnohonárodnostním státem, v němž ne všichni občané změnu vítali. Zejména v pohraničních oblastech se často demonstrovalo a protestovalo proti nové republice. Dne 4. března 1919 se v Kadani odehrál tragický incident německých demonstrantů s československými vojáky. Proč k němu vlastně došlo?","index":"562514","idec":"402 213 10008/1017","bonus":"","sidp":"","director":"Procházka Jindřich","type":"v","category":0},"v-0-6":{"id":"6","title":"Ruská pomocná akce","topic":["společnost"],"subtopic":["menšiny"],"tags":["imigranti","1921","menšiny"],"date":"1921","timeline":"1921–1945","gpsn":"","gpse":"","desc":"V roce 1921 zorganizovalo Československo humanitární \"ruskou pomocnou akci\". V jejím rámci nabídlo pomoc a azyl tisícům imigrantů z Ruska, kteří se po bolševické revoluci a občanské válce ocitli v nebezpečí.","index":"558798","idec":"211 452 80140/0022 ","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":0},"v-0-7":{"id":"7","title":"Podkarpatská Rus","topic":["společnost"],"subtopic":["menšiny"],"tags":["Podkarpatská Rus","Československo","Rusíni","1919","menšiny"],"date":"1919","timeline":"1919–1938","gpsn":"48.6223503","gpse":"22.3021256","desc":"Podkarpatská Rus byla roku 1919 připojena k Československu a byla jeho součástí až do roku 1938. Působení Čechoslováků na Podkarpatské Rusi je dodnes vnímáno jako éra hospodářského růstu a všeobecného rozkvětu a stopy této doby jsou zde dodnes patrné. Jaký je současný život obyvatel tohoto uzemí a jejich vztah k České republice a češtině?","index":"558795","idec":"211 562 26012/0034","bonus":"","sidp":"","director":"Vašíček Roman","type":"v","category":0},"v-0-8":{"id":"8","title":"Konflikty v pohraničí: Němci v ČSR po vzniku republiky","topic":["společnost"],"subtopic":["menšiny"],"tags":["Němci","Sudety","1919","menšiny","konflikt"],"date":"1919","timeline":"1919","gpsn":"","gpse":"","desc":"Národnostní a sociální nepokoje a konflikty v československém pohraničí vyvrcholily násilím při demonstracích v březnu 1919. Jaké byly jejich příčiny a následky?","index":"559959","idec":"211 452 80140/0015","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":0},"v-0-9":{"id":"9","title":"Olympiáda v Antverpách 1920","topic":["sport"],"subtopic":[""],"tags":["sport","hokej","olympiáda","1920"],"date":"1920","timeline":"1920","gpsn":"51.2211097","gpse":"4.3997081","desc":"Byly to první olympijské hry po skončení první světové války. Českoslovenští hokejisté v Antverpách poprvé rezprezentovali svůj samostatný stát a odvezli si z nich bronzovou medaili.","index":"333204","idec":"214 471 29029/0021 ","bonus":"","sidp":"","director":"Sluka Štěpán","type":"v","category":0},"v-0-10":{"id":"10","title":"Vyhlášení Československa","topic":["politika"],"subtopic":["boj o nezávislost"],"tags":["politika","1918"],"date":"1918","timeline":"1918","gpsn":"","gpse":"","desc":"Jak a proč vzniklo samostatné Československo? Humorně zpracované animované podání vzniku československé republiky a jejích institucí.","index":"558802","idec":"211 543 11623/0095","bonus":"","sidp":"","director":"Koutský Pavel","type":"v","category":0},"v-0-11":{"id":"11","title":"Slovenská republika rad","topic":["politika"],"subtopic":["boj o nezávislost"],"tags":["Maďarsko","1919","konflikt","Slovensko","menšiny","komunismus","armáda"],"date":"1919","timeline":"1919","gpsn":"48.9926500","gpse":"21.2436400","desc":"První pokus o vytvoření komunistického státu na území Československa se odehrál již v červnu 1919 v Prešově jako Slovenská republika rad (SRR). Šlo o dočasný státní útvar, který byl založen na základě výpadů vojsk Maďarské republiky rad na slovenské území. Slovenská republika rad, která měla ambici fungovat jako diktatura proletariátu, ovšem neměla dlouhého trvání - již v červenci 1919 bylo území SRR opět obsazeno československými vojenskými jednotkami.","index":"80838","idec":"209 411 00037/0616","bonus":"","sidp":"","director":"","type":"v","category":0},"v-0-12":{"id":"12","title":"Jaroslav Heyrovský","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["Nobelova cena","chemie","věda"],"date":"1923","timeline":"1890-1967","gpsn":"","gpse":"","desc":"Kdo byl Jaroslav Heyrovský, první český nositel Nobelovy ceny, objevitel polarografie a jeden z nejvýznamnějších československých vědců?","index":"559141","idec":"213 411 00036/0015","bonus":"","sidp":"","director":"Dufek Jan","type":"v","category":0},"v-0-13":{"id":"13","title":"Jože Plečnik a Josef Fanta: Architekti ve službách první republiky","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["stavby","architektura","umění"],"date":"1928","timeline":"","gpsn":"","gpse":"","desc":"Nově vzniklá republika si žádala nové budovy. Jejich plánování a výstavby se ujali přední architekti nejen domácí, ale i zahraniční. Tyto stavby často dodnes slouží svým účelům a staly se přirozenou součástí novodobé tváře Prahy.","index":"558803","idec":"211 563 23520/0013","bonus":"","sidp":"","director":"Novák Jiří","type":"v","category":0},"v-0-14":{"id":"14","title":"Nové architektonické směry a proudy","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["architektura","umění","stavby"],"date":"1928","timeline":"","gpsn":"","gpse":"","desc":"Nový demokratický systém přinesl i rozvoj nových uměleckých směrů jako kubismus, art deco, konstruktivismus nebo funkcionalismus. Jak se moderní architektura odrazila v budovách moderní Prahy?","index":"561679","idec":"207 562 23051/0006","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":0},"v-0-15":{"id":"15","title":"Divadlo za první republiky","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["umění","divadlo"],"date":"1925","timeline":"1920-1938","gpsn":"","gpse":"","desc":"Prvorepublikové divadlo hrálo v tehdejší společnosti významnou roli. Hlavní trendy utvářely zejména pražské scény, Národní divadlo, Stavovské divadlo, Osvobozené divadlo nebo divadlo E.F. Buriana.","index":"561698","idec":"207 562 23051/0002","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":0},"v-0-16":{"id":"16","title":"První republika a počátky filmu","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["umění","kinematografie","film"],"date":"1929","timeline":"1918-1929","gpsn":"","gpse":"","desc":"Erotikon, Extáze nebo Tonka Šibenice. To jsou názvy nejslavnějších československých filmů 20. let. Mnohé z nich se staly ikonickými snímky nejen české kinematografie.","index":"561764","idec":"207 562 23051/0004","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":0},"v-0-17":{"id":"17","title":"Vzpomínka na bratry Čapkovy","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["Čapek","literatura","výtvarné umění","žurnalistika","umění"],"date":"1922","timeline":"","gpsn":"","gpse":"","desc":"Bratři Čapkové - jeden malíř, druhý spisovatel, oba významné osobnosti kultury první republiky. V dobách totalitních byli jako velcí demokraté zatracovaní, v časech svobody byli oslavovaní. Podívejte se na připomínku obou z roku 1946.","index":"267337","idec":"210 452 80135/0037","bonus":"","sidp":"","director":"Poledne Aleš","type":"v","category":0},"v-0-18":{"id":"18","title":"KSČ","topic":["politika"],"subtopic":[""],"tags":["KSČ","komunismus","1921"],"date":"1921","timeline":"1921","gpsn":"","gpse":"","desc":"Komunistická strana Československa vznikla v roce 1921 jako odštěpená ultralevicová část sociálně demokratické strany. Jejím prvním předsedou byl zvolen Václav Šturc.","index":"559298","idec":"211 452 80140/0018","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":0},"v-0-19":{"id":"19","title":"Tomáš Baťa a jeho závody","topic":["hospodářství"],"subtopic":[""],"tags":["obuv","Baťa","export"],"date":"1927","timeline":"","gpsn":"49.2266542","gpse":"17.6663339","desc":"„Lépe dobrým ševcem, nežli špatným králem“ - portrét obuvníka ze Zlína, který svým podnikáním dobyl celý svět. ","index":"529287","idec":"217 562 23500/0007","bonus":"","sidp":"","director":"Hackenschmied Hanuš, Sládek Jan","type":"v","category":0},"v-0-20":{"id":"20","title":"Masarykova univerzita v Brně","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["vzdělávání","Masaryk","1919"],"date":"1919","timeline":"1919","gpsn":"49.1988242","gpse":"16.6052267","desc":"I zásluhou prezidenta Masaryka vznikla v roce 1919 druhá československá univerzita - Masarykova univerzita v Brně. Během téměř sto let let existence jí prošlo již více než 200 000 absolventů.","index":"305112","idec":"314 281 38199/0128","bonus":"","sidp":"","director":"Grégr Tomáš, Špička Michael","type":"v","category":0},"v-0-21":{"id":"21","title":"Rodinný život TGM","topic":["společnost"],"subtopic":[""],"tags":["Masaryk","prezident"],"date":"1920","timeline":"","gpsn":"","gpse":"","desc":"Tomáš Gariggue Masaryk byl aktivní nejen v politice, ale i v rodinném životě. Své americké manželce Charlottě značně pomáhal při výchově čtyř dětí i chodu domácnosti.","index":"559684","idec":"202 324 24400/0001","bonus":"","sidp":"","director":"Karvánek František","type":"v","category":0},"v-0-22":{"id":"22","title":"Německé strany poprvé ve vládě","topic":["politika"],"subtopic":[""],"tags":["Švehla","1926","Němci","Sudety","volby"],"date":"1926","timeline":"1926","gpsn":"","gpse":"","desc":"Po volbách roku 1926 se rozpadla tzv. Pětka - tedy dosavadní koalice spolupracující s prezidentem Masarykem, která působila jako stabilizační faktor československé politiky. Nově vzniklá koalice přivedla do vlády poprvé také německé strany.","index":"559685","idec":"208 452 80140/0026","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":0},"v-0-23":{"id":"23","title":"Jaroslav Preiss","topic":["hospodářství"],"subtopic":[""],"tags":["žurnalistika","hospodářství"],"date":"1923","timeline":"","gpsn":"","gpse":"","desc":"Jaroslav Preiss, dnes již téměř zapomenutý československý bankéř a mecenáš, žurnalista, poslanec nejprve za Mladočechy a v nově vzniklém státě za Československou národní demokracii. Kromě jiného byl milovníkem umění a stal se ředitelem Živnostenské banky.","index":"559736","idec":"207 562 23051/0003","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":0},"v-0-24":{"id":"24","title":"Čechoslovakismus a národnostní otázka","topic":["společnost"],"subtopic":["menšiny"],"tags":["Slovensko","menšiny","Sudety","Němci"],"date":"1920","timeline":"","gpsn":"","gpse":"","desc":"Byla idea jednotného československého národa jen pouhou fikcí? Národnostní otázka jako Achillova pata první republiky. Jakou roli při pádu Československa sehrála sudetoněmecká strana pod vedením Konráda Henleina? ","index":"569434","idec":"207 562 23051/0001","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":0},"v-0-25":{"id":"25","title":"Pogrom československé armády proti Židům","topic":["společnost"],"subtopic":["menšiny"],"tags":["1918","Židé","menšiny"],"date":"1918","timeline":"1918","gpsn":"49.3333103","gpse":"17.5783208","desc":"Dým valící se z hořících domů, rabování, plenění, ničení. Kdo měl na svědomí vyvrcholení antisemitských nálad v nově vzniklém Československu? Podívejte se na dokument o holešovském pogromu v roce 1918.","index":"569438","idec":"401 213 10008/1014","bonus":"","sidp":"","director":"Novák Ján","type":"v","category":0},"v-0-26":{"id":"26","title":"Století rádia","topic":["společnost"],"subtopic":["volný čas"],"tags":["rozhlas","technika","1923","média"],"date":"1923","timeline":"1923","gpsn":"","gpse":"","desc":"Československo bylo první zemí na evropském kontinentě, která zahájila pravidelné rozhlasové vysílání, a to 18. května 1923. Od té doby rozhlas byl a je svědkem zásadních dějinných milníků naší země. ","index":"569439","idec":"209 572 23342/0002","bonus":"","sidp":"","director":"Skalický Jakub","type":"v","category":0},"v-0-27":{"id":"27","title":"Pozemková reforma 1919–1938","topic":["hospodářství"],"subtopic":[""],"tags":["1919","šlechta","církev"],"date":"1919","timeline":"1919–1938","gpsn":"","gpse":"","desc":"Téměř třicet procent zemědělské půdy vlastnila v nově vzniklém Československu šlechta a velkostatkáři, největší podíly měli Schwarzenbergové a Lichtenštejnové. Záměrem československé vlády bylo tento stav změnit a stalo se tak na základě záborového zákona z roku 1919. V jeho důsledku byly v letech 1919-1938 státem zabrány (resp. vyvlastněny) všechny zemědělské pozemky větší než 150 hektarů a všechny pozemky o celkové rozloze větší než 250 hektarů. ","index":"559083","idec":"207 452 80139/0003","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":0},"v-0-28":{"id":"28","title":" 90 let rozhlasu","topic":["společnost"],"subtopic":["volný čas"],"tags":["rozhlas","média","technika","1924"],"date":"1924","timeline":"1923","gpsn":"","gpse":"","desc":"První Haló, haló zaznělo 18. května 1923, a to v Praze-Kbelích ze stanu vypůjčeného od skautů. Jak se z improvizovaného vysílání stalo významné médium, které hrálo významnou roli v mnoha událostech dějin Československa?","index":"","idec":"213 411 00037/0517","bonus":"30012","sidp":"","director":"","type":"v","category":0},"v-0-29":{"id":"29","title":"Alois Rašín","topic":["politika"],"subtopic":["zakladatelé"],"tags":["Rašín","politika"],"date":"1923","timeline":"","gpsn":"","gpse":"","desc":"Alois Rašín je známý hlavně jako první ministr financí samostatného Československa a ekonom. Jeho život za Rakouska-Uherska a první světové války byl ale plný zvratů a dobrodružství... ","index":"","idec":"213 452 80140/0020","bonus":"29999","sidp":"","director":"Romanov Vítězslav","type":"v","category":0},"v-0-30":{"id":"30","title":"Českoslovenští legionáři","topic":["společnost"],"subtopic":[""],"tags":["legionáři","válka","armáda","Štefánik","Kutlvašr","1920"],"date":"1920","timeline":"1920","gpsn":"","gpse":"","desc":"Poslední českoslovenští legionáři se vrátili domů až roku 1920. Jejich účast v bojích na straně spojenců výrazně přispěla ke snahám TGM o samostatný stát. ","index":"","idec":"299 323 23315/0080","bonus":"30001","sidp":"","director":"Vantuch Pavel","type":"v","category":0},"v-0-31":{"id":"31","title":"Karel Kramář","topic":["politika"],"subtopic":["zakladatelé"],"tags":["Kramář","politika","premiér"],"date":"1918","timeline":"","gpsn":"","gpse":"","desc":"Karel Kramář by se rád stal prezidentem, musí se ale spokojit \"jen\" s funkcí předsedy vlády a poslance. Na konci života se stane zahořklým člověkem, který trpí pocitem neuznání.  ","index":"","idec":"210 411 00037/1227","bonus":"30004","sidp":"","director":"","type":"v","category":0},"v-0-32":{"id":"32","title":"Zábavní a sportovní park Eden","topic":["společnost"],"subtopic":["volný čas"],"tags":["zábava","architektura","1922"],"date":"1922","timeline":"1922","gpsn":"50.0668564","gpse":"14.4685378","desc":"V roce 1922 vznikl v Praze po vzoru vídeňského Prátru obrovský moderní zábavní park, ve kterém se nacházela mimo jiné i horská dráha dlouhá 5 kilometrů. Park plný nevídaných atrakcí se stal oblíbeným výletním cílem nejen Pražanů. Po druhé světová válce ale prvorepublikový Eden upadl v zapomnění.","index":"","idec":"212 411 05823/0019","bonus":"30010","sidp":"","director":"","type":"v","category":0},"v-0-33":{"id":"33","title":"Skauting","topic":["společnost"],"subtopic":["volný čas"],"tags":["skauting","příroda","mládež"],"date":"1919","timeline":"","gpsn":"","gpse":"","desc":"Na počátku 20. století vzniklo v Anglii díky Robertu Baden-Powellovi skautské hnutí. Jak se skauting zakládal u nás? Kdo byl Antonín Benjamin Svojsík a kdy se u nás konal první skautský tábor?","index":"","idec":"207 452 80128/0019 ","bonus":"30007","sidp":"","director":"Křístek Václav","type":"v","category":0},"v-0-34":{"id":"34","title":"Edvard Beneš a Versailleská mírová smlouva","topic":["politika"],"subtopic":["boj o nezávislost"],"tags":["Beneš","1918","politika"],"date":"1918","timeline":"1918–1948","gpsn":"","gpse":"","desc":"Jaký byl Edvard Beneš politik? Jak působil Edvard Beneš za první světové války a na mírovém kongresu ve Versailles? Jaká byla jeho role při vyjednávání poválečného uspořádání Evropy a vzniku samostatného Československa?","index":"","idec":"208 452 80140/0035","bonus":"30002","sidp":"","director":"Křístek Václav","type":"v","category":0},"v-0-35":{"id":"35","title":"Práva žen na začátku století","topic":["společnost"],"subtopic":[""],"tags":["feminismus","volby","1919"],"date":"1919","timeline":"1919","gpsn":"","gpse":"","desc":"Postavení žen bylo v historii vždy poměrně složité. Jak to bylo za první republiky u nás a ve světě? Kdy a proč vznikl Mezinárodní den žen a kdy získaly ženy v Československu možnost hlasovat ve volbách?","index":"","idec":"208 411 00036/0416","bonus":"30006","sidp":"","director":"Urban Vlastimil","type":"v","category":0},"v-0-36":{"id":"36","title":"Atentát na Aloise Rašína","topic":["politika"],"subtopic":["zakladatelé"],"tags":["Rašín","1923"],"date":"1923","timeline":"1923","gpsn":"50.0835494","gpse":"14.4341414","desc":"Den 5. ledna 1923 ráno byl v Praze spáchán atentát na prvního československého ministra financí Aloise Rašína. Jak k tomu tenkrát došlo? ","index":"","idec":"205 411 00037/0105","bonus":"30188","sidp":"","director":"","type":"v","category":0},"v-0-37":{"id":"37","title":"Štefánikova smrt","topic":["politika"],"subtopic":["zakladatelé"],"tags":["Štefánik","Beneš","Masaryk","armáda","1919","legionáři","atentát","letectví"],"date":"1919","timeline":"1919","gpsn":"48.1878100","gpse":"17.2563600","desc":"Generál Milan Rastislav Štefánik se značnou mírou zasloužil o založení Československa, organizoval československé zahraniční legie a byl členem Československé národní rady. Při návratu z emigrace v květnu 1919 zahynul při letecké nehodě nedaleko Bratislavy. Kolem jeho úmrtí se dodnes objevují nejrůznější spekulace. Jak to tenkrát bylo?","index":"","idec":"213 452 80140/0011","bonus":"30009","sidp":"","director":"Romanov Vítězslav","type":"v","category":0},"v-0-38":{"id":"38","title":"Štefánik - jeho názory a odkaz","topic":["společnost"],"subtopic":[""],"tags":["Štefánik","politika","legionáři","armáda"],"date":"1919","timeline":"","gpsn":"","gpse":"","desc":"Štefánik byl významným československým politikem a generálem. Již během svého života jednou z klíčových osobností při utváření československého státu. Ještě větší vliv ale získal po své smrti, když si jeho odkaz snažily přizpůsobit různé režimy vládnoucí v Československu. Jaké však byly Štefánikovy opravdové názory na poválečný vývoj formující se republiky a jaká byla jeho vize?","index":"","idec":"213 452 80140/0011","bonus":"30008","sidp":"","director":"Romanov Vítězslav","type":"v","category":0},"v-0-39":{"id":"39","title":"Leoš Janáček ","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["hudba","umění"],"date":"1924","timeline":"","gpsn":"","gpse":"","desc":"Jen málokterý hudební skladatel byl ve svém životě tak odmítaný a posléze vyzdvihovaný, jako geniální hudební skladatel světového formátu Leoš Janáček. Podívejte se na jeho portrét. ","index":"","idec":"208 452 80128/0034","bonus":"30005","sidp":"","director":"Křístek Václav","type":"v","category":0},"v-0-40":{"id":"40","title":"Josef Pekař","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["věda","vzdělávání"],"date":"1928","timeline":"","gpsn":"","gpse":"","desc":"Život Josefa Pekaře, významného českého historika, profesora a také rektora Univerzity Karlovy. Ve svých pracech se věnoval pojetí dějin a také husitství a baroku. Zároveň byl také výraznou osobností prvorepublikové společnosti.","index":"","idec":"207 452 80128/0004","bonus":"30003","sidp":"","director":"Křístek Václav","type":"v","category":0},"v-0-41":{"id":"41","title":"František Ventura","topic":["sport"],"subtopic":[""],"tags":["sport","parkur","olympiáda","1928"],"date":"1928","timeline":"","gpsn":"","gpse":"","desc":"Původně vojenský důstojník po první světové válce absolvoval jezdeckou školu v Saumuru. Ve své sportovní kariéře se František Ventura věnoval především parkuru. V roce 1928 získal zlatou medaili na Olympijských hrách v Amsterdamu. Dodnes jde o náš jediný olympijský kov v jezdeckých sportech.","index":"594754","idec":"215 471 29029/0040","bonus":"","sidp":"","director":"Sluka Štěpán","type":"v","category":0},"v-0-42":{"id":"42","title":"Štefánikův týden 1947","topic":["společnost"],"subtopic":[""],"tags":["Štefánik","politika","legionáři","armáda","TOTO100LETÍ ve škole"],"date":"1947","timeline":"","gpsn":"","gpse":"","desc":"Štefánikův týden česko-slovenského bratrství byl slavnostně vyhlášen v únoru 1947 v Obecním domě v Praze.","index":"523127","idec":"217 411 05821/0006","bonus":"","sidp":"","director":"","type":"v","category":0},"v-1-5":{"id":"5","title":"Adolf Loos a Müllerova vila","topic":["kultura a vzdělávání"],"subtopic":["architektura"],"tags":["architektura","umění","1930","stavby"],"date":"1930","timeline":"1928–1930","gpsn":"50.0925789","gpse":"14.3784506","desc":"V pražských Střešovicích vznikla v letech 1928–1930 neobvyklá vila podle návrhů již tehdy známého architekta Adolfa Loose. Vila navržená pro rodinu stavitele Františka Műllera je skvělou ukázkou světové architektonické avantgardy, a to v duchu funkcionalismu. Podívejte se dovnitř společně se Zdeňkem Lukešem. ","index":"561692","idec":"207 562 23051/0006","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":1},"v-1-4":{"id":"4","title":"Radola Gajda a fašistický pokus o státní převrat","topic":["politika"],"subtopic":[""],"tags":["fašismus","1933","konflikt","hospodářství"],"date":"1933","timeline":"1933","gpsn":"49.2075839","gpse":"16.6426353","desc":"S nástupem ekonomické krize v Československu začala stoupat podpora Národní obce fašistické. Velkou podporu měla strana v Židenicích u Brna, proto se fašisté právě zde pokusili zahájit státní převrat. Dne 22. ledna 1933 přepadli místní kasárna, ovšem přibližně šedesát špatně vyzbrojených mužů bylo záhy poraženo. Pokus o převrat dopadl neúspěšně a Radola Gajda skončil ve vězení.","index":"559145","idec":"401 213 10008/1004","bonus":"","sidp":"","director":"Najbrt Michal","type":"v","category":1},"v-1-3":{"id":"3","title":"Mobilizace československé armády 1938","topic":["politika"],"subtopic":["krize 1938"],"tags":["1938","armáda"],"date":"1938","timeline":"1938","gpsn":"","gpse":"","desc":"Dne 23. září 1938 byla vyhlášena všeobecná mobilizace. Bylo mobilizováno 1 280 000 mužů a většina vojska se přesunula k hranicím. I přesto, že armáda byla dobře vybavená a po týdnu mobilizace akceschopná, bylo zřejmé, že bez budoucí pomoci zahraničních vojsk by se země neubránila. Po podpisu Mnichovské dohody 30. září 1938 se armáda musela stáhnout z příhraničních oblastí postoupených Německu a bylo upuštěno od dalších etap mobilizace. S konečnou platností byla demobilizace dokončena v prosinci 1938.","index":"559939","idec":"212 512 12007","bonus":"","sidp":"","director":"Sedláček Robert","type":"v","category":1},"v-1-2":{"id":"2","title":"Úmrtí TGM","topic":["politika"],"subtopic":[""],"tags":["1937","pohřeb","Masaryk","prezident"],"date":"1937","timeline":"1937","gpsn":"","gpse":"","desc":"První československý prezident T. G. Masaryk zemřel 14. září 1937 v Lánech. Jeho smrt prožívala celá země. Rozhlas vysílal pouze vážnou hudbu, konala se smuteční shromáždění, vlály černé prapory, dokonce byla zcela vyprodána černá látka. Jaké dopady mělo umrtí TGM na společnost? ","index":"558539","idec":"212 452 80140/0011","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":1},"v-1-1":{"id":"1","title":"Dopady velké hospodářské krize ve 30. letech","topic":["hospodářství"],"subtopic":[""],"tags":["1929–1934","krize"],"date":"1929","timeline":"1929–1934","gpsn":"","gpse":"","desc":"Jak dopadla světová hospodářská krize 1929 na Československo? Jaká protikrizová opatření zaváděla československá vláda?","index":"558558","idec":"208 452 80140/0025","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":1},"v-1-6":{"id":"6","title":"1929 - stalinista Gottwald ve vedení KSČ","topic":["politika"],"subtopic":[""],"tags":["KSČ","Gottwald","1929","komunismus","politika"],"date":"1929","timeline":"1929","gpsn":"","gpse":"","desc":"Od svého založení získávala komunistická strana na popularitě a v roce 1925 skončila v parlamentních volbách druhá. V roce 1929 se vedení ve straně ujali tzv. \"karlínští kluci\", v čele s Klementem Gottwaldem. Jaký byl vzestup Klementa Gottwalda k moci a jak se strana postupně bolševizovala? ","index":"558559","idec":"209 452 80140/0033","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":1},"v-1-7":{"id":"7","title":"Zahájení provozu letiště Ruzyně ","topic":["hospodářství"],"subtopic":[""],"tags":["letectví","technika","1937"],"date":"1937","timeline":"1937","gpsn":"","gpse":"","desc":"Roku 1937 přistálo na letišti Ruzyně první letadlo, letělo z Piešťan a uvedlo tím pražské letiště do plného provozu. Ještě ve stejném roce letiště otevřelo spojení s mnoha evropskými městy, jako třeba Amsterdam, Vídeň nebo Moskva. ","index":"558794","idec":"216 562 26622 ","bonus":"","sidp":"","director":"Slavík Petr","type":"v","category":1},"v-1-8":{"id":"8","title":"Osvobozené divadlo","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["divadlo","umění","1926–1938"],"date":"1930","timeline":"1926–1938","gpsn":"","gpse":"","desc":"Jiří Voskovec, Jan Werich a Jaroslav Ježek společně vytvořili v Osvobozeném divadle legendární satirická představení. Po Mnichovské dohodě však začalo být jejich působení v Československu velmi riskantní. Jak se vyvíjela jejich společná kariéra?","index":"558799","idec":"216 562 23500/0008","bonus":"","sidp":"","director":"Hackenschmied Hanuš, Sládek Jan","type":"v","category":1},"v-1-9":{"id":"9","title":"Všesokolský slet 1932","topic":["sport"],"subtopic":[""],"tags":["Strahov","sport","1932"],"date":"1932","timeline":"1932","gpsn":"50.0805614","gpse":"14.3875469","desc":"IX. všesokolský slet na Strahově oslavil 100. výročí narození svého zakladatele Miroslava Tyrše. Zúčastnilo se ho přes 188 000 cvičenců a na Strahov přišlo milión diváků.","index":"204244","idec":"212 471 29047/0003","bonus":"","sidp":"","director":"Karvánek František","type":"v","category":1},"v-1-10":{"id":"10","title":"Novinář Ferdinand Peroutka","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["žurnalistika","antisemitismus","komunismus","1948","emigrace"],"date":"1933","timeline":"1948","gpsn":"","gpse":"","desc":"Portrét liberálního novináře Ferdinanda Peroutky, vytrvalého obránce demokracie, který musel emigrovat před nacistickým i komunistickým režimem.","index":"559946","idec":"406 235 10022/1032","bonus":"","sidp":"","director":"Všelichová Petra","type":"v","category":1},"v-1-11":{"id":"11","title":"Přijímání uprchlíků ze Sudet za druhé republiky","topic":["společnost"],"subtopic":["krize 1938"],"tags":["Němci","imigrace","Sudety","1938"],"date":"1938","timeline":"1938","gpsn":"","gpse":"","desc":"V roce 1938 se začaly vyostřovat národnostní konflikty v československém pohraničí. V důsledku postoupení těchto území po podpisu Mnichovské dohody odešlo do vnitrozemí ČSR mnoho lidí. Jaká byla politika československých úřadů vůči emigrantům přichazejícím ze zabraných území?","index":"558959","idec":"208 452 80140/0038","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":1},"v-1-12":{"id":"12","title":"Masarykova abdikace a prezidentské volby","topic":["politika"],"subtopic":[""],"tags":["Masaryk","Beneš","prezident","volby","1935"],"date":"1935","timeline":"1935","gpsn":"","gpse":"","desc":"T.G.Masaryk v roce 1935 musel ze zdravotních důvodů rezignovat na prezidentský úřad. Na své místo se snažil prosadit Edvarda Beneše. Volba ale nebyla zdaleka tak snadná, jak se může zdát.","index":"559142","idec":"215 411 01010/1214","bonus":"","sidp":"","director":"Ďurica Peter, Knopp Erik Mgr.art.","type":"v","category":1},"v-1-13":{"id":"13","title":"Komik Vlasta Burian","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["divadlo","film","umění"],"date":"1932","timeline":"1891–1962","gpsn":"","gpse":"","desc":"Král komiků, tak se dodnes říká skvělému prvorepublikovému herci Vlastovi Burianovi. Byl hvězdou filmovou, ale i divadelní, založil vlastní Divadlo Vlasty Buriana. Ke všemu byl také sportovcem, brankářem fotbalové Sparty. Jaké byly jako osudy během a po druhé světové válce?","index":"523488","idec":"217 411 01010/0131","bonus":"","sidp":"","director":"Ďurica Peter","type":"v","category":1},"v-1-14":{"id":"14","title":"Maďaři jako menšina v Československu","topic":["společnost"],"subtopic":["menšiny"],"tags":["menšiny","1920","Maďarsko","Slovensko"],"date":"1920","timeline":"1920","gpsn":"","gpse":"","desc":"Trianonská smlouva ze 4. června 1920 jako jeden z mírových poválečných dokumentů, měla obrovské následky zejména pro Maďarsko, které přišlo téměř o sedmdesát procet svého území. Mnoho Maďarů se stalo také československými občany. Kolik jich bylo a jaké byly další osudy maďarské menšiny na našem území?","index":"559962","idec":"213 542 15605/0008","bonus":"","sidp":"","director":"Kristóf György","type":"v","category":1},"v-1-15":{"id":"15","title":"Skladatel Jaroslav Ježek","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["hudba","divadlo","umění"],"date":"1929","timeline":"1906–1942","gpsn":"","gpse":"","desc":"Jaroslav Ježek - geniální hudebník, skladatel a klavírista. Téměř nevidomý jazzman, který se do povědomí zapsal především jako dvorní skladatel Voskovce a Wericha.","index":"502334","idec":"216 562 23500/0028","bonus":"","sidp":"","director":"Hackenschmied Hanuš, Sládek Jan","type":"v","category":1},"v-1-16":{"id":"16","title":"Fotbalista Josef Bican","topic":["sport"],"subtopic":[""],"tags":["sport","fotbal"],"date":"1937","timeline":"1913–2001","gpsn":"","gpse":"","desc":"Josef Bican, český ale i rakouský fotbalista, hrál za Rapid i Admiru Vídeň, za rakouskou i českou reprezentaci, od roku 1937 hvězda Slavie Praha. Vstřelil 644 ligových branek a tisíce dalších v jiných soutěžích.","index":"559343","idec":"201 471 29602/0011","bonus":"","sidp":"","director":"Horal Jozef","type":"v","category":1},"v-1-17":{"id":"17","title":"Českoslovenští Němci","topic":["společnost"],"subtopic":["menšiny"],"tags":["Němci","Sudety","politika","menšiny","konflikt"],"date":"1933","timeline":"","gpsn":"","gpse":"","desc":"Jaké bylo soužití Čechů a Němců za první republiky? Začala se situace v zemi vyhrocovat až s nástupem fašistických tendencí v zahraničí, nebo v Československu panovalo jakési křehké příměří již dříve?","index":"559377","idec":"211 452 80140/0015","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":1},"v-1-18":{"id":"18","title":"Režisér Martin Frič","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["film","umění"],"date":"1931","timeline":"1902–1968","gpsn":"","gpse":"","desc":"Portrét slavného prvorepublikového režiséra Martina Friče, který natočil desítky kultovních snímků. Např. Tři vejce do skla, Kristián, Císařův pekař, Pekařův císař. Spolupracoval často s talentovanými scénáristy např. s Jiřím Brdečkou nebo s ikonickou dvojicí Voskovec a Werich.","index":"559380","idec":"217 562 23500/0015","bonus":"","sidp":"","director":"Hackenschmied Hanuš, Sládek Jan","type":"v","category":1},"v-1-19":{"id":"19","title":"Skladatel Bohuslav Martinů","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["emigrace","hudba","umění"],"date":"1937","timeline":"1890–1959","gpsn":"","gpse":"","desc":"Život a působení českého skladatele Bohuslava Martinů, rodáka z Poličky, který žil od roku 1923 nejprve ve Francii a před druhou světovou válkou emigroval do USA. Po válce se sice vrátil do Evropy, ale natrvalo se usídlil ve Švýcarsku. Jako skladatel si vydobyl světový věhlas a je jedním z předních představitelů moderní vážné hudby.","index":"559683","idec":"216 411 00012/1120","bonus":"","sidp":"","director":"","type":"v","category":1},"v-1-20":{"id":"20","title":"Architekt Jože Plečnik","topic":["kultura a vzdělávání"],"subtopic":["architektura"],"tags":["architektura","umění","stavby"],"date":"1932","timeline":"1872–1957","gpsn":"","gpse":"","desc":"David Vávra vypráví o slovinském architektovi Josipu Plečnikovi a jeho stavbách v ČR i ve Slovinsku. Ukazuje například Plečnikovy stopy na rekonstrukci Pražského hradu, unikátní kostel Nejsvětějšího Srdce Páně na pražských Vinohradech nebo Plečnikem navrženou Obchodní a průmyslovou komoru v Lublani.","index":"561729","idec":"211 522 16235/0003 ","bonus":"","sidp":"","director":"Lipus Radovan","type":"v","category":1},"v-1-21":{"id":"21","title":"Rodina Havlů a prvorepublikový film","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["film","stavby","umění"],"date":"1931","timeline":"","gpsn":"","gpse":"","desc":"Miloš Havel i jeho bratr Václav působili jako úspěšní podnikatelé v období první republiky. Václav vystavěl vilovou čtvrť na Barrandově a Miloš postavil Barrandovské ateliéry, ve kterých pomáhal vytvářet české filmy.","index":"561854","idec":"207 562 23051/0004","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":1},"v-1-22":{"id":"22","title":"Filmové hvězdy za první republiky","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["film","umění"],"date":"1935","timeline":"","gpsn":"50.0328964","gpse":"14.3898428","desc":"První republika to byly také moderní filmové ateliéry AB Barrandov podnikatele Miloše Havla. Filmy zde vzniklé produkovaly také nové filmové celebrity.  Vlasta Burian se svými komediemi proslavil nejen u nás, ale i v Německu. Rovněž Hugo Haas natočil řadu filmů. Jiří Voskovec a Jan Werich natočili např. film Hej rup, který humornou formou popisoval potíže českých občanů s ekonomickou krizí.","index":"561873","idec":"207 562 23051/0004","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":1},"v-1-23":{"id":"23","title":"Mobilizace ČSR v září 1938, jaká byla atmosféra mezi lidmi?","topic":["politika"],"subtopic":["krize 1938"],"tags":["armáda","1938","23. září 1938","válka","mobilizace"],"date":"1938","timeline":"1938","gpsn":"","gpse":"","desc":"Československo bylo v roce 1938 rozhodnuto se bránit. Armáda o síle téměř jeden a půl milionu mužů byla odhodlána čelit případnému německému útoku. Podívejte se na unikátní záběry z těch dní v pražských ulicích...","index":"569437","idec":"208 522 16151/0010","bonus":"","sidp":"","director":"Vantuch Pavel","type":"v","category":1},"v-1-24":{"id":"24","title":"Generální stávka a demonstrace 22. září 1938","topic":["společnost"],"subtopic":["krize 1938"],"tags":["1938","mobilizace","demonstrace","Sudety","armáda","válka"],"date":"1938","timeline":"1938","gpsn":"50.0899300","gpse":"14.4154419","desc":"\"Dokud máme pohraničí, republiku nám nezničí\" znělo heslo účastníků generální stávky na Václavském náměstí. O území Sudet už ale v tu chvíli s Německem tajně vyjednávali Britové a Francouzi. ","index":"569403","idec":"208 522 16151/0010","bonus":"","sidp":"","director":"Vantuch Pavel","type":"v","category":1},"v-1-25":{"id":"25","title":"Národnostní otázka Československa","topic":["společnost"],"subtopic":["menšiny"],"tags":["menšiny","Němci","Slovensko"],"date":"1929","timeline":"","gpsn":"","gpse":"","desc":"Československo bylo státem mnohonárodnostním, žili zde v jednom státě Češi, Slováci, Němci, Maďaři a další menšiny. Časem se ovšem začaly projevovat autonomistické tendence jednotlivých národů, zejména sudetských Němců a Slováků.","index":"569434","idec":"207 562 23051/0001","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":1},"v-1-26":{"id":"26","title":"Částečná mobilizace 21. května 1938","topic":["politika"],"subtopic":["krize 1938"],"tags":["1938","mobilizace","armáda"],"date":"1938","timeline":"","gpsn":"","gpse":"","desc":"Mobilizace československé armády a zároveň propagační ukázka připravenosti v době, kdy se již nad ostrovem demokracie ve střední Evropě stahovala mračna.","index":"","idec":"283 430 71775","bonus":"13477","sidp":"","director":"Najbrt Michal","type":"v","category":1},"v-1-27":{"id":"27","title":"Výstava soudobé kultury v Československu 1928","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["výstava","1928","věda","umění"],"date":"1928","timeline":"","gpsn":"","gpse":"","desc":"Deset let své existence oslavilo Československo velkolepou výstavou. Brněnské výstaviště navštívilo více než 2 miliony lidí, kteří si přišli prohlédnout úspěchy nového státu na poli architektury, techniky, vědy, vzdělávání a umění.","index":"","idec":"308 295 35029","bonus":"30018","sidp":"","director":"Vantuch Pavel","type":"v","category":1},"v-1-28":{"id":"28","title":"Květen 1938: Československá armáda v pohotovosti","topic":["politika"],"subtopic":["krize 1938"],"tags":["mobilizace","armáda","válka","1938"],"date":"1938","timeline":"","gpsn":"","gpse":"","desc":"\"Mobilisace!\" na titulních stranách všech novin. Jeden a půl milionu mužů bylo připravených čelit německému útoku.","index":"","idec":"","bonus":"30013","sidp":"","director":"Mann Ivan","type":"v","category":1},"v-1-29":{"id":"29","title":"Karlovarské požadavky Sudetoněmecké strany","topic":["politika"],"subtopic":["krize 1938"],"tags":["1938","válka","nacismus","menšiny","Sudety","Němci"],"date":"1938","timeline":"1938","gpsn":"50.2339389","gpse":"12.8604439","desc":"Na sjezdu Sudetoněmecké strany 24. dubna 1938 v Karlových Varech představil předseda Konrad Henlein tzv. Karlovarský program. Jednalo se o seznam požadavků SdP na československou vládu. Bylo možné vyhovět stupňujícím se Henleinovým požadavkům? Československo v Hitlerově hledáčku a politika appeasementu západních mocností.","index":"","idec":"291 383 60176","bonus":"30014","sidp":"","director":"Wild K.","type":"v","category":1},"v-1-30":{"id":"30","title":"Stávka horníků na Mostecku","topic":["hospodářství"],"subtopic":[""],"tags":["Gottwald","KSČ","krize","1932","demonstrace"],"date":"1932","timeline":"1932","gpsn":"","gpse":"","desc":"Jednou z nejvýraznějších reakcí na důsledky hospodářské krize u nás byla tzv. Velká mostecká stávka, která probíhala na přelomu března a dubna 1932. Hlavním efektem stávky byl zejména obrovský růst popularity komunistické strany, která se během stávek silně angažovala.","index":"","idec":"207 452 80128/0010","bonus":"30017","sidp":"","director":"Křístek Václav","type":"v","category":1},"v-1-31":{"id":"31","title":"Le Corbusier - zakladatel funkcionalismu","topic":["kultura a vzdělávání"],"subtopic":["architektura"],"tags":["architektura","umění","stavby","hospodářství"],"date":"1931","timeline":"1887–1965","gpsn":"","gpse":"","desc":"Le Corbusier byl slavným evropským architektem, zakladatelem funkcionalismu, který ovlivnil celou moderní i současnou architekturu. Jeho nejslavnějším dílem je vila Savoy v Paříži. Corbusier působil ve dvacátých letech v SSSR, kde navrhl řadu staveb. Působil také ve Zlíně a měl několik československých žáků.","index":"","idec":"214 411 01012/0615","bonus":"30015","sidp":"","director":"Ďurica Peter","type":"v","category":1},"v-1-32":{"id":"32","title":"Stavba opevnění Československa ve 30. letech","topic":["politika"],"subtopic":[""],"tags":["1935–1938","armáda","stavby"],"date":"1935","timeline":" 1935–1938","gpsn":"","gpse":"","desc":"Už od založení Československa bylo jasné, že může být potenciálně ohroženo všemi sousedními státy a bude třeba se na případný útok připravit. Po vzoru francouzské Maginotovy linie se proto v polovině 30. let začalo stavět betonové opevnění. Proč nakonec k využití opevnění ani nedošlo? ","index":"","idec":"208 452 80140/0037","bonus":"30016","sidp":"","director":"Romanov Vítězslav","type":"v","category":1},"v-1-33":{"id":"33","title":"Alois Hudec","topic":["sport"],"subtopic":[""],"tags":["olympiáda","1936","medaile","gymnastika","sokol"],"date":"1936","timeline":"1936","gpsn":"","gpse":"","desc":"Jednu ze tří zlatých medailích na olympijských hrách  v Berlíně 1936 získal pro Československo sportovní gymnasta Alois Hudec. A to přesto, že hry byly silně politicky zabarvené a rozhodčí protežovali sportovce soutěžící pod vlajkou nacistického Německa. Zejména díky výkonu na kruzích se mu ale podařilo přeskočit všechny ostatní gymnasty.","index":"594776","idec":"215 471 29029/0044","bonus":"","sidp":"","director":"Guryča Jiří","type":"v","category":1},"v-2-1":{"id":"1","title":"Fredy Hirsch nadchnul pro sport i vězně v Osvětimi","topic":["společnost"],"subtopic":["holocaust"],"tags":["antisemitismus","Terezín","Osvětim","holocaust","sport"],"date":"1944","timeline":"1916–1944","gpsn":"50.0389061","gpse":"19.1712983","desc":"Fredy Hirsch, organizátor aktivit s židovskou mládeží, který pomáhal dětem přežít v nelidském prostředí koncentračních táborů nejdříve v Terezíně a později v Osvětimi. Před odjezdem do koncentračního tábora působil zejména v Praze-Strašnicích, kde organizoval nejrůznější sportovní a kulturní akce pro diskriminované děti a mládež.","index":"560389","idec":"211 452 80139/0011","bonus":"","sidp":"","director":"Sommerová Olga doc.Mgr.","type":"v","category":2},"v-2-2":{"id":"2","title":"Josef Mašín starší","topic":["politika"],"subtopic":["odboj"],"tags":["odboj","armáda","válka","legionáři"],"date":"1942","timeline":"1896–1942","gpsn":"","gpse":"","desc":"Jeden z nejvýznamnějších českých odbojářů, příslušník odbojové organizace Tři králové, legionář a důstojník dělostřelectva Josef Mašín starší, jenž byl podle jednoho komisaře gestapa „nejstatečnější a nejrytířštější protivník, jakého kdy poznal.“","index":"560393","idec":"209 452 80124/0011","bonus":"","sidp":"","director":"Bareš Ivan, Knížek Jiří, Kudela Radek, Šantúr Roman, Vondráček David","type":"v","category":2},"v-2-3":{"id":"3","title":"Miloš Havel a barrandovské ateliéry","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["film","umění"],"date":"1940","timeline":"1921–1945","gpsn":"50.0305983","gpse":"14.3911242","desc":"Nejvýznamnější český filmový podnikatel, který vlastnil největší prvorepublikovou produkční firmu Lucernafilm. Jeho jméno je spjato se vznikem Barrandovských filmových ateliérů a rozvojem československé kinematografie v období mezi oběma světovými válkami.","index":"565157","idec":"213 411 00010/0420","bonus":"","sidp":"","director":"","type":"v","category":2},"v-2-4":{"id":"4","title":"Lidice a Ležáky","topic":["politika"],"subtopic":["perzekuce"],"tags":["odboj","1942","válka","nacismus"],"date":"1942","timeline":"1942","gpsn":"50.1435222","gpse":"14.1901258","desc":"Vypálení obce Ležáky na Chrudimsku dne 24. června 1942 bylo, stejně jako v případě obce Lidice, trestem za atentát na říšského protektora Reinharda Heydricha. Všech 33 dospělých obyvatel osady Ležáky bylo popraveno, přežily jen dvě dívky, které nacisté poslali do Německa na převýchovu.","index":"560574","idec":"217 452 80110/0618","bonus":"","sidp":"","director":"Bareš Ivan, Čížek Daniel","type":"v","category":2},"v-2-5":{"id":"5","title":"Operace Anthropoid","topic":["politika"],"subtopic":["odboj"],"tags":["odboj","atentát","válka","1942"],"date":"1942","timeline":"1942","gpsn":"","gpse":"","desc":"Operace Anthropoid, v jejímž finále výsadkáři Jan Kubiš a Jozef Gabčík provedli v pražských Kobylisích úspěšný atentát na říšského protektora Reinharda Heydricha. Ten byl považován za třetího nejvýše postaveného muže v nacistické hierarchii. Jak si ale vedly další výsadkářské odbojové skupiny na našem území?","index":"443552","idec":"215 411 00010/1229","bonus":"","sidp":"","director":"Škampa Michal","type":"v","category":2},"v-2-6":{"id":"6","title":"Československo-sovětská smlouva","topic":["politika"],"subtopic":["politická jednání"],"tags":["Beneš","SSSR","politika","1943"],"date":"1943","timeline":"1943","gpsn":"","gpse":"","desc":"V prosinci 1943 vznikla v Moskvě spojenecká smlouva mezi Československem a Sovětským svazem. Smlouvu signovali velvyslanec ČSR v Moskvě Zdeněk Fierlinger a Vjačeslav Molotov, ale podpisu byli přítomni i Edvard Beneš a Stalin. Byl podpis smlouvy ortelem pro sovětskou orientaci poválečného Československa?","index":"560952","idec":"213 452 80140/0043","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":2},"v-2-7":{"id":"7","title":"Uznání exilové vlády","topic":["politika"],"subtopic":["politická jednání"],"tags":["válka","politika","1940"],"date":"1940","timeline":"1940","gpsn":"","gpse":"","desc":"Britská vláda souhlasila se zřízením provizorní československé vlády v exilu a zároveň neuznala suverenitu vládního kabinetu v protektorátu. Jak složitá byla cesta k jejímu finálnímu uznání a jaké diplomatické kroky byly zapotřebí?","index":"561165","idec":"215 411 01010/0721","bonus":"","sidp":"","director":"Rásocha Jaroslav","type":"v","category":2},"v-2-8":{"id":"8","title":"Čechoslováci v RAF","topic":["politika"],"subtopic":["odboj"],"tags":["válka","armáda","letectví"],"date":"1940","timeline":"1939–1945","gpsn":"","gpse":"","desc":"O odvážných československých letcích, kteří pomohli zachránit Británii před Hitlerem. Do britských vojenských jednotek vstoupily během války také stovky československých vojáků, kteří byli rozhodnuti bojovat proti nacistickému Německu. Podívejte se na osudy některých z nich.","index":"560995","idec":"210 563 23025/0004","bonus":"","sidp":"","director":"Tabery Jakub","type":"v","category":2},"v-2-9":{"id":"9","title":"Holocaust Romů v protektorátu","topic":["společnost"],"subtopic":["holocaust"],"tags":["holocaust","Romové","menšiny","rasismus"],"date":"1942","timeline":"1939–1945","gpsn":"","gpse":"","desc":"Romská genocida jako opomíjená součást holocaustu? Jen na území Československa byly zřízeny dva koncentrační tábory pro Romy, v Letech u Písku a v Hodoníně u Kunštátu. Většina zdejších vězňů byla dále deportována do dalších koncentračních táborů, zejména Osvětimi, odkud se jich vrátil pouze zlomek.","index":"561172","idec":"411 236 10015/2020 ","bonus":"","sidp":"","director":"Koudela Aleš","type":"v","category":2},"v-2-10":{"id":"10","title":"Smrt Karla Čapka","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["Čapek","pohřeb","literatura","1938","umění"],"date":"1938","timeline":"1938","gpsn":"50.0647161","gpse":"14.4180161","desc":"Krátký komentář, který však vysvětluje vše podstatné o smrti Karla Čapka 25. prosince 1938 a jeho následném pohřbu. Čapkova smrt je často symbolicky považována za konec demokratického Československa a předzvěst druhé světové války.","index":"559966","idec":"206 562 23046/0002","bonus":"","sidp":"","director":"Filip Václav","type":"v","category":2},"v-2-11":{"id":"11","title":"Americký film „Krize“","topic":["společnost"],"subtopic":[""],"tags":["Sudety","Němci","krize"],"date":"1939","timeline":"1939","gpsn":"","gpse":"","desc":"Dokument Krize pojednávající o událostech roku 1939 byl natočen americkým štábem přímo v Československu. Jedná se o unikátní dobový materiál, který skvěle zachycuje společenskou atmosféru v ČSR.","index":"582826","idec":"208 452 80140/0038","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":2},"v-2-12":{"id":"12","title":"Protektorát Čechy a Morava","topic":["politika"],"subtopic":[""],"tags":["protektorát","okupace"],"date":"1939","timeline":"1939–1945","gpsn":"","gpse":"","desc":"Příčiny a okolnosti vzniku Protektorátu Čechy a Morava srozumitelně prezentuje krátký dětský pořad Dějiny udatného národa českého.","index":"560162","idec":"211 543 11623/0101","bonus":"","sidp":"","director":"Koutský Pavel","type":"v","category":2},"v-2-13":{"id":"13","title":"Ostatky Karla Hynka Máchy","topic":["společnost"],"subtopic":[""],"tags":["protektorát","pohřeb","1939"],"date":"1939","timeline":"1939","gpsn":"50.0647161","gpse":"14.4180161","desc":"Dne 7. května 1939 byly na pražský Vyšehrad převezeny ostatky básníka K. H. Máchy. Akce v pohnuté době vyvovala velkou vlnu národního cítění a stala se pietním manifestem.","index":"560578","idec":"208 522 16151/0010 ","bonus":"","sidp":"","director":"Vantuch Pavel","type":"v","category":2},"v-2-14":{"id":"14","title":"Neplatnost Mnichovské dohody","topic":["politika"],"subtopic":["politická jednání"],"tags":["politika","1942"],"date":"1942","timeline":"1942","gpsn":"","gpse":"","desc":"Co bylo spouštěcím momentem pro to, aby spojenci v roce 1942 prohlásili Mnichovskou dohodu za neplatnou a proč se k tomu Britové stavěli zpočátku odmítavě?","index":"560954","idec":"213 452 80140/0030","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":2},"v-2-15":{"id":"15","title":"Uzavření vysokých škol 17. listopadu 1939","topic":["společnost"],"subtopic":[""],"tags":["protektorát","pohřeb","vzdělávání","studenti"],"date":"1939","timeline":"1939","gpsn":"","gpse":"","desc":"Jako odvetu za protesty studentů během pohřbu Jana Opletala uzavřeli nacisté 17. listopadu všechny české vysoké školy v protektorátu. Co je k tomu vedlo? Poslechněte si také vzpomínky jednoho z pamětníků-studentů na útok na vysokoškolské koleje v noci dne 16. listopadu 1939.","index":"560961","idec":"209 452 80140/0035 ","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":2},"v-2-16":{"id":"16","title":"Začátek druhé světové války","topic":["politika"],"subtopic":[""],"tags":["válka","armáda"],"date":"1939","timeline":"1939","gpsn":"","gpse":"","desc":"První výstřely 2. světové války padly na Westerplatte v Gdaňsku 1. září 1939. Kdo začal pálit jako první a co následovalo?","index":"560962","idec":"209 411 00010/0831","bonus":"","sidp":"","director":"","type":"v","category":2},"v-2-17":{"id":"17","title":"Československé jednotky v britské armádě","topic":["politika"],"subtopic":["odboj"],"tags":["válka","armáda","propaganda"],"date":"1940","timeline":"1939–1945","gpsn":"","gpse":"","desc":"Během druhé světové války bojovalo v řadách britské armády několik tisíc československých dobrovolníků, zpravidla příslušníků československé armády. Podívejte se na záběry z propagačního filmu o přípravě československých jednotek na vylodění v Evropě a boj s nacismem všude tam, kde bylo potřeba. ","index":"560966","idec":"206 522 16151/0008","bonus":"","sidp":"","director":"Vantuch Pavel","type":"v","category":2},"v-2-18":{"id":"18","title":"Tobruk 1941","topic":["politika"],"subtopic":["odboj"],"tags":["armáda","válka","1941"],"date":"1941","timeline":"1941","gpsn":"32.0774322","gpse":"23.9600147","desc":"O osudech československých vojáků na Blízkém východě a o důležité bitvě o město Tobruk v Libyi, kde se naše jednotky hrdinně bránily Němcům a Italům po 241 dní. Proslavil se zde zejména Československý pěší prapor 11 - Východní pod vedením generála Klapálka.","index":"560991","idec":"208 452 80140/0045","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":2},"v-2-19":{"id":"19","title":"Pražské povstání","topic":["politika"],"subtopic":["odboj"],"tags":["protektorát","rozhlas","1945","okupace"],"date":"1945","timeline":"1945","gpsn":"50.0783169","gpse":"14.4341517","desc":"Dne 5. května 1945 vypuklo v československém hlavním městě povstání proti nacistické okupaci. Obyvatelé Prahy museli s fanatickými oddíly SS svádět na barikádách tuhé boje. Během 4 dní trvajícího povstání přišlo o život téměř 3000 lidí.","index":"561870","idec":"215 411 05823/0018 ","bonus":"","sidp":"","director":"","type":"v","category":2},"v-2-20":{"id":"20","title":"Demokrat Wenzel Jaksch","topic":["politika"],"subtopic":[""],"tags":["Němci","politika"],"date":"1939","timeline":"1896–1966","gpsn":"","gpse":"","desc":"Čeští Němci nebyli zdaleka jen kolaboranti a nepřátelé. Wenzel Jaksch – významný politik, jenž hájil práva a zájmy sudetských Němců v Československu, ale také hodnoty demokracie a svobody.","index":"562268","idec":"211 452 80140/0029","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":2},"v-2-21":{"id":"21","title":"Edvard Beneš","topic":["politika"],"subtopic":[""],"tags":["Beneš","prezident"],"date":"1940","timeline":"1884–1948","gpsn":"","gpse":"","desc":"Edvard Beneš – prototyp vzorného úředníka, jenž řídil zemi v těžké době 30. a 40. let. Podařilo se mu stmelit národ, přesto však jeho jméno a odkaz budí kontroverze. Jaký byl druhý československý prezident?","index":"","idec":"214 411 01012/0525","bonus":"30021","sidp":"","director":"Knopp Erik Mgr.art.","type":"v","category":2},"v-2-22":{"id":"22","title":"Slovenské národní povstání","topic":["politika"],"subtopic":["odboj"],"tags":["Slovensko","odboj","válka","1944"],"date":"1944","timeline":"1944","gpsn":"48.7372500","gpse":"19.1418200","desc":"Povstání, v němž dalo Slovensko v roce 1944 světu najevo, že stojí po jeho boku v boji proti nacismu. Proč bylo odsouzeno k neúspěchu?","index":"","idec":"214 411 00037/0829","bonus":"30026","sidp":"","director":"Ďurica Peter","type":"v","category":2},"v-2-23":{"id":"23","title":"Protektorát Čechy a Morava","topic":["politika"],"subtopic":[""],"tags":["protektorát","armáda","1939","okupace"],"date":"1939","timeline":"1939","gpsn":"","gpse":"","desc":"Jak došlo k okupaci československé druhé republiky německými vojsky a vzniku protektorátu, a jak na tyto události reagovala tehdejší společnost?","index":"","idec":"216 411 03400/0024","bonus":"30025","sidp":"","director":"Dulava Jan","type":"v","category":2},"v-2-24":{"id":"24","title":"Československo: dva státy?","topic":["politika"],"subtopic":[""],"tags":["Slovensko","1945"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","desc":"Proč došlo po 2. světové válce ke znovusjednocení Česka a Slovenska? Zajímavý komentář k nepříliš často diskutované otázce...","index":"","idec":"412 231 10025/2086","bonus":"30020","sidp":"","director":"Flak Jan","type":"v","category":2},"v-2-25":{"id":"25","title":"Odbojová skupina Tři králové","topic":["politika"],"subtopic":["odboj"],"tags":["protektorát","odboj","armáda","1939"],"date":"1939","timeline":"1939","gpsn":"","gpse":"","desc":"Legendární odbojová organizace Tři králové, před níž se třásli všichni příslušníci gestapa v protektorátu. Jejími příslušníky byli Josef Mašín starší, Václav Morávek a Josef Balabán. Připomeňte si jejich nejslavnější akce a další osudy.","index":"","idec":"208 452 80140/0031","bonus":"30024","sidp":"","director":"Křístek Václav","type":"v","category":2},"v-2-26":{"id":"26","title":"Emil Hácha","topic":["politika"],"subtopic":[""],"tags":["prezident","protektorát"],"date":"1939","timeline":"1872–1945","gpsn":"","gpse":"","desc":"Emil Hácha, československý právník, předseda Nejvyššího správního soudu, který je známý zejména jako prezident v letech 1938-1945. Podívejte se na portrét této kontroverzní osobnosti.","index":"","idec":"213 411 01012/1124","bonus":"30022","sidp":"","director":"Knopp Erik Mgr.art.","type":"v","category":2},"v-2-27":{"id":"27","title":"Arizace židovského majetku","topic":["hospodářství"],"subtopic":[""],"tags":["holocaust","antisemitismus","menšiny"],"date":"1939","timeline":"1939–1945","gpsn":"","gpse":"","desc":"Vyvlastnění majetku osob, které byly židovského původu a jeho převedení do rukou árijských majitelů. Jaké byly kroky a postupy při vylučování Židů z veřejného života?","index":"","idec":"208 452 80140/0034 ","bonus":"30019","sidp":"","director":"Romanov Vítězslav","type":"v","category":2},"v-2-28":{"id":"28","title":"Vstup německých vojsk na území Československa","topic":["politika"],"subtopic":[""],"tags":["armáda","1939","konflikt","okupace"],"date":"1939","timeline":"1939","gpsn":"49.6853661","gpse":"18.3483767","desc":"Dne 15. března 1939 vstoupila německá okupační vojska na území Československa. Na Moravu však neoficiálně o den dříve. Právě ve Frýdku-Místku proto na německé vojáky zahájili ti čeští palbu. Asi půlhodinová přestřelka si vyžádala několik mrtvých a je považována za začátek války na našem území.","index":"","idec":"411 231 10021/2011","bonus":"30027","sidp":"","director":"Pražáková Zuzana","type":"v","category":2},"v-2-29":{"id":"29","title":"Generál Alois Eliáš","topic":["politika"],"subtopic":[""],"tags":["protektorát","odboj","armáda"],"date":"1942","timeline":"1890–1942 ","gpsn":"","gpse":"","desc":"Generál Alois Eliáš, hrdina první světové války, protektorátní ministr a významný představitel československého odboje. Byl popraven nacisty v roce 1942. Seznamte se blíže s jeho životními osudy.","index":"","idec":"206 411 03400/0250","bonus":"30023","sidp":"","director":"","type":"v","category":2},"v-2-30":{"id":"30","title":"Slovenský holocaust","topic":["společnost"],"subtopic":["holocaust"],"tags":["holocaust","antisemitismus","protektorát"],"date":"1940","timeline":"1939–1945","gpsn":"","gpse":"","desc":"Jakou podobu měl židovský holocaust na okupovaném českém území a na Slovensku?","index":"","idec":"208 452 80140/0034","bonus":"30190","sidp":"","director":"Romanov Vítězslav","type":"v","category":2},"v-2-31":{"id":"31","title":"Řešení tzv. české otázky","topic":["politika"],"subtopic":["perzekuce"],"tags":["protektorát","válka"],"date":"1940","timeline":"1938–1945","gpsn":"","gpse":"","desc":"Český národ měl po vítězné válce jako takový přestat existovat. Seznamte se s plány nacistů k řešení tzv. české otázky...","index":"","idec":"216 411 05806/0831","bonus":"30189","sidp":"","director":"","type":"v","category":2},"v-2-32":{"id":"32","title":"Terezínská liga","topic":["sport"],"subtopic":["holocaust"],"tags":["holocaust","Terezín","ghetto"],"date":"1942","timeline":"1942 - 1944","gpsn":"50.5109981","gpse":"14.1505467","desc":"Mezi roky 1942 - 1944 se v Terezínském židovském ghettu odehrávala pravidelná utkání fotbalových týmu. Nešlo ale o profisionální sportovce, nýbrž o muže vězněné nacisty. Právě fotbal pomáhal vězňům alespoň po dobu utkání zapomenout na nelehkou dobu druhé světové války.  ","index":"595992","idec":"212 411 00010/0525","bonus":"","sidp":"","director":"","type":"v","category":2},"v-2-33":{"id":"33","title":"Umělecká rekonstrukce rozhovoru Beneše a Churchilla z dubna 1941","topic":["politika"],"subtopic":["politická jednání"],"tags":[],"date":"1941","timeline":"1941","gpsn":"","gpse":"","desc":"Jak asi v roce 1941 vypadal rozhovor exilového prezidenta Beneše s britským premiérem Churchillem o nutnosti zrušení Mnichovské dohody? Ukázka z cyklu České století.","index":"604512","idec":"212 512 12024","bonus":"","sidp":"","director":"Sedláček Robert","type":"v","category":2},"v-2-34":{"id":"34","title":"Mnichovská dohoda","topic":["politika"],"subtopic":["krize 1938"],"tags":["politika","1938","nacismus"],"date":"1938","timeline":"1938","gpsn":"","gpse":"","desc":"V Mnichově se Velká Británie a Francie snažily zachránit evropský mír na úkor Československa. Nepovedlo se to. Ani ne rok po podpisu dohody se Evropa přesvědčila, že ustupovat Hitlerovi byla chyba.","index":"425972","idec":"211 543 11623/0099","bonus":"","sidp":"","director":"Pavel Koutský","type":"v","category":2},"v-3-1":{"id":"1","title":"Majetek rodu Schwarzenbergů","topic":["hospodářství"],"subtopic":[""],"tags":["šlechta","1947"],"date":"1947","timeline":"1947","gpsn":"","gpse":"","desc":"Proces znárodňování začal v Československu již v roce 1945, kolektivizace zemědělství započala masově až v roce 1948. Tendence státu omezovat osobní vlastnictví byly zřejmé, a tak v roce 1947 vznikl bezprecedentní zákon postihující rod Schwarzenbergů z hlubocké větve rodu kvůli velikosti jejich majetku.","index":"559950","idec":"212452801240025","bonus":"","sidp":"","director":"Hackenschmied Hanuš, Omasta Vladko, Šantúr Roman, Vondráček David","type":"v","category":3},"v-3-2":{"id":"2","title":"Situace maďarské menšiny v poválečném Československu","topic":["společnost"],"subtopic":[""],"tags":["odsun","menšiny","Maďarsko","1945–1946"],"date":"1945","timeline":"1945–1946","gpsn":"","gpse":"","desc":"Po válce museli Československo opustit nejen Němci, ale také Maďaři. Jak početná byla maďarská menšina a jak bylo zacházeno s jejími příslušníky během odsunu?","index":"559969","idec":"215411010101215","bonus":"","sidp":"","director":"Knopp Erik Mgr.art.","type":"v","category":3},"v-3-3":{"id":"3","title":"Druhý život Mistra Jana Husa: První komunista?","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["propaganda","KSČ"],"date":"1949","timeline":"1878–1962","gpsn":"","gpse":"","desc":"Jan Hus byl komunistickým režimem v Československu představován jako propagátor komunistické myšlenky, kterou nový socialistický režim pouze následuje. Jaká byla ideologická východiska komunistické interpretace postavy Jana Husa?","index":"559975","idec":"214562260660005","bonus":"","sidp":"","director":"Kučera Miloslav","type":"v","category":3},"v-3-4":{"id":"4","title":"Proces s Rudolfem Slánským a spol.","topic":["politika"],"subtopic":["umírání soudruhů"],"tags":["1952","proces","perzekuce","KSČ"],"date":"1952","timeline":"1952","gpsn":"","gpse":"","desc":"Stručné shrnutí důvodů vykonstruovaného procesu s Rudolfem Slánským včetně dobových fotografií a hraných ukázek z cyklu České století.","index":"560160","idec":"214562210800012","bonus":"","sidp":"","director":"Střecha Jiří","type":"v","category":3},"v-3-5":{"id":"5","title":"Perzekuce řeholních řádů v komunistickém Československu","topic":["politika"],"subtopic":["nespravedlivě odsouzení"],"tags":["1950","perzekuce","církev"],"date":"1950","timeline":"1950","gpsn":"","gpse":"","desc":"V roce 1950 začala Akce K, která spočívala v rušení mužských klášterů, internaci a věznění členů mužských řeholních řádů. Na ní navázala Akce Ř, která byla zaměřená proti ženským řeholním řádům. Podívejte se na reportáž o obou násilných akcích, která obsahuje rozhovory s pamětníky a archivní záběry.","index":"560163","idec":"215411000100413","bonus":"","sidp":"","director":"Škampa Michal","type":"v","category":3},"v-3-6":{"id":"6","title":"Rada vzájemné hospodářské pomoci","topic":["hospodářství"],"subtopic":[""],"tags":["1949","hospodářství"],"date":"1949","timeline":"1949","gpsn":"","gpse":"","desc":"Shrnutí politických motivů a ekonomických důsledků založení Rady vzájemné hospodářské pomoci v roce 1949. Obsahuje ukázku z Československého filmového týdeníku.","index":"560166","idec":"210452801400016","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":3},"v-3-7":{"id":"7","title":"Železná opona","topic":["politika"],"subtopic":[""],"tags":["hranice","1951","železná opona","emigrace","cestování","TOTO100LETÍ ve škole"],"date":"1951","timeline":"1951","gpsn":"","gpse":"","desc":"Příběh útěku za přísně střežené státní hranice ve vlaku, jedoucím původně z Prahy do Aše. Obsahuje výpovědi pamětníků a archivní záběry.","index":"560175","idec":"406235100221011","bonus":"","sidp":"","director":"Novák Ján","type":"v","category":3},"v-3-8":{"id":"8","title":"České století: Zabíjení soudruha","topic":["politika"],"subtopic":[""],"tags":["1952","antisemitismus","perzekuce","proces","KSČ"],"date":"1952","timeline":"1952","gpsn":"","gpse":"","desc":"Hlavní motivací vykonstruovaného procesu s Rudolfem Slánským, Otto Schlingem a dalšími byla sovětská snaha zastrašit samotné vedení stranických organizací v satelitních státech. Útoky na oběti se přitom nesly v antisemitském duchu. V ukázce ze seriálu R. Sedláčka České století sledujeme ostrý útok Václava Kopeckého na Rudolfa Slánského a zcela nepokryté projevy antisemitismu.","index":"560368","idec":"21251212043","bonus":"","sidp":"","director":"Sedláček Robert","type":"v","category":3},"v-3-9":{"id":"9","title":"Vznik pomocných technických praporů","topic":["politika"],"subtopic":[""],"tags":["armáda","perzekuce","1950–1954"],"date":"1950","timeline":"1950–1954","gpsn":"","gpse":"","desc":"Proč v československé armádě v 50. letech 20. století vznikly tzv. pomocné technické prapory? Kdo byli jejich příslušníci a jaké v praporech panovaly podmínky?","index":"560380","idec":"213411000360006","bonus":"","sidp":"","director":"Bareš Ivan","type":"v","category":3},"v-3-10":{"id":"10","title":"Otázkové protokoly ve vykonstruovaných procesech","topic":["politika"],"subtopic":["nespravedlivě odsouzení"],"tags":["proces","perzekuce","Horáková","1950"],"date":"1950","timeline":"1950","gpsn":"","gpse":"","desc":"Soudní procesy v 50. letech byly předem naplánovány podle velmi přesného scénáře. Jak probíhala příprava výpovědí ve vykonstruovaném soudním procesu s Miladou Horákovou?","index":"560387","idec":"20756226864","bonus":"","sidp":"","director":"Vadas Martin","type":"v","category":3},"v-3-11":{"id":"11","title":"Poslední rozloučení Milady Horákové","topic":["politika"],"subtopic":["nespravedlivě odsouzení"],"tags":["proces","1950","perzekuce","Horáková"],"date":"1950","timeline":"1950","gpsn":"50.0582631","gpse":"14.4381672","desc":"Poslední návštěva Milady Horákové v pankrácké věznici očima její dcery a sestry.","index":"560569","idec":"208562268640010","bonus":"","sidp":"","director":"Vadas Martin","type":"v","category":3},"v-3-12":{"id":"12","title":"Volba kandidátů Národní fronty v roce 1954","topic":["politika"],"subtopic":[""],"tags":["1954","propaganda","politika"],"date":"1954","timeline":"1954","gpsn":"","gpse":"","desc":"Národní fronta vznikla v roce 1945 jako uskupení všech politických stran, později všech povolených politických stran. Ústřední roli hrála KSČ. Národní fronta fungovala až do roku 1990. Podívejte se na dobové zpravodajství o volbách kandidátů Národní fronty v roce 1954.","index":"560938","idec":"214411058210027","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-13":{"id":"13","title":"Historie podle Zdeňka Nejedlého","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["propaganda","komunismus"],"date":"1947","timeline":"","gpsn":"","gpse":"","desc":"Zdeněk Nejedlý byl značně kontroverzní a vlivnou postavou poúnorového vývoje v Československu. Podívejte se na portrét tohoto historika, politika a komunistického ministra školství.","index":"560951","idec":"213411000100302","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-14":{"id":"14","title":"Vznik Stalinova pomníku","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["propaganda","1955","umění","pomník"],"date":"1955","timeline":"1955","gpsn":"","gpse":"","desc":"Stavba letenského pomníku J. V. Stalina začala již v roce 1949, nicméně práce na sousoší byly zahájeny až v roce 1952 a tým pod vedením sochaře Otakara Švece pracoval usilovně až do roku 1955, kdy bylo sousoší slavnostně odhaleno. Jak ukazuje dobový materiál, o průběhu stavby byla veřejnost průběžně informována. Odstřel pomníku proběhl v roce 1962.","index":"560958","idec":"214411058210014","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-15":{"id":"15","title":"Rekreace ROH: Co víc si přát?","topic":["společnost"],"subtopic":[""],"tags":["propaganda","volný čas"],"date":"1946","timeline":"1945–1990","gpsn":"","gpse":"","desc":"ROH, neboli Revoluční odborové hnutí bylo v podstatě zastřešující odborovou organizací všech zaměstnanců. Členství v něm bylo často téměř povinné, nicméně zahrnovalo i některé výhody, například možnost využití zotavoven a rekreačních zařízení. Podívejte se na dobový materiál propagující rekreace ROH.","index":"561145","idec":"215411058210009","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-16":{"id":"16","title":"Egon Bondy: Vždy proti proudu","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["underground","Státní bezpečnost","poezie","literatura","umění"],"date":"1949","timeline":"1930–2007","gpsn":"","gpse":"","desc":"Stručný medailonek o životě a tvorbě básníka a filosofa Egona Bondyho.","index":"561154","idec":"217411058210017","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-17":{"id":"17","title":"Levicová orientace Československa","topic":["společnost"],"subtopic":[""],"tags":["krize","literatura","propaganda","umění"],"date":"1948","timeline":"","gpsn":"","gpse":"","desc":"Z čeho vzešla inklinace k levici a komunismu v Československu? Kořeny levicové orientace mnoha vlivných československých osobností v pojetí literárního historika Jaroslava Meda, spisovatele Pavla Kosatíka a historika Milana Drápaly.","index":"561164","idec":"208542154050001","bonus":"","sidp":"","director":"Soukup Jan","type":"v","category":3},"v-3-18":{"id":"18","title":"Co přináší socialistický realismus?","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["umění","komunismus"],"date":"1949","timeline":"","gpsn":"","gpse":"","desc":"Socialistický realismus byl přijat Komunistickou stranou Sovětského svazu již v roce 1932 jako oficiální směrnice pro všechny umělecké směry. Jaký vliv měla sovětská kulturní politika na Československo?","index":"561166","idec":"208542154050001","bonus":"","sidp":"","director":"Soukup Jan","type":"v","category":3},"v-3-19":{"id":"19","title":"Násilný únor 1948","topic":["politika"],"subtopic":["únor 1948"],"tags":["politika","1948"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"O únoru 1948 hovoří spisovatel Pavel Kosatík, následuje oficiální dobové zpravodajství o pohřbu Jana Masaryka.","index":"561167","idec":"208542154050001","bonus":"","sidp":"","director":"Soukup Jan","type":"v","category":3},"v-3-20":{"id":"20","title":"Básník Jiří Kolář","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["perzekuce","poezie","literatura","umění","1948"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"Historik Milan Drápala hovoří o osudech básníka Jiřího Koláře po únoru 1948 a jeho postupné rozluce s komunistickým režimem.","index":"561360","idec":"208542154050001","bonus":"","sidp":"","director":"Soukup Jan","type":"v","category":3},"v-3-21":{"id":"21","title":"Mechanismy propagandy","topic":["politika"],"subtopic":[""],"tags":["propaganda","komunismus"],"date":"1953","timeline":"1950–1960","gpsn":"","gpse":"","desc":"Pavel Kosatík hovoří o podobnostech v metodách nacistické a komunistické propagandy a uvádí jako příklad projevy komunistického ministra Václava Kopeckého.","index":"561361","idec":"208542154050001","bonus":"","sidp":"","director":"Soukup Jan","type":"v","category":3},"v-3-22":{"id":"22","title":"Československá armáda po roce 1948","topic":["politika"],"subtopic":[""],"tags":["1948 - 1956","perzekuce","armáda"],"date":"1948","timeline":"1948–1956","gpsn":"","gpse":"","desc":"Vojenský historik Eduard Stehlík hovoří o represích vůči příslušníkům československých ozbrojených sil po únoru 1948.","index":"561362","idec":"208542154050001","bonus":"","sidp":"","director":"Soukup Jan","type":"v","category":3},"v-3-23":{"id":"23","title":"Smrt J. V. Stalina","topic":["politika"],"subtopic":["umírání soudruhů"],"tags":["pohřeb","1953"],"date":"1953","timeline":"1953","gpsn":"","gpse":"","desc":"Dobové zpravodajství o smrti J. V. Stalina dne 5. března 1953. ","index":"561373","idec":"213411058210012","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-24":{"id":"24","title":"Znárodňování očima zpravodajství roku 1945","topic":["hospodářství"],"subtopic":[""],"tags":["znárodnění","1945","hospodářství"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","desc":"Dobové zpravodajství o znárodnění československých bank, dolů a průmyslových podniků v říjnu 1945.","index":"561609","idec":"207452801390009","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":3},"v-3-25":{"id":"25","title":"Znárodňování očima zpravodajství roku 1946","topic":["hospodářství"],"subtopic":[""],"tags":["1946","znárodnění","propaganda","hospodářství"],"date":"1946","timeline":"1946","gpsn":"","gpse":"","desc":"Zpravodajství z roku 1946 o práci ve znárodněných závodech a na znárodněných polích. O dosaženém se hovoří jako o „plodu revoluce“.","index":"561661","idec":"216411058210022","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-26":{"id":"26","title":"Poválečné soudní procesy","topic":["politika"],"subtopic":[""],"tags":["proces"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","desc":"Poválečné soudní procesy s lidmi, kteří kolaborovali s nacisty či byli podezřelí z válečných zločinů, měly na starost tzv. lidové soudy. Odsouzeno bylo cca 20 000 lidí, proti rozsudku zpravidla nebylo odvolání. K odsouzení stačila tři svědectví. ","index":"561693","idec":"210411000100619","bonus":"","sidp":"","director":"Petráček Miroslav","type":"v","category":3},"v-3-27":{"id":"27","title":"Zrychlený čas: Osudy Prokopa Drtiny a Ferdinanda Peroutky","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["politika","1948","perzekuce","literatura"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"Jak se odvíjel život spisovatele a dramatika Ferdinanda Peroutky a právníka a ministra spravedlnosti Prokopa Drtiny po nástupu KSČ v roce 1948?","index":"561696","idec":"208 572 23232/0005","bonus":"","sidp":"","director":"Matějková Jolana","type":"v","category":3},"v-3-28":{"id":"28","title":"Emigrace Pavla Tigrida v roce 1948","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1948","emigrace"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"Spisovatel a novinář Pavel Tigrid hovoří o své emigraci v roce 1948. Ukázka z dokumentu Heleny Třeštíkové Pavel Tigrid – Evropan.","index":"561727","idec":"203 562 26216","bonus":"","sidp":"","director":"Třeštíková Helena","type":"v","category":3},"v-3-29":{"id":"29","title":"Svobodná Evropa","topic":["společnost"],"subtopic":[""],"tags":["1951","železná opona","emigrace","média"],"date":"1951","timeline":"1951","gpsn":"","gpse":"","desc":"Spisovatel a novinář Pavel Tigrid hovoří o začátku vysílání rozhlasové stanice Svobodná Evropa. Ukázka z dokumentu Heleny Třeštíkové Pavel Tigrid – Evropan.","index":"561728","idec":"203 562 26216","bonus":"","sidp":"","director":"Třeštíková Helena","type":"v","category":3},"v-3-30":{"id":"30","title":"Generál Karel Kutlvašr","topic":["politika"],"subtopic":["nespravedlivě odsouzení"],"tags":["odboj","1945","armáda"],"date":"1945","timeline":"1945","gpsn":"50.0835494","gpse":" 14.4341414E","desc":"Reportáž o životě generála Karla Kutlvašra, jednoho z vůdců pražského povstání v roce 1945. Jakým způsobem a kým bylo Pražské povstání v květnu 1945 organizováno?","index":"561874","idec":"215452801240021","bonus":"","sidp":"","director":"Bareš Ivan, Hanuš Pavel, Kudela Radek, Menšl Vavřinec, Nedorostová Raupachová Stanislava, Omasta Vladko, Petráček Miroslav, Šťastný David, Vondráček David","type":"v","category":3},"v-3-31":{"id":"31","title":"Cestovatelé Hanzelka a Zikmund","topic":["společnost"],"subtopic":[""],"tags":["cestování","1947–1950"],"date":"1947","timeline":"1947–1968","gpsn":"","gpse":"","desc":"Příběh slavných československých cestovatelů Jiřího Hanzelky a Miroslava Zikmunda, kteří na svoji první cestu vyrazili v roce 1947.","index":"562271","idec":"213563231900010","bonus":"","sidp":"","director":"Horký Petr, Šajmovič Juraj","type":"v","category":3},"v-3-32":{"id":"32","title":"Úmrtí Edvarda Beneše","topic":["politika"],"subtopic":[""],"tags":["Beneš","prezident","pohřeb","1948","KSČ"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"Popis pohřbu Edvarda Beneše v září 1948 a reakce komunistů v Československu na jeho průběh.","index":"562503","idec":"212452801400011","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":3},"v-3-33":{"id":"33","title":"Průběh pohřbu Klementa Gottwalda","topic":["politika"],"subtopic":["umírání soudruhů"],"tags":["pohřeb","prezident","1953"],"date":"1953","timeline":"1953","gpsn":"","gpse":"","desc":"Jen několik dní po smrti J. V. Stalina v březnu 1953 zemřel také československý prezident Klement Gottwald. Jak probíhal jeho státní pohřeb a jaká byla ideologická východiska tohoto pompézního obřadu?","index":"562515","idec":"212452801400011","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":3},"v-3-34":{"id":"34","title":"Násilná kolektivizace","topic":["politika"],"subtopic":[""],"tags":["kolektivizace","perzekuce","1951","zemědělství"],"date":"1951","timeline":"1951","gpsn":"","gpse":"","desc":"Po vzoru SSSR bylo i v komunistickém Československu násilně zakročeno proti soukromým zemědělcům, a to v duchu tzv. „zprůmyslnění zemědělství“. Důsledkem této akce byly tisíce postižených a likvidace krajiny, jejíž důsledky jsou patrné dodnes.","index":"562709","idec":"409235100221006","bonus":"","sidp":"","director":"Všelichová Petra","type":"v","category":3},"v-3-35":{"id":"35","title":"Z kanceláře do továrny","topic":["hospodářství"],"subtopic":[""],"tags":["perzekuce","hospodářství","1951"],"date":"1951","timeline":"1951","gpsn":"","gpse":"","desc":"V červnu roku 1951 bylo převedeno více než 77 000 úředníků do průmyslové výroby. O ideologických i praktických důvodech tzv. Akce 77 tisíc do výroby hovoří historici Zdeněk Jirásek a Michal Pehr.","index":"562714","idec":"211452801400006","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":3},"v-3-36":{"id":"36","title":"Důvod vzniku Varšavské smlouvy","topic":["politika"],"subtopic":[""],"tags":["Varšavská smlouva","1955","NATO","armáda"],"date":"1955","timeline":"1955","gpsn":"52.2319236","gpse":"21.0067264","desc":"Varšavský pakt vznikl v reakci na vznik NATO v roce 1955, a to jako spojenecká organizace armád východního bloku. Největší operací vojsk Varšavské smlouvy byla okupace Československa v roce 1968. ","index":"563074","idec":"215411010100514","bonus":"","sidp":"","director":"Škampa Michal","type":"v","category":3},"v-3-37":{"id":"37","title":"Odhalení Stalinova pomníku","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1955","umění","sochařství","propaganda","pomník"],"date":"1955","timeline":"1955","gpsn":"50.0976897","gpse":"14.4158122","desc":"Za účasti desítek tisíc občanů byl v roce 1955 odhalen pomník J. V. Stalina na pražském letenském návrší. Dobové zpravodajství o odhalení Stalinova pomníku.","index":"563079","idec":"216411058210019","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-38":{"id":"38","title":"Dana Zátopková a Emil Zátopek","topic":["sport"],"subtopic":[""],"tags":["1948","sport","olympiáda"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"Seznámení legendárních sportovců a olympioniků Dany a Emila Zátopkových a zlatá olympijská medaile pro Emila Zátopka z her v Londýně v roce 1948. Ukázka z dokumentárního filmu Davida Ondříčka.","index":"563080","idec":"21556226566","bonus":"","sidp":"","director":"Ondříček David","type":"v","category":3},"v-3-39":{"id":"39","title":"Odsun Němců","topic":["společnost"],"subtopic":[""],"tags":["1945","1946","odsun","Němci","Sudety"],"date":"1945","timeline":"1945–1946","gpsn":"","gpse":"","desc":"Dobová československá média přinášela značně idealizovaný pohled na poválečný odsun německého obyvatelstva. Podívejte se na jeden z nich...","index":"437955","idec":"215 411 05821/0034","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-40":{"id":"40","title":"Divoký odsun","topic":["společnost"],"subtopic":[""],"tags":["1945","1946","odsun","Němci","Sudety"],"date":"1945","timeline":"1945–1946","gpsn":"","gpse":"","desc":"Kterou fázi odsunu německého obyvatelstva z československého území označujeme jako tzv. divoký odsun?","index":"568526","idec":"213 452 80140/0023","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":3},"v-3-41":{"id":"41","title":"Soud s K. H. Frankem","topic":["politika"],"subtopic":[""],"tags":["Němci","kolaborace","antisemitismus","1945–1946"],"date":"1945","timeline":"1945–1946","gpsn":"50.0582631","gpse":"14.4381672","desc":"Karl Hermann Frank, rodák z Karlových Varů, knihkupec, československý občan, ale také prominentní člen Sudetoněmecké strany a později SS, nacistický politik a válečný zločinec. Jak probíhalo jeho dopadení a soudní proces po skončení 2. světové války?","index":"560169","idec":"215 411 03311/0011","bonus":"","sidp":"","director":"Karadžos Charilaos, Podlipný Jiří","type":"v","category":3},"v-3-42":{"id":"42","title":"Vážený kněz Josef Toufar","topic":["politika"],"subtopic":["nespravedlivě odsouzení"],"tags":["církev","perzekuce","1949","1950"],"date":"1949","timeline":"1949–1950","gpsn":"49.7417517","gpse":"15.3350758","desc":"Ukázka z dokumentu M. Doležala a R. Vávry o tzv. Čihošťském zázraku a následné perzekuci a umučení katolického kněze Josefa Toufara. V této ukázce je popsáno působení Josefa Toufara během války, v jeho první farnosti a následné přeložení do Čihošti po únoru 1948.","index":"","idec":"-","bonus":"30191","sidp":"","director":"Vávra Roman","type":"v","category":3},"v-3-43":{"id":"43","title":"Jan Masaryk","topic":["politika"],"subtopic":[""],"tags":["1948","Masaryk"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"Medailonek o životě, kariéře a tragické smrti významného československého politika Jana Masaryka.","index":"","idec":"213 411 01012/0310","bonus":"30193","sidp":"","director":"Knopp Erik Mgr.art., Moravec Ondřej","type":"v","category":3},"v-3-44":{"id":"44","title":"Odsun Němců z Československa","topic":["společnost"],"subtopic":[""],"tags":["odsun","Němci","menšiny","1945–1946"],"date":"1945","timeline":"1945–1946","gpsn":"","gpse":"","desc":"Již od poloviny května 1945 začal na území Československa odsun německých občanů. Podívejte se, jaké fáze tato akce měla a kolik obyvatel muselo odejít. ","index":"","idec":"216 411 05813/0516","bonus":"30197","sidp":"","director":"Škampa Michal","type":"v","category":3},"v-3-45":{"id":"45","title":"Studentské protesty v roce 1948","topic":["politika"],"subtopic":["únor 1948"],"tags":["studenti","Beneš","1948","demonstrace","vzdělávání"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"V únoru 1948 svůj nesouhlas s probíhajícím politickým zvratem v zemi vyjádřili pouze studenti, kteří uspořádali pochod, který směřoval na Hrad. Represe protestujících přišla okamžitě.","index":"","idec":"216 411 00037/0225","bonus":"30202","sidp":"","director":"Škampa Michal","type":"v","category":3},"v-3-46":{"id":"46","title":"Plzeňské protesty proti měnové reformě","topic":["hospodářství"],"subtopic":[""],"tags":["1953","demonstrace","hospodářství"],"date":"1953","timeline":"1953","gpsn":"49.7477831","gpse":"13.3783489","desc":"V roce 1953 proběhla v Československu měnová reforma. Jejím cílem bylo ukončit přídělový systém a potlačit černý trh, reálný důsledek byl ovšem znehodnocení úspor lidí a snížení jejich životní úrovně. V Plzni se v reakci na reformu odehrály dělnické protesty, které byly násilně potlačeny.","index":"","idec":"215 411 00037/0604","bonus":"30198","sidp":"","director":"","type":"v","category":3},"v-3-47":{"id":"47","title":"G. C. Marshall a plán na poválečnou obnovu Evropy","topic":["hospodářství"],"subtopic":[""],"tags":["železná opona","hospodářství"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"Americký generál George Marshall je známý zejména jako autor plánu na hospodářskou obnovu poválečné Evropy. Jaká byla politická východiska Marshallova plánu z hlediska komunistické propagandy a z hlediska americké zahraniční politiky po roce 1945?","index":"","idec":"207 452 80128/0024","bonus":"30192","sidp":"","director":"Křístek Václav","type":"v","category":3},"v-3-48":{"id":"48","title":"Nepohodlná Růžena Vacková","topic":["politika"],"subtopic":["nespravedlivě odsouzení"],"tags":["odboj","proces","Charta 77","perzekuce","vzdělávání"],"date":"1951","timeline":"1901–1982","gpsn":"","gpse":"","desc":"O osobnosti a životních osudech profesorky Růženy Vackové, pronásledované komunistickým režimem, hovoří spisovatelka Milena Štráfeldová.","index":"","idec":"216 411 01010/0225","bonus":"30196","sidp":"","director":"Brada Štěpán, Knopp Erik Mgr.art.","type":"v","category":3},"v-3-49":{"id":"49","title":"Smrt Klementa Gottwalda","topic":["politika"],"subtopic":["umírání soudruhů"],"tags":["pohřeb","prezident","1953"],"date":"1953","timeline":"1953","gpsn":"","gpse":"","desc":"Dobové zpravodajství o smrti Klementa Gottwalda dne 14. března 1953.","index":"","idec":"213 411 05821/0012","bonus":"30201","sidp":"","director":"","type":"v","category":3},"v-3-50":{"id":"50","title":"První reportáže v Československé televizi","topic":["společnost"],"subtopic":[""],"tags":["média","televize","1953"],"date":"1953","timeline":"1956","gpsn":"","gpse":"","desc":"První reportáže zahraničních televizních stanic a Československé televize.","index":"","idec":"212 452 80138/0013","bonus":"30232","sidp":"","director":"Karadžos Charilaos","type":"v","category":3},"v-3-51":{"id":"51","title":"Ztráta Podkarpatské Rusi","topic":["politika"],"subtopic":[""],"tags":["Podkarpatská Rus","1945"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","desc":"Území Podkarpatské Rusi bylo součástí Československa v letech 1919–1939. Po 2. světové válce ale SSSR vzneslo nárok na toto území, což bylo v rozporu se záměrem prezidenta Edvarda Beneše obnovit Československo v jeho předmnichovských hranicích.","index":"","idec":"215 411 03400/0089","bonus":"30205","sidp":"","director":"Všelichová Petra","type":"v","category":3},"v-3-52":{"id":"52","title":"První pětiletka","topic":["hospodářství"],"subtopic":[""],"tags":["1949","propaganda","hospodářství"],"date":"1949","timeline":"1949","gpsn":"","gpse":"","desc":"Roku 1949 přijalo Československo podle sovětského vzoru tzv. pětiletku neboli pětiletý hospodářský plán. Jednalo se o státní plánování výroby i zemědělství. Ukázka z dobového zpravodajství o první pětiletce.","index":"","idec":"208 452 80135/0034","bonus":"30199","sidp":"","director":"Poledne Aleš","type":"v","category":3},"v-3-53":{"id":"53","title":"Vyhlášení první pětiletky","topic":["hospodářství"],"subtopic":[""],"tags":["1948","hospodářství","zemědělství","kolektivizace","TOTO100LETÍ ve škole"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"Projev Antonína Zápotockého z roku 1948, v němž vyhlašuje první pětiletý hospodářský plán a zpravodajství o kolektivizaci zemědělství a jednotném osobním plánu v obci Bohatice.","index":"","idec":"211 411 05821/0018","bonus":"30603","sidp":"","director":"","type":"v","category":3},"v-3-54":{"id":"54","title":"Měnová reforma: proč a zač?","topic":["hospodářství"],"subtopic":[""],"tags":["1953","hospodářství"],"date":"1953","timeline":"1953","gpsn":"51.5073219","gpse":"0.1276475","desc":"Jaké byly důvody měnové reformy v Československu v roce 1953?","index":"","idec":"213 411 05831/0529","bonus":"30195","sidp":"","director":"","type":"v","category":3},"v-3-55":{"id":"55","title":"Svoboda zaniká za velkých ovací","topic":["politika"],"subtopic":["únor 1948"],"tags":["1948","propaganda","politika","komunismus"],"date":"1948","timeline":"1948","gpsn":"","gpse":"","desc":"Demise nekomunistických ministrů v dobovém zpravodajství z roku 1948 a počty obětí komunitického režimu v Československu.","index":"","idec":"215 411 00037/0225","bonus":"30203","sidp":"","director":"Rásocha Jaroslav","type":"v","category":3},"v-3-56":{"id":"56","title":"Mauzoleum Klementa Gottwalda","topic":["politika"],"subtopic":["umírání soudruhů"],"tags":["prezident","1953–1962"],"date":"1953","timeline":"1953–1962","gpsn":"50.0885164","gpse":"14.4498550","desc":"Po smrti Klementa Gottwalda bylo rozhodnuto o zachování jeho těla a umístění do mauzolea na pražském Vítkově. Dodnes není jisté, zda bylo tělo v roce 1962 zpopelněno kvůli uvolnění politických poměrů, nebo kvůli zhoršujícímu se stavu těla.","index":"","idec":"211 411 05823/0008","bonus":"30194","sidp":"","director":"Sojka Petr","type":"v","category":3},"v-3-57":{"id":"57","title":"Sabotáž a zneužití lidového družstva","topic":["hospodářství"],"subtopic":[""],"tags":["1952","hospodářství","zemědělství","kolektivizace","TOTO100LETÍ ve škole"],"date":"1952","timeline":"1952","gpsn":"","gpse":"","desc":"Ideologicky silně zabarvená ukázka ukazuje proces s bývalým statkářem Královským, který se snažil podvodem vyhnout vysokým odvodům do jednotného zemědělského družstva. ","index":"464205","idec":"216 411 05821/0015","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-58":{"id":"58","title":"Celostátní sjezd družstevníků","topic":["hospodářství"],"subtopic":[""],"tags":["1953","hospodářství","zemědělství","kolektivizace","TOTO100LETÍ ve škole"],"date":"1953","timeline":"1953","gpsn":"","gpse":"","desc":"Dobová reportáž z prvního celostátního sjezdu družstevníků, který se konal v roce 1953 v Praze. Zůčastnilo se ho více než 5000 zemědělců, kteří zde jednomyslně schválili družstevní stanovy.","index":"464207","idec":"216 411 05821/0015","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-59":{"id":"59","title":"Pohraniční stráž Sboru národní bezpečnosti","topic":["politika"],"subtopic":[""],"tags":["hranice","1950","železná opona","TOTO100LETÍ ve škole"],"date":"1950","timeline":"1950","gpsn":"","gpse":"","desc":"Ideologicky zabarvená dobová ukázka popisuje práci příslušníků Pohraniční stráže Sboru národní bezpečnosti.","index":"426977","idec":"215 411 05821/0027","bonus":"","sidp":"","director":"","type":"v","category":3},"v-3-60":{"id":"60","title":"Vzpomínka na Jana Opletala v roce 1945","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["TOTO100LETÍ ve škole","1945","studenti","Jan Opletal"],"date":"1945","timeline":"1945","gpsn":"","gpse":"","desc":"Dne 15. listopadu 1945 se na Pražském hradě konala pietní akce za československé vysokoškolské studenty popravené nacisty. Podívejte se na dobovou reportáž.","index":"437954","idec":"215 411 05821/0034","bonus":"","sidp":"","director":"","type":"v","category":3},"v-4-1":{"id":"1","title":"Tajný projev N. S. Chruščova na XX. sjezdu KSSS","topic":["politika"],"subtopic":[""],"tags":["politika","1956"],"date":"1956","timeline":"1956","gpsn":"55.7507178","gpse":"37.6176606","desc":"Na 20. sjezdu Komunistické strany Sovětského svazu v únoru 1956 v Moskvě nastal zlomový okamžik v sovětských dějinách: první tajemník Chruščov poprvé odsuzuje Stalinův kult osobnosti a jeho zločiny.","index":"559739","idec":"216 411 00010/0609","bonus":"","sidp":"","director":"Škampa Michal","type":"v","category":4},"v-4-2":{"id":"2","title":"První člověk ve vesmíru","topic":["společnost"],"subtopic":[""],"tags":["technika","propaganda","vesmír","1961"],"date":"1961","timeline":"1961","gpsn":"45.9178933","gpse":"63.4083722","desc":"Sovětský kosmonaut Jurij Gagarin se zapsal do dějin jako první člověk ve vesmíru. Okamžitě po přistání se stal populární osobností – jaký však byl jeho osud a jak se vyrovnal s rolí „maskota“ Sovětského svazu? ","index":"559740","idec":"214 411 01012/0309","bonus":"30229","sidp":"","director":"Knopp Erik Mgr.art.","type":"v","category":4},"v-4-3":{"id":"3","title":"Maďarské povstání","topic":["politika"],"subtopic":[""],"tags":["Maďarsko","1956"],"date":"1956","timeline":"1956","gpsn":"52.4082664","gpse":"16.9335200","desc":"V roce 1956 proběhlo v Maďarsku povstání proti komunistickému režimu, bylo však krvavě potlačeno sovětskými tanky. Symbolem tohoto povstání se stal Imre Nagy – odvážný premiér, který se postavil na stranu povstalců. ","index":"559954","idec":"214 411 00037/0616","bonus":"30222","sidp":"","director":"","type":"v","category":4},"v-4-4":{"id":"4","title":"Vynálezce kontaktních čoček","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["věda","technika","1961"],"date":"1961","timeline":"1961","gpsn":"","gpse":"","desc":"Profesor Otto Wichterle se proslavil především vynálezem měkkých kontaktních čoček. Na Štědrý den roku 1961 vyrobil první stroj na čočky ze stavebnice Merkur. ","index":"559961","idec":"215 562 23500/0031","bonus":"","sidp":"","director":"Hackenschmied Hanuš","type":"v","category":4},"v-4-5":{"id":"5","title":"Allen Gingsberg zvolen králem majálesu ","topic":["společnost"],"subtopic":["studenti"],"tags":["studenti","vzdělávání","literatura","1965"],"date":"1965","timeline":"1965","gpsn":"50.1017981","gpse":" 14.3907025","desc":"V roce 1965 byly po několikaleté pauze povoleny studentské oslavy – majáles. Jeho králem se stal americký beatnický básník Allen Ginsberg. Oslavy však skončily skandálem: Ginsberg byl „z mravnostních důvodů“ z Československa vyhoštěn. ","index":"559963","idec":"215 411 00010/0501","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-6":{"id":"6","title":"EXPO Brusel 1958","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1958","výstava","umění"],"date":"1958","timeline":"1958","gpsn":"50.8465572","gpse":"4.3516969E","desc":"V roce 1958 se v Bruselu po 2. světové válce konala první velká světová výstava. Československo mělo velký úspěch a přivezlo si domů nejvyšší ocenění. „Bruselský sen“ měl však od reálného života v totalitním Československu daleko.","index":"559967","idec":"213 411 00036/0014","bonus":"","sidp":"","director":"Šmídová Vojtěchová Aneta","type":"v","category":4},"v-4-7":{"id":"7","title":"Stalinův pomník neboli „Fronta na maso“","topic":["politika"],"subtopic":[""],"tags":["sochařství","pomík","1955","umění"],"date":"1955","timeline":"1955","gpsn":"50.0976897","gpse":"14.4158122","desc":"Pouhých 7 let zdobil pražskou Letnou obrovský Stalinův pomník, v té době největší skupinové sousoší v Evropě. Po odsouzení kultu osobnosti nechali komunisté za přísně tajných podmínek toto žulové monstrum odstřelit.","index":"559972","idec":"215 411 00014/0731","bonus":"","sidp":"","director":"Škampa Michal","type":"v","category":4},"v-4-8":{"id":"8","title":"Josef Škvorecký","topic":["kultura a vzdělávání"],"subtopic":["literatura"],"tags":["emigrace","literatura","umění"],"date":"1963","timeline":"1924–2012","gpsn":"","gpse":"","desc":"Josef Škvorecký patřil k nejvýznamnějším poválečným prozaikům. Po potlačení pražského jara v roce 1968 emigroval do Kanady, kde založil se svou manželkou nakladatelství '68 Publishers. V něm se vydávaly knihy, které byly v Československu zakázané.","index":"560560","idec":"212 411 00037/0103","bonus":"30220","sidp":"","director":"","type":"v","category":4},"v-4-9":{"id":"9","title":"První český nositel Nobelovy ceny","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["věda","1959"],"date":"1959","timeline":"1959","gpsn":"","gpse":"","desc":"Jaroslav Heyrovský změnil objevením polarografie celou elektroanalytickou chemii. Za svůj objev dostal v roce 1959 Nobelovu cenu a stal se tak prvním Čechem, který se tímto oceněním mohl pyšnit. ","index":"560562","idec":"217 411 05834/0013","bonus":"30231","sidp":"","director":"Dulava Jan","type":"v","category":4},"v-4-10":{"id":"10","title":"Chceme světlo!","topic":["společnost"],"subtopic":["studenti"],"tags":["Strahov","1967","1968","demonstrace","studenti","pražské jaro"],"date":"1967","timeline":"1967–1968","gpsn":"50.0805261","gpse":"14.3935361","desc":"Pod tímto heslem protestovalo 2000 studentů proti výpadku elektřiny, který postihl strahovské koleje. Demonstrace byla brutálně rozehnána Veřejnou bezpečností, akce se však stala jednou z předzvěstí pražského jara.","index":"","idec":"","bonus":"6920","sidp":"","director":"","type":"v","category":4},"v-4-11":{"id":"11","title":"Ludvík Svoboda se stává prezidentem","topic":["politika"],"subtopic":[""],"tags":["volby","prezident","politika","1968","pražské jaro"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Po vlně kritiky rezignoval v roce 1968 prezident Antonín Novotný na funkci prezidenta. Jeho nástupcem se stal hrdina z 2. světové války, generál Ludvík Svoboda.","index":"","idec":"","bonus":"7298","sidp":"","director":"","type":"v","category":4},"v-4-12":{"id":"12","title":"2000 slov","topic":["politika"],"subtopic":["pražské jaro"],"tags":["média","literatura","1968","pražské jaro"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Manifest Dva tisíce slov byl jedním z nejvýznamnějších dokumentů pražského jara. Jeho autorem byl spisovatel Ludvík Vaculík, prohlášení však podepsaly stovky dalších osobností veřejného života a více než sto tisíc občanů.","index":"560571","idec":"213 411 01010/0627","bonus":"","sidp":"","director":"Ďurica Peter","type":"v","category":4},"v-4-13":{"id":"13","title":"Alexander Dubček","topic":["politika"],"subtopic":["pražské jaro"],"tags":["pražské jaro","1968","okupace","Varšavská smlouva"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Po ostré kritice Novotného se stal v lednu 1968 novým prvním tajemníkem ÚV KSČ Alexander Dubček. Svým lidským vystupováním si rychle získal oblibu veřejnosti. S invazí vojsk Varšavské smlouvy v jeho politickém životě přišel ale velký zlom.","index":"560876","idec":"209 411 00010/1227","bonus":"","sidp":"","director":"Kotlář Vladimír","type":"v","category":4},"v-4-14":{"id":"14","title":"Ruce pryč od Československa","topic":["politika"],"subtopic":["srpen 1968"],"tags":["demonstrace","okupace","Varšavská smlouva","pražské jaro","Sovětský svaz"],"date":"1968","timeline":"1968","gpsn":"55.7542544","gpse":"37.6201161","desc":"Osm statečných si v srpnu 1968 dovolilo protestovat na Rudém náměstí v Moskvě proti okupaci Československa. Demonstranti byli odsouzeni k několikaletým trestům odnětí svobody nebo posláni do psychiatrické léčebny. Nejvíce se lidem do povědomí zapsala Natalja Gorbaněvská.","index":"560886","idec":"213 411 00010/1130 ","bonus":"30225","sidp":"","director":"","type":"v","category":4},"v-4-15":{"id":"15","title":"Moskevský protokol","topic":["politika"],"subtopic":["srpen 1968"],"tags":["Sovětský svaz","okupace","Varšavská smlouva","1968","pražské jaro","politika"],"date":"1968","timeline":"1968","gpsn":"55.7507178","gpse":"37.6176606","desc":"Českoslovenští politici doufali v socialismus s lidskou tváří. Konec nadějí ale přišel v srpnu 1968. Československá delegace – vyjma Františka Kriegla – podepsala Moskevský protokol, který korunoval okupaci Československa vojsky Varšavské smlouvy.","index":"560905","idec":"213 411 01010/0826 ","bonus":"30223","sidp":"","director":"Knopp Erik Mgr.art.","type":"v","category":4},"v-4-16":{"id":"16","title":"Polské povstání v roce 1956","topic":["politika"],"subtopic":[""],"tags":["Polsko","demonstrace","1956"],"date":"1956","timeline":"1956","gpsn":"52.4082664","gpse":"16.9335200","desc":"V červnu 1956 se v Poznani konaly protesty, ve kterých dělníci žádali lepší pracovní podmínky. Poznaňské povstání bylo sice krvavě potlačeno, přispělo však k podzimnímu uvolnění politické situace. ","index":"560906","idec":"206 411 00010/0628 ","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-17":{"id":"17","title":"Hrdina František Kriegel","topic":["politika"],"subtopic":["srpen 1968"],"tags":["okupace","Varšavská smlouva","1968","pražské jaro"],"date":"1968","timeline":"1968","gpsn":"55.7507178","gpse":"37.6176606","desc":"Lékař, politik, později dokonce člen Ústředního výboru KSČ František Kriegel byl jediným z československé delegace, kdo v roce 1968 nepodepsal Moskevský protokol. Po nastolení normalizace byl vyloučen z politického života.","index":"560940","idec":"208 411 00037/0410 ","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-18":{"id":"18","title":"Vpád vojsk Varšavské smlouvy","topic":["politika"],"subtopic":["srpen 1968"],"tags":["1968","okupace","armáda","Varšavská smlouva"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Roku 1945 přijeli jako osvoboditelé, roku 1968 jako okupanti. Vojska pěti zemí Varšavské smlouvy pod vedením Sovětského svazu překročila v noci z 20. na 21. srpna 1968 naše státní hranice. Násilně tím byl potlačen pokus o reformu socialismu. ","index":"","idec":"","bonus":"7294","sidp":"","director":"","type":"v","category":4},"v-4-19":{"id":"19","title":"Věra Čáslavská","topic":["sport"],"subtopic":[""],"tags":["sport","1968","olympiáda"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Nejúspěšnější česká sportovkyně se stala čtyřikrát mistryní světa. Kvůli svému postoji k režimu byla ale nucena sportovní kariéru ukončit – podepsala Manifest 2000 slov a během hraní sovětské hymny na olympijských hrách sklopila na protest proti sovětské okupaci Československa hlavu.","index":"560953","idec":"216 411 05809/0206 ","bonus":"30228","sidp":"","director":"Vlk Martin","type":"v","category":4},"v-4-20":{"id":"20","title":"Vasil Bil'ak ","topic":["politika"],"subtopic":[""],"tags":["pražské jaro","okupace","Varšavská smlouva","1968","KSČ"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Komunistický politik a pozdější tajemník Ústředního výboru KSČ Vasil Bil'ak byl jedním z autorů „zvacího dopisu“, který měl legitimizovat invazi vojsk Varšavské smlouvy. Společně s dalšími konzervativními komunisty v něm prosí Brežněva o pomoc proti „kontrarevoluci“ v Československu.","index":"560957","idec":"214 411 00010/0206","bonus":"","sidp":"","director":"Hackenschmied Hanuš","type":"v","category":4},"v-4-21":{"id":"21","title":"První československý jaderný reaktor","topic":["společnost"],"subtopic":[""],"tags":["1957","věda","jádro","technika"],"date":"1957","timeline":"1957","gpsn":"50.1776036","gpse":"14.3589303","desc":"V roce 1957 byl v Řeži uveden do provozu první československý jaderný reaktor, na jehož vybudování spolupracovali čeští a sovětští fyzici. Byl to nesmírně významný krok pro vývoj českého jaderného programu.","index":"561146","idec":"213 411 00036/0013","bonus":"","sidp":"","director":"Voženílek Tomáš","type":"v","category":4},"v-4-22":{"id":"22","title":"Starý Most mizí v propadlišti dějin","topic":["hospodářství"],"subtopic":[""],"tags":["architektura","hospodářství","těžba","propaganda","1965–1987","stavby"],"date":"1965","timeline":"1965–1987","gpsn":"50.5030069","gpse":"13.6361742","desc":"Most – město, které muselo ustoupit těžbě hnědého uhlí. Stát sice vydělal necelé 3 miliardy korun, zaplatil za to však památkami a krajinou, které zmizely v nenávratnu. Jedna skupina obyvatel však měla z odstřelu města radost – filmaři. ","index":"561157","idec":"212 411 00036/0016","bonus":"","sidp":"","director":"Voženílek Tomáš","type":"v","category":4},"v-4-23":{"id":"23","title":"Dočasný pobyt sovětských vojsk na našem území","topic":["politika"],"subtopic":[""],"tags":["1968","pražské jaro","okupace","armáda","Varšavská smlouva"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"V říjnu 1968 byla podepsána smlouva, která uzákoňovala pobyt vojsk Sovětského svazu v Československu. Pozvání se nakonec protáhlo na 23 let, vojáci odjeli až roku 1991.","index":"561160","idec":"217 411 05821/0019","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-24":{"id":"24","title":"Spisovatelé kritizují režim","topic":["společnost"],"subtopic":[""],"tags":["literatura","pražské jaro","KSČ","1967"],"date":"1967","timeline":"1967","gpsn":"","gpse":"","desc":"Na IV. sjezdu československých spisovatelů v roce 1967 zaznělo mnoho kritických slov na adresu komunistického režimu. Literáti, mezi nimiž byli Ivan Klíma, Ludvík Vaculík nebo Milan Kundera, upozorňovali na odlišnost názorů KSČ a občanů. Spisovatelé byli režimem potrestáni, přispěli ale výrazně k pražskému jaru.","index":"","idec":"","bonus":"6921","sidp":"","director":"","type":"v","category":4},"v-4-25":{"id":"25","title":"Československý film získává již druhého Oscara","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["umění","film","1968"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Československý film měl v šedesátých letech mimořádné postavení. O tom svědčí i fakt, že v průběhu tří let byly oceněny Oscarem hned dva naše filmy: Obchod na korze a Ostře sledované vlaky. V reportáži blahopřeje prezident Svoboda režisérovi Ostře sledovaných vlaků Jiřímu Menzelovi.","index":"561169","idec":"213 411 05821/0009 ","bonus":"30230","sidp":"","director":"","type":"v","category":4},"v-4-26":{"id":"26","title":"Semafor","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["divadlo","hudba","1959","umění"],"date":"1959","timeline":"1959","gpsn":"50.0991656","gpse":"14.3975933","desc":"Divadlo Semafor – tedy SEdm MAlých FORem – Jiřího Suchého a Jiřího Šlitra bylo populární už od premiéry první hry Člověk z půdy. Netrvalo dlouho a písničky této autorské dvojice se zpívaly od Šumavy k Tatrám.","index":"561170","idec":"214 411 05823/0049","bonus":"","sidp":"","director":"Jíra Luděk","type":"v","category":4},"v-4-27":{"id":"27","title":"Činoherní klub","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["divadlo","1965","umění"],"date":"1965","timeline":"1965","gpsn":"50.0792786","gpse":"14.4274444","desc":"Legendární Činoherní klub se zrodil v roce 1965. Od té doby ho navštívily již téměř 3 miliony diváků. Mimo slavná představení zde vzniklo také Občanské fórum. ","index":"562104","idec":"215 411 05823/0008","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-28":{"id":"28","title":"Počátky Divadla Na Zábradlí","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["divadlo","literatura","1958","umění"],"date":"1958","timeline":"1958","gpsn":"50.0850006","gpse":"14.4146531","desc":"Pražské Divadlo Na Zábradlí zahájilo svou činnost 9. 12. 1958 představením Kdyby tisíc klarinetů. Jeho diváci říkali, že se do divadla chodí nadýchat čerstvého vzduchu. ","index":"252251","idec":"213 411 00036/0014","bonus":"","sidp":"","director":"Šmídová Vojtěchová Aneta","type":"v","category":4},"v-4-29":{"id":"29","title":"Ota Šik a jeho ekonomické reformy","topic":["hospodářství"],"subtopic":["pražské jaro"],"tags":["krize","hospodářství","pražské jaro","emigrace","1968"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"V šedesátých letech byly z důvodu hospodářské krize nutné ekonomické reformy. Na jejich realizaci pracoval představitel pražského jara Ota Šik. Poukázal na to, že československý dělník je ve srovnání s tím západoněmeckým vlastně žebrák. Po příchodu vojsk v roce 1968 emigroval a v Československu začal být očerňován, některé jeho myšlenky zde však začaly být tajně realizovány.","index":"","idec":"","bonus":"7078","sidp":"","director":"","type":"v","category":4},"v-4-30":{"id":"30","title":"Arnošt Lustig","topic":["kultura a vzdělávání"],"subtopic":["literatura"],"tags":["umění","literatura","holocaust","Terezín","Osvětim","antisemitismus"],"date":"1968","timeline":"1926–2011","gpsn":"","gpse":"","desc":"Prošel Terezínem, Osvětimí a Buchenwaldem. Otřesné zážitky z koncentračních táborů zaznamenával do svých knih. Byl pověstný svým humorem, který neztrácel v žádné životní situaci. ","index":"562134","idec":"212 411 00010/0225","bonus":"","sidp":"","director":"Rásocha Jaroslav","type":"v","category":4},"v-4-31":{"id":"31","title":"Laterna magika","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["divadlo","1958","umění"],"date":"1958","timeline":"1958","gpsn":"50.081225","gpse":"14.414754","desc":"Multimediální divadlo Laterna magika se poprvé představilo v rámci bruselského Expa 58. Plátna na jevišti, která se obrazově doplňují s herci, tehdy svět šokovala. Dnes je Laterna magika součástí Nové scény Národního divadla.","index":"562135","idec":"214 411 05823/0018","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-32":{"id":"32","title":"Expedice Lambaréné","topic":["společnost"],"subtopic":["studenti"],"tags":["1968","studenti","cestování"],"date":"1968","timeline":"1968","gpsn":"-0.698602","gpse":"10.244579","desc":"Skupina československých studentů se v roce 1968 vydala na expedici do slavné nemocnice Alberta Schweitzera v gabunském Lambaréné. Tatrou 138 měli dovézt zdravotnický materiál až do tak vzdáleného místa v Africe. I odsud však měli možnost pozorovat vývoj politické situace u nás.","index":"562254","idec":"209 411 05806/1203 ","bonus":"30219","sidp":"","director":"","type":"v","category":4},"v-4-33":{"id":"33","title":"Liberec – město vzdoru ","topic":["politika"],"subtopic":["srpen 1968"],"tags":["demonstrace","okupace","1968","Varšavská smlouva"],"date":"1968","timeline":"1968","gpsn":"50.7699972","gpse":"15.0584492","desc":"V Liberci zahynulo během srpnové invaze 1968 celkem 9 lidí. Po Praze byl druhým největším místem odporu proti okupačním vojskům.","index":"562258","idec":"213 411 00014/0821","bonus":"30221","sidp":"","director":"","type":"v","category":4},"v-4-34":{"id":"34","title":"Srpnová noc ve vzpomínkách Kamily Moučkové","topic":["politika"],"subtopic":["srpen 1968"],"tags":["okupace","1968","Varšavská smlouva","média","televize"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Vyprávění moderátorky, která jako první oznámila z obrazovky Československé televize invazi vojsk Varšavské smlouvy. ","index":"","idec":"","bonus":"1385","sidp":"","director":"","type":"v","category":4},"v-4-35":{"id":"35","title":"Spartakiáda 1960","topic":["společnost"],"subtopic":[""],"tags":["propaganda","sport","volný čas","1960","Strahov"],"date":"1960","timeline":"1960","gpsn":"50.0805614","gpse":"14.3875469","desc":"Roku 1960 se na pražském Strahově konala druhá spartakiáda. Této masové sportovní přehlídky se zúčastnilo více než 750 tisíc cvičenců, jejichž výkony zhlédly téměř 2 milióny diváků. ","index":"251078","idec":"213 411 05821/0013","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-36":{"id":"36","title":"Majáles 1956","topic":["společnost"],"subtopic":["studenti"],"tags":["majáles","1956","studenti","volný čas"],"date":"1956","timeline":"1956","gpsn":"","gpse":"","desc":"V roce 1956 se výrazně kriticky projevili studenti během oslav majálesu. Vyzývali například k přehodnocení vztahů se Sovětským svazem. Kamera však tyto pro režim nepříznivé stránky průvodu nezachycuje...","index":"562270","idec":"213 411 05821/0013","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-37":{"id":"37","title":"Oldřich Černík","topic":["politika"],"subtopic":["pražské jaro"],"tags":["pražské jaro","1968","politika","okupace","normalizace"],"date":"1968","timeline":"1968–1970","gpsn":"","gpse":"","desc":"„Prosral jsem pozici i čest“, okomentoval v soukromém rozhovoru na jaře 1971 své posrpnové působení Oldřich Černík. Československý premiér a jeden z reformátorů v době pražského jara později podepsal moskevské protokoly a přidal se na stranu Gustava Husáka.","index":"562274","idec":"208 572 23311/0001","bonus":"","sidp":"","director":"Straka Marek","type":"v","category":4},"v-4-38":{"id":"38","title":"Nejkrásnější prezident Antonín Novotný","topic":["politika"],"subtopic":[""],"tags":["prezident","1953–1962"],"date":"1953","timeline":"1953–1968","gpsn":"","gpse":"","desc":"Dle legendy byl na valném shromáždění OSN zvolen nejkrásnějším prezidentem, a tak se mu mezi lidmi začalo přezdívat „schöne Tony“. Video zachycuje jeho návštěvu průmyslové Ostravy.","index":"562496","idec":"208 452 80135/0020","bonus":"30224","sidp":"","director":"Poledne Aleš","type":"v","category":4},"v-4-39":{"id":"39","title":"Podpovrchová dráha","topic":["společnost"],"subtopic":[""],"tags":["architektura","doprava","technika","1966"],"date":"1966","timeline":"1966","gpsn":"","gpse":"","desc":"V roce 1966 byla v Praze zahájena výstavba trasy C. V té době však projekt ještě nebyl zamýšlen jako metro, ale jako podpovrchová dráha pro tramvaje. Kvůli neefektivnosti trati nebyla výstavba dokončena a rozhodlo se tedy o přebudování podpovrchové dráhy na metro. Jako pozůstatek podpovrchové dráhy se ponechala stanice Hlavní nádraží.","index":"562498","idec":"266 531 09453","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-40":{"id":"40","title":"Bohumil Hrabal","topic":["kultura a vzdělávání"],"subtopic":["literatura"],"tags":["literatura","umění"],"date":"1965","timeline":"1914–1997","gpsn":"","gpse":"","desc":"Nejpřekládanější český prozaik Bohumil Hrabal obvykle zachycoval příběhy obyčejných lidí, v nichž však hledal hlubší filozofická témata. Zdánlivým hospodským pábením pak maskoval svou silnou, až surrealistickou obraznost. Po okupaci v roce 1968 se dostal na seznam zakázaných autorů.","index":"562501","idec":"214 411 01012/0323 ","bonus":"30218","sidp":"","director":"","type":"v","category":4},"v-4-41":{"id":"41","title":"Suchý-Šlitr","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["divadlo","hudba","umění"],"date":"1959","timeline":"1959–1969","gpsn":"","gpse":"","desc":"Legendární umělecká dvojice Suchý-Šlitr se léta pojila s Divadlem Semafor. Společně skládali písně jak pro sebe, tak i pro ostatní zpěváky. V rozhovoru vzpomíná Jiří Suchý na svého kolegu, který svět opustil před půlstoletím.","index":"565000","idec":"209 411 01010/1228","bonus":"30226","sidp":"","director":"","type":"v","category":4},"v-4-42":{"id":"42","title":"Milan Kundera ","topic":["kultura a vzdělávání"],"subtopic":["literatura"],"tags":["literatura","umění","emigrace"],"date":"1968","timeline":"1929–současnost","gpsn":"","gpse":"","desc":"Milan Kundera je ve světě nejznámnější český spisovatel, v Česku ho však tolik lidí nezná. V sedmdesátých letech emigroval do Francie, kde žije dodnes. Píše výhradně francouzsky a neposkytuje žádné rozhovory.  ","index":"565003","idec":"214 411 01010/0401","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-43":{"id":"43","title":"Co si děti přejí k nové pětiletce ","topic":["společnost"],"subtopic":[""],"tags":["vzdělávání","propaganda"],"date":"1960","timeline":"1960","gpsn":"","gpse":"","desc":"Dětský svět patřil k častým a věrným motivům Československé televize. Reportáž z jeslí v Hradci Králové měla občany povzbuzovat k pracovitosti, aby se jejich dětem dařilo dobře.","index":"565165","idec":"213 411 05821/0022","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-44":{"id":"44","title":"Miloš Forman","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["film","umění","televize","emigrace"],"date":"1965","timeline":"1932–současnost","gpsn":"","gpse":"","desc":"Miloš Forman patří mezi režiséry, kteří dobyli Hollywood. Po emigraci z Československa se proslavil filmem Nad kukaččím hnízdem. V osmdesátých letech u nás už jako zámořská hvězda natáčel trhák Amadeus. ","index":"565376","idec":"217 411 00010/0218","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-45":{"id":"45","title":"Václav Havel před rokem 1989","topic":["kultura a vzdělávání"],"subtopic":["divadlo a film"],"tags":["literatura","divadlo","umění","prezident","Charta 77","KSČ"],"date":"1967","timeline":"1936–1989","gpsn":"","gpse":"","desc":"Václav Havel již v šedesátých letech otevřeně kritizoval komunistický režim. Psal divadelní hry, které uvádělo Divadlo Na Zábradlí a zahraniční scény. Odpovědí mu byl zákaz veřejné činnosti a osobní perzekuce.","index":"565377","idec":"216 411 05813/1005","bonus":"30227","sidp":"","director":"","type":"v","category":4},"v-4-46":{"id":"46","title":"Lživá propaganda o Československu","topic":["politika"],"subtopic":[""],"tags":["hranice","1960","železná opona","TOTO100LETÍ ve škole","cestování"],"date":"1960","timeline":"1960","gpsn":"49.6550594","gpse":"12.5250819","desc":"Propagandistická reportáž z roku 1960 popisuje bezproblémový a čilý mezinárodní provoz na hraničním přechodu v Rozvadově.","index":"426987","idec":"215 411 05821/0027","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-47":{"id":"47","title":"Věc veřejná: O akčním programu","topic":["společnost"],"subtopic":[""],"tags":["pražské jaro","1968","politika","média","TOTO100LETÍ ve škole"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Publicistický pořad o tom, co si lidé myslí o novém tzv. akčním programu strany. Mezi zpovídanými občany se objevuje například Dana Němcová nebo Stanislav Devátý.","index":"604464","idec":"268 531 18797","bonus":"","sidp":"","director":"Pech Karel","type":"v","category":4},"v-4-48":{"id":"48","title":"Co je to duch národa?","topic":["společnost"],"subtopic":[""],"tags":["pražské jaro","1968","politika","média"],"date":"1969","timeline":"1969","gpsn":"","gpse":"","desc":"Co je to duch národa? Na otázku redaktora Oty Nutze odpovídá spisovatel Jiří Mucha. Nikdy neodvysílaný pořad ČST z roku 1969. ","index":"604472","idec":"269 531 07469","bonus":"","sidp":"","director":"Tomsa Milan","type":"v","category":4},"v-4-49":{"id":"49","title":"Zvědavá kamera: Znovu jaro","topic":["společnost"],"subtopic":[""],"tags":["pražské jaro","1968","politika","média","TOTO100LETÍ ve škole"],"date":"1969","timeline":"1969","gpsn":"49.9652839","gpse":"16.9706081","desc":"Nikdy neodvysílaný pořad ČST z roku 1969. Co je to duch národa? Vladimír Šimek odpovídá na otázku, co by řekl Janu Zajícovi, kdyby se s ním setkal před odjezdem do Prahy. Otázky pokládal redaktor Ota Nutz.","index":"496201","idec":"269 531 07469","bonus":"","sidp":"","director":"Tomsa Milan","type":"v","category":4},"v-4-50":{"id":"50","title":"Světová výstava EXPO 1958 v Bruselu","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1958","výstava","umění","kultura"],"date":"1958","timeline":"1958","gpsn":"","gpse":"","desc":"Světová výstava Expo 58 byla zajímavá díky první poválečné konfrontaci Východu a Západu. Československý pavilon v Bruselu zhlédlo tehdy více než šest milionů lidí. Exponáty přihlášené do soutěže získaly 56 velkých cen, 47 čestných diplomů, 35 zlatých, 18 stříbrných, a 14 bronzových medailí. ","index":"","idec":"210 542 15113/0001","bonus":"","sidp":"10290620971","director":"Jaroslav Soukup","type":"v","category":4},"v-4-51":{"id":"51","title":"Triumf v Mexiku: Věra Čáslavská","topic":["sport"],"subtopic":[""],"tags":["sport","1968","olympiáda"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Nejslavnější gymnastka a česká sportovkyně všech dob v životní roli olympijské vítězky. Čtyři cvičení Věry Čáslavské na OH v Mexiku s původním komentářem z roku 1968.","index":"609871","idec":"213 471 29101/9102","bonus":"","sidp":"","director":"","type":"v","category":4},"v-4-52":{"id":"52","title":"Dějiny na osm","topic":["společnost"],"subtopic":[""],"tags":["pražské jaro","1968","politika"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"V roce 1968 slavila republika další osmičkový rok. Po předchozích letech, která přinášela dramatické změny, věřili lidé, že atmosféra pražského jara jen tak neodejde. Miloš Kopecký v pořadu Dějiny na osm vzpomíná na předchozí osmičková výročí. Na závěr se obyvatel ptá, jaká očekávání mají od roku nastávajícího. Pořad byl odvysílán v lednu 1968. O osm měsíců později dorazily do Československa tanky okupačních vojsk.","index":"612803","idec":"208 382 54085","bonus":"","sidp":"","director":"Václav Táborský","type":"v","category":4},"v-4-53":{"id":"53","title":"Medaile z Grenoblu","topic":["sport"],"subtopic":[""],"tags":["sport","1968","olympiáda"],"date":"1968","timeline":"1968","gpsn":"45.1821511","gpse":"5.7274722","desc":"V roce 1968 se ve francouzském Grenoblu konaly 10. zimní Olympijské hry. Pro československou reprezentaci byly úspěšné - sportovci se vrátili domů s celkem čtyřmi medailemi. Jedinou zlatou získal skokan na lyžích Jiří Raška.","index":"612805","idec":"268 330 12939 ","bonus":"","sidp":"","director":"František Papoušek","type":"v","category":4},"v-5-1":{"id":"1","title":"Nuselský most","topic":["společnost"],"subtopic":[""],"tags":["stavby","doprava","1973","architektura"],"date":"1973","timeline":"1973","gpsn":"50.0657594","gpse":"14.4304119","desc":"Nuselský most je významnou inženýrskou stavbou, která si v době svého vzniku získala značnou pozornost i v zahraničí. Tato ukázka se zabývá předchozími koncepcemi přemostění nuselského údolí a samozřejmě také tou zrealizovanou.","index":"559964","idec":"213 411 00036/0029","bonus":"","sidp":"","director":"Šmídová Vojtěchová Aneta","type":"v","category":5},"v-5-2":{"id":"2","title":"Jaroslav Seifert získal Nobelovu cenu","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1984","literatura","umění"],"date":"1984","timeline":"1984","gpsn":"","gpse":"","desc":"Jaroslav Seifert byl a je nejznámějším českým básníkem, mistrem lyriky a poetismu. Ukázka zahrnuje záznam ceremoniálu při udělení Nobelovy ceny za literaturu Jaroslavu Seifertovi v roce 1984 a reakce režimu. ","index":"559968","idec":"213 411 00036/0040","bonus":"","sidp":"","director":"Dufek Jan","type":"v","category":5},"v-5-3":{"id":"3","title":"Mezinárodní spolupráce českých vědců: prof. Holý a prof. DeClerq","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["věda"],"date":"1976","timeline":"1936–2012","gpsn":"","gpse":"","desc":"Výzkum významného českého chemika Antonína Holého vedl k objevu léku proti AIDS. Ukázka popisuje začátek jeho spolupráce s belgickým profesorem Erikem De Clerqem v roce 1976.","index":"559971","idec":"415 235 10008/1005","bonus":"","sidp":"","director":"Motyčka Roman","type":"v","category":5},"v-5-4":{"id":"4","title":"Stěhování kostela v Mostě","topic":["hospodářství"],"subtopic":[""],"tags":["Most","těžba","1975"],"date":"1975","timeline":"1975","gpsn":"50.5030069","gpse":"13.6361742","desc":"Významná památka pokrušnohorské gotiky, kostel Nanebevzetí Panny Marie byl v roce 1975 kvůli těžbě uhlí přestěhován o více než 800 metrů. I přesto, že těžbě ustoupilo celé architektonicky a historicky významné město, socialistický režim využil stěhování kostela jako gesta, jak ohleduplně se chová ke kulturním památkám našeho státu.","index":"559974","idec":"215 411 05821/0031","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-5":{"id":"5","title":"První provoz metra","topic":["společnost"],"subtopic":[""],"tags":["1974","doprava","stavby","architektura","technika"],"date":"1947","timeline":"1974","gpsn":"50.0835494","gpse":"14.4341414","desc":"Počátkem roku 1974 byla slavnostně otevřena první linka metra v Praze. Zkušební provoz byl zaveden na trase C, a to z Kačerova do Sokolovské. ","index":"304598","idec":"214 411 05821/0004","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-6":{"id":"6","title":"Jaderná elektrárna Jaslovské Bohunice","topic":["hospodářství"],"subtopic":[""],"tags":["1973","jádro","stavby","technika"],"date":"1973","timeline":"1973","gpsn":"48.4760600","gpse":"17.6466000","desc":"V roce 1973 byla uvedena do provozu první československá jaderná elektrárna Jaslovské Bohunice. Elektrárna využívala kombinaci sovětských technologií a vlastních československých patentů. ","index":"560168","idec":"213 411 05821/0035","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-7":{"id":"7","title":"Jan Patočka","topic":["kultura a vzdělávání"],"subtopic":["neoficiální kultura"],"tags":["underground","Charta 77","vzdělávání","věda","1977"],"date":"1977","timeline":"1977","gpsn":"","gpse":"","desc":"Nejvýznamější moderní český filosof Jan Patočka patřil mezi přední evropské myslitele a podílel se na popularizaci filosofie u nás. Prokázal také velkou občanskou statečnost, a to jak organizováním bytových seminářů, tak zejména při organizaci petice za propuštění hudebníků kapely Plastic People. Byl jedním z prvních mluvčích Charty 77. Zemřel v březnu 1977 na následky jednoho z vyčerpávajících výslechů StB. ","index":"","idec":"215 411 05809/0509","bonus":"20748","sidp":"","director":"Ďurica Peter","type":"v","category":5},"v-5-8":{"id":"8","title":"Jaroslav Dietl","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["normalizace","film","televize","umění"],"date":"1978","timeline":"1929–1985","gpsn":"","gpse":"","desc":"Portrét slavného scénáristy, mistra dialogů a autora kultovních normalizačních seriálů Nemocnice na kraji města, Žena za pultem nebo Okres na severu.","index":"560376","idec":"215 562 23500/0023","bonus":"","sidp":"","director":"Sládek Jan","type":"v","category":5},"v-5-9":{"id":"9","title":"Proces s vydavateli Vokna","topic":["kultura a vzdělávání"],"subtopic":["neoficiální kultura"],"tags":["underground","perzekuce","proces","literatura","1981"],"date":"1981","timeline":"1981","gpsn":"","gpse":"","desc":"František Čuňas Stárek vypráví o procesech s vydavateli samizdatového časopisu Vokno. Vokno vycházelo od roku 1979 a v roce 1981 byli zatčeni a odsouzeni k nepodmíněným trestům odnětí svobody jeho autoři a vydavatelé František Stárek, Ivan Jirous, Michal Hýbek a Milan Frič. Stárek popisuje také postupy StB po ukončení prvního trestu a další zatčení v roce 1989.","index":"560379","idec":"210 452 80139/0011","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":5},"v-5-10":{"id":"10","title":"Vysílač na Ještědu","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["stavby","architektura","technika","1973"],"date":"1973","timeline":"1973","gpsn":"50.7326872","gpse":"14.9845903","desc":"Vysílač na Ještědu jako příklad nejmodernější architektury své doby. Byl navržen architektem Karlem Hubáčkem a stavba byla dokončena v roce 1973. Ukázka představuje moderní řešení stavby a její kladný ohlas v zahraničí.","index":"560382","idec":"213 411 00036/0029","bonus":"","sidp":"","director":"Šmídová Vojtěchová Aneta","type":"v","category":5},"v-5-11":{"id":"11","title":"ME ve fotbale v roce 1976","topic":["sport"],"subtopic":[""],"tags":["1976","fotbal","sport"],"date":"1976","timeline":"1976","gpsn":"44.8178786","gpse":"20.4568089","desc":"Fotbalové mistrovství Evropy v roce 1976 se konalo v jugoslávském Bělehradě. Finálový zápas mezi Československem a Spolkovou republikou Německo byl napínavý a neuvěřitelně vyrovnaný, ale penaltové kopy rozhodly o vítězství Československa. Rozhodující penaltu proměnil Antonín Panenka. ","index":"566329","idec":"214 471 29402/0014","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-12":{"id":"12","title":"Hokejové mistrovství světa v roce 1976","topic":["sport"],"subtopic":[""],"tags":["1976","hokej","sport"],"date":"1976","timeline":"1976–1977","gpsn":"","gpse":"","desc":"Karel Gut v pořadu vzpomíná na své úspěšné období ve funkci trenéra národního hokejového týmu a především zisk dvou titulů mistra světa v letech 1976 a 1977. Pořad obsahuje i vzpomínky hráčů a funkcionářů na Karla Guta.","index":"560388","idec":"214 471 29402/0001","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-13":{"id":"13","title":"Dálnice Praha–Bratislava","topic":["společnost"],"subtopic":[""],"tags":["stavby","doprava","1980","architektura","automobil"],"date":"1980","timeline":"1980","gpsn":"","gpse":"","desc":"Dálnice spojující dvě hlavní centra Československa byla dokončena v roce 1980. Jak probíhala její stavba a jaké materiály byly při stavbě použity? ","index":"560390","idec":"210 411 00036/0003","bonus":"","sidp":"","director":"Šantúr Roman","type":"v","category":5},"v-5-14":{"id":"14","title":"Bytové semináře","topic":["kultura a vzdělávání"],"subtopic":["neoficiální kultura"],"tags":["vzdělávání","underground"],"date":"1969","timeline":"1969–1980","gpsn":"","gpse":"","desc":"Tisíce lidí nemohly studovat, vystavovat, hrát vlastní hudbu či divadlo. Azylem se jim staly byty, které se proměnily v galerie, koncertní sály nebo univerzity. ","index":"560547","idec":"414 235 10022/1002","bonus":"","sidp":"","director":"Fiedor Jiří","type":"v","category":5},"v-5-15":{"id":"15","title":"Anticharta","topic":["politika"],"subtopic":["Charta 77"],"tags":["perzekuce","normalizace","propaganda","Charta 77","1977"],"date":"1977","timeline":"1977","gpsn":"","gpse":"","desc":"Komunistický režim se musel po vniku Charty 77 ideově vypořádat s jejími signatáři. Proto sezval dne 28. ledna 1977 do Národního divadla představitele české umělecké scény, aby podepsali dokument odsuzující Chartu 77 tzv. Antichartu.","index":"560566","idec":"216 562 26618","bonus":"","sidp":"","director":"Křemen Pavel, Křemen Pavel","type":"v","category":5},"v-5-16":{"id":"16","title":"Vladimír Remek ve vesmíru","topic":["společnost"],"subtopic":[""],"tags":["1978","vesmír","věda","technika","letectví"],"date":"1978","timeline":"1978","gpsn":"","gpse":"","desc":"Vladimír Remek se stal v roce 1978 prvním člověkem ve vesmíru, který nepocházel z USA nebo SSSR. Na sovětskou vesmírnou stanici letěl na palubě kosmické lodi Sojuz 28 a ve vesmíru prožil celkem 7 dní a 22 hodin.","index":"560567","idec":"213 411 00036/0034","bonus":"","sidp":"","director":"Šmídová Vojtěchová Aneta","type":"v","category":5},"v-5-17":{"id":"17","title":"Ropáci","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["těžba","ekologie","film","umění","1988"],"date":"1988","timeline":"1988","gpsn":"","gpse":"","desc":"Absolventský film Jana Svěráka paroduje ekologické myšlení 80. let. Mohly by v „měsíční krajině“ hnědouhelných dolů a výsypek žít nové živočišné druhy? ","index":"560572","idec":"297 383 65832","bonus":"","sidp":"","director":"Svěrák Jan","type":"v","category":5},"v-5-18":{"id":"18","title":"Hnutí Brontosaurus","topic":["společnost"],"subtopic":[""],"tags":["ekologie","1974"],"date":"1974","timeline":"1974","gpsn":"","gpse":"","desc":"Ukázka popisuje vznik ekologického hnutí Brontosaurus a fungování jím pořádaných brigád na dobrovolnické bázi. Jednalo se o režimem schválený pokus o zlepšení životního prostředí.","index":"560575","idec":"211 411 00036/0019","bonus":"","sidp":"","director":"Bareš Ivan","type":"v","category":5},"v-5-19":{"id":"19","title":"Evžen Plocek","topic":["politika"],"subtopic":["živé pochodně"],"tags":["sebeupálení","1969","Varšavská smlouva"],"date":"1969","timeline":"1969","gpsn":"49.3961000","gpse":"15.5912447","desc":"Evžen Plocek se v dubnu 1969 upálil v centru Jihlavy na protest proti okupaci Československa vojsky Varšavské smlouvy. Evžen Plocek je znám také jako tzv. Pochodeň č. 3.","index":"566331","idec":"214 452 80124/0004","bonus":"","sidp":"","director":"Omasta Vladko, Raupachová Stanislava, Šantúr Roman, Vlk Martin","type":"v","category":5},"v-5-20":{"id":"20","title":"Havlův dopis Husákovi","topic":["politika"],"subtopic":[""],"tags":["normalizace","1975","perzekuce"],"date":"1975","timeline":"1975","gpsn":"","gpse":"","desc":"Václav Havel se rozhodl na normalizační prázdnotu reagovat dopisem prezidentovi Gustávu Husákovi. V důsledku tohoto kroku se Havel dostává pod každodenní policejní sledování.","index":"560579","idec":"214 562 26499","bonus":"","sidp":"","director":"Sedláčková Andrea","type":"v","category":5},"v-5-21":{"id":"21","title":"Proces s Plastic People of the Universe","topic":["politika"],"subtopic":["Charta 77"],"tags":["proces","underground","1976","perzekuce"],"date":"1976","timeline":"1976","gpsn":"","gpse":"","desc":"Ukázka ze série České století vypraví o procesu s Plastic People of the Universe. Václav Havel a jiní intelektuálové se dostavili k soudu, aby podpořili obviněné hudebníky. Tento soudní proces nastartoval sérii událostí, které vedly k založení Charty 77.","index":"560950","idec":"212 512 12057","bonus":"","sidp":"","director":"Sedláček Robert","type":"v","category":5},"v-5-22":{"id":"22","title":"Jaderné zbraně u nás","topic":["politika"],"subtopic":[""],"tags":["jádro","technika","armáda","Varšavská smlouva"],"date":"1976","timeline":"1976–1988","gpsn":"","gpse":"","desc":"Byly na našem území v době totality jaderné hlavice a odpalovací zařízení? Ukázka popisuje rozmístění raket SS-20 v SSSR a následné rozmístění Pershingů v západní Evropě. ","index":"560960","idec":"213 452 80140/0018","bonus":"","sidp":"","director":"Romanov Vítězslav","type":"v","category":5},"v-5-23":{"id":"23","title":"Jaderná elektrárna Dukovany","topic":["hospodářství"],"subtopic":[""],"tags":["jádro","stavby","technika","1985"],"date":"1985","timeline":"1985","gpsn":"49.0902167","gpse":"16.1461608","desc":"Plány na výstavbu jaderné elektrárny vznikly již v sedmdesátých letech 20. století. Plánování i výstavba probíhala za sovětské asistence.","index":"560963","idec":"213 411 00036/0041","bonus":"","sidp":"","director":"Bareš Ivan","type":"v","category":5},"v-5-24":{"id":"24","title":"Dana Němcová","topic":["politika"],"subtopic":["Charta 77"],"tags":["underground","perzekuce"],"date":"1979","timeline":"1934–2017","gpsn":"","gpse":"","desc":"Disidentka Dana Němcová vypráví o svém životě s filozofem Jiřím Němcem a o jejich politických aktivitách. Zmiňuje se rovněž o svém uvěznění a spolupráci s jinými chartisty.","index":"560967","idec":"208 452 80141/0014","bonus":"","sidp":"","director":"Vondráček David","type":"v","category":5},"v-5-25":{"id":"25","title":"Charta 77","topic":["politika"],"subtopic":["Charta 77"],"tags":["Charta 77","underground"],"date":"1977","timeline":"1977","gpsn":"","gpse":"","desc":"Co si myslel o Chartě 77 Jan Patočka? Jak probíhalo získávání signatářů Charty a také realizace zveřejnění Charty 77 v zahraničním tisku? Ukázka z cyklu České století. ","index":"560970","idec":"212 512 12057","bonus":"","sidp":"","director":"Sedláček Robert","type":"v","category":5},"v-5-26":{"id":"26","title":"Jan Kodeš","topic":["sport"],"subtopic":[""],"tags":["sport"],"date":"1973","timeline":"1966–1980","gpsn":"","gpse":"","desc":"Slavný československý tenista, vítěz Wimbledonu i French Open Jan Kodeš vypraví o svém dětství a cestě k tenisovému vrcholu.","index":"560971","idec":"202 471 29602/0031","bonus":"","sidp":"","director":"Střecha Jiří","type":"v","category":5},"v-5-27":{"id":"27","title":"Veksláci","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","normalizace"],"date":"1980","timeline":"1957–1980","gpsn":"","gpse":"","desc":"Veksláci byli pro komunistický režim důležití, přestože jejich počínaní bylo trestné. Černý obchod s valutami totiž umožňoval přísun drahocenné zahraniční měny.","index":"561155","idec":"209 411 00036/0032","bonus":"","sidp":"","director":"Bareš Ivan","type":"v","category":5},"v-5-28":{"id":"28","title":"Poučení z krizového vývoje","topic":["politika"],"subtopic":["nástup normalizace"],"tags":["1970","normalizace","Varšavská smlouva","okupace","KSČ"],"date":"1970","timeline":"1970","gpsn":"","gpse":"","desc":"Tzv. Poučení z krizového vývoje vzniklo v roce 1970 a stalo se oficiální interpretací sovětské invaze v roce 1968. Tato oficiální verze okupace byla režimem tvrdě prosazována.","index":"561168","idec":"210 411 00010/1210","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-29":{"id":"29","title":"Podpultový prodej","topic":["hospodářství"],"subtopic":[""],"tags":["normalizace","hospodářství"],"date":"1979","timeline":"1970–1989","gpsn":"","gpse":"","desc":"Občané ČSSR trpěli – především ve srovnání se západními zeměmi – nedostatkem spotřebního zboží. Právě přístup k nedostatkovému zboží řešili českoslovenští občané úplatky či navazováním blízkých vztahů s prodejci. ","index":"561355","idec":"209 411 00036/0018","bonus":"","sidp":"","director":"Bareš Ivan","type":"v","category":5},"v-5-30":{"id":"30","title":"Šedá ekonomika","topic":["hospodářství"],"subtopic":[""],"tags":["normalizace","hospodářství"],"date":"1971","timeline":"1969–1989","gpsn":"","gpse":"","desc":"Práce na černo zažívala během normalizace rozkvět, neboť komunistický režim nebyl schopen zajistit občanům kvalitní služby. Instalatéři, zedníci a řemeslníci si zase chtěli přivydělat ke svému platu, a tak bylo běžné „dělat melouchy“.","index":"561358","idec":"211 411 00036/0004","bonus":"","sidp":"","director":"Šantúr Roman","type":"v","category":5},"v-5-31":{"id":"31","title":"Ivan Martin Jirous","topic":["kultura a vzdělávání"],"subtopic":["neoficiální kultura"],"tags":["underground","Charta 77","proces","perzekuce","umění"],"date":"1977","timeline":"1973–1989","gpsn":"","gpse":"","desc":"Básník, publicista, umělecký vedoucí skupiny Plastic People of the Universe Ivan Martin Jirous vypráví o svém věznění i o boji s komunistickým režimem.","index":"561374","idec":"206 562 21080/0044","bonus":"","sidp":"","director":"Slavík Petr, Šajmovič Juraj","type":"v","category":5},"v-5-32":{"id":"32","title":"JZD Slušovice","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","zemědělství"],"date":"1985","timeline":"1952–1989","gpsn":"49.2478181","gpse":"17.8014972","desc":"Hospodářský zázrak, JZD Slušovice byly zemědělským koncernem, který obchodoval se zahraničním a neorientoval se pouze na zemědělskou produkci.Bývalí zaměstnanci koncernu JZD Slušovice vyprávějí o své zkušenosti s tímto podnikem.","index":"562269","idec":"208 411 00036/0618","bonus":"","sidp":"","director":"Bareš Ivan","type":"v","category":5},"v-5-33":{"id":"33","title":"Solidarita","topic":["politika"],"subtopic":[""],"tags":["Polsko","1980"],"date":"1980","timeline":"1980","gpsn":"54.3476281","gpse":"18.6452028","desc":"V roce 1980 vzniklo v Polsku odborové hnutí Solidarita, které se stalo jednou ze sil, která přispěla k demontáži komunismu v roce 1989 ve východní Evropě.","index":"562273","idec":"205 411 00010/0829","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-34":{"id":"34","title":"Glasnosť a perestrojka","topic":["politika"],"subtopic":[""],"tags":["politika","Sovětský svaz"],"date":"1987","timeline":"1987–1989","gpsn":"","gpse":"","desc":"Glasnosť a perestrojka byly termíny, které zavedl v osmdesátých letech v SSSR generální tajemník ÚV KSSS Michail Gorbačov. Glasnosť omezila cenzuru, neboť Gorbačov chtěl, aby se v SSSR mohlo svobodněji diskutovat a tím napravit některé chyby režimu. Perestrojka byla ekonomickou přestavbou, která měla za cíl reformovat sovětské hospodářství. Vedení KSČ souhlasilo s perestrojkou, avšak na glasnosť se dívalo s nedůvěrou.","index":"562289","idec":"212 411 00036/0017","bonus":"","sidp":"","director":"Šantúr Roman","type":"v","category":5},"v-5-35":{"id":"35","title":"LOH 1984: Socialistické země bojkotují olympiádu v USA","topic":["sport"],"subtopic":[""],"tags":["1984","sport","olympiáda"],"date":"1984","timeline":"1984","gpsn":"34.0549350","gpse":"118.2444761W","desc":"Letních olympijských her v Los Angeles roku 1984 se nezúčastnily SSSR a většina socialistických zemí, a to v důsledku ochlazení vztahů mezi Západem a Východem. Přesto se jednalo úspěšné letní olympijské hry. Na olympiádě zazářil Carl Lewis, který získal čtyři zlaté olympijské medaile.","index":"351235","idec":"214 471 29029/0035 ","bonus":"","sidp":"","director":"Šíma David","type":"v","category":5},"v-5-36":{"id":"36","title":"Demonstrace 17. listopadu 1989","topic":["politika"],"subtopic":["protesty a demonstrace"],"tags":["demonstrace","1989","studenti"],"date":"1989","timeline":"1989","gpsn":"50.0819300","gpse":"14.4179222","desc":"Dne 17. listopadu 1989 uspořádali studenti na Albertově demonstraci v den 50. výročí uzavření vysokých škol nacisty. Demonstrace se poté z Albertova přesunula na Vyšehrad, kde studenti zazpívali státní hymnu. Potom dav došel až na Národní třídu, kde byli studenti obklíčeni policií a surově zbiti. Tato událost odstartovala sametovou revoluci.","index":"562713","idec":"216 562 26551","bonus":"","sidp":"","director":"Sommerová Olga doc.Mgr.","type":"v","category":5},"v-5-37":{"id":"37","title":"Stávky studentů v roce 1989","topic":["politika"],"subtopic":["protesty a demonstrace"],"tags":["vzdělávání","studenti","demonstrace","1989"],"date":"1989","timeline":"1989","gpsn":"","gpse":"","desc":"Po tvrdém potlačení demonstrace na Národní třídě za dne 17. listopadu 1989 se studenti rozhodli vstoupit do stávky. Do stávky vstoupila FAMU, Filozofická fakulta UK, Fakulta žurnalistiky UK a mnohé další. Studentské stávky byly důležitým prostředkem nátlaku na komunistický režim a zároveň inspirací pro dělníky a odbory, které se postupně také ke stávce přidaly. ","index":"562715","idec":"216 562 26551","bonus":"","sidp":"","director":"Sommerová Olga doc.Mgr.","type":"v","category":5},"v-5-38":{"id":"38","title":"Sebeupálení Jana Palacha","topic":["politika"],"subtopic":["živé pochodně"],"tags":["pohřeb","sebeupálení","1969"],"date":"1969","timeline":"1969","gpsn":"50.0796056","gpse":"14.4299547","desc":"Student Filozofické fakulty Jan Palach se 16. ledna 1969 zapálil na Václavském náměstí na protest proti potlačování svobod a nastupující pasivitě československé veřejnosti. Dokument obsahuje reflexi Palachova činu ze strany Václava Havla a Tomáše Halíka.","index":"562716","idec":"214 542 15720","bonus":"","sidp":"","director":"Soukup Jan","type":"v","category":5},"v-5-39":{"id":"39","title":"Bojanovice","topic":["politika"],"subtopic":["neoficiální kultura"],"tags":["Charta 77","1976","underground","perzekuce","hudba","umění"],"date":"1976","timeline":"1976","gpsn":"49.8544375","gpse":"14.3520386","desc":"V Bojanovicích se v roce 1976 u příležitosti svatby Ivana Martina Jirouse uskutečnil také koncert zakázané kapely The Plastic People of the Universe. Následný soudní proces vedl k uvěznění členů kapely The Plastic People of the Universe a byl klíčový pro vznik Charty 77.","index":"562729","idec":"409 235 10022/1008","bonus":"","sidp":"","director":"Křemen Pavel","type":"v","category":5},"v-5-40":{"id":"40","title":"Potlačení demonstrace v roce 1969","topic":["kultura a vzdělávání"],"subtopic":["protesty a demonstrace"],"tags":["demonstrace","1969","okupace","Varšavská smlouva"],"date":"1969","timeline":"1969","gpsn":"","gpse":"","desc":"Demonstrace 21. srpna 1969 u příležitosti prvního výročí od sovětské invaze byla násilně potlačena policií, armádou a lidovými milicemi. Petr Pithart vzpomíná na svoji účast na demonstraci a represivní postup režimu.","index":"562841","idec":"207 452 80139/0001","bonus":"","sidp":"","director":"Křístek Václav","type":"v","category":5},"v-5-41":{"id":"41","title":"Pendrekový zákon","topic":["politika"],"subtopic":["protesty a demonstrace"],"tags":["demonstrace","1969","normalizace"],"date":"1969","timeline":"1969","gpsn":"","gpse":"","desc":"Alexander Dubček jako předseda Národního shromáždění podepsal v srpnu 1969 tzv. pendrekový zákon. Tento zákon umožnil tvrdé zásahy i pozdější perzekuci demonstrantů.","index":"562842","idec":"306 295 35034/0001","bonus":"","sidp":"","director":"Chudoba Rudolf","type":"v","category":5},"v-5-42":{"id":"42","title":"Demonstrace na Letné","topic":["politika"],"subtopic":["protesty a demonstrace"],"tags":["demonstrace","1989"],"date":"1989","timeline":"1989","gpsn":"50.0979461","gpse":"14.4160019","desc":"Demonstrací pod záštitou Občanského fóra na pražské Letné ve dnech 25. a 26. listopadu 1989 se zúčastnilo téměř tři čtvrtě miliónu lidí. Hovořili zde také vůdce studentů Martin Mejstřík a disident Václav Havel. Na vlastní žádost se slova ujal i tehdejší premiér Ladislav Adamec. Jeho výstup však pro něj dopadl špatně. Ukázka pochází ze série České století.","index":"562899","idec":"213 512 12041","bonus":"","sidp":"","director":"Sedláček Robert","type":"v","category":5},"v-5-43":{"id":"43","title":"Filmová cenzura","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["film","normalizace","umění"],"date":"1969","timeline":"1969–1989","gpsn":"","gpse":"","desc":"Nastupující normalizace s sebou přinesla utužení nejen v politické, ale i v kulturní oblasti. Na Barrandově došlo k zavedení silné cenzury. K nejtužším cenzorům patřil Ludvík Toman, který svými zásahy negativně ovlivnil řadu vznikajících filmů.","index":"563081","idec":"212 562 26284","bonus":"","sidp":"","director":"Stehlík Jan","type":"v","category":5},"v-5-44":{"id":"44","title":"Kostel sv. Josefa v Senetářově","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["stavby","architektura","církev","1971","umění"],"date":"1969","timeline":"1969–1971","gpsn":"49.3533469","gpse":"16.8042239","desc":"Ojedinělý případ církevní stavby, která vznikla v době normalizace i navzdory nepřízni komunistické strany, a to v roce 1971. Unikátní modernistický kostel podle návrhu Ludvíka Kolka a Otakara Vrabce vznikl hlavně díky odvaze faráře Františka Vavříčka a finančním příspěvkům od obyčejných občanů. Na výzdobě kostela se podílel Mikuláš Medek.","index":"563082","idec":"208 522 16235/0005","bonus":"","sidp":"","director":"Lipus Radovan","type":"v","category":5},"v-5-45":{"id":"45","title":"Pohřeb Jana Palacha","topic":["politika"],"subtopic":["živé pochodně"],"tags":["pohřeb","1969","sebeupálení"],"date":"1969","timeline":"1969","gpsn":"","gpse":"","desc":"Ačkoliv Gustáv Husák byl během pražského jara v roce 1968 stoupenec reforem, po vpádu vojsk Varšavské smlouvy a zejména po jednáních v Moskvě se rozhodl pro pragmatický přístup. Stal se hlavním představitelem tzv. normalizace poměrů. V dubnu 1969 se stal prvním tajemníkem ÚV KSČ a v roce 1975 byl zvolen prezidentem ČSSR.","index":"563084","idec":"208 562 26883","bonus":"","sidp":"","director":"Vlachová Kristina","type":"v","category":5},"v-5-46":{"id":"46","title":"Svatořečení Anežky České","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1989","církev"],"date":"1989","timeline":"1989","gpsn":"41.8933203","gpse":"12.4829322","desc":"Komunistický režim odmítl svatořečení Anežky České za účasti papeže v Praze. Na nátlak katolické církve doma i v zahraničí nakonec umožnil československým poutníkům odcestovat na kanonizaci v listopadu 1989 do Říma. Zde se poutníci setkali s papežem Janem Pavlem II.","index":"563085","idec":"214 411 00037/1020","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-47":{"id":"47","title":"Zvolení Gustáva Husáka generálním tajemníkem ÚV KSČ","topic":["politika"],"subtopic":["nástup normalizace"],"tags":["KSČ","1969","normalizace"],"date":"1969","timeline":"1913–1991","gpsn":"","gpse":"","desc":"Ačkoliv Gustáv Husák byl během pražského jara v roce 1968 stoupenec reforem, po vpádu vojsk Varšavské smlouvy a zejména po jednáních v Moskvě se rozhodl pro pragmatický přístup. Stal se hlavním představitelem tzv. normalizace poměrů. V dubnu 1969 se stal prvním tajemníkem ÚV KSČ a v roce 1975 byl zvolen prezidentem ČSSR.","index":"563103","idec":"208 411 03329/0002","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-48":{"id":"48","title":"Emigrace","topic":["společnost"],"subtopic":[""],"tags":["emigrace","1948","1968","hranice"],"date":"1968","timeline":"1968","gpsn":"","gpse":"","desc":"Československo postihlo několik emigračních vln, nejvíce lidí odešlo po komunistickém převratu v roce 1948 a utužení poměrů v srpnu 1968. Československo tak přišlo o elity z vědecké, kulturní i podnikatelské oblasti.","index":"563121","idec":"411 235 10018/1005","bonus":"","sidp":"","director":"Petrov Marcel","type":"v","category":5},"v-5-49":{"id":"49","title":"Palachův týden","topic":["historie","politika"],"subtopic":[""],"tags":["Jan Palach","John Bok","Stanislav Devátý","demonstrace","Jan Palach","protest","živá pochodeň","sebeupálení"],"date":"1989","timeline":"1989","gpsn":"","gpse":"","desc":"Mezi 15. a 22. lednem 1989 proběhla na Václavském náměstí série demonstrací, označovaná též jako Palachův týden. Ten se stal prvním signálem blížícího se konce komunistické vlády v Československu. Palachův týden odstartovalo násilné rozehnání několika tisíc lidí, kteří se i přes oficiální zákaz sešli na Václavském náměstí, aby zde uctili památku Jana Palacha, který se upálil 16.1. 1969 ve snaze vyburcovat společnost z letargie. ","index":"560965","idec":"214 411 00010/0112","bonus":"","sidp":"","director":"Škampa Michal","type":"v","category":5},"v-5-50":{"id":"50","title":"Celostátní sjezd JZD v roce 1984","topic":["hospodářství"],"subtopic":[""],"tags":["1984","hospodářství","zemědělství","kolektivizace","TOTO100LETÍ ve škole"],"date":"1984","timeline":"1984","gpsn":"","gpse":"","desc":"Dobová reportáž z roku 1984 informuje o 10. celostátním sjezdu JZD v pražském Paláci Kultury (dnes Kongresové centrum). Účastníci zde vyslechli statistiky společného hospodaření, které ukázaly, že zemědělská produkce dosáhla skvělých výsledků.","index":"464323","idec":"216 411 05821/0015","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-51":{"id":"51","title":"Sjezd JZD roku 1989","topic":["hospodářství"],"subtopic":[""],"tags":["1989","hospodářství","zemědělství","kolektivizace","TOTO100LETÍ ve škole"],"date":"1989","timeline":"1989","gpsn":"","gpse":"","desc":"V roce 1989 se v Praze sjeli zástupci JZD, aby zde zhodnotili výsledky plnění úkolů zemědělsko-potravinářské produkce v 8. pětiletce.","index":"464324","idec":"216 411 05821/0015","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-52":{"id":"52","title":"Pozdravy pohraničníkům","topic":["politika"],"subtopic":[""],"tags":["hranice","1951","železná opona","TOTO100LETÍ ve škole"],"date":"1972","timeline":"1972","gpsn":"","gpse":"","desc":"Dobová reportáž připomíná vývoj ochrany hranic, a to od Pohotovostních pluků, které střežily hranice od poválečných měsíců 1945, až ke vzniku zákona O ochraně státních hranic z roku 1951.","index":"481467","idec":"272 531 12670","bonus":"","sidp":"","director":"Podhorec Tibor","type":"v","category":5},"v-5-53":{"id":"53","title":"Most před Nuselské údolí","topic":["společnost"],"subtopic":[""],"tags":["stavby","doprava","1973","architektura","TOTO100LETÍ ve škole"],"date":"1973","timeline":"1973","gpsn":"50.0657594","gpse":"14.4304119","desc":"Most přes nuselské údolí byl původně pojmenován most Klementa Gottwalda. Podívejte se na záběry ze slavnostního otevření mostu, které se konalo v roce 1973 u příležitosti 25. výročí od Vítězného února.","index":"443988","idec":"216 411 05821/0001","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-54":{"id":"54","title":"Mistrovství světa v hokeji 1972","topic":["sport"],"subtopic":[""],"tags":["1972","hokej","sport","mistrovství světa","ms"],"date":"1972","timeline":"1972","gpsn":"50.0835494","gpse":"14.4341414","desc":"V roce 1972 čekala československá hokejová reprezentace na titul už 23 let. Nakonec se národnímu týmu podařilo ve finále mistrovství světa v Praze porazit tým Sovětského svazu 3:2.","index":"","idec":"","bonus":"7786","sidp":"","director":"","type":"v","category":5},"v-5-55":{"id":"55","title":"Kamila Bendová","topic":["politika"],"subtopic":["Charta 77"],"tags":["Charta 77","underground","TOTO100LETÍ ve škole","feminismus","perzekuce"],"date":"1977","timeline":"1977","gpsn":"","gpse":"","desc":"Matematička Kamila Bendová založila s manželem Václavem Bendou početnou rodinu, která se aktivně angažovala v prostředí českého disentu. V ukázce popisuje okolnosti a následky podpisu Charty 77 pro ni samotnou a její rodinu.","index":"603158","idec":"206 562 26400/0003","bonus":"","sidp":"","director":"Smržová Dagmar","type":"v","category":5},"v-5-56":{"id":"56","title":"Zdena Tominová – Mluvčí Charty 77","topic":["politika"],"subtopic":["Charta 77"],"tags":["Charta 77","underground","TOTO100LETÍ ve škole","feminismus","perzekuce"],"date":"1977","timeline":"1977","gpsn":"","gpse":"","desc":"Zdena Tominová popisuje v pořadu svoji zkušenost se zastáváním funkce Mluvčí Charty 77 v době, kdy její oba spolumluvčí byli zatčeni v procesu s Výborem na obranu nespravedlivě stíhaných.","index":"603159","idec":"206 562 26400/0007","bonus":"","sidp":"","director":"Hynková Alena","type":"v","category":5},"v-5-57":{"id":"57","title":"Kdo je Václav Havel?","topic":["politika"],"subtopic":["Charta 77"],"tags":["Charta 77","underground","TOTO100LETÍ ve škole","perzekuce"],"date":"1977","timeline":"1977","gpsn":"","gpse":"","desc":"Dobový publicistický pořad byl součástí kampaně vedené proti Chartě 77 bezprostředně po jejím zveřejnění. Reportáž zobrazuje Václava Havla jako celoživotního \"nepřítele socialismu\".","index":"","idec":"277 531 18376","bonus":"","sidp":"1064010780","director":"Matiášová Helena","type":"v","category":5},"v-5-58":{"id":"58","title":"První výročí okupace","topic":["společnost"],"subtopic":["nástup normalizace"],"tags":["1968","1969","politika","média","okupace","TOTO100LETÍ ve škole"],"date":"1969","timeline":"1969","gpsn":"","gpse":"","desc":"Tendenční pořad o událostech ze srpna 1969. Výpovědi svědků a poškozených.","index":"608465","idec":"269 531 31034","bonus":"","sidp":"","director":"","type":"v","category":5},"v-5-59":{"id":"59","title":"Jazzová sekce","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1971","hudba","umění","underground","perzekuce"],"date":"1971","timeline":"1971","gpsn":"","gpse":"","desc":"V roce 1971 zahájila činnost Jazzová sekce Svazu hudebníků Československé socialistické republiky. Původně úzké zájmové sdružení začalo tehdejšímu režimu brzy přerůstat přes hlavu.","index":"609550","idec":"409 235 10022/1033","bonus":"","sidp":"","director":"Pavel Křemen","type":"v","category":5},"v-5-60":{"id":"60","title":"Proces s Jazzovou sekcí","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["1986","hudba","umění","perzekuce","underground"],"date":"1986","timeline":"1986","gpsn":"","gpse":"","desc":"Jazzová sekce byla jedním z nejzásadnějších kulturních fenoménů let 1975–1985. Její činnost a existence byla o to pozoruhodnější, že se do poslední chvíle snažila pohybovat v rámci právní legality, s využitím všech skulin v normalizačním právním systému.","index":"609576","idec":"208 562 26881","bonus":"","sidp":"","director":"Aleš Kisil","type":"v","category":5},"v-5-61":{"id":"61","title":"První povolená demonstrace","topic":["politika"],"subtopic":["protesty a demonstrace"],"tags":["demonstrace","1988","Václav Havel"],"date":"1988","timeline":"1988","gpsn":"","gpse":"","desc":"Dne 10. prosince 1988 se na pražském Škroupově náměstí konala první oficiálně povolená demonstrace proti totalitnímu režimu. Na demonstraci zpívala Marta Kubišová, zazněla česká hymna a promluvil Václav Havel.","index":"562259","idec":"208 452 80140/0049","bonus":"","sidp":"","director":"","type":"v","category":5},"v-6-1":{"id":"1","title":"Petr Pithart o první svobodné vládě","topic":["politika"],"subtopic":["strany a vlády"],"tags":["politika","česká vláda","Petr Pithart","ministři","ČSFR","1990","premiér"],"date":"1990","timeline":"1990","gpsn":"","gpse":"","desc":"Expremiér Petr Pithart a další členové československé vlády z let 1990–1992 se setkali na bilančním setkání a vzpomínají na své působení v první porevoluční vládě ČSFR.","index":"561730","idec":"313 294 34001/0001 ","bonus":"","sidp":"","director":"Kratochvíl Jaroslav","type":"v","category":6},"v-6-2":{"id":"2","title":"Václav Havel v Kongresu USA","topic":["politika"],"subtopic":["Havel"],"tags":["politika","prezident","1990"],"date":"1990","timeline":"1990","gpsn":"38.8898089","gpse":"77.0091086","desc":"Byl to jeden z nejsilnějších okamžiků po sametové revoluci – dne 21. února 1990 navštívil nově zvolený prezident Václav Havel za bouřlivých potlesků Kongres USA a přednesl zde proslov, který vstoupil do dějin.","index":"381139","idec":"215 411 01012/0215","bonus":"","sidp":"","director":"Karen Vít","type":"v","category":6},"v-6-3":{"id":"3","title":"Václav Havel v Kongresu USA","topic":["politika"],"subtopic":["Havel"],"tags":["politika","prezident","1990"],"date":"1990","timeline":"1990","gpsn":"38.8898089","gpse":"77.0091086","desc":"Prezident ČSFR Václav Havel byl v roce 1990 přijat bouřlivým potleskem v Kongresu USA, jeho projev 23krát přerušen potleskem kongresmanů a Havlův projev se dodnes připomíná jako jeden z nejlepších projevů novodobé historie ČR/ČSFR. Podívejte se alespoň na jeho část.","index":"561831","idec":"290 451 70709","bonus":"","sidp":"","director":"","type":"v","category":6},"v-6-4":{"id":"4","title":"Pomlčková válka – republika získala nový název ","topic":["politika"],"subtopic":[""],"tags":["1990","Slovensko"],"date":"1990","timeline":"1990","gpsn":"","gpse":"","desc":"Dne 23. dubna 1990 vznikla oficiálně Česká a Slovenská Federativní Republika, a to po tzv. „pomlčkové válce“ a předchozím názvu Československá federativní republika.","index":"390697","idec":"215 411 00010/0329 ","bonus":"","sidp":"","director":"","type":"v","category":6},"v-6-5":{"id":"5","title":"Jan Pavel II. v Československu","topic":["společnost"],"subtopic":[""],"tags":["církev","1990"],"date":"1990","timeline":"1990","gpsn":"","gpse":"","desc":"Reportáž z roku 2015 připomíná návštěvu papeže Jana Pavla II. v roce 1990. Byla to událost, kdy Jan Pavel II. podruhé (po Polsku) navštívil postkomunistickou zemi. Slavnostní mše na pražské Letenské pláni se zúčastnilo více než 500 000 lidí. ","index":"395444","idec":"215 411 01010/0421","bonus":"","sidp":"","director":"Vlk Martin","type":"v","category":6},"v-6-6":{"id":"6","title":"Občanské fórum vítězem ve volbách","topic":["politika"],"subtopic":["strany a vlády"],"tags":["volby","1990"],"date":"1990","timeline":"1990","gpsn":"","gpse":"","desc":"Podívejte se, jak v červnu 1990 probíhaly první svobodné postkomunistické volby v Československu a na infografiku jejich výsledků.","index":"561876","idec":"210 452 80135/0036","bonus":"30276","sidp":"","director":"Poledne Aleš","type":"v","category":6},"v-6-7":{"id":"7","title":"Ustavující kongres ODS","topic":["politika"],"subtopic":["strany a vlády"],"tags":["politika","1990"],"date":"1990","timeline":"1990","gpsn":"49.5938686","gpse":"17.2508706","desc":"Hnutí Občanské fórum se po vnitřních rozbrojích nakonec rozdělilo na dva samostatné subjekty: Občanské hnutí a Občanskou demokratickou stranu. V Olomouci se ve dnech 20.–21. dubna 1991 konal ustavující kongres ODS.","index":"561900","idec":"208 452 80135/0045","bonus":"30281","sidp":"","director":"","type":"v","category":6},"v-6-8":{"id":"8","title":"Odsun sovětských vojsk","topic":["politika"],"subtopic":[""],"tags":["armáda","Varšavská smlouva","1991"],"date":"1991","timeline":"1991","gpsn":"","gpse":"","desc":"Po 23 letech bylo v roce 1991 dohodnuto, že sovětská vojska musí opustit území ČSFR: Jak probíhala vyjednávání o odchodu sovětských vojsk z Československa v červnu roku 1991 popisuje Michael Kocáb.","index":"561901","idec":"215 411 01010/0226","bonus":"","sidp":"","director":"Rásocha Jaroslav, Vlk Martin","type":"v","category":6},"v-6-9":{"id":"9","title":"Lustrační zákon","topic":["politika"],"subtopic":[""],"tags":["1991"],"date":"1991","timeline":"1991","gpsn":"","gpse":"","desc":"Lustrační zákon účinný od 5. listopadu 1991 kontroluje činnost žadatelů o příslušný post před rokem 1989 a jeho snahou je omezit působení bývalých komunistických funkcionářů ve vrcholné politice. Povedlo se to?","index":"561902","idec":"211 411 03400/0288","bonus":"30274","sidp":"","director":"Straka Marek","type":"v","category":6},"v-6-10":{"id":"10","title":"Každý Čech se stal akcionářem","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","1991"],"date":"1991","timeline":"1991","gpsn":"","gpse":"","desc":"Dne 1. listopadu 1991 začala první vlna prodeje kupónových knížek s poukazy, které opravňovaly k nákupu určitého množství podílů v privatizovaných státních podnicích. Ačkoliv pvodní idea privatizace byla správná, ne vždy se podařilo zajistit, aby nedocházelo ke spekulacím s akciemi a tunelování podniků.","index":"562844","idec":"216 411 05813/1101 ","bonus":"30273","sidp":"","director":"","type":"v","category":6},"v-6-11":{"id":"11","title":"Odvrácená strana kupónové privatizace","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství"],"date":"1992","timeline":"1990–1993","gpsn":"","gpse":"","desc":"Česká cesta privatizace některých státních podniků znamenala často přímý prodej jejich vrcholovým manažerům. Bilance kupónové privatizace 90. let tak nepůsobí příznivě.","index":"562846","idec":"212 563 23190/0002","bonus":"","sidp":"","director":"Horký Petr, Šajmovič Juraj","type":"v","category":6},"v-6-12":{"id":"12","title":"ODS vyhrává parlamentní volby","topic":["politika"],"subtopic":["strany a vlády"],"tags":["politika","volby","Slovensko","1992"],"date":"1991","timeline":"1992","gpsn":"","gpse":"","desc":"ODS v čele s Václavem Klausem zahajuje koaliční jednání po ohlášení výsledků parlamentních voleb ČSFR v roce 1992. Byl to začátek období vlády Václava Klause, která nakonec trvala až do roku 1998 a přinesla mnoho změn, zejména rozdělení České a Slovenské republiky v roce 1993. ","index":"562852","idec":"212 411 05821/0024","bonus":"30277","sidp":"","director":"","type":"v","category":6},"v-6-13":{"id":"13","title":"„Zvací dopis“ z roku 1968 existuje!","topic":["politika"],"subtopic":[""],"tags":["Varšavská smlouva","armáda"],"date":"1992","timeline":"1992","gpsn":"","gpse":"","desc":"Tzv. zvací dopis z roku 1968 je nedatovaný dopis od pěti československých politiků žádající Sovětský svaz o pomoc proti údajně chystané kontrarevoluci v Československu. Kopii obdržel v roce 1992 Václav Havel od prezidenta Borise Jelcina po nálezu ve Státním archivu Ruské federace. Poté začalo jednání o expertíze originálu uloženého v Moskvě.","index":"562864","idec":"208 562 26639","bonus":"","sidp":"","director":"Cejnková Zora","type":"v","category":6},"v-6-14":{"id":"14","title":"Abdikace prezidenta Václava Havla","topic":["politika"],"subtopic":["Havel"],"tags":["prezident","1992"],"date":"1992","timeline":"1992","gpsn":"","gpse":"","desc":"Václav Havel nechtěl být jen dosluhujícím úředníkem země, která se měla rozdělit, a proto v červenci roku 1992 abdikoval. Havel byl ale v lednu 1993 opět zvolen, a to jako první prezident České republiky.","index":"562910","idec":"217 411 00037/0720","bonus":"30268","sidp":"","director":"","type":"v","category":6},"v-6-15":{"id":"15","title":"Bezprostřední atmosféra po vzniku České republiky","topic":["společnost"],"subtopic":[""],"tags":["hranice","1993","Slovensko"],"date":"1993","timeline":"1993","gpsn":"","gpse":"","desc":"Jak reagovali lidé roku 1992 těsně před silvestrovskou půlnocí a vznikem České republiky? V ukázce zazní také novoroční projevy politiků.","index":"564041","idec":"213 411 05821/0041","bonus":"","sidp":"","director":"","type":"v","category":6},"v-6-16":{"id":"16","title":"Václav Havel se stal prvním prezidentem České republiky","topic":["politika"],"subtopic":["Havel"],"tags":["prezident","1993"],"date":"1993","timeline":"1993","gpsn":"","gpse":"","desc":"Po vzniku samostatného českého státu byl Václav Havel zvolen jeho prvním prezidentem, a to volbou dne 26. ledna 1993. Prezidentský úřad zastával i v dalším funkčním období a funkci opustil roku 2003.","index":"564042","idec":"213 411 05821/0041","bonus":"","sidp":"","director":"","type":"v","category":6},"v-6-17":{"id":"17","title":"První dva bloky Temelína se dostaví","topic":["hospodářství"],"subtopic":[""],"tags":["jádro","stavby","technika","1993"],"date":"1993","timeline":"1993","gpsn":"","gpse":"","desc":"Česká vláda schválila v roce 1993 dostavbu 1. a 2. bloku jaderné elektrárny Temelín. Stavba jihočeské jaderné elektrárny začala již v roce 1987, zkušební provoz elektrárny byl ale zahájen až v roce 2002. V současné době jsou v provozu pouze dva bloky z plánovanýcjh čtyř.","index":"","idec":"","bonus":"7363","sidp":"","director":"","type":"v","category":6},"v-6-18":{"id":"18","title":"Blíž k Evropě","topic":["politika"],"subtopic":["zpátky do Evropy"],"tags":["politika","hospodářství","1993","Evropská unie"],"date":"1993","timeline":"1993","gpsn":"","gpse":"","desc":"První asociační dohoda o vstupu do Evropské unie byla sjednána již mezi Českou a Slovenskou Federativní Republikou a Evropským společenstvím a jejich členskými státy 16. prosince 1991. Po rozpadu ČSFR platila Prozatimní dohoda a poté byla další jednání zahájena 28. ledna 1993.","index":"564043","idec":"209 452 80135/0001","bonus":"","sidp":"","director":"Poledne Aleš","type":"v","category":6},"v-6-19":{"id":"19","title":"Začínáme platit českou korunou","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","1993"],"date":"1993","timeline":"1993","gpsn":"","gpse":"","desc":"S rozdělením ČSFR na samostatné státy souviselo také zavedení samostatných měn. Dne 3. února 1993 byla ohlášena měnová odluka a od 8. února zastaven veškerý platební styk. Výměna peněz probíhala mezi 8.–12. únorem 1993.","index":"564046","idec":"213 411 03400/0016","bonus":"30284","sidp":"","director":"","type":"v","category":6},"v-6-20":{"id":"20","title":"První návštěva Billa Clintona v Praze","topic":["politika"],"subtopic":[""],"tags":["prezident","1994"],"date":"1994","timeline":"1994","gpsn":"","gpse":"","desc":"V roce 1994 navštívil americký prezident Bill Clinton společně s ministryní zahraničních věcí USA Madeleine Albrightovou poprvé Prahu.","index":"564047","idec":"214 411 05821/0004","bonus":"","sidp":"","director":"","type":"v","category":6},"v-6-21":{"id":"21","title":"Premiéra filmu Šakalí léta","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["film","hudba","umění","1993"],"date":"1993","timeline":"1993","gpsn":"","gpse":"","desc":"V roce 1993 natočil režisér Jan Hřebejk muzikálovou komedii Šakalí léta. Příběh podle předlohy Petra Šabacha se odehrává kolem roku 1959 v pražských Dejvicích.","index":"564048","idec":"210 562 26504","bonus":"","sidp":"","director":"Stehlík Jan, Vachler Petr","type":"v","category":6},"v-6-22":{"id":"22","title":"Automobilku Škoda koupil německý koncern Volkswagen","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","1990","automobil","doprava"],"date":"1990","timeline":"1990","gpsn":"50.4187919","gpse":"14.9139031","desc":"Česká vláda dne 9. prosince 1990 rozhodla o prodeji automobilky Škoda německému koncernu Volkswagen. Šlo o nejzdařilejší případ privatizace státního podniku.","index":"564049","idec":"216 411 05813/0415","bonus":"30269","sidp":"","director":"Ďurica Peter","type":"v","category":6},"v-6-23":{"id":"23","title":"Svatořečení Jana Sarkandera a Zdislavy z Lemberka","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["církev","1995"],"date":"1995","timeline":"1995","gpsn":"","gpse":"","desc":"Papež Jan Pavel II. svatořečil dne 20. května 1995 při své návštěvě v Olomouci blahoslaveného Jana Sarkandera a blahoslavenou Zdislavu z Lemberka.","index":"564050","idec":"209 452 80135/0035","bonus":"","sidp":"","director":"Poledne Aleš","type":"v","category":6},"v-6-24":{"id":"24","title":"Svobodná Evropa začíná vysílat z Prahy","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["média","rozhlas","1995"],"date":"1995","timeline":"1995","gpsn":"","gpse":"","desc":"Rozhlasová stanice Svobodná Evropa začala dne 1. července 1995 vysílat z budovy bývalého Federálního shromáždění ČSSR v Praze. Stanice přesunula své místo z Mnichova do Prahy na pozvání prezidenta Havla a zástupců české vlády.","index":"568009","idec":"215 411 05821/0013","bonus":"","sidp":"","director":"","type":"v","category":6},"v-6-25":{"id":"25","title":"Žádáme o vstup do EU","topic":["politika"],"subtopic":["zpátky do Evropy"],"tags":["politika","1996","Evropská unie"],"date":"1996","timeline":"1996","gpsn":"","gpse":"","desc":"Vláda České republiky v zastoupení předsedy vlády Václava Klause podala 23. ledna 1996 v Římě žádost o vstup do Evropské unie.","index":"564052","idec":"209 452 80135/0001","bonus":"","sidp":"","director":"Poledne Aleš","type":"v","category":6},"v-6-26":{"id":"26","title":"Čeští fotbalisté vezou domů stříbro z Anglie","topic":["sport"],"subtopic":[""],"tags":["sport","fotbal","1996"],"date":"1996","timeline":"1996","gpsn":"51.5073219","gpse":"0.1276475","desc":"Česká fotbalová reprezentace získala stříbrnou medaili na ME ve fotbale konaném od 8. do 30. června 1996 v Anglii. Ve finále Mistrovství Evropy ve fotbale podlehla česká reprezentace mužstvu Německa 1:2.","index":"","idec":"","bonus":"8653","sidp":"","director":"","type":"v","category":6},"v-6-28":{"id":"28","title":"Úmrtí Olgy Havlové","topic":["společnost"],"subtopic":[""],"tags":["1996"],"date":"1996","timeline":"1996","gpsn":"50.5850417","gpse":" 15.8290417E","desc":"Olga Havlová, manželka Václava Havla, zakladatelka Výboru dobré vůle, silná osobnost českého disentu a statečná žena. Zemřela 27. ledna 1996.","index":"564265","idec":"215 452 80124/0005","bonus":"","sidp":"","director":"Hanuš Pavel, Hodek Milan, LeFay Monika, Šťastný David","type":"v","category":6},"v-6-29":{"id":"29","title":"Zlatá medaile pro Jana Železného na OH v Atlantě ","topic":["sport"],"subtopic":[""],"tags":["sport","olympiáda","1996"],"date":"1996","timeline":"1996","gpsn":"33.7490986","gpse":"84.3901850","desc":"Oštěpař Jan Železný získal na OH v Atlantě v roce 1996 podruhé olympijské zlato, a to díky hodu dlouhému 88,16 m.","index":"564266","idec":"217 471 29407/0003","bonus":"","sidp":"","director":"Robert Záruba","type":"v","category":6},"v-6-30":{"id":"30","title":"Vláda Václava Klause v krizi","topic":["politika"],"subtopic":["strany a vlády"],"tags":["politika","1997"],"date":"1997","timeline":"1997","gpsn":"","gpse":"","desc":"Vládnoucí Občanská demokratická strana řeší problémy s falešnými sponzory a podvádění v účetnictví a pro rostoucí ekonomické problémy státu podává 30. listopadu 1997 demisi.","index":"564267","idec":"407 235 10002/1003","bonus":"","sidp":"","director":"Kudrna Tomáš","type":"v","category":6},"v-6-31":{"id":"31","title":"Ničivé povodně na Moravě a Odře","topic":["společnost"],"subtopic":[""],"tags":["přírodní katastrofy","1997"],"date":"1997","timeline":"1997","gpsn":"49.3597061","gpse":"17.3094203","desc":"V roce 1997 zasáhly Moravu, Slezsko a část východních Čech ničivé a neočekávané povodně. Zemřelo 49 lidí a škody byly odhadnuty ve výši přesahující 60 miliard korun.","index":"564269","idec":"216 411 01010/0707","bonus":"","sidp":"","director":"Knopp Erik Mgr.art.","type":"v","category":6},"v-6-32":{"id":"32","title":"Česko-německá deklarace podepsána","topic":["politika"],"subtopic":[""],"tags":["Němci","odsun","Sudety","1997"],"date":"1997","timeline":"1997","gpsn":"","gpse":"","desc":"Zástupci Česka a Německa podepsali 21. ledna 1997 Česko-německou deklaraci o vzájemných vztazích a jejich budoucím rozvoji. Měla znamenat především odpoutání se od křivd způsobených v historii.","index":"564270","idec":"217 411 05813/0119","bonus":"30270","sidp":"","director":"","type":"v","category":6},"v-6-33":{"id":"33","title":"Zimní olympijské hry v Naganu v roce 1998","topic":["sport"],"subtopic":[""],"tags":["olympiáda","sport","hokej","1998"],"date":"1998","timeline":"1998","gpsn":"36.6439911","gpse":"138.0999589","desc":"Podceňovaný český hokejový tým v čele s Domikem Haškem vybojoval v „turnaji století“ na Zimních olympijských hrách v Naganu zlatou medaili. I další sportovní disciplíny slavily úspěch. Běžkařka Kateřina Neumannová v Naganu získala svoji první olympijskou medaili – bronzovou.","index":"564271","idec":"215 471 29029/0011","bonus":"30285","sidp":"","director":"Sluka Štěpán","type":"v","category":6},"v-6-34":{"id":"34","title":"Úřednická vláda Josefa Tošovského","topic":["politika"],"subtopic":["strany a vlády"],"tags":["1998"],"date":"1998","timeline":"1998","gpsn":"","gpse":"","desc":"Po demisi vlády Václava Klause kvůli ekonomickým problémům, poklesu české ekonomiky a kauze s falešnými sponzory ODS byla dne 2. ledna 1998 jmenována úřednická vláda tehdejšího guvernéra ČNB Josefa Tošovského. ","index":"564272","idec":"313 294 34001/0003","bonus":"","sidp":"","director":"Portel Viktor","type":"v","category":6},"v-6-35":{"id":"35","title":"Podpis opoziční smlouvy","topic":["politika"],"subtopic":["strany a vlády"],"tags":["politika","volby","1998"],"date":"1998","timeline":"1998","gpsn":"","gpse":"","desc":"Po předčasných parlamentních volbách v roce 1998 menšinová vláda Miloše Zemana podepsala tzv. opoziční smlouvu (o vytvoření stabilního politického prostředí v České republice) uzavřenou mezi menšinovou ČSSD a většinovou ODS na celé funkční volební období 1998–2002. Reportáž z roku 2013 hodnotí důsledky tohoto dokumentu.","index":"564273","idec":"213 411 00010/0714 ","bonus":"","sidp":"","director":"Škampa Michal","type":"v","category":6},"v-6-36":{"id":"36","title":"Stavba zdi v Matiční ulici v Ústí nad Labem","topic":["společnost"],"subtopic":[""],"tags":["menšiny","rasismus","1999"],"date":"1999","timeline":"1999","gpsn":"50.6628506","gpse":"14.0791181","desc":"V roce 1999 oddělila stavba zdi obyvatele čtvrti Krásné Březno v Ústí nad Labem od sociálně vyloučených Romů žijících v Matiční ulici. Zeď byla ale po roce opět odstraněna. Zpětně je stavba zdi hodnocena jako špatné řešení sociálních problémů.","index":"564275","idec":"211 411 00010/1106","bonus":"","sidp":"","director":"Petráček Miroslav","type":"v","category":6},"v-6-37":{"id":"37","title":"Protestní hnutí Děkujeme, odejděte","topic":["společnost"],"subtopic":[""],"tags":["demonstrace","1999"],"date":"1999","timeline":"1999","gpsn":"","gpse":"","desc":"Někdejší studentští vůdci sametové revoluce podepsali 17. listopadu 1999 výzvu Děkujeme, odejděte!, ve které dali jasný nesouhlas politikům, kteří stáli za tzv. opoziční smlouvou. ","index":"564276","idec":"209 562 26664","bonus":"","sidp":"","director":"Kaňka Petr","type":"v","category":6},"v-6-38":{"id":"38","title":"První štěpení jádra v JE Temelín","topic":["hospodářství"],"subtopic":[""],"tags":["jádro","technika","věda","2000"],"date":"2000","timeline":"2000","gpsn":"49.1800739","gpse":"14.3761972","desc":"V roce 2000 bylo oficiálně spuštěno štěpení jádra v prvním bloku jaderné elektrárny Temelín.","index":"565167","idec":"205 411 00037/1011","bonus":"30280","sidp":"","director":"","type":"v","category":6},"v-6-39":{"id":"39","title":"Protesty během konání summitu Světové banky a MMF v Praze","topic":["společnost"],"subtopic":[""],"tags":["hospodářství","demonstrace","2000"],"date":"2000","timeline":"2000","gpsn":"","gpse":"","desc":"Ve dnech 26. a 27. září 2000 se v Kongresovém centru v Praze konalo 55. výroční zasedání Rad guvernérů Mezinárodního měnového fondu a Světové banky. Odpůrci ekonomické globalizace z několika evropských zemí masově protestovali v pražských ulicích a celou akci provázely poměrně dramatické střety demonstrantů s policií.","index":"565168","idec":"210 452 80135/0040 ","bonus":"30279","sidp":"","director":"Poledne Aleš","type":"v","category":6},"v-6-40":{"id":"40","title":"Krach IPB","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství","2000"],"date":"2000","timeline":"2000","gpsn":"","gpse":"","desc":"Jedna z tehdejších největších českých bank Investiční a poštovní banka (IPB) v roce 2000 zkrachovala a za 1 Kč ji převzala Československá obchodní banka. Klienti banky rychle vybírali své vklady. Zpětně hodnoceno se jednalo o jeden z největších krachů soukromé společnosti. ","index":"565169","idec":"207 411 00037/0723","bonus":"","sidp":"","director":"","type":"v","category":6},"v-6-41":{"id":"41","title":"ČSSD vítězem parlamentních voleb v roce 2002","topic":["politika"],"subtopic":["strany a vlády"],"tags":["politika","volby","2002"],"date":"2002","timeline":"2002","gpsn":"","gpse":"","desc":"ČSSD v čele s Vladimírem Špidlou zvítězila v parlamentních volbách roku 2002. Veřejnost jí dala šanci po odchodu Miloše Zemana z politiky. Podívejte se, jak ve volebním studiu ČT hodnotili výsledek voleb Václav Klaus, Miroslav Grebeníček a Vladimír Špidla.","index":"","idec":"","bonus":"10304","sidp":"","director":"","type":"v","category":6},"v-6-42":{"id":"42","title":"Povodně 2002","topic":["společnost"],"subtopic":[""],"tags":["přírodní katastrofy","2002"],"date":"2002","timeline":"2002","gpsn":"","gpse":"","desc":"Česko zasáhly 2 vlny nejničivější povodně od velké povodně v roce 1845. První vlna trvala ve dnech 7.–11. srpna, druhá pak mezi 12.–16 sprna 2002. Prahou v druhé vlně proteklo až 100x více vody než bylo běžné. Příčinou byly nadprůměrné srážky v jižních Čechách v první vlně a v druhé na většině území Čech.","index":"565178","idec":"217 411 05813/0807","bonus":"30278","sidp":"","director":"","type":"v","category":6},"v-6-43":{"id":"43","title":"Mirek Topolánek předsedou ODS","topic":["politika"],"subtopic":["strany a vlády"],"tags":["politika","2002"],"date":"2002","timeline":"2002","gpsn":"50.1203300","gpse":"12.3517392","desc":"Na 13. kongresu ODS, který se konal ve dnech 13.–15. prosince 2002 ve Františkových Lázních byl zvolen Mirek Topolánek předsedou strany a tím po 11 letech vystřídal Václava Klause. Ten se ovšem stal doživotním čestným předsedou strany.","index":"565180","idec":"208 452 80135/0045 ","bonus":"30275","sidp":"","director":"","type":"v","category":6},"v-6-44":{"id":"44","title":"Referendum o vstupu Česka do EU","topic":["politika"],"subtopic":["zpátky do Evropy"],"tags":["politika","Evropská unie","2003"],"date":"2003","timeline":"2003","gpsn":"","gpse":"","desc":"Češi rozhodli! V referendu o vstupu Česka do EU bylo celkem 77,3% platných hlasovacích lístků pro vstup do Evropské unie.","index":"565181","idec":"209 452 80135/0001","bonus":"","sidp":"","director":"Poledne Aleš","type":"v","category":6},"v-6-45":{"id":"45","title":"Václav Klaus prezidentem ČR","topic":["politika"],"subtopic":[""],"tags":["2003","prezident"],"date":"2003","timeline":"2003","gpsn":"","gpse":"","desc":"Čestný předseda ODS a bývalý premiér Václav Klaus byl v roce 2003 zvolen prezidentem České republiky. Jak probíhaly přípravy na převzetí úřadu a jeho inaugurační slib?","index":"565182","idec":"213 411 05821/0012","bonus":"30282","sidp":"","director":"","type":"v","category":6},"v-6-46":{"id":"46","title":"Vstupujeme do EU (1. května 2004)","topic":["politika"],"subtopic":["zpátky do Evropy"],"tags":["politika","2004","Evropská unie"],"date":"2004","timeline":"2004","gpsn":"","gpse":"","desc":"Deset zemí včetně Česka vstoupilo dne 1. května 2004 do Evropské unie. Podívejte se, jak probíhaly oslavy tohoto kroku a jak tento akt hodnotili přední čeští politici.","index":"565183","idec":"209 452 80135/0001","bonus":"","sidp":"","director":"Poledne Aleš","type":"v","category":6},"v-6-47":{"id":"47","title":"Viktor Kožený","topic":["hospodářství"],"subtopic":[""],"tags":["hospodářství"],"date":"1992","timeline":"1991–2004","gpsn":"","gpse":"","desc":"Viktor Kožený alias „pirát z Prahy“ stál za podvodem v rámci kupónové privatizace v 90. letech. Jeho Harvadské investiční fondy získaly přes milion kupónových knížek s příslibem až desetinásobného výnosu. Kožený je stíhán za finanční operace, kterými připravil o majetek Harvardského průmyslového holdingu, který byl přetransformován z Harvardských investičních fondů. ","index":"565187","idec":"205 411 00037/1007","bonus":"30283","sidp":"","director":"Kotlář Vladimír","type":"v","category":6},"v-6-48":{"id":"48","title":"Rasová vražda Tibora Danihela","topic":["společnost"],"subtopic":[""],"tags":["menšiny","rasismus","1993"],"date":"1993","timeline":"1993","gpsn":"49.3087953","gpse":"14.1475028","desc":"Sedmnáctiletý Rom Tibor Danihel utonul v řece při rasovém útoku 24. září 1993 v Písku. Rasově motivovaných činů bylo v 90. letech poměrně hodně a trvalo dlouho, než se vůči nim česká justice jednoznačně vymezila. ","index":"565188","idec":"211 562 26406","bonus":"","sidp":"","director":"Janeček Vít","type":"v","category":6},"v-6-49":{"id":"49","title":"Hokejová legenda Jaromír Jágr","topic":["sport"],"subtopic":[""],"tags":["sport","hokej","olympiáda","1998"],"date":"1998","timeline":"1998","gpsn":"36.6439911","gpse":"138.0999589","desc":"Hokejista Jaromír Jágr se nesmazatelně zapsal jako legenda českého i světového ledního hokeje. Exceloval také na Zimních olympijských hrách v Naganu v roce 1998. Kromě jiného se stal třetím nejlepším střelcem v historii NHL.","index":"565368","idec":"216 411 05813/0222 ","bonus":"30272","sidp":"","director":"","type":"v","category":6},"v-6-50":{"id":"50","title":"Jan Svěrák","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["film","umění","1991"],"date":"1991","timeline":"1991","gpsn":"","gpse":"","desc":"Osobnosti českého filmu hovoří o úspěších režiséra Jana Svěráka a vzniku jeho prvního celovečerního filmu Obecná škola z roku 1991.","index":"565369","idec":"210 562 26502","bonus":"","sidp":"","director":"Stehlík Jan, Vachler Petr","type":"v","category":6},"v-6-51":{"id":"51","title":"Rolling Stones v Praze","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["hudba","umění","1990","Strahov"],"date":"1990","timeline":"","gpsn":"","gpse":"","desc":"Jedna z nejznámějších světových rockových kapel navštívila v srpnu 1990 Prahu, mimo jiné i na pozvání prezidenta Václava Havla. Rolling Stones zahráli na zaplněném strahovském stadionu a jejich show se pro mnohé stala symbolem demokracie a svobody. Vstupenka stála 250 Kč. ","index":"581872","idec":"210 452 80135/0036 ","bonus":"30287","sidp":"","director":"Poledne Aleš","type":"v","category":6},"v-6-52":{"id":"52","title":"Vystěhovaní kutlířští hospodáři","topic":["hospodářství"],"subtopic":[""],"tags":["1995","hospodářství","zemědělství","kolektivizace","TOTO100LETÍ ve škole"],"date":"1995","timeline":"1995","gpsn":"50.0288239","gpse":"15.1418158","desc":"Z Kutlíř na Kolínsku byli v 50. letech vystěhováni všichni sedláci a jejich statky se staly součástí státního statku. V 90. letech byl zabavený majetek vrácen původním majitelům, kteří zde začali opět hospodařit. ","index":"464329","idec":"216 411 05821/0015","bonus":"","sidp":"","director":"","type":"v","category":6},"v-6-53":{"id":"53","title":"Opoziční smlouva: Výsledek předčasných parlamentních voleb","topic":["politika"],"subtopic":["strany a vlády"],"tags":["politika","volby","1998"],"date":"1998","timeline":"1998","gpsn":"","gpse":"","desc":"Po patovém výsledku voleb v roce 1998 přišli s řešením Miloš Zeman a Václav Klaus. Předseda sociálních demokratů a šéf ODS se dohodli na toleranci menšinové vlády ČSSD výměnou za podíl na moci na všech úrovních. Dokument získal název opoziční smlouva a jeho kritici jeho podpis považují za klíčovou ránu české politické kultuře. Navíc spolupráce obou hlavních politických stran v parlamentu i na regionální úrovni podporovala zákulisní politikaření, lobbyismus a různé formy korupce.","index":"","idec":"","bonus":"8665","sidp":"","director":"","type":"v","category":6},"v-7-1":{"id":"1","title":"Stanislav Gross","topic":["politika"],"subtopic":["kauzy"],"tags":["2004","2005"],"date":"2004","timeline":"2000–2005","gpsn":"","gpse":"","desc":"Stanislav Gross se zapsal do dějin jako nejmladší premiér České republiky. Šéf ČSSD vládnul necelý rok, v roce 2005 z funkce premiéra odstoupil kvůli nevyjasněné aféře kolem jeho financí.","index":"565818","idec":"215 411 00037/0416","bonus":"30348","sidp":"","director":"","type":"v","category":7},"v-7-2":{"id":"2","title":"Jiří Paroubek premiérem","topic":["politika"],"subtopic":["vlády"],"tags":["2005"],"date":"2005","timeline":"2004–2010","gpsn":"","gpse":"","desc":"Nástupcem Stanislava Grosse se stal v roce 2005 ministr pro místní rozvoj Jiří Paroubek. Podařilo se mu sjednotit sociálnědemokratickou stranu a obnovit její politický význam.","index":"","idec":"","bonus":"11096","sidp":"","director":"","type":"v","category":7},"v-7-3":{"id":"3","title":"Čerstvě zvolený prezident Miloš Zeman odpočívá na Vysočině","topic":["politika"],"subtopic":["prezidenti"],"tags":["prezident","2013","volby"],"date":"2013","timeline":"2013","gpsn":"","gpse":"","desc":"Občané České republiky zvolili v roce 2013 v historicky první přímé prezidentské volbě Miloše Zemana. Hned na začátku deklaroval, že bude prezidentem všech občanů, tedy i těch, kteří volili jeho rivala Karla Schwarzenberga. Podívejte se, jak prezident Zeman trávil první dny po svém zvolení.","index":"566077","idec":"213 411 00010/0129","bonus":"","sidp":"","director":"Škampa Michal","type":"v","category":7},"v-7-4":{"id":"4","title":"CzechTek 2005","topic":["společnost"],"subtopic":[""],"tags":["konflikt","2005"],"date":"2005","timeline":"2005","gpsn":"","gpse":"","desc":"V roce 2005 proběhl neúspěšně festival CzechTek. Kvůli stížnostem majitelů okolních pozemků došlo k tvrdému policejnímu zásahu, při kterém byli nasazeni těžkooděnci, slzný plyn nebo vodní děla. Zásah, při kterém bylo zraněno několik lidí, odsoudil prezident Václav Klaus, naopak premiér Jiří Paroubek vyzval k razantnímu řešení.","index":"","idec":"","bonus":"11097","sidp":"","director":"","type":"v","category":7},"v-7-5":{"id":"5","title":"Zlatí čeští hokejisté","topic":["sport"],"subtopic":[""],"tags":["sport","hokej","2005","Kanada"],"date":"2005","timeline":"2005","gpsn":"48.202558","gpse":"16.333352","desc":"V roce 2005 se Češi po čtyřech letech opět stávají mistry světa v hokeji. Ve finále ve Vídni porazili Kanadu 3:0. ","index":"","idec":"","bonus":"11098","sidp":"","director":"","type":"v","category":7},"v-7-6":{"id":"6","title":"Zákon o registrovaném partnerství","topic":["společnost"],"subtopic":[""],"tags":["menšiny","2006"],"date":"2006","timeline":"2006","gpsn":"","gpse":"","desc":"Již více než deset let mohou čeští homosexuálové uzavírat registrované partnerství. Cesta k tomuto zákonu byla dlouhá, byl schválen až na pátý pokus, vetoval ho také prezident Václav Klaus. V rozhodujícím hlasování v březnu 2006 byli proti především poslanci za ODS a KDU-ČSL.","index":"566104","idec":"206 411 00037/0315","bonus":"30355","sidp":"","director":"","type":"v","category":7},"v-7-7":{"id":"7","title":"Schengenský prostor ","topic":["politika"],"subtopic":[""],"tags":["Evropská unie","cestování","hranice","2007"],"date":"2007","timeline":"2007","gpsn":"","gpse":"","desc":"V roce 2007 vstoupila Česká republika spolu s dalšími osmi zeměmi Evropské unie do Schengenského prostoru. Lidé tak mohou cestovat mezi mnoha státy Evropy, aniž by byli kontrolováni na hranicích. Schengen však neusnadnil jen cestování, ale i mezinárodní obchod.","index":"566105","idec":"207 411 00010/1220 ","bonus":"","sidp":"","director":"Klímová Lucie, Urbišová Julie","type":"v","category":7},"v-7-8":{"id":"8","title":"Kubiceho zpráva","topic":["politika"],"subtopic":["kauzy"],"tags":["volby","politika","2006"],"date":"2006","timeline":"2006","gpsn":"","gpse":"","desc":"Necelý týden před volbami roku 2006 zveřejnil šéf elitních detektivů Jan Kubice zprávu o prorůstání zločinu do politiky. Mělo se tak dít především v souvislosti s vyšetřováním vraždy podnikatele Františka Mrázka. ČSSD tehdy odsoudila ODS, že stojí za Kubiceho zprávou a snaží se tím ovlivnit výsledky voleb. ODS tyto volby skutečně vyhrála.","index":"566270","idec":"206 411 00010/0609","bonus":"30345","sidp":"","director":"","type":"v","category":7},"v-7-9":{"id":"9","title":"Dobrý den, radare","topic":["politika"],"subtopic":[""],"tags":["armáda","technika","2008"],"date":"2008","timeline":"2008","gpsn":"","gpse":"","desc":"V Brdech měl stát americký radar, který by hájil bezpečnostní zájmy USA a jejich spojenců před nepřáteli. Stavba radaru vzbudila nevoli. Administrativa nového prezidenta Obamy nakonec od plánu radar vybudovat odstoupila.","index":"566290","idec":"208 411 00014/0708","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-10":{"id":"10","title":"Povodně 2006","topic":["společnost"],"subtopic":[""],"tags":["2006","přírodní katastrofy"],"date":"2006","timeline":"2006","gpsn":"","gpse":"","desc":"V jarních měsících roku 2006 zastihly Českou republiku povodně. Nejhorší situace byla na Moravě, škody se vyšplhaly až k 5 miliardám korun.","index":"566315","idec":"206 411 00022/0406","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-11":{"id":"11","title":"Oko nad Prahou","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["2006","stavby","archiitektura"],"date":"2006","timeline":"2006","gpsn":"","gpse":"","desc":"Protože Národní knihovně docházel volný prostor, byla roku 2006 vyhlášena soutěž na její novou budovu. Tu vyhrál Jan Kaplický s neobvyklým návrhem, který ve veřejnosti vzbudil velký ohlas. Brzy po tom však z tohoto projektu sešlo... Jaké bylo pokračování kauzy známé jako \"blob\" nebo \"chobotnice\"?","index":"566316","idec":"208 411 05825/0427","bonus":"30348","sidp":"","director":"Klabouch Jan, Kratochvíl Martin, Sluka Štěpán, Straka Marek","type":"v","category":7},"v-7-12":{"id":"12","title":"Kauza Rath","topic":["politika"],"subtopic":["kauzy"],"tags":["politika","2012"],"date":"2012","timeline":"2012","gpsn":"","gpse":"","desc":"Bývalý středočeský hejtman, ministr zdravotnictví a poslanec za ČSSD David Rath byl obviněn z korupce a odsouzen k 8,5 rokům odnětí svobody. Byl přichycen přímo při činu - policisté u něj nalezli 7 milionů korun. Tento peněžní úplatek měl schovaný v krabicích od vína.","index":"566497","idec":"213 411 00010/0514","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-13":{"id":"13","title":"Olympijské hry v Londýně ","topic":["sport"],"subtopic":[""],"tags":["olympiáda","sport","2012"],"date":"2012","timeline":"","gpsn":"51.538082","gpse":"-0.016539","desc":"Olympijské hry v Londýně byly oproti Pekingu úspornější, ale ukázaly svou lidskou tvář. V roce 2012 tam vybojovali čeští sportovci 10 medailí. Barbora Špotáková, Mirka Knapková, David Svoboda a Jaroslav Kulhavý se vrátili dokonce s tou zlatou. ","index":"566502","idec":"214 471 29029/0042","bonus":"","sidp":"","director":"Sluka Štěpán","type":"v","category":7},"v-7-14":{"id":"14","title":"Předsednictví Česka v EU","topic":["politika"],"subtopic":[""],"tags":["Evropská unie","2009"],"date":"2009","timeline":"2009","gpsn":"","gpse":"","desc":"Česká republika předsedala Evropské unii během první poloviny roku 2009. Šlo o úplně první a zatím poslední šéfování Česka. V době českého předsednictví u nás padla vláda, a tak jsme se dostali pod palbu kritiky.","index":"566543","idec":"209 411 00037/0619","bonus":"","sidp":"","director":"Kotlář Vladimír","type":"v","category":7},"v-7-15":{"id":"15","title":"Entropa - plastika Davida Černého","topic":["kultura a vzdělávání"],"subtopic":[""],"tags":["Evropská unie","umění","2009"],"date":"2009","timeline":"2009","gpsn":"50.842142","gpse":"4.381986","desc":"Entropa - kontroverzní plastika umělce Davida Černého byla instalována na průčelí budovy Rady Evropské unie (Justus Lipsius) v době českého předsednictví v Radě EU. ","index":"566750","idec":"209 411 01010/0511","bonus":"30342","sidp":"","director":"Kubíková Blanka, Petráček Miroslav","type":"v","category":7},"v-7-16":{"id":"16","title":"Václav Klaus znovu prezidentem","topic":["politika"],"subtopic":["prezidenti"],"tags":["prezident","2008"],"date":"2008","timeline":"2008","gpsn":"","gpse":"","desc":"Václav Klaus byl zvolen na druhé funkční období prezidentem 15. února 2008. Stalo se tak ve třetím kole druhé volby v obou komorách Parlamentu ČR, Klaus porazil ekonoma Jana Švejnara.","index":"566751","idec":"208 411 05825/0309","bonus":"30352","sidp":"","director":"Halama Štěpán, Kratochvíl Martin, Straka Marek","type":"v","category":7},"v-7-17":{"id":"17","title":"Úřednická vláda Jana Fischera","topic":["politika"],"subtopic":["vlády"],"tags":["politika","2009"],"date":"2009","timeline":"2009","gpsn":"","gpse":"","desc":"Po pádu Topolánkovy vlády na jaře 2009 pověřil prezident Klaus Jana Fischera sestavením úřednické vlády. Tato překlenovací vláda nakonec trvala dvakrát delší dobu, než bylo původně zamýšleno. Úspěšně dokončila předsednictví Česka v Evropské unii.","index":"566752","idec":"209 411 00037/0505","bonus":"30351","sidp":"","director":"Petráček Miroslav","type":"v","category":7},"v-7-18":{"id":"18","title":"Vyšetřování úplatku Jiřího Čunka","topic":["politika"],"subtopic":["kauzy"],"tags":["2006","politika"],"date":"2006","timeline":"2006","gpsn":"","gpse":"","desc":"Senátor a předseda KDU-ČSL Jiří Čunek byl vyšetřován za údajný úplatek 497 tisíc korun od realitní společnosti HB Real za přidělení lukrativní zakázky v době, kdy byl starostou Vsetína.","index":"566753","idec":"207 411 00037/0117","bonus":"30354","sidp":"","director":"Petráček Miroslav","type":"v","category":7},"v-7-19":{"id":"19","title":"Kůrovcová kalamita na Šumavě","topic":["společnost"],"subtopic":[""],"tags":["přírodní katastrofy","ekologie"],"date":"2009","timeline":"","gpsn":"49.0344489","gpse":"13.5260611","desc":"Jak přesně kůrovec ohrožuje strom? A co to pro les znamená? Je lepší napadené stromy těžit, nebo je nechat svému osudu?","index":"566754","idec":"206 411 00032/0723","bonus":"","sidp":"","director":"Hackenschmied Hanuš","type":"v","category":7},"v-7-20":{"id":"20","title":"Děkujeme, odcházíme","topic":["společnost"],"subtopic":[""],"tags":["2010"],"date":"2010","timeline":"2010","gpsn":"","gpse":"","desc":"Heslem Děkujeme, odcházíme! vyzývali lékaři v roce 2010 ke zvýšení platů ve zdravotnictví. Přes 3000 lékařů tehdy skutečně opustilo české nemocnice a šlo pracovat jinam. Některé pojišťovny jako odpověď zkrátily nebo zrušily smlouvy nemocnicím, ze kterých lékaři odešli.","index":"566756","idec":"210 411 00010/1213","bonus":"","sidp":"","director":"Kotlář Vladimír","type":"v","category":7},"v-7-21":{"id":"21","title":"Konec analogového vysílání","topic":["společnost"],"subtopic":[""],"tags":["média","televize","2011"],"date":"2011","timeline":"2011","gpsn":"","gpse":"","desc":"Analogové televizní vysílače ČT ve Vsetíně a Zlíně byly na podzim 2011 vypnuty. Televizní diváci naladí Českou televizi pouze ve veřejnoprávním digitální multiplexu.","index":"566755","idec":"311 281 38199/1130","bonus":"","sidp":"","director":"Grégr Tomáš","type":"v","category":7},"v-7-22":{"id":"22","title":"Petr Pavel ve vedení NATO","topic":["politika"],"subtopic":[""],"tags":["armáda","NATO"],"date":"2015","timeline":"2015–současnost","gpsn":"","gpse":"","desc":"Český generál Petr Pavel se stal druhým nejdůležitějším mužem v Severoatlantické alianci. Jedná se o prvního muže z bývalých zemí Varšavské smlouvy, který do Vojenského výboru NATO usedl. ","index":"566766","idec":"214 411 00010/0920","bonus":"","sidp":"","director":"Škampa Michal","type":"v","category":7},"v-7-23":{"id":"23","title":"Zemřel Václav Havel","topic":["politika"],"subtopic":["prezidenti"],"tags":["prezident","pohřeb","2011"],"date":"2011","timeline":"2011","gpsn":"","gpse":"","desc":"Bývalý prezident Václav Havel zemřel v neděli 18. prosince 2011 po dlouhodobých zdravotních problémech. V pondělí 23. prosince 2011 se konal v katedrále sv. Víta na Pražském hradě státní pohřeb, pohřebního průvodu na Hrad se účastnily tisíce lidí. ","index":"566778","idec":"211 411 05823/0051","bonus":"30356","sidp":"","director":"Sojka Petr","type":"v","category":7},"v-7-24":{"id":"24","title":"Kauza Nagyová","topic":["politika"],"subtopic":["kauzy"],"tags":["politika","2013"],"date":"2013","timeline":"2013","gpsn":"","gpse":"","desc":"Byla to asi nejrozsáhlejší policejní kauza české politiky. Detektivové při ní zasahovali na významných místech, třeba na Úřadu vlády. Zjistili například, že přítelkyně premiéra Nečase nechala odposlouchávat jeho manželku. Kauza Nagyová představovala konec Nečasovy vlády.","index":"566779","idec":"214 411 03400/0068","bonus":"30344","sidp":"","director":"","type":"v","category":7},"v-7-25":{"id":"25","title":"Hnutí ANO a Andrej Babiš","topic":["politika"],"subtopic":[""],"tags":["volby","2013"],"date":"2013","timeline":"2013","gpsn":"","gpse":"","desc":"Politické hnutí ANO 2011 bylo novým subjektem ve volbách do Poslanecké sněmovny Parlamentu ČR na podzim 2013. Lídrem hnutí je podnikatel a zakladatel koncernu Agrofert Andrej Babiš. Hnutí ANO se podařilo získat celkem 18,65 % hlasů a tím se umístilo na druhém místě hned po ČSSD.","index":"566780","idec":"213 411 00010/1026","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-26":{"id":"26","title":"Bohuslav Sobotka","topic":["politika"],"subtopic":[""],"tags":["politika"],"date":"2004","timeline":"2002–2017","gpsn":"","gpse":"","desc":"Vystudovaný právník je jeden z nejvýznamnějších členů ČSSD. V roce 2002 byl jmenován ministrem financí, o dekádu později premiérem České republiky. Podívejte se s námi na začátek jeho politické kariéry.","index":"567320","idec":"213 411 00010/0315","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-27":{"id":"27","title":"Jmenování Sobotkovy vlády","topic":["politika"],"subtopic":["vlády"],"tags":["volby","politika","2013"],"date":"2013","timeline":"2013","gpsn":"","gpse":"","desc":"Sobotkova vláda, vzniklá z voleb 2013, čekala na své jmenování prezidentem rekordní dobu, celkem 95 dnů. Ani ceremoniál jmenování vlády na pražském Hradě se neobešel bez drobných chyb. Ve vládě zasedli ministři tří politických stran - ČSSD, ANO a KDU-ČSL, podívejte se, kdo jakou funkci získal a jak jmenování probíhalo. ","index":"567346","idec":"214 411 00010/0129","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-28":{"id":"28","title":"Týden neklidu","topic":["politika"],"subtopic":[""],"tags":["vzdělávání","2012"],"date":"2012","timeline":"2012","gpsn":"","gpse":"","desc":"Studenti vysokých škol pořádali na přelomu února a března 2012  \"Týden neklidu\". V univerzitních městech po celé republice tak protestovali proti reformám a vládním škrtům, především však proti zavedení školného. Ministr školství Dobeš následně od zavedení školného odstoupil.","index":"567362","idec":"212 411 00014/0227","bonus":"","sidp":"","director":"Škampa Michal","type":"v","category":7},"v-7-29":{"id":"29","title":"Vít Bárta","topic":["politika"],"subtopic":["kauzy"],"tags":["politika","2011"],"date":"2011","timeline":"2011","gpsn":"","gpse":"","desc":"Někdejší lídr Věcí veřejných a ministr dopravy Vít Bárta byl v roce 2011 obviněn z uplácení dvou svých spolustraníků. Poslanecký imunitní výbor jej vydal k prošetření kauzy. Soud jej v roce 2012 potrestal odnětím svobody, nakonec byl však v odvolacím řízení zprostěn obvinění. Tato kauza Bártu stála politickou kariéru.","index":"567450","idec":"211 411 00010/0823","bonus":"","sidp":"","director":"Kotlář Vladimír","type":"v","category":7},"v-7-30":{"id":"30","title":"Amnestie prezidenta Klause","topic":["politika"],"subtopic":["kauzy"],"tags":["prezident","2013"],"date":"2013","timeline":"2013","gpsn":"","gpse":"","desc":"Ke konci svého funkčního období vyhlásil v roce 2013 prezident Klaus dílčí amnestii. Za udělení amnestie byl dlouho kritizován, propustil totiž i vězně s hospodářskými a korupčními trestnými činy. Někteří senátoři dokonce požadovali, aby byl Václav Klaus obviněn z vlastizrady.","index":"567972","idec":"215 411 05821/0001","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-31":{"id":"31","title":"Václav Klaus končí ve funkci prezidenta","topic":["politika"],"subtopic":["prezidenti"],"tags":["prezident","2013"],"date":"2013","timeline":"2013","gpsn":"","gpse":"","desc":"Celkem 10 let působil Václav Klaus ve funkci prezidenta České republiky. Hlasitě kritizoval Evropskou unii či vědecké poznatky o globální změně klimatu. Pyšní se mnoha mezinárodními cenami i čestnými doktoráty různých univerzit.","index":"567973","idec":"213 411 00010/0307","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-32":{"id":"32","title":"Konec Bambini di Praga","topic":["společnost"],"subtopic":[""],"tags":["hudba","2004"],"date":"2004","timeline":"2004","gpsn":"","gpse":"","desc":"Slavný dětský pěvecký sbor Bambini di Praga zažil po 40 letech své existence strmý pád. Jeho šéf Bohumil Kulínský byl odsouzen k odnětí svobody za zneužívání mladých sboristek. Mediální kauza kolem Kulínského nakonec sbor zcela rozložila.","index":"567980","idec":"211 411 05825/0904","bonus":"","sidp":"","director":"Bareš Ivan, Matějka Michal, Rásocha Jaroslav, Štěpánek Vlastislav","type":"v","category":7},"v-7-33":{"id":"33","title":"Nečasova vláda","topic":["politika"],"subtopic":["vlády"],"tags":["politika","volby","2011"],"date":"2010","timeline":"2010–2013","gpsn":"","gpse":"","desc":"Vládu Petra Nečase tvořila koalice ODS, TOP09 a Věcí veřejných. Vláda přestála pět hlasování o důvěře, nakonec skončila kvůli aféře s Janou Nagyovou. Jaké známky dostala vláda po jednom školním roce vládnutí?","index":"567991","idec":"211 411 05825/0904","bonus":"","sidp":"","director":"Bareš Ivan, Matějka Michal, Rásocha Jaroslav, Štěpánek Vlastislav","type":"v","category":7},"v-7-34":{"id":"34","title":"Grossova vláda","topic":["politika"],"subtopic":["vlády"],"tags":["poltika","volby","2004"],"date":"2004","timeline":"2004–2005","gpsn":"","gpse":"","desc":"V pořadí šestá vláda od vyhlášení samostatné republiky trvala necelý rok. Skládala se z koalice ČSSD, lidovců a Unie svobody. Kvůli aféře předsedy vlády Grosse byla vystřídána vládou Jiřího Paroubka. ","index":"568524","idec":"205 411 00010/0103","bonus":"30343","sidp":"","director":"","type":"v","category":7},"v-7-35":{"id":"35","title":"Barrack Obama na návštěvě v Praze","topic":["politika"],"subtopic":[""],"tags":["prezident","2009"],"date":"2009","timeline":"2009","gpsn":"","gpse":"","desc":"V rámci summitu Evropské unie a USA navštívil 8. dubna 2009 Prahu tehdejší americký prezident Barack Obama. Vystoupil se svým projevem na Hradčanském náměstí a setkal se dále například s Václavem Havlem.","index":"568215","idec":"209 411 03400/0192","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-36":{"id":"36","title":"Církevní restituce","topic":["společnost"],"subtopic":[""],"tags":["církev","hospodářství","2013"],"date":"2013","timeline":"2013","gpsn":"","gpse":"","desc":"Od roku 2013 vstoupil v účinnost zákon o majektovém vyrovnání s církvemi a náboženskými společnostmi. A tím také začal proces návratu části majetku, který byl znárodněn po roce 1948. Jak vypadalo vracení majetku v prosinci roku 2013?","index":"257903","idec":"213 411 00037/0423","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-37":{"id":"37","title":"Česká televize spustila Déčko","topic":["společnost"],"subtopic":[""],"tags":["televize","média","2013"],"date":"2013","timeline":"2013","gpsn":"","gpse":"","desc":"Dne 31. srpna 2013 spustila Česká televize dětský kanál ČT :D a kulturní kanál ČT art, který vysílá ve večerních hodinách na stejné frekvenci. ","index":"277425","idec":"313 281 38190/0831","bonus":"30340","sidp":"","director":"Grégr Tomáš","type":"v","category":7},"v-7-38":{"id":"38","title":"Stanoven termín prezidentských voleb","topic":["politika"],"subtopic":["prezidenti"],"tags":["volby","prezident","2018"],"date":"2018","timeline":"2018","gpsn":"","gpse":"","desc":"V lednu 2018 Česko čeká prezidentská volba. Bude to druhá přímá volba v historii ČR. Mezi prezidentské kandidáty budou patřit současný prezident Miloš Zeman, bývalý předseda Akademie věd Jiří Drahoš, producent Michal Horáček a mnozí další.","index":"568525","idec":"217 411 00037/0823","bonus":"30350","sidp":"","director":"Rásocha Jaroslav","type":"v","category":7},"v-7-39":{"id":"39","title":"Občanský zákoník změnil život Čechů","topic":["společnost"],"subtopic":[""],"tags":["2014"],"date":"2014","timeline":"","gpsn":"","gpse":"","desc":"K 1. lednu 2014 vstoupil v účinnost nový občanský zákoník, který byl schválen v roce 2012. Nahradil předchozí československý občanský zákoník z roku 1964 a zrušil či ovlivnil stovky jiných zákonů a tím ovlivnil život každého Čecha. ","index":"568527","idec":"214 411 00010/0101","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-40":{"id":"40","title":"Vláda Petra Nečase","topic":["politika"],"subtopic":["vlády"],"tags":["politika"],"date":"2010","timeline":"","gpsn":"","gpse":"","desc":"Takzvanou vládu rozpočtové odpovědnosti, tedy vládu Petra Nečase jmenoval prezident Václav Klaus dne 13. července 2010.","index":"568528","idec":"210 411 00037/0713","bonus":"30353","sidp":"","director":"Kotlář Vladimír","type":"v","category":7},"v-7-41":{"id":"41","title":"Uprchlická krize","topic":["politika","společnost"],"subtopic":[""],"tags":["Evropská unie","hranice"],"date":"2015","timeline":"","gpsn":"","gpse":"","desc":"Kvóty na uprchlíky - ano či ne? Mezi státy EU se prohlubuje spor o přijímání uprchlíků. Česku a dalším státům Visšegrádské čtyřky vytýká západ EU nedostatek solidarity s uprchlíky.","index":"568529","idec":"215 411 00010/0911","bonus":"","sidp":"","director":"Rásocha Jaroslav","type":"v","category":7},"v-7-42":{"id":"42","title":"Andrej Babiš","topic":["osobnosti","politika"],"subtopic":[""],"tags":["2013"],"date":"2012","timeline":"","gpsn":"","gpse":"","desc":"Jak začínal Andrej Babiš? A jak vypadá jeho běžný pracovní den? Profil miliardáře a politika.","index":"568530","idec":"212 563 23190/0002","bonus":"","sidp":"","director":"Horký Petr, Šajmovič Juraj","type":"v","category":7},"v-7-43":{"id":"43","title":"ČSSD jako vítěz v krajských a senátních volbách 2008","topic":["politika"],"subtopic":[""],"tags":["volby","2008"],"date":"2008","timeline":"","gpsn":"","gpse":"","desc":"Sociální demokraté se stali vítězi v krajských a senátních volbách roku 2008.","index":"568531","idec":"208 411 03326/1025","bonus":"30341","sidp":"","director":"","type":"v","category":7},"v-7-44":{"id":"44","title":"Mirek Topolánek končí, na řadu přichází Petr Nečas","topic":["politika"],"subtopic":[""],"tags":["2010"],"date":"2010","timeline":"","gpsn":"","gpse":"","desc":"Po zasedání výkonné rady ODS rezignoval v dubnu 2010 na post předsedy strany Mirek Topolánek kvůli nevhodnému rozhovoru pro časopis LUI. Výkonná rada navrhla za lídra do parlamentních voleb místopředsedu strany Petra Nečase.","index":"568533","idec":"210 411 05825/0328 ","bonus":"30346","sidp":"","director":"Bareš Ivan, Jakovec Jiří, Straka Marek","type":"v","category":7},"v-7-45":{"id":"45","title":"Nenávistné příspěvky o uprchlících","topic":["politika","společnost"],"subtopic":[""],"tags":["Evropská unie","hranice","2015"],"date":"2015","timeline":"","gpsn":"","gpse":"","desc":"Součástí vlny nenávisti proti imigrantům jsou také příspěvky některých uživatelů sociálních sítí. Policie komentáře, které podněcují k nenávisti, pravidelně prověřuje, může se totiž jednat o trestný čin.","index":"568532","idec":"215 411 00037/0828","bonus":"30347","sidp":"","director":"Škampa Michal","type":"v","category":7},"v-7-46":{"id":"46","title":"Vládní krize Babiš-Sobotka","topic":["politika"],"subtopic":["vlády"],"tags":["politka"],"date":"2017","timeline":"","gpsn":"","gpse":"","desc":"Nebylo jisté, zda se Andrej Babiš stane příštím premiérem, nebo půjde před soud. Podívejte se na průběh krize, ve které figuroval premiér Sobotka, exministr financí Babiš a prezident Zeman. ","index":"568534","idec":"217 411 05813/0505","bonus":"","sidp":"","director":"Ďurica Peter","type":"v","category":7},"v-7-47":{"id":"47","title":"Češi – mistři světa v hokeji ve Vídni","topic":["sport"],"subtopic":[""],"tags":["sport","hokej","2005"],"date":"2005","timeline":"2005","gpsn":"48.2083536","gpse":"16.3725042","desc":"Reprezentační výběr Česka vyhrál na 69. Mistrovství světa v ledním hokeji ve Vídni konaném ve dnech 30. 4–15. 5. 2005.","index":"","idec":"","bonus":"11098","sidp":"","director":"","type":"v","category":7},"v-7-48":{"id":"48","title":"Letecká katastrofa týmu z Jaroslavle","topic":["sport"],"subtopic":[""],"tags":["sport","hokej","2011"],"date":"2011","timeline":"2011","gpsn":"57.6489839","gpse":"39.8590242","desc":"Při letecké havárii zahynulo 37 členů ruského hokejového týmu Lokomotiv Jaroslavl. Mezi nimi i tři čeští hokejisté Josef Vašíček, Jan Marek a Karel Rachůnek.","index":"596195","idec":"211 411 00037/0907","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-49":{"id":"49","title":"Organizace Člověk v tísni","topic":["společnost"],"subtopic":[""],"tags":["menšiny","2007"],"date":"2007","timeline":"2007","gpsn":"","gpse":"","desc":"Česká organizace Člověk v tísni se od roku 1992 věnuje humanitární, rozvojové a vzdělávací pomoci. Doposud působila ve více než 50 zemích světa. Již od 90. let pomáhá také v zemích, kde jsou porušována či ohrožena lidská práva.","index":"661099","idec":"207 411 00010/0922","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-50":{"id":"50","title":"Miloš Zeman opět zvolen prezidentem","topic":["politika"],"subtopic":["prezidenti"],"tags":["prezident","2018"],"date":"2018","timeline":"2018","gpsn":"","gpse":"","desc":"Ve druhém kole přímé volby prezidenta zvítězil 27. ledna 2018 Miloš Zeman. V celkovém součtu těsně porazil Jiřího Drahoše o necelá 3% hlasů.","index":"596594","idec":"218 411 00010/0128","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-51":{"id":"51","title":"Demonstrace proti zvolení Zdeňka Ondráčka","topic":["politika"],"subtopic":[""],"tags":["demonstrace","2018"],"date":"2018","timeline":"","gpsn":"","gpse":"","desc":"Zdeněk Ondráček, poslanec za KSČM, který v roce 1989 potlačoval protirežimní demonstrace, byl zvolen členem sněmovní komise Generální inspekce bezpečnostních sborů (GIBS). Tato událost vyvolala vlnu protestů. Zdeněk Ondráček později na funkci rezignoval.","index":"604914","idec":"218 411 00010/0305","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-52":{"id":"52","title":"Návrat ostatků kardinála Josefa Berana do vlasti","topic":["společnost"],"subtopic":[""],"tags":["církev","2018"],"date":"2018","timeline":"2018","gpsn":"","gpse":"","desc":"Téměř po padesáti letech se do Čech vrátily ostatky kardinála Josefa Berana, který zemřel v roce 1969 v nuceném exilu v Římě. Byl slavnostně pochován v katedrále sv. Víta na pražském Hradě.","index":"614655","idec":"218 411 00010/0419","bonus":"","sidp":"","director":"","type":"v","category":7},"v-7-53":{"id":"53","title":"Výbuch metanu v Dole ČSM na Karvinsku","topic":["společnost"],"subtopic":[""],"tags":["těžba","2018"],"date":"2018","timeline":"2018","gpsn":"49.8176983","gpse":"18.5485536","desc":"V hloubce 800 metrů v Dole ČSM ve Stonavě na Karvinsku došlo 20. prosince 2018 k výbuchu metanu. Výbuch si vyžádal 13 obětí, jedná se o druhé nejhorší důlní neštěstí na území Česka od roku 1990.","index":"667778","idec":"218 411 00010/1221","bonus":"","sidp":"","director":"","type":"v","category":7}}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = {"v-7-53":{"premiere":"21. 12. 2018 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/218411000101221"},"v-7-52":{"premiere":"19. 4. 2018 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/218411000100419"},"v-7-51":{"premiere":"5. 3. 2018 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/218411000100305"},"v-7-50":{"premiere":"28. 1. 2018 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/218411000100128"},"v-7-49":{"premiere":"22. 9. 2007 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/207411000100922"},"v-7-48":{"premiere":"7. 9. 2011 - ČT24","title":"Události, komentáře","partTitle":"","description":"Zdravotnická reforma — Sněmovní manipulace — Letecká tragédie — Fotografie na hraně","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/211411000370907"},"v-7-46":{"premiere":"5. 5. 2017 - ČT24","title":"90’ ČT24","partTitle":"Sobotka demisi nepodá a chce odvolat Babiše","description":"Host: Martin Kupka","link":"http://www.ceskatelevize.cz/ivysilani/11412378947-90-ct24/217411058130505"},"v-7-45":{"premiere":"28. 8. 2015 - ČT24","title":"Události, komentáře","partTitle":"","description":"Nový náhled na imigraci — Reakce na uprchlíky — Aféra fotbalových rozhodčích — Saské dny Lužických Srbů","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/215411000370828"},"v-7-44":{"premiere":"28. 3. 2010 - ČT1","title":"168 hodin","partTitle":"","description":"Předseda ODS, premiér, vládce Evropy, sportovec, milovník Toskánska a autor nehynoucích perel","link":"http://www.ceskatelevize.cz/ivysilani/10117034229-168-hodin/210411058250328"},"v-7-43":{"premiere":"25. 10. 2008 - ČT1","title":"Studio Volby 2008","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10207567581-studio-volby-2008/208411033261025"},"v-7-42":{"premiere":"21. 1. 2013 - ČT1","title":"Rub a líc","partTitle":"Sametoví miliardáři","description":"Andrej Babiš — David Beran — Karel Janeček","link":"http://www.ceskatelevize.cz/ivysilani/10399366967-rub-a-lic/212563231900002-rub-a-lic-sametovych-miliardaru"},"v-7-41":{"premiere":"11. 9. 2015 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/215411000100911"},"v-7-40":{"premiere":"13. 7. 2010 - ČT24","title":"Události, komentáře","partTitle":"","description":"Na startu — Slovenské lavírování — Hvězdný tenor José Cura","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/210411000370713"},"v-7-39":{"premiere":"1. 1. 2014 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/214411000100101"},"v-7-38":{"premiere":"23. 8. 2017 - ČT24","title":"Události, komentáře","partTitle":"","description":"Macronova evropská mise — Prezidentské volby","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/217411000370823"},"v-7-37":{"premiere":"31. 8. 2013 - ČT24","title":"Události v regionech (Brno)","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10122427178-udalosti-v-regionech-brno/313281381900831-udalosti-v-regionech-vikend"},"v-7-36":{"premiere":"23. 4. 2013 - ČT24","title":"Události, komentáře","partTitle":"","description":"Spor o velvyslance — Církevní restituce — Dagestánská stopa? — Pád fotbalové legendy?","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/213411000370423"},"v-7-35":{"premiere":"5. 4. 2009 - ČT2","title":"Obama v Praze","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10101491767-studio-ct24/209411034000192-projev-prezidenta-usa-baracka-obamy"},"v-7-34":{"premiere":"3. 1. 2005 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/205411000100103"},"v-7-33":{"premiere":"3. 7. 2011 - ČT1","title":"168 hodin","partTitle":"","description":"Vysvědčení vládě Petra Nečase — Příliš drahá Sazka Aréna — Konec Bambini di Praga — Sportovci jako loutky diktátorů","link":"http://www.ceskatelevize.cz/ivysilani/10117034229-168-hodin/211411058250904"},"v-7-32":{"premiere":"3. 7. 2011 - ČT1","title":"168 hodin","partTitle":"","description":"Vysvědčení vládě Petra Nečase — Příliš drahá Sazka Aréna — Konec Bambini di Praga — Sportovci jako loutky diktátorů","link":"http://www.ceskatelevize.cz/ivysilani/10117034229-168-hodin/211411058250904"},"v-7-31":{"premiere":"7. 3. 2013 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/213411000100307"},"v-7-30":{"premiere":"3. 1. 2015 - ČT24","title":"Archiv ČT24","partTitle":"Amnestie a milosti","description":"Jaká dobrodiní udělali prezidenti, kteří se vystřídali na Hradě během uplynulých pětadvaceti let","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/215411058210001"},"v-7-29":{"premiere":"23. 8. 2011 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/211411000100823"},"v-7-28":{"premiere":"27. 2. 2012 - ČT1","title":"Události v regionech (Praha)","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10118379000-udalosti-v-regionech-praha/212411000140227-udalosti-v-regionech"},"v-7-27":{"premiere":"29. 1. 2014 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/214411000100129"},"v-7-26":{"premiere":"15. 3. 2013 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/213411000100315"},"v-7-25":{"premiere":"26. 10. 2013 - ČT1","title":"Události","partTitle":"","description":"Volby 2013","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/213411000101026"},"v-7-24":{"premiere":"11. 6. 2014 - ČT24","title":"Rok s kauzou Nagyová","partTitle":"","description":"Rok s kauzou Nagyová","link":"http://www.ceskatelevize.cz/ivysilani/10101491767-studio-ct24/214411034000068-rok-s-kauzou-nagyova"},"v-7-23":{"premiere":"24. 12. 2011 - ČT24","title":"Z metropole","partTitle":"","description":"Zemřel Václav Havel — Otakáro Schmidt natočil dokument Pražské Jezulátko — Husův sbor v Holešovicích — Sbor Radostné stáří — Zbraně v Prašné bráně — Otec Anastázio","link":"http://www.ceskatelevize.cz/ivysilani/10116288835-z-metropole/211411058230051"},"v-7-22":{"premiere":"20. 9. 2014 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/214411000100920"},"v-7-21":{"premiere":"30. 11. 2011 - ČT1","title":"Události v regionech (Brno)","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10122427178-udalosti-v-regionech-brno/311281381991130-udalosti-v-regionech"},"v-7-20":{"premiere":"13. 12. 2010 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/210411000101213"},"v-7-19":{"premiere":"23. 7. 2006 - ČT1","title":"Toulavá kamera","partTitle":"","description":"Lednicko-valtický areál — Dudy — Stezka Járy Cimrmana — Zoo Plzeň","link":"http://www.ceskatelevize.cz/ivysilani/1126666764-toulava-kamera/206411000320723"},"v-7-18":{"premiere":"17. 1. 2007 - ČT2","title":"Události, komentáře","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/207411000370117"},"v-7-17":{"premiere":"5. 5. 2009 - ČT24","title":"Události, komentáře","partTitle":"","description":"Co udělá nová vláda? — Pokus o vojenský převrat? — Exhumace vojáků","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/209411000370505"},"v-7-16":{"premiere":"9. 3. 2008 - ČT1","title":"168 hodin","partTitle":"","description":"Jak to dopadne s Hillary? — Malostranské korekce","link":"http://www.ceskatelevize.cz/ivysilani/10117034229-168-hodin/208411058250309"},"v-7-15":{"premiere":"11. 5. 2009 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/209411010100511"},"v-7-14":{"premiere":"19. 6. 2009 - ČT2","title":"Události, komentáře","partTitle":"","description":"Konec dobrý, všechno dobré? — Protest on-line generace — Konec Formule 1?","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/209411000370619"},"v-7-13":{"premiere":"5. 11. 2014 - ČT sport","title":"Olympijský magazín","partTitle":"","description":"Událost týdne — Setkání generací: Zuzana Hejnová a Jana Reissová — Sportovní lezení na vlastní kůži — Host magazínu: Petr Graclík — České olympijské novinky — Sazka olympijský víceboj — Z historie OH: Londýn 2012 — Olympijské muzeum v Lausanne — Sport v umění — Hrdinové českého sportu: Iveta Bidařová","link":"http://www.ceskatelevize.cz/ivysilani/10321897020-olympijsky-magazin/214471290290042"},"v-7-12":{"premiere":"14. 5. 2013 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/213411000100514"},"v-7-11":{"premiere":"27. 4. 2008 - ČT1","title":"168 hodin","partTitle":"","description":"Kauza Kulínský, kauza knihovna","link":"http://www.ceskatelevize.cz/ivysilani/10117034229-168-hodin/208411058250427"},"v-7-10":{"premiere":"6. 4. 2006 - ČT1","title":"Zprávy","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1178166846-zpravy/206411000220406"},"v-7-9":{"premiere":"8. 7. 2008 - ČT1","title":"Události v regionech (Praha)","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10118379000-udalosti-v-regionech-praha/208411000140708-udalosti-v-regionech"},"v-7-8":{"premiere":"9. 6. 2006 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/206411000100609"},"v-7-7":{"premiere":"20. 12. 2007 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/207411000101220"},"v-7-6":{"premiere":"15. 3. 2006 - ČT1","title":"Události, komentáře","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/206411000370315"},"v-7-3":{"premiere":"29. 1. 2013 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/213411000100129"},"v-7-1":{"premiere":"16. 4. 2015 - ČT24","title":"Události, komentáře","partTitle":"","description":"Čech v řadách IS? — Stanislav Gross (1969–2015) — Nezávislost médií — Putin odpovídal","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/215411000370416"},"v-6-52":{"premiere":"9. 4. 2016 - ČT24","title":"Archiv ČT24","partTitle":"Kolektivizace","description":"Společné hospodaření zemědělců bylo jedním ze základních požadavků socialistického budování","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/216411058210015"},"v-6-51":{"premiere":"6. 11. 2010 - ČT24","title":"Archiv ČT24","partTitle":"Před dvaceti lety - rok 1990","description":"Co se událo v prvním roce obnovené demokracie, jak to zachytily kamery televizního zpravodajství","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/210452801350036"},"v-6-50":{"premiere":"11. 1. 2011 - ČT1","title":"Rozmarná léta českého filmu","partTitle":"","description":"1990/1991","link":"http://www.ceskatelevize.cz/ivysilani/10267861763-rozmarna-leta-ceskeho-filmu/21056226502-rozmarna-leta-ceskeho-filmu-1990-1991"},"v-6-49":{"premiere":"22. 2. 2016 - ČT24","title":"90’ ČT24","partTitle":"Fenomén Jágr / Budoucnost českého hokeje","description":"Host: Jiří Šlégr","link":"http://www.ceskatelevize.cz/ivysilani/11412378947-90-ct24/216411058130222"},"v-6-48":{"premiere":"24. 8. 2014 - ČT2","title":"Léčba dějin","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10293374741-lecba-dejin/21156226406"},"v-6-47":{"premiere":"7. 10. 2005 - ČT1","title":"Události, komentáře","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/205411000371007"},"v-6-46":{"premiere":"3. 1. 2009 - ČT24","title":"Archiv ČT24","partTitle":"Cesta do EU","description":"Nejdůležitější události našeho polistopadového návratu do Evropy","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/209452801350001"},"v-6-45":{"premiere":"23. 3. 2013 - ČT24","title":"Archiv ČT24","partTitle":"Trojkové březny","description":"Co se událo v březnu v letech končících trojkou","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/213411058210012"},"v-6-44":{"premiere":"3. 1. 2009 - ČT24","title":"Archiv ČT24","partTitle":"Cesta do EU","description":"Nejdůležitější události našeho polistopadového návratu do Evropy","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/209452801350001"},"v-6-43":{"premiere":"5. 12. 2008 - ČT24","title":"Archiv ČT24","partTitle":"Kongresy ODS","description":"Zlomové momenty v dějinách naší nejsilnější pravicové strany, jak je zachytilo televizní zpravodajství","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/208452801350045"},"v-6-42":{"premiere":"7. 8. 2017 - ČT24","title":"90’ ČT24","partTitle":"Česko před 15 lety zasáhly povodně","description":"Host: Petr Kubala","link":"http://www.ceskatelevize.cz/ivysilani/11412378947-90-ct24/217411058130807"},"v-6-40":{"premiere":"23. 7. 2007 - ČT2","title":"Události, komentáře","partTitle":"","description":"Spor stát versus ČSOB a volby v Turecku ","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/207411000370723"},"v-6-39":{"premiere":"4. 12. 2010 - ČT24","title":"Archiv ČT24","partTitle":"Před deseti lety - rok 2000","description":"Jak zachytily kamery televizního zpravodajství nejdůležitější události na přelomu tisícíletí.","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/210452801350040"},"v-6-38":{"premiere":"11. 10. 2005 - ČT1","title":"Události, komentáře","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/205411000371011"},"v-6-37":{"premiere":"9. 11. 2010 - ČT2","title":"Prachy a ideály","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10245598642-prachy-a-idealy/20956226664"},"v-6-36":{"premiere":"6. 11. 2011 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/211411000101106"},"v-6-35":{"premiere":"14. 7. 2013 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/213411000100714"},"v-6-34":{"premiere":"4. 11. 2014 - ČT2","title":"Expremiéři","partTitle":"Josef Tošovský","description":"Pilíř stability","link":"http://www.ceskatelevize.cz/ivysilani/10495416715-expremieri/313294340010003-josef-tosovsky-pilir-stability"},"v-6-33":{"premiere":"18. 3. 2015 - ČT sport","title":"Olympijský magazín","partTitle":"","description":"Událost týdne — Setkání generací: Tomáš Verner a Petr Coufal — Wu-šu na vlastní kůži — Host magazínu: Michael Rittstein — České olympijské novinky — Sazka olympijský víceboj — Osobnosti a sport: Lubomír Brabec — Z historie OH: Nagano 1998 — Hrdinové českého sportu: Jaroslav Baďura","link":"http://www.ceskatelevize.cz/ivysilani/10321897020-olympijsky-magazin/215471290290011"},"v-6-32":{"premiere":"19. 1. 2017 - ČT24","title":"90’ ČT24","partTitle":"20 let od podpisu Česko-německé deklarace","description":"Host: Tomáš Jelínek","link":"http://www.ceskatelevize.cz/ivysilani/11412378947-90-ct24/217411058130119"},"v-6-31":{"premiere":"7. 7. 2016 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/216411010100707"},"v-6-30":{"premiere":"22. 11. 2007 - ČT1","title":"Vládneme, nerušit","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10123147075-vladneme-nerusit/407235100021003"},"v-6-29":{"premiere":"1. 8. 2017 - ČT sport","title":"Archiv Z","partTitle":"Jan Železný","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10364596087-archiv-z/217471294070003-archiv-z-jan-zelezny"},"v-6-28":{"premiere":"2. 2. 2015 - ČT1","title":"Reportéři ČT","partTitle":"","description":"Ostravský Janoušek — Olga z Hrádečku","link":"http://www.ceskatelevize.cz/ivysilani/1142743803-reporteri-ct/215452801240005"},"v-6-25":{"premiere":"3. 1. 2009 - ČT24","title":"Archiv ČT24","partTitle":"Cesta do EU","description":"Nejdůležitější události našeho polistopadového návratu do Evropy","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/209452801350001"},"v-6-24":{"premiere":"28. 3. 2015 - ČT24","title":"Archiv ČT24","partTitle":"Pětkové březny","description":"Co považovaly za důležité kamery Čs. filmových týdeníků a televizního zpravodajství v březnu v letech končících pětkou","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/215411058210013"},"v-6-23":{"premiere":"26. 9. 2009 - ČT24","title":"Archiv ČT24","partTitle":"Návštěvy papeže","description":"Jak probíhaly návštěvy hlavy katolické církve u nás","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/209452801350035"},"v-6-22":{"premiere":"15. 4. 2016 - ČT24","title":"90’ ČT24","partTitle":"25 let Škody v náruči Volkswagenu","description":"Host: Vratislav Kulhánek","link":"http://www.ceskatelevize.cz/ivysilani/11412378947-90-ct24/216411058130415"},"v-6-21":{"premiere":"25. 1. 2011 - ČT1","title":"Rozmarná léta českého filmu","partTitle":"","description":"1993","link":"http://www.ceskatelevize.cz/ivysilani/10267861763-rozmarna-leta-ceskeho-filmu/21056226504-rozmarna-leta-ceskeho-filmu-1993"},"v-6-20":{"premiere":"25. 1. 2014 - ČT24","title":"Archiv ČT24","partTitle":"Čtyřkové ledny","description":"Co podstatného se událo v prvním měsíci roků končících čtyřkou, jak to zachytily kamery filmových týdeníků a televizního zpravodajství","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/214411058210004"},"v-6-19":{"premiere":"7. 2. 2013 - ČT24","title":"Speciál 20 let české koruny","partTitle":"","description":"Speciál 20 let české koruny","link":"http://www.ceskatelevize.cz/ivysilani/10101491767-studio-ct24/213411034000016-special-20-let-ceske-koruny"},"v-6-18":{"premiere":"3. 1. 2009 - ČT24","title":"Archiv ČT24","partTitle":"Cesta do EU","description":"Nejdůležitější události našeho polistopadového návratu do Evropy","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/209452801350001"},"v-6-16":{"premiere":"14. 12. 2013 - ČT24","title":"Archiv ČT24","partTitle":"Před dvaceti lety - rok 1993","description":"Jaké byly nejdůležitější události roku 1993 kamerami České televize","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/213411058210041"},"v-6-15":{"premiere":"14. 12. 2013 - ČT24","title":"Archiv ČT24","partTitle":"Před dvaceti lety - rok 1993","description":"Jaké byly nejdůležitější události roku 1993 kamerami České televize","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/213411058210041"},"v-6-14":{"premiere":"20. 7. 2017 - ČT24","title":"Události, komentáře","partTitle":"","description":"25 let od abdikace Václava Havla — Budoucnost důchodů v Česku","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/217411000370720"},"v-6-13":{"premiere":"18. 11. 2008 - ČT2","title":"Vážený Leonide Iljiči","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10169621358-vazeny-leonide-iljici/20856226639"},"v-6-12":{"premiere":"16. 6. 2012 - ČT24","title":"Archiv ČT24","partTitle":"Dvojkové červny","description":"Co se dělo v červnu v letech končících dvojkou?","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/212411058210024"},"v-6-11":{"premiere":"21. 1. 2013 - ČT1","title":"Rub a líc","partTitle":"Sametoví miliardáři","description":"Andrej Babiš — David Beran — Karel Janeček","link":"http://www.ceskatelevize.cz/ivysilani/10399366967-rub-a-lic/212563231900002-rub-a-lic-sametovych-miliardaru"},"v-6-10":{"premiere":"1. 11. 2016 - ČT24","title":"90’ ČT24","partTitle":"Před 25 lety odstartovala kupónová privatizace","description":"Host: Dušan Tříska","link":"http://www.ceskatelevize.cz/ivysilani/11412378947-90-ct24/216411058131101"},"v-6-9":{"premiere":"5. 11. 2011 - ČT24","title":"20 let lustračního zákona","partTitle":"","description":"20 let lustračního zákona","link":"http://www.ceskatelevize.cz/ivysilani/10101491767-studio-ct24/211411034000288-20-let-lustracniho-zakona"},"v-6-8":{"premiere":"26. 2. 2015 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/215411010100226"},"v-6-7":{"premiere":"5. 12. 2008 - ČT24","title":"Archiv ČT24","partTitle":"Kongresy ODS","description":"Zlomové momenty v dějinách naší nejsilnější pravicové strany, jak je zachytilo televizní zpravodajství","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/208452801350045"},"v-6-6":{"premiere":"6. 11. 2010 - ČT24","title":"Archiv ČT24","partTitle":"Před dvaceti lety - rok 1990","description":"Co se událo v prvním roce obnovené demokracie, jak to zachytily kamery televizního zpravodajství","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/210452801350036"},"v-6-5":{"premiere":"21. 4. 2015 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/215411010100421"},"v-6-4":{"premiere":"29. 3. 2015 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/215411000100329"},"v-6-3":{"premiere":"21. 2. 1990 - ČT1","title":"Projev prezidenta Václava Havla v Kongresu USA","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/655987-projev-prezidenta-vaclava-havla-v-kongresu-usa/29045170709"},"v-6-2":{"premiere":"15. 2. 2015 - ČT24","title":"Studio 6 Víkend","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10441287766-studio-6-vikend/215411010120215"},"v-6-1":{"premiere":"21. 10. 2014 - ČT2","title":"Expremiéři","partTitle":"Petr Pithart","description":"Limity vládnutí","link":"http://www.ceskatelevize.cz/ivysilani/10495416715-expremieri/313294340010001-petr-pithart-limity-vladnuti"},"v-5-61":{"premiere":"11. 12. 2008 - ČT2","title":"Historie.cs","partTitle":"Svoboda na Škroupově náměstí","description":"Jak se drolil totalitní systém, když na první režimem povolené demonstraci zazněla československá hymna, zpívaná Martou Kubišovou.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400049"},"v-5-60":{"premiere":"19. 6. 2008 - ČT2","title":"Jazzová sekce","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10169743762-jazzova-sekce/20856226881"},"v-5-59":{"premiere":"2. 11. 2009 - ČT1","title":"Tajné akce StB","partTitle":"Akce Jazz","description":"Téměř dvacet let vedl stát s Jazzovou sekcí zákopovou válku, kde hlavními zbraněmi byla šikana, soudy, vězení.","link":"http://www.ceskatelevize.cz/ivysilani/10209991308-tajne-akce-stb/409235100221033-akce-jazz"},"v-5-58":{"premiere":"12. 9. 1969 - ČT1","title":"Vlastenci bez masky","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1064049608-vlastenci-bez-masky/26953131034"},"v-5-57":{"premiere":"20. 1. 1977 - ČT1","title":"Kdo je Václav Havel?","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1064010780-kdo-je-vaclav-havel/27753118376"},"v-5-56":{"premiere":"11. 3. 2007 - ČT1","title":"Ženy Charty 77","partTitle":"","description":"Zdena Tominová","link":"http://www.ceskatelevize.cz/ivysilani/10114412382-zeny-charty-77/206562264000007-zdena-tominova"},"v-5-55":{"premiere":"18. 2. 2007 - ČT1","title":"Ženy Charty 77","partTitle":"","description":"Kamila Bendová","link":"http://www.ceskatelevize.cz/ivysilani/10114412382-zeny-charty-77/206562264000003-kamila-bendova"},"v-5-53":{"premiere":"2. 1. 2016 - ČT24","title":"Archiv ČT24","partTitle":"Slavnostní začátky","description":"Otevírání a odhalování čehokoli je důvodem k oslavě","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/216411058210001"},"v-5-52":{"premiere":"7. 7. 1972 - ČT1","title":"Pozdravy pohraničníkům","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1063985797-pozdravy-pohranicnikum/27253112670"},"v-5-51":{"premiere":"9. 4. 2016 - ČT24","title":"Archiv ČT24","partTitle":"Kolektivizace","description":"Společné hospodaření zemědělců bylo jedním ze základních požadavků socialistického budování","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/216411058210015"},"v-5-50":{"premiere":"9. 4. 2016 - ČT24","title":"Archiv ČT24","partTitle":"Kolektivizace","description":"Společné hospodaření zemědělců bylo jedním ze základních požadavků socialistického budování","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/216411058210015"},"v-5-49":{"premiere":"12. 1. 2014 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/214411000100112"},"v-5-48":{"premiere":"31. 1. 2011 - ČT2","title":"Abeceda komunistických zločinů","partTitle":"Emigrace","description":"Útěk na Západ neznamenal jen svobodu, ale také noční můry, výčitky a strach.","link":"http://www.ceskatelevize.cz/ivysilani/10317262233-abeceda-komunistickych-zlocinu/411235100181005-emigrace"},"v-5-47":{"premiere":"26. 12. 2008 - ČT2","title":"Gustáv Husák","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10218330054-gustav-husak/208411033290002"},"v-5-46":{"premiere":"20. 10. 2014 - ČT24","title":"Události, komentáře","partTitle":"","description":"Vítězové a poražení — Sestavování koalic — Lesní školky (ne)končí — 25 let od svatořečení Anežky české","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/214411000371020"},"v-5-45":{"premiere":"15. 1. 2009 - ČT2","title":"Poselství Jana Palacha","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10178479416-poselstvi-jana-palacha/20856226883"},"v-5-44":{"premiere":"24. 11. 2008 - ČT2","title":"Šumná města","partTitle":"","description":"Šumný Moravský kras","link":"http://www.ceskatelevize.cz/ivysilani/1008546862-sumna-mesta/208522162350005-sumny-moravsky-kras"},"v-5-43":{"premiere":"16. 2. 2013 - ČT2","title":"Těžká léta československého filmu 1969 - 89","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10523691056-tezka-leta-ceskoslovenskeho-filmu-1969-89/21256226284-principy-cenzury"},"v-5-42":{"premiere":"30. 11. 2014 - ČT1","title":"České století","partTitle":"Poslední hurá (1989)","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10362011008-ceske-stoleti/21351212041-posledni-hura-1989"},"v-5-41":{"premiere":"18. 2. 2008 - ČT2","title":"Občanská hnutí","partTitle":"","description":"Osudy Pražského jara","link":"http://www.ceskatelevize.cz/ivysilani/10104453571-obcanska-hnuti/306295350340001-osudy-prazskeho-jara"},"v-5-40":{"premiere":"3. 9. 2007 - ČT1","title":"Historie.cs","partTitle":"Srpen 1969 – lámání páteře","description":"Jaké byly počátky normalizace.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/207452801390001"},"v-5-39":{"premiere":"23. 2. 2009 - ČT1","title":"Tajné akce StB","partTitle":"Akce Bojanovice","description":"Šikanování, ponižování, zatýkání. Tak v sedmdesátých letech platily nezávislé kapely za to, že chtěly hrát vlastní muziku.","link":"http://www.ceskatelevize.cz/ivysilani/10209991308-tajne-akce-stb/409235100221008-akce-bojanovice"},"v-5-38":{"premiere":"19. 1. 2014 - ČT2","title":"Oběť nejvyšší","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10751705758-obet-nejvyssi/21454215720"},"v-5-37":{"premiere":"17. 11. 2016 - ČT2","title":"České studentské revolty","partTitle":"80. léta","description":"","link":"http://www.ceskatelevize.cz/ivysilani/11089222465-ceske-studentske-revolty/21656226551-ceske-studentske-revolty-80-leta"},"v-5-36":{"premiere":"17. 11. 2016 - ČT2","title":"České studentské revolty","partTitle":"80. léta","description":"","link":"http://www.ceskatelevize.cz/ivysilani/11089222465-ceske-studentske-revolty/21656226551-ceske-studentske-revolty-80-leta"},"v-5-35":{"premiere":"17. 9. 2014 - ČT sport","title":"Olympijský magazín","partTitle":"","description":"Zpravodajský souhrn uplynulého týdne — Aktuální stav příprav Her v Rio de Janeiro — Setkání generací: Marie Hrachová a Iveta Vacenovská — Nová podoba Olympijského muzea v Lausanne — České olympijské novinky — Z historie OH: Los Angeles 1984 — Umělecká díla se sportovní tématikou — Síň slávy českých trenérů: Václav Koudelka","link":"http://www.ceskatelevize.cz/ivysilani/10321897020-olympijsky-magazin/214471290290035"},"v-5-34":{"premiere":"28. 4. 2012 - ČT1","title":"Retro","partTitle":"","description":"Perestrojka","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/212411000360017"},"v-5-33":{"premiere":"29. 8. 2005 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/205411000100829"},"v-5-32":{"premiere":"10. 6. 2008 - ČT1","title":"Retro","partTitle":"","description":"JZD Slušovice","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/208411000360618"},"v-5-31":{"premiere":"12. 1. 2007 - ČT1","title":"13. komnata","partTitle":"","description":"Jeden z nejvýznamnějších hrdinů undergroundové scény, bojovník proti totalitě, mnohokrát vězněný básník Ivan Martin Jirous, se zpovídá z traumat svého nejtěžšího období.","link":"http://www.ceskatelevize.cz/ivysilani/1186000189-13-komnata/206562210800044-13-komnata-ivana-martina-jirouse"},"v-5-30":{"premiere":"22. 1. 2011 - ČT1","title":"Retro","partTitle":"","description":"Ceny zboží","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/211411000360004"},"v-5-29":{"premiere":"3. 5. 2009 - ČT1","title":"Retro","partTitle":"","description":"Podpultové zboží","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/209411000360018"},"v-5-28":{"premiere":"10. 12. 2010 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/210411000101210"},"v-5-27":{"premiere":"25. 10. 2009 - ČT1","title":"Retro","partTitle":"","description":"Veksláci","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/209411000360032"},"v-5-26":{"premiere":"19. 8. 2002 - ČT2","title":"Sláva vítězům","partTitle":"Jan Kodeš","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1058319265-slava-vitezum/202471296020031-jan-kodes"},"v-5-25":{"premiere":"23. 11. 2014 - ČT1","title":"České století","partTitle":"Je to jen rock'n'roll (1976)","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10362011008-ceske-stoleti/21251212057-je-to-jen-rock-n-roll-1976"},"v-5-24":{"premiere":"8. 12. 2008 - ČT2","title":"Vzkaz","partTitle":"Vzkaz Dany Němcové","description":"Psycholožka, bývalá disidentka a předsedkyně správní rady Výboru dobré vůle Olgy Havlové.","link":"http://www.ceskatelevize.cz/ivysilani/10160488386-vzkaz/208452801410014-vzkaz-dany-nemcove"},"v-5-23":{"premiere":"14. 12. 2013 - ČT24","title":"Retro","partTitle":"","description":"Rok 1985","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/213411000360041"},"v-5-22":{"premiere":"11. 5. 2013 - ČT24","title":"Historie.cs","partTitle":"Plánování apokalypsy –  jaderné zbraně u nás","description":"Oldřich Tůma — Prokop Tomek — Petr Luňák","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/213452801400018"},"v-5-21":{"premiere":"23. 11. 2014 - ČT1","title":"České století","partTitle":"Je to jen rock'n'roll (1976)","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10362011008-ceske-stoleti/21251212057-je-to-jen-rock-n-roll-1976"},"v-5-20":{"premiere":"1. 1. 2015 - ČT2","title":"Život podle Václava Havla","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10781943775-zivot-podle-vaclava-havla/21456226499"},"v-5-19":{"premiere":"27. 1. 2014 - ČT1","title":"Reportéři ČT","partTitle":"","description":"Dovolená s kmotrem — Vyznamenání pro živou pochodeň — Vítězný boj o dědictví","link":"http://www.ceskatelevize.cz/ivysilani/1142743803-reporteri-ct/214452801240004"},"v-5-18":{"premiere":"7. 5. 2011 - ČT24","title":"Retro","partTitle":"","description":"Hnutí Brontosaurus","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/211411000360019"},"v-5-17":{"premiere":"6. 4. 2001 - ČT1","title":"Ropáci","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/24856-ropaci/29738365832"},"v-5-16":{"premiere":"28. 10. 2013 - ČT24","title":"Retro","partTitle":"","description":"Rok 1978","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/213411000360034"},"v-5-15":{"premiere":"17. 1. 2017 - ČT2","title":"Anticharta, mechanismus loajality","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/11565547623-anticharta-mechanismus-loajality/21656226618"},"v-5-14":{"premiere":"27. 2. 2015 - ČT2","title":"Fenomén underground","partTitle":"Byty","description":"Tisíce lidí nemohly studovat, vystavovat, hrát vlastní hudbu. Azylem se jim staly byty, které se proměnily v galerie, koncertní sály nebo univerzity.","link":"http://www.ceskatelevize.cz/ivysilani/10419676635-fenomen-underground/414235100221002-byty"},"v-5-13":{"premiere":"17. 1. 2010 - ČT1","title":"Retro","partTitle":"","description":"Dálnice","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/210411000360003"},"v-5-12":{"premiere":"4. 2. 2014 - ČT sport","title":"Sláva vítězům","partTitle":"Tři životy Karla Guta","description":"Vzpomínka na legendárního hokejového hráče, trenéra a funkcionáře","link":"http://www.ceskatelevize.cz/ivysilani/1058319265-slava-vitezum/214471294020001-slava-vitezum-tri-zivoty-karla-guta"},"v-5-11":{"premiere":"9. 9. 2014 - ČT sport","title":"Sláva vítězům","partTitle":"Zlatý tým z ME 1976","description":"Vzpomínky na jediný titul československého fotbalu","link":"http://www.ceskatelevize.cz/ivysilani/1058319265-slava-vitezum/214471294020014-zlaty-tym-z-me-1976"},"v-5-10":{"premiere":"21. 9. 2013 - ČT24","title":"Retro","partTitle":"","description":"Rok 1973","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/213411000360029"},"v-5-9":{"premiere":"26. 4. 2010 - ČT2","title":"Neznámí hrdinové","partTitle":"Mánička ze severu","description":"František Stárek - z undergroundu do BIS.","link":"http://www.ceskatelevize.cz/ivysilani/10204458965-neznami-hrdinove/210452801390011"},"v-5-8":{"premiere":"10. 9. 2015 - ČT1","title":"Gejzír","partTitle":"","description":"Pyramidy v Bosně — Jaroslav Dietl — Chůze bosky — Šestinové tanky — Neverbální komunikace","link":"http://www.ceskatelevize.cz/ivysilani/10805121298-gejzir/215562235000023"},"v-5-7":{"premiere":"9. 5. 2015 - ČT24","title":"Hyde Park Civilizace","partTitle":"","description":"Radim Palouš, pedagog a komeniolog, mluvčí Charty 77 a bývalý rektor Univerzity Karlovy — Martin Palouš, diplomat, pedagog, bývalý ředitel Knihovny Václava Havla, mluvčí Charty 77","link":"http://www.ceskatelevize.cz/ivysilani/10441294653-hyde-park-civilizace/215411058090509"},"v-5-6":{"premiere":"2. 11. 2013 - ČT24","title":"Archiv ČT24","partTitle":"Energie nad zlato","description":"Hledání nových zdrojů se táhne celou druhou polovinou 20. století","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/213411058210035"},"v-5-5":{"premiere":"25. 1. 2014 - ČT24","title":"Archiv ČT24","partTitle":"Čtyřkové ledny","description":"Co podstatného se událo v prvním měsíci roků končících čtyřkou, jak to zachytily kamery filmových týdeníků a televizního zpravodajství","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/214411058210004"},"v-5-4":{"premiere":"31. 10. 2015 - ČT24","title":"Archiv ČT24","partTitle":"Pětkové říjny","description":"Co se událo v říjnu v letech končících pětkou, jak to zachytily zpravodajské kamery","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/215411058210031"},"v-5-3":{"premiere":"8. 6. 2017 - ČT2","title":"České zázraky","partTitle":"Profesor naděje","description":"Jméno výjimečného českého chemika Antonína Holého zná svět především (ale nejen) díky účinné látce proti viru HIV. Milionům lidí dal šanci žít déle.","link":"http://www.ceskatelevize.cz/ivysilani/11091597618-ceske-zazraky/415235100081005-profesor-nadeje"},"v-5-2":{"premiere":"7. 12. 2013 - ČT24","title":"Retro","partTitle":"","description":"Rok 1984","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/213411000360040"},"v-5-1":{"premiere":"21. 9. 2013 - ČT24","title":"Retro","partTitle":"","description":"Rok 1973","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/213411000360029"},"v-4-53":{"premiere":"1. 3. 1968 - ČT1","title":"S kamerou za sportem","partTitle":"Medaile z Grenoblu","description":"Dokumentární film krátkého filmu o Zimních olympijských hrách 1968 v Grenoblu. Vyzdvižení úspěchů Československých sportovců, zejména hokejistů a olympijského vítěze J. Rašky.","link":"http://www.ceskatelevize.cz/ivysilani/1114662639-s-kamerou-za-sportem/26833012939-medaile-z-grenoblu"},"v-4-52":{"premiere":"1. 1. 1968 - ČT1","title":"Dějiny na osm","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10165875410-dejiny-na-osm/20838254085"},"v-4-51":{"premiere":"28. 10. 2013 - ČT sport","title":"Archiv Z","partTitle":"Věra Čáslavská","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10364596087-archiv-z/213471291019102-archiv-z-vera-caslavska"},"v-4-50":{"premiere":"2. 5. 2010 - ČT2","title":"Co předcházelo","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10290620971-co-predchazelo/210542151130001"},"v-4-49":{"premiere":"3. 10. 2016 - iVysílání extra","title":"Zvědavá kamera","partTitle":"Znovu jaro","description":"Co je to duch národa? Posilujeme jej? Máme naději na vítězství?","link":"http://www.ceskatelevize.cz/ivysilani/1006323478-zvedava-kamera/26953107469-znovu-jaro"},"v-4-48":{"premiere":"3. 10. 2016 - iVysílání extra","title":"Zvědavá kamera","partTitle":"Znovu jaro","description":"Co je to duch národa? Posilujeme jej? Máme naději na vítězství?","link":"http://www.ceskatelevize.cz/ivysilani/1006323478-zvedava-kamera/26953107469-znovu-jaro"},"v-4-47":{"premiere":"28. 3. 1968 - ČT1","title":"Věc veřejná","partTitle":"O akčním programu","description":"Publicistický pořad o tom, co si lidé myslí o novém tzv. akčním programu strany. Mezi zpovídanými občany se objevuje například Dana Němcová nebo Stanislav Devátý.","link":"http://www.ceskatelevize.cz/ivysilani/1064346348-vec-verejna/26853118797-o-akcnim-programu"},"v-4-46":{"premiere":"3. 10. 2015 - ČT24","title":"Archiv ČT24","partTitle":"Strážci hranic","description":"Plot, ostnatý drát, vojáci se psy a samopaly, tak vypadala hranice za totality","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/215411058210027"},"v-4-45":{"premiere":"5. 10. 2016 - ČT24","title":"90’ ČT24","partTitle":"Václav Havel 80","description":"Host: Martin Palouš","link":"http://www.ceskatelevize.cz/ivysilani/11412378947-90-ct24/216411058131005"},"v-4-44":{"premiere":"18. 2. 2017 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/217411000100218"},"v-4-43":{"premiere":"1. 6. 2013 - ČT24","title":"Archiv ČT24","partTitle":"Naše děti","description":"Reportáže o nejmladších občáncích byly vděčným a častým námětem Čs. filmových týdeníků","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/213411058210022"},"v-4-42":{"premiere":"1. 4. 2014 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/214411010100401"},"v-4-41":{"premiere":"28. 12. 2009 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/209411010101228"},"v-4-40":{"premiere":"23. 3. 2014 - ČT24","title":"Studio 6 Víkend","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10441287766-studio-6-vikend/214411010120323"},"v-4-39":{"premiere":"20. 1. 1966 - ČT1","title":"Pražská kronika","partTitle":"Podpovrchová dráha","description":"Ředitel výstavby podpovrchové dráhy Antonín Hudera hovoří o první fázi výstavby trasy C","link":"http://www.ceskatelevize.cz/ivysilani/1064346323-prazska-kronika/26653109453-podpovrchova-draha"},"v-4-38":{"premiere":"17. 5. 2008 - ČT24","title":"Archiv ČT24","partTitle":"","description":"Komunističtí prezidenti - Antonín Novotný","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/208452801350020"},"v-4-37":{"premiere":"20. 8. 2008 - ČT1","title":"Srpnová noc","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10196440842-srpnova-noc/208572233110001"},"v-4-36":{"premiere":"30. 3. 2013 - ČT24","title":"Archiv ČT24","partTitle":"Oslavy a veselice","description":"Jak se lidé bavili v prvních desetiletích po válce","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/213411058210013"},"v-4-35":{"premiere":"30. 3. 2013 - ČT24","title":"Archiv ČT24","partTitle":"Oslavy a veselice","description":"Jak se lidé bavili v prvních desetiletích po válce","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/213411058210013"},"v-4-33":{"premiere":"21. 8. 2013 - ČT1","title":"Události v regionech (Praha)","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10118379000-udalosti-v-regionech-praha/213411000140821-udalosti-v-regionech"},"v-4-32":{"premiere":"3. 12. 2009 - ČT24","title":"Studio ČT24","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10101491767-studio-ct24/209411058061203-pred-polednem"},"v-4-31":{"premiere":"10. 5. 2014 - ČT1","title":"Z metropole","partTitle":"","description":"Proměny Smíchova aneb Cestička do školy — 40 let metra — Tunel Blanka — Záchytná parkoviště — Útoky na exekutory — 55 let Laterny magiky — Bedřich Smetana — Výročí Gymnázia na Zatlance","link":"http://www.ceskatelevize.cz/ivysilani/10116288835-z-metropole/214411058230018"},"v-4-30":{"premiere":"25. 2. 2012 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/212411000100225"},"v-4-28":{"premiere":"6. 4. 2013 - ČT24","title":"Retro","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/213411000360014"},"v-4-27":{"premiere":"21. 2. 2015 - ČT1","title":"Z metropole","partTitle":"","description":"50 let Činoherního klubu — Místo bytů bude u Staroměstského náměstí hotel — Jak se změní doprava po otevření Blanky? — Bezdomovci v chatách — Potíže Zeleného údolí — Řemeslná škola Hrdlořezy — Rotunda sv. Václava před opravou — Nejstarší česká fotografie na Hradě — Kamnářské mistrovství Evropy","link":"http://www.ceskatelevize.cz/ivysilani/10116288835-z-metropole/215411058230008"},"v-4-26":{"premiere":"13. 12. 2014 - ČT1","title":"Z metropole","partTitle":"","description":"Oslava Sokola Libeň — Vystěhování žižkovského squattu — Shořela Obecná škola — 100 let kostela sv. Antonína v Holešovicích — Sdílení kol v Praze — YMCA v Praze — 55 let divadla Semafor","link":"http://www.ceskatelevize.cz/ivysilani/10116288835-z-metropole/214411058230049"},"v-4-25":{"premiere":"2. 3. 2013 - ČT24","title":"Archiv ČT24","partTitle":"Československé úspěchy","description":"Co považovaly za mezinárodní úspěch oficiální Čs. filmové týdeníky","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/213411058210009"},"v-4-23":{"premiere":"13. 5. 2017 - ČT24","title":"Archiv ČT24","partTitle":"Odchod „spřátelených“ vojsk","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/217411058210019"},"v-4-22":{"premiere":"21. 4. 2012 - ČT1","title":"Retro","partTitle":"","description":"Most","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/212411000360016"},"v-4-21":{"premiere":"30. 3. 2013 - ČT24","title":"Retro","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/213411000360013"},"v-4-20":{"premiere":"6. 2. 2014 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/214411000100206"},"v-4-19":{"premiere":"6. 2. 2016 - ČT24","title":"Hyde Park Civilizace","partTitle":"Věra Čáslavská","description":"Nejvýznamnější česká gymnastka, 15. nejúspěšnější olympionička světa","link":"http://www.ceskatelevize.cz/ivysilani/10441294653-hyde-park-civilizace/216411058090206"},"v-4-17":{"premiere":"10. 4. 2008 - ČT2","title":"Události, komentáře","partTitle":"","description":"Kdo uhasí olympiádu? — Za lepší venkov — Hrdina František Kriegel","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/208411000370410"},"v-4-16":{"premiere":"28. 6. 2006 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/206411000100628"},"v-4-15":{"premiere":"26. 8. 2013 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/213411010100826"},"v-4-14":{"premiere":"30. 11. 2013 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/213411000101130"},"v-4-13":{"premiere":"27. 12. 2009 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/209411000101227"},"v-4-12":{"premiere":"27. 6. 2013 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/213411010100627"},"v-4-9":{"premiere":"2. 4. 2017 - ČT24","title":"Věda 24","partTitle":"","description":"Bakterie odolné vůči antibiotikům — Jaroslav Heyrovský  — Útoky pomocí dronů — Největší stopa dinosaura na světě — Mikve — Umělá inteligence a poker — Newtonovy zákony — HPC: Pieter Timotheus de Zeeuw — Mapy světa v Gall-Petersově zobrazení","link":"http://www.ceskatelevize.cz/ivysilani/11633975240-veda-24/217411058340013"},"v-4-8":{"premiere":"3. 1. 2012 - ČT24","title":"Události, komentáře","partTitle":"","description":"Josef Škvorecký (1924–2012) — \"Alternativní\" rodiče před soudem — (Příliš) vysoký deficit? — Americký (před)volební kolotoč","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/212411000370103"},"v-4-7":{"premiere":"31. 7. 2015 - ČT1","title":"Události v regionech (Praha)","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10118379000-udalosti-v-regionech-praha/215411000140731-udalosti-v-regionech"},"v-4-6":{"premiere":"6. 4. 2013 - ČT24","title":"Retro","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/213411000360014"},"v-4-5":{"premiere":"1. 5. 2015 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/215411000100501"},"v-4-4":{"premiere":"29. 10. 2015 - ČT1","title":"Gejzír","partTitle":"","description":"Jiří Sovák — Bylinkové dobroty — Michelinské hvězdy — Motorkářka — Otto Wichterle","link":"http://www.ceskatelevize.cz/ivysilani/10805121298-gejzir/215562235000031"},"v-4-3":{"premiere":"16. 6. 2014 - ČT24","title":"Události, komentáře","partTitle":"","description":"Ukrajina bez plynu — Odboráři a daňové úlevy — Audity na ministerstvech — Maďarské výročí — DNA","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/214411000370616"},"v-4-2":{"premiere":"9. 3. 2014 - ČT24","title":"Studio 6 Víkend","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10441287766-studio-6-vikend/214411010120309"},"v-4-1":{"premiere":"9. 6. 2016 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/216411000100609"},"v-3-60":{"premiere":"28. 11. 2015 - ČT24","title":"Archiv ČT24","partTitle":"Pětkové listopady","description":"Co podstatného se událo v listopadu v letech končících pětkou","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/215411058210034"},"v-3-59":{"premiere":"3. 10. 2015 - ČT24","title":"Archiv ČT24","partTitle":"Strážci hranic","description":"Plot, ostnatý drát, vojáci se psy a samopaly, tak vypadala hranice za totality","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/215411058210027"},"v-3-58":{"premiere":"9. 4. 2016 - ČT24","title":"Archiv ČT24","partTitle":"Kolektivizace","description":"Společné hospodaření zemědělců bylo jedním ze základních požadavků socialistického budování","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/216411058210015"},"v-3-57":{"premiere":"9. 4. 2016 - ČT24","title":"Archiv ČT24","partTitle":"Kolektivizace","description":"Společné hospodaření zemědělců bylo jedním ze základních požadavků socialistického budování","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/216411058210015"},"v-3-56":{"premiere":"26. 2. 2011 - ČT1","title":"Z metropole","partTitle":"","description":"Interiéry budoucího železničního muzea — Zakladatel památkové péče v Čechách Zdeněk Wirth — Mumie Klementa Gottwalda","link":"http://www.ceskatelevize.cz/ivysilani/10116288835-z-metropole/211411058230008"},"v-3-55":{"premiere":"25. 2. 2015 - ČT24","title":"Události, komentáře","partTitle":"","description":"Šílený útok v Uherském Brodě — Vítězný únor — Boj za lidská práva","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/215411000370225"},"v-3-54":{"premiere":"29. 5. 2013 - ČT24","title":"Studio ČT24","partTitle":"","description":" Měnová reforma roku 1953","link":"http://www.ceskatelevize.cz/ivysilani/10101491767-studio-ct24/213411058310529"},"v-3-53":{"premiere":"7. 5. 2011 - ČT24","title":"Archiv ČT24","partTitle":"Plánované hospodářství","description":"Po roce 1945 a především 1948 se z tržního hospodářství u nás stává hospodářství plánované. Proměnu zachytily i Čs. filmové týdeníky","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/211411058210018"},"v-3-52":{"premiere":"20. 9. 2008 - ČT24","title":"Archiv ČT24","partTitle":"","description":"První pětiletka","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/208452801350034"},"v-3-51":{"premiere":"27. 6. 2015 - ČT24","title":"Jak jsme přišli o Podkarpatskou Rus","partTitle":"Jak jsme přišli o Podkarpatskou Rus","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10997918455-mimoradne-porady-ct24/215411034000089-jak-jsme-prisli-o-podkarpatskou-rus"},"v-3-50":{"premiere":"17. 3. 2013 - ČT24","title":"Pozor vysíláme","partTitle":"","description":"Jak to všechno začalo","link":"http://www.ceskatelevize.cz/ivysilani/10554316820-pozor-vysilame/212452801380013"},"v-3-49":{"premiere":"23. 3. 2013 - ČT24","title":"Archiv ČT24","partTitle":"Trojkové březny","description":"Co se událo v březnu v letech končících trojkou","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/213411058210012"},"v-3-48":{"premiere":"25. 2. 2016 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/216411010100225"},"v-3-47":{"premiere":"16. 6. 2007 - ČT1","title":"Historický magazín","partTitle":"","description":"Marshallův plán","link":"http://www.ceskatelevize.cz/ivysilani/10095687448-historicky-magazin/207452801280024"},"v-3-46":{"premiere":"4. 6. 2015 - ČT24","title":"Události, komentáře","partTitle":"","description":"Porošenkův rok ve funkci — Drogy v ČR — Měnová reforma","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/215411000370604"},"v-3-45":{"premiere":"25. 2. 2016 - ČT24","title":"Události, komentáře","partTitle":"","description":"Napětí kvůli migrační krizi — Návrat branné výchovy? — Oceňovaný únor 1948? — Stalin stále živý?","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/216411000370225"},"v-3-44":{"premiere":"16. 5. 2016 - ČT24","title":"90’ ČT24","partTitle":"Nová kapitolačesko-německého smiřování","description":"Host: Daniel Herman","link":"http://www.ceskatelevize.cz/ivysilani/11412378947-90-ct24/216411058130516"},"v-3-43":{"premiere":"10. 3. 2013 - ČT24","title":"Studio 6 Víkend","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10441287766-studio-6-vikend/213411010120310"},"v-3-41":{"premiere":"27. 6. 2015 - ČT24","title":"Jaro 45","partTitle":"Americké mise","description":"","link":"http://www.ceskatelevize.cz/ivysilani/11059888231-jaro-45/215411033110011"},"v-3-40":{"premiere":"15. 6. 2013 - ČT24","title":"Historie.cs","partTitle":"Divoký odsun","description":"Václav Houžvička — Adrian Portmann Von Arburg — Tomáš Dvořák","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/213452801400023"},"v-3-39":{"premiere":"28. 11. 2015 - ČT24","title":"Archiv ČT24","partTitle":"Pětkové listopady","description":"Co podstatného se událo v listopadu v letech končících pětkou","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/215411058210034"},"v-3-38":{"premiere":"5. 8. 2016 - ČT2","title":"Zátopek","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/11304277912-zatopek/21556226566"},"v-3-37":{"premiere":"7. 5. 2016 - ČT24","title":"Archiv ČT24","partTitle":"Odhalování pomníků","description":"Busty, pamětní desky a pomníky odráží ducha doby svého vzniku","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/216411058210019"},"v-3-36":{"premiere":"14. 5. 2015 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/215411010100514"},"v-3-35":{"premiere":"7. 2. 2011 - ČT2","title":"Historie.cs","partTitle":"77 000 do výroby","description":"Jak se komunistická vláda snažila po únoru 1948 vypořádat s nespolehlivou střední třídou, především úředníky.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/211452801400006"},"v-3-34":{"premiere":"9. 2. 2009 - ČT1","title":"Tajné akce StB","partTitle":"Akce Kulak","description":"Násilné ovládnutí venkova a zotročení českých sedláků patří mezi nejsmutnější kapitoly moderních dějin.","link":"http://www.ceskatelevize.cz/ivysilani/10209991308-tajne-akce-stb/409235100221006-akce-kulak"},"v-3-33":{"premiere":"13. 3. 2012 - ČT2","title":"Historie.cs","partTitle":"Pohřby prezidentů","description":"Dagmar Hájková — Jiří Pernes","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/212452801400011"},"v-3-32":{"premiere":"13. 3. 2012 - ČT2","title":"Historie.cs","partTitle":"Pohřby prezidentů","description":"Dagmar Hájková — Jiří Pernes","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/212452801400011"},"v-3-31":{"premiere":"17. 6. 2013 - ČT1","title":"Rub a líc","partTitle":"Dobrodružné výpravy","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10399366967-rub-a-lic/213563231900010-rub-a-lic-dobrodruznych-vyprav"},"v-3-30":{"premiere":"1. 6. 2015 - ČT1","title":"Reportéři ČT","partTitle":"","description":"A přece se točí — Zmařené studium — Osud řízený z Moskvy","link":"http://www.ceskatelevize.cz/ivysilani/1142743803-reporteri-ct/215452801240021"},"v-3-29":{"premiere":"11. 5. 2004 - ČT2","title":"Pavel Tigrid - Evropan","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1109371424-pavel-tigrid-evropan/20356226216"},"v-3-28":{"premiere":"11. 5. 2004 - ČT2","title":"Pavel Tigrid - Evropan","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1109371424-pavel-tigrid-evropan/20356226216"},"v-3-27":{"premiere":"18. 11. 2008 - ČT1","title":"Zrychlený čas","partTitle":"","description":"Osudy Prokopa Drtiny a Ferdinanda Peroutky","link":"http://www.ceskatelevize.cz/ivysilani/10169657796-zrychleny-cas/208572232320005-osudy-prokopa-drtiny-a-ferdinanda-peroutky"},"v-3-26":{"premiere":"19. 6. 2010 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/210411000100619"},"v-3-25":{"premiere":"28. 5. 2016 - ČT24","title":"Archiv ČT24","partTitle":"Šestkové květny","description":"Co zachytily kamery Čs. týdeníků a televizního zpravodajství v květnu v letech končících šestkou","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/216411058210022"},"v-3-24":{"premiere":"29. 10. 2007 - ČT1","title":"Historie.cs","partTitle":"Příběh znárodnění","description":"Cesta k socialistickému hospodaření začala již léta před Únorem 1948.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/207452801390009"},"v-3-23":{"premiere":"23. 3. 2013 - ČT24","title":"Archiv ČT24","partTitle":"Trojkové březny","description":"Co se událo v březnu v letech končících trojkou","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/213411058210012"},"v-3-22":{"premiere":"24. 2. 2008 - ČT2","title":"Únorové variace","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10174631979-unorove-variace/208542154050001"},"v-3-21":{"premiere":"24. 2. 2008 - ČT2","title":"Únorové variace","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10174631979-unorove-variace/208542154050001"},"v-3-20":{"premiere":"24. 2. 2008 - ČT2","title":"Únorové variace","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10174631979-unorove-variace/208542154050001"},"v-3-19":{"premiere":"24. 2. 2008 - ČT2","title":"Únorové variace","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10174631979-unorove-variace/208542154050001"},"v-3-18":{"premiere":"24. 2. 2008 - ČT2","title":"Únorové variace","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10174631979-unorove-variace/208542154050001"},"v-3-17":{"premiere":"24. 2. 2008 - ČT2","title":"Únorové variace","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10174631979-unorove-variace/208542154050001"},"v-3-16":{"premiere":"29. 4. 2017 - ČT24","title":"Archiv ČT24","partTitle":"Sedmičkové dubny","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/217411058210017"},"v-3-15":{"premiere":"28. 2. 2015 - ČT24","title":"Archiv ČT24","partTitle":"Pětkové únory","description":"Co považovaly za důležité kamery Čs. filmových týdeníků a televizního zpravodajství v únoru v letech končících pětkou","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/215411058210009"},"v-3-14":{"premiere":"5. 4. 2014 - ČT24","title":"Archiv ČT24","partTitle":"Stavební ruch","description":"V prvních desetiletích po válce bylo stavebnictví v evropských zemích logicky na vzestupu, zachytily to i Československé filmové týdeníky","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/214411058210014"},"v-3-13":{"premiere":"2. 3. 2013 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/213411000100302"},"v-3-12":{"premiere":"29. 11. 2014 - ČT24","title":"Archiv ČT24","partTitle":"Čtyřkové listopady","description":"Co se událo v listopadu v letech končících čtyřkou, jak to zaznamenaly Čs. filmové týdeníky a televizní zpravodajství","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/214411058210027"},"v-3-11":{"premiere":"9. 6. 2009 - ČT2","title":"Proces H","partTitle":"Dny D","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10153697395-proces-h/208562268640010-proces-h-dny-d"},"v-3-10":{"premiere":"31. 5. 2009 - ČT2","title":"Proces H","partTitle":"Den první","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10153697395-proces-h/20756226864-proces-h-den-prvni"},"v-3-9":{"premiere":"9. 2. 2013 - ČT24","title":"Retro","partTitle":"","description":"Rok 1950","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/213411000360006"},"v-3-8":{"premiere":"24. 11. 2013 - ČT1","title":"České století","partTitle":"Zabíjení soudruha (1951)","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10362011008-ceske-stoleti/21251212043-zabijeni-soudruha-1951"},"v-3-7":{"premiere":"13. 3. 2006 - ČT1","title":"Příběhy železné opony","partTitle":"Vlak svobody","description":"Místo do Aše dojel vlak do německého Selbu","link":"http://www.ceskatelevize.cz/ivysilani/10095467107-pribehy-zelezne-opony/406235100221011-vlak-svobody"},"v-3-6":{"premiere":"27. 5. 2010 - ČT2","title":"Historie.cs","partTitle":"Museli jsme si pomáhat","description":"Rada vzájemné hospodářské pomoci - RVHP - měl být řídící ekonomický orgán zemí sovětského bloku. Jak fungovala a proč se nikdy nepodařilo naplnit její poslání?","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/210452801400016"},"v-3-5":{"premiere":"13. 4. 2015 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/215411000100413"},"v-3-4":{"premiere":"9. 5. 2014 - ČT1","title":"13. komnata","partTitle":"","description":"Dcera generálního tajemníka KSČ, popraveného v 50. letech 20. století, prožila léta pod tlakem tajné policie. Dnes patří Marta Slánská k uznávaným podnikatelkám.","link":"http://www.ceskatelevize.cz/ivysilani/1186000189-13-komnata/214562210800012-13-komnata-marty-slanske"},"v-3-3":{"premiere":"2. 7. 2015 - ČT2","title":"Druhý život Mistra Jana Husa","partTitle":"První komunista?","description":"Pro někoho český vlastenec, pro jiného arcikacíř, nebo také vzorový revolucionář","link":"http://www.ceskatelevize.cz/ivysilani/10840627426-druhy-zivot-mistra-jana-husa/214562260660005-prvni-komunista"},"v-3-2":{"premiere":"15. 12. 2015 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/215411010101215"},"v-3-1":{"premiere":"25. 6. 2012 - ČT1","title":"Reportéři ČT","partTitle":"","description":"Podnikatelské aktivity starosty Cerhenic — Boj investorů o ložiska písku v obci Bělá — Závěť rodu Schwarzenbergů","link":"http://www.ceskatelevize.cz/ivysilani/1142743803-reporteri-ct/212452801240025"},"v-2-34":{"premiere":"15. 4. 2012 - ČT2","title":"Dějiny udatného českého národa","partTitle":"Mnichov","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10177109865-dejiny-udatneho-ceskeho-naroda/211543116230099-mnichov"},"v-2-33":{"premiere":"10. 11. 2013 - ČT1","title":"České století","partTitle":"Kulka pro Heydricha (1941)","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10362011008-ceske-stoleti/21251212024-kulka-pro-heydricha-1941"},"v-2-32":{"premiere":"25. 5. 2012 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/212411000100525"},"v-2-31":{"premiere":"31. 8. 2016 - ČT24","title":"Studio ČT24","partTitle":"","description":" Zemřela olympionička Věra Čáslavská —  Příměří na rusko-ukrajinské hranici? —  Premiéra filmu Anthropoid v Londýně —  Von Neurath a Frank o řešení tzv. české otázky —  Zemřela legendární gymnastka Věra Čáslavská —  Změny v novém akademickém roce brífink) —  Sněmovní vyšetřovací komise k reformě policie —  Církevní školy se rozšiřují","link":"http://www.ceskatelevize.cz/ivysilani/10101491767-studio-ct24/216411058060831"},"v-2-30":{"premiere":"28. 8. 2008 - ČT2","title":"Historie.cs","partTitle":"Židé za protektorátu a slovenského štátu","description":"Jakou podobu měl holocaust na okupovaném českém území a na Slovensku.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400034"},"v-2-29":{"premiere":"7. 5. 2006 - ČT2","title":"Pohřeb generála Eliáše a jeho manželky","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10101491767-studio-ct24/206411034000250-statni-smutecni-akt-pohreb-generala-eliase-a-jeho-manzelky"},"v-2-28":{"premiere":"20. 3. 2011 - ČT24","title":"Týden v regionech (Ostrava)","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1183909575-tyden-v-regionech-ostrava/411231100212011-tyden-v-regionech"},"v-2-27":{"premiere":"28. 8. 2008 - ČT2","title":"Historie.cs","partTitle":"Židé za protektorátu a slovenského štátu","description":"Jakou podobu měl holocaust na okupovaném českém území a na Slovensku.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400034"},"v-2-26":{"premiere":"24. 11. 2013 - ČT24","title":"Studio 6 Víkend","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10441287766-studio-6-vikend/213411010121124"},"v-2-25":{"premiere":"20. 3. 2008 - ČT2","title":"Historie.cs","partTitle":"Mašínové","description":"Osudy členů rodiny vlastenců, kteří bojovali proti totalitě.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400031"},"v-2-24":{"premiere":"29. 10. 2012 - ČT24","title":"Před půlnocí","partTitle":"","description":"Jan Rychlík, historik FF UK Praha: Češi a Slováci ve 20. století","link":"http://www.ceskatelevize.cz/ivysilani/10095690193-pred-pulnoci/412231100252086"},"v-2-23":{"premiere":"19. 3. 2016 - ČT24","title":"Březen 1939: vznik protektorátu","partTitle":"Březen 1939","description":"Vznik protektorátu","link":"http://www.ceskatelevize.cz/ivysilani/10997918455-mimoradne-porady-ct24/216411034000024-brezen-1939-vznik-protektoratu"},"v-2-22":{"premiere":"29. 8. 2014 - ČT24","title":"Události, komentáře","partTitle":"","description":"Ukrajinská krize — Kdo byli banderovci — Spor o šátky ve školách — Islandská sopka — Slovenské národní povstání","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/214411000370829"},"v-2-21":{"premiere":"25. 5. 2014 - ČT24","title":"Studio 6 Víkend","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10441287766-studio-6-vikend/214411010120525"},"v-2-20":{"premiere":"26. 9. 2011 - ČT2","title":"Historie.cs","partTitle":"Konrád Henlein a Wenzel Jaksch","description":"Jaroslav Kučera — Jan Kuklík — Jaroslav Šebek","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/211452801400029"},"v-2-19":{"premiere":"2. 5. 2015 - ČT1","title":"Z metropole","partTitle":"","description":"Barikády Pražského povstání — Konec pankrácké sekyrárny — Konec války ve fotografickém albu — Seznam padlých z povstání — Dvorek U Řečických","link":"http://www.ceskatelevize.cz/ivysilani/10116288835-z-metropole/215411058230018"},"v-2-18":{"premiere":"13. 11. 2008 - ČT2","title":"Historie.cs","partTitle":"Tobruk","description":"Jak válčily československé \"krysy pouště\" na africkém bojišti 2. světové války.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400045"},"v-2-17":{"premiere":"30. 4. 2006 - ČT1","title":"Hledání ztraceného času","partTitle":"Východ - západ","description":"","link":"http://www.ceskatelevize.cz/ivysilani/873537-hledani-ztraceneho-casu/206522161510008-vychod-zapad"},"v-2-16":{"premiere":"31. 8. 2009 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/209411000100831"},"v-2-15":{"premiere":"12. 11. 2009 - ČT2","title":"Historie.cs","partTitle":"Student Opletal a dělník Sedláček","description":"Jan Opletal byl těžce zraněn 28. října 1939 a protinacistická demonstrace při jeho pohřbu se stala záminkou k popravám studentů a zavření českých vysokých škol 17. listopadu. Nebyl ale jedinou obětí, 28. října byl nacisty zastřelen i dělník Václav Sedláček.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/209452801400035"},"v-2-14":{"premiere":"28. 9. 2013 - ČT2","title":"Historie.cs","partTitle":"Zvon zrady","description":"Jan Němeček — Jaroslav Šebek — Vít Smetana","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/213452801400030"},"v-2-13":{"premiere":"8. 6. 2008 - ČT1","title":"Hledání ztraceného času","partTitle":"Filmy z Václaváku (9)","description":"","link":"http://www.ceskatelevize.cz/ivysilani/873537-hledani-ztraceneho-casu/208522161510010-filmy-z-vaclavaku-9"},"v-2-12":{"premiere":"29. 4. 2012 - ČT2","title":"Dějiny udatného českého národa","partTitle":"Protektorát","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10177109865-dejiny-udatneho-ceskeho-naroda/211543116230101-protektorat"},"v-2-11":{"premiere":"22. 9. 2008 - ČT2","title":"Historie.cs","partTitle":"Domů do Říše aneb Sudety bez Čechů?","description":"Žili spolu a vedle sebe stovky let. Až přišel Mnichov 1938 a někteří Češi a Moravané museli odejít. Proč?","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400038"},"v-2-10":{"premiere":"11. 9. 2006 - ČT1","title":"Znáte je dobře?","partTitle":"","description":"Karel Čapek","link":"http://www.ceskatelevize.cz/ivysilani/10087924982-znate-je-dobre/206562230460002-karel-capek"},"v-2-9":{"premiere":"27. 5. 2011 - ČT2","title":"Babylon","partTitle":"","description":"Tibetské čhamové tance — Připomínka židovských obětí v Ostravě — Emílie Machálková – jediná dnes žijící Romka přeživší holocaust","link":"http://www.ceskatelevize.cz/ivysilani/1131721572-babylon/411236100152020"},"v-2-8":{"premiere":"10. 12. 2012 - ČT2","title":"Dejte nám křídla","partTitle":"","description":"Stíhačky a bombardéry se začaly potkávat uprostřed noci a i tam byli jedni z nejlepších Čechoslováci.","link":"http://www.ceskatelevize.cz/ivysilani/10314600084-dejte-nam-kridla/210563230250004"},"v-2-7":{"premiere":"21. 7. 2015 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/215411010100721"},"v-2-6":{"premiere":"28. 12. 2013 - ČT24","title":"Historie.cs","partTitle":"Smlouva ČSR – SSSR 1943; pouto nebo objetí?","description":"Vít Smetana — Jiří Friedl — Jan Kuklík — Jan Němeček","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/213452801400043"},"v-2-5":{"premiere":"29. 12. 2015 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/215411000101229"},"v-2-4":{"premiere":"18. 6. 2017 - ČT1","title":"168 hodin","partTitle":"","description":"Operace Sobotka — Yetti ze Senátu — Ležáky ve stínu Lidic — Diagnóza karcinom — Nepozvaná","link":"http://www.ceskatelevize.cz/ivysilani/10117034229-168-hodin/217452801100618"},"v-2-3":{"premiere":"20. 4. 2013 - ČT1","title":"Události","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/213411000100420"},"v-2-2":{"premiere":"16. 3. 2009 - ČT1","title":"Reportéři ČT","partTitle":"","description":"Javorné kontra Horní Bradlo — Pražský voják Josef Mašín — Vyšetřování poslance Wolfa","link":"http://www.ceskatelevize.cz/ivysilani/1142743803-reporteri-ct/209452801240011"},"v-2-1":{"premiere":"14. 3. 2011 - ČT2","title":"Neznámí hrdinové","partTitle":"Krotitel esesáků","description":"Fredy Hirsch, sám vězeň, pomáhal dětem přežít v nelidském prostředí koncentračních táborů nejdříve v Terezíně a později v Osvětimi.","link":"http://www.ceskatelevize.cz/ivysilani/10204458965-neznami-hrdinove/211452801390011-neznami-hrdinove-pohnute-osudy"},"v-1-33":{"premiere":"4. 11. 2015 - ČT sport","title":"Olympijský magazín","partTitle":"","description":"Volá Rio — Naděje pro Rio: Petra Chocová — Host magazínu: Antonín Brabec — České olympijské novinky — Sazka olympijský víceboj — Osobnosti a sport: Lucie Koldová — Olympijští rivalové: Tonya Hardingová a Nancy Kerriganová — Zlatí medailisté: Alois Hudec — Škoda olympijské jízdy: Jiří Adam","link":"http://www.ceskatelevize.cz/ivysilani/10321897020-olympijsky-magazin/215471290290044"},"v-1-32":{"premiere":"18. 9. 2008 - ČT2","title":"Historie.cs","partTitle":"1938 – opevnění a mobilizace","description":"Existují nové odpovědi na starou otázku – mohli jsme se bránit?","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400037"},"v-1-31":{"premiere":"15. 6. 2014 - ČT24","title":"Studio 6 Víkend","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10441287766-studio-6-vikend/214411010120615"},"v-1-30":{"premiere":"10. 3. 2007 - ČT1","title":"Historický magazín","partTitle":"","description":"Mostecká stávka horníků 1932","link":"http://www.ceskatelevize.cz/ivysilani/10095687448-historicky-magazin/207452801280010"},"v-1-29":{"premiere":"28. 10. 2008 - ČT2","title":"Mnichov 1938","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/26621-mnichov-1938/29138360176"},"v-1-27":{"premiere":"29. 6. 2008 - ČT2","title":"Brněnský zázrak architektury a obchodu","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10178280755-brnensky-zazrak-architektury-a-obchodu/30829535029"},"v-1-25":{"premiere":"4. 9. 2007 - ČT1","title":"Na vlně první republiky","partTitle":"","description":"O politice a politicích","link":"http://www.ceskatelevize.cz/ivysilani/10123460450-na-vlne-prvni-republiky/207562230510001"},"v-1-24":{"premiere":"8. 6. 2008 - ČT1","title":"Hledání ztraceného času","partTitle":"Filmy z Václaváku (9)","description":"","link":"http://www.ceskatelevize.cz/ivysilani/873537-hledani-ztraceneho-casu/208522161510010-filmy-z-vaclavaku-9"},"v-1-23":{"premiere":"8. 6. 2008 - ČT1","title":"Hledání ztraceného času","partTitle":"Filmy z Václaváku (9)","description":"","link":"http://www.ceskatelevize.cz/ivysilani/873537-hledani-ztraceneho-casu/208522161510010-filmy-z-vaclavaku-9"},"v-1-22":{"premiere":"18. 9. 2007 - ČT1","title":"Na vlně první republiky","partTitle":"","description":"O filmu a filmařích","link":"http://www.ceskatelevize.cz/ivysilani/10123460450-na-vlne-prvni-republiky/207562230510004"},"v-1-21":{"premiere":"18. 9. 2007 - ČT1","title":"Na vlně první republiky","partTitle":"","description":"O filmu a filmařích","link":"http://www.ceskatelevize.cz/ivysilani/10123460450-na-vlne-prvni-republiky/207562230510004"},"v-1-20":{"premiere":"6. 3. 2013 - ČT2","title":"Šumné stopy","partTitle":"Slovinsko - Jože Plečnik","description":"Cesta Jože Plečnika ze Slovinska až na Pražský hrad a zpět. Životní příběh bohabojného architekta, jehož už tak trochu považujeme za svého.","link":"http://www.ceskatelevize.cz/ivysilani/10262550261-sumne-stopy/211522162350003-slovinsko-joze-plecnik"},"v-1-19":{"premiere":"20. 11. 2016 - ČT24","title":"Události v kultuře","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1097206490-udalosti-v-kulture/216411000121120"},"v-1-18":{"premiere":"11. 5. 2017 - ČT1","title":"Gejzír","partTitle":"","description":"Martin Frič — Klavírista Matyáš Novák — Protidrogový vlak — Čepice pro ženy po chemoterapii — Paleontolog","link":"http://www.ceskatelevize.cz/ivysilani/10805121298-gejzir/217562235000015"},"v-1-17":{"premiere":"11. 4. 2011 - ČT2","title":"Historie.cs","partTitle":"Češi a Němci za 1. republiky","description":"Dva národy žily spolu věky v jednom státním útvaru. V první polovině 20. století se jejich soužití zkomplikovalo. Jaké byly příčiny vyhrocení vzájemných vztahů?","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/211452801400015"},"v-1-16":{"premiere":"1. 10. 2001 - ČT1","title":"Sláva vítězům","partTitle":"Josef Bican","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1058319265-slava-vitezum/201471296020011-josef-bican"},"v-1-15":{"premiere":"3. 11. 2016 - ČT1","title":"Gejzír","partTitle":"","description":"Čeští kaskadéři — Muži na mateřské — Aleš Wasserbauer — Vratné kelímky bratří Hanáků — 110 let od narození Jaroslava Ježka","link":"http://www.ceskatelevize.cz/ivysilani/10805121298-gejzir/216562235000028"},"v-1-14":{"premiere":"26. 10. 2013 - ČT2","title":"Cizinec je našinec","partTitle":"Osudy Maďarů","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10611271606-cizinec-je-nasinec/213542156050008"},"v-1-13":{"premiere":"31. 1. 2017 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/217411010100131"},"v-1-12":{"premiere":"14. 12. 2015 - ČT1","title":"Studio 6","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/215411010101214"},"v-1-11":{"premiere":"22. 9. 2008 - ČT2","title":"Historie.cs","partTitle":"Domů do Říše aneb Sudety bez Čechů?","description":"Žili spolu a vedle sebe stovky let. Až přišel Mnichov 1938 a někteří Češi a Moravané museli odejít. Proč?","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400038"},"v-1-10":{"premiere":"24. 10. 2006 - ČT1","title":"Příběhy železné opony","partTitle":"Útěk novináře Peroutky","description":"Rokem 1948 přišel národ o intelektuální elitu","link":"http://www.ceskatelevize.cz/ivysilani/10095467107-pribehy-zelezne-opony/406235100221032-utek-novinare-peroutky"},"v-1-9":{"premiere":"1. 3. 2012 - ČT sport","title":"Sokol, síla tradice","partTitle":"","description":"Sokol Písek — 1932 — Bohuslav Bubník — Sokol v Novém Kníně — Martin Lébl","link":"http://www.ceskatelevize.cz/ivysilani/10406331335-sokol-sila-tradice/212471290470003"},"v-1-8":{"premiere":"31. 3. 2016 - ČT1","title":"Gejzír","partTitle":"","description":"Osvobozené divadlo — Extrémní biker — Zlaté marmelády — Vítězství nad rakovinou — Šperkařská rodina","link":"http://www.ceskatelevize.cz/ivysilani/10805121298-gejzir/216562235000008"},"v-1-7":{"premiere":"26. 6. 2017 - ČT2","title":"Příběh letiště Praha","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/11660566862-pribeh-letiste-praha/21656226622"},"v-1-6":{"premiere":"29. 10. 2009 - ČT2","title":"Historie.cs","partTitle":"Pod Klémovou čepicí","description":"Že má Klement Gottwald pod čepicí, napsal už básník František Halas. Co pod jeho pokrývkou hlavy doopravdy bylo, a jak se nám pod Gottwaldovou čepicí žilo?","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/209452801400033"},"v-1-1":{"premiere":"3. 7. 2008 - ČT2","title":"Historie.cs","partTitle":"Hospodářská krize","description":"Jak dopadla velká hospodářská krize 1929 na Československo. Doba, kdy peníze a akcie neměly cenu ani papíru, na kterém byly vytištěny.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400025"},"v-1-2":{"premiere":"13. 3. 2012 - ČT2","title":"Historie.cs","partTitle":"Pohřby prezidentů","description":"Dagmar Hájková — Jiří Pernes","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/212452801400011"},"v-1-3":{"premiere":"3. 11. 2013 - ČT1","title":"České století","partTitle":"Den po Mnichovu (1938)","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10362011008-ceske-stoleti/21251212007-den-po-mnichovu-1938"},"v-1-4":{"premiere":"30. 7. 2002 - ČT1","title":"Osudové okamžiky","partTitle":"Židenice 1933","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1091682868-osudove-okamziky/401213100081004-zidenice-1933"},"v-1-5":{"premiere":"2. 10. 2007 - ČT1","title":"Na vlně první republiky","partTitle":"","description":"O módě, výtvarnících, fotografech a architektuře","link":"http://www.ceskatelevize.cz/ivysilani/10123460450-na-vlne-prvni-republiky/207562230510006"},"v-0-42":{"premiere":"11. 2. 2017 - ČT24","title":"Archiv ČT24","partTitle":"Před sedmdesáti lety – rok 1947","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/217411058210006"},"v-0-41":{"premiere":"7. 10. 2015 - ČT sport","title":"Olympijský magazín","partTitle":"","description":"Volá Rio — Naděje pro Rio: Kateřina Kudějová — Host magazínu: Kryštof Krýzl — České olympijské novinky — Sazka olympijský víceboj — Osobnosti a sport: Rostislav Osička — Olympijští rivalové: Baumgartner vs. Gobedžišvili — Zlatí medailisté: František Ventura — Škoda olympijské jízdy: Tomáš Ujfaluši","link":"http://www.ceskatelevize.cz/ivysilani/10321897020-olympijsky-magazin/215471290290040"},"v-0-40":{"premiere":"27. 1. 2007 - ČT1","title":"Historický magazín","partTitle":"","description":"Josef Pekař","link":"http://www.ceskatelevize.cz/ivysilani/10095687448-historicky-magazin/207452801280004"},"v-0-39":{"premiere":"27. 9. 2008 - ČT24","title":"Historický magazín","partTitle":"","description":"Leoš Janáček - moravský \"bláznivý podivín\" světové proslulosti","link":"http://www.ceskatelevize.cz/ivysilani/10095687448-historicky-magazin/208452801280034"},"v-0-38":{"premiere":"23. 3. 2013 - ČT24","title":"Historie.cs","partTitle":"První československý voják","description":"Ivan Šedivý — Jiří Rajlich — Michal Kšiňan","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/213452801400011"},"v-0-37":{"premiere":"23. 3. 2013 - ČT24","title":"Historie.cs","partTitle":"První československý voják","description":"Ivan Šedivý — Jiří Rajlich — Michal Kšiňan","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/213452801400011"},"v-0-36":{"premiere":"5. 1. 2005 - ČT1","title":"Události, komentáře","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/205411000370105"},"v-0-35":{"premiere":"19. 4. 2008 - ČT24","title":"Retro","partTitle":"","description":"MDŽ","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/208411000360416"},"v-0-34":{"premiere":"4. 9. 2008 - ČT2","title":"Historie.cs","partTitle":"Beneš – zasloužil se o stát?","description":"Jaká byla role druhého prezidenta v československých dějinách...","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400035"},"v-0-33":{"premiere":"12. 5. 2007 - ČT1","title":"Historický magazín","partTitle":"","description":"Sto let skautingu","link":"http://www.ceskatelevize.cz/ivysilani/10095687448-historicky-magazin/207452801280019"},"v-0-32":{"premiere":"12. 5. 2012 - ČT1","title":"Z metropole","partTitle":"","description":"Svatobor a Dominikánský dvůr — Slovanská epopej vystavena — Nové lesoparky — Archeologický nález v Bubenči — Zavěšení zvonů v chrámu sv. Víta — Metro slaví 38. narozeniny — 147 let Pražské paroplavební společnosti — Malířský salon v DOXu — 90 let Edenu","link":"http://www.ceskatelevize.cz/ivysilani/10116288835-z-metropole/212411058230019"},"v-0-31":{"premiere":"27. 12. 2010 - ČT24","title":"Události, komentáře","partTitle":"","description":"Zdravotnický kolaps? — „Zločinec“ Chodorkovskij — (Ne)střídavá péče — Karel Kramář /1860-1937/","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/210411000371227"},"v-0-29":{"premiere":"25. 5. 2013 - ČT24","title":"Historie.cs","partTitle":"Dobrodružný život ministra","description":"Josef Tomeš — Jana Čechurová — Radek Soběhart","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/213452801400020"},"v-0-28":{"premiere":"17. 5. 2013 - ČT24","title":"Události, komentáře","partTitle":"","description":"Profesoři podle Hradu — Bezpráví na Guantanámu? — Ruské zbraně v Sýrii — 90 let rozhlasu","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/213411000370517"},"v-0-27":{"premiere":"17. 9. 2007 - ČT1","title":"Historie.cs","partTitle":"Čeští šlechtici a nacismus","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/207452801390003"},"v-0-26":{"premiere":"17. 9. 2011 - ČT2","title":"Být v obraze","partTitle":"Rozhlas","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10214728740-byt-v-obraze/209572233420002-rozhlas"},"v-0-25":{"premiere":"22. 2. 2001 - ČT1","title":"Osudové okamžiky","partTitle":"Holešov 1918","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1091682868-osudove-okamziky/401213100081014-holesov-1918"},"v-0-24":{"premiere":"4. 9. 2007 - ČT1","title":"Na vlně první republiky","partTitle":"","description":"O politice a politicích","link":"http://www.ceskatelevize.cz/ivysilani/10123460450-na-vlne-prvni-republiky/207562230510001"},"v-0-23":{"premiere":"16. 10. 2007 - ČT1","title":"Na vlně první republiky","partTitle":"","description":"O podnikatelích","link":"http://www.ceskatelevize.cz/ivysilani/10123460450-na-vlne-prvni-republiky/207562230510003"},"v-0-22":{"premiere":"10. 7. 2008 - ČT2","title":"Historie.cs","partTitle":"Masaryk a velká Pětka","description":"Jak se dělala politika za první republiky. Nakolik ovlivňoval TGM vztahy mezi pěti nejsilnějšími politickými stranami a jejich vůdci.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/208452801400026"},"v-0-21":{"premiere":"6. 1. 2002 - ČT1","title":"Domácí štěstí","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1095813559-domaci-stesti/202324244000001"},"v-0-20":{"premiere":"28. 1. 2014 - ČT1","title":"Události v regionech (Brno)","partTitle":"","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10122427178-udalosti-v-regionech-brno/314281381990128-udalosti-v-regionech"},"v-0-19":{"premiere":"9. 3. 2017 - ČT1","title":"Gejzír","partTitle":"","description":"Pražské metro — Angličáky — Vědecký ilustrátor Jan Dungel — Výrobce bubenických paliček Ivan Pelíšek — Tomáš Baťa","link":"http://www.ceskatelevize.cz/ivysilani/10805121298-gejzir/217562235000007"},"v-0-18":{"premiere":"9. 5. 2011 - ČT2","title":"Historie.cs","partTitle":"Když byli komunisté v opozici","description":"Jak se chovala KSČ během demokratické První republiky? Proč zvítězilo v roce 1929 bolševické křídlo vedené Klementem Gottwaldem a co to znamenalo pro další vývoj?","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/211452801400018"},"v-0-17":{"premiere":"13. 11. 2010 - ČT24","title":"Archiv ČT24","partTitle":"Jak se oslavovali čeští velikáni","description":"Jak se oslavovaly významné osobnosti naší historie v poválečných desetiletích","link":"http://www.ceskatelevize.cz/ivysilani/10116288585-archiv-ct24/210452801350037"},"v-0-16":{"premiere":"18. 9. 2007 - ČT1","title":"Na vlně první republiky","partTitle":"","description":"O filmu a filmařích","link":"http://www.ceskatelevize.cz/ivysilani/10123460450-na-vlne-prvni-republiky/207562230510004"},"v-0-15":{"premiere":"11. 9. 2007 - ČT1","title":"Na vlně první republiky","partTitle":"","description":"O hercích a divadlech","link":"http://www.ceskatelevize.cz/ivysilani/10123460450-na-vlne-prvni-republiky/207562230510002"},"v-0-14":{"premiere":"2. 10. 2007 - ČT1","title":"Na vlně první republiky","partTitle":"","description":"O módě, výtvarnících, fotografech a architektuře","link":"http://www.ceskatelevize.cz/ivysilani/10123460450-na-vlne-prvni-republiky/207562230510006"},"v-0-13":{"premiere":"25. 6. 2012 - ČT1","title":"Národní klenoty","partTitle":"Praha - jednota v rozmanitosti","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10361869257-narodni-klenoty/211563235200013-praha-jednota-v-rozmanitosti"},"v-0-12":{"premiere":"13. 4. 2013 - ČT24","title":"Retro","partTitle":"","description":"Rok 1959","link":"http://www.ceskatelevize.cz/ivysilani/10176269182-retro/213411000360015"},"v-0-11":{"premiere":"16. 6. 2009 - ČT2","title":"Události, komentáře","partTitle":"","description":"Zdravotnický kompromis? — Přepočítá Írán hlasy? — Slovenská republika rad","link":"http://www.ceskatelevize.cz/ivysilani/1096898594-udalosti-komentare/209411000370616"},"v-0-10":{"premiere":"18. 3. 2012 - ČT2","title":"Dějiny udatného českého národa","partTitle":"Vznik Československa","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10177109865-dejiny-udatneho-ceskeho-naroda/211543116230095-vznik-ceskoslovenska"},"v-0-9":{"premiere":"11. 6. 2014 - ČT sport","title":"Olympijský magazín","partTitle":"","description":"Zpravodajský souhrn uplynulého týdne — Setkání generací: Jan Železný a Barbora Špotáková — Host magazínu: Jan Macháček — České olympijské novinky — Z historie OH: Antverpy 1920 — Umělecká díla se sportovní tématikou — Síň slávy českých trenérů: Pavel Petera","link":"http://www.ceskatelevize.cz/ivysilani/10321897020-olympijsky-magazin/214471290290021"},"v-0-8":{"premiere":"11. 4. 2011 - ČT2","title":"Historie.cs","partTitle":"Češi a Němci za 1. republiky","description":"Dva národy žily spolu věky v jednom státním útvaru. V první polovině 20. století se jejich soužití zkomplikovalo. Jaké byly příčiny vyhrocení vzájemných vztahů?","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/211452801400015"},"v-0-7":{"premiere":"13. 12. 2011 - ČT1","title":"Na cestě","partTitle":"","description":"Podkarpatská Rus","link":"http://www.ceskatelevize.cz/ivysilani/1185966822-na-ceste/211562260120034-na-ceste-po-podkarpatske-rusi"},"v-0-6":{"premiere":"6. 6. 2011 - ČT2","title":"Historie.cs","partTitle":"Jiní Rusové","description":"Po bolševické revoluci v roce 1917 přišlo do Československa mnoho ruských emigrantů, kteří utíkali před komunistickou mocí. Mnozí z nich zůstali u nás natrvalo. Jak se k nim chovala První republika? Jaké byli jejich osudy za protektorátu a jaké po roce 1945?","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/211452801400022"},"v-0-5":{"premiere":"29. 10. 2003 - ČT1","title":"Osudové okamžiky","partTitle":"Kadaň 1919","description":"","link":"http://www.ceskatelevize.cz/ivysilani/1091682868-osudove-okamziky/402213100081017-kadan-1919"},"v-0-4":{"premiere":"24. 8. 2014 - ČT24","title":"Naše Velká válka","partTitle":"Nazdar, salut!","description":"","link":"http://www.ceskatelevize.cz/ivysilani/10877203125-nase-velka-valka/214411033220011"},"v-0-3":{"premiere":"4. 9. 2007 - ČT1","title":"Na vlně první republiky","partTitle":"","description":"O politice a politicích","link":"http://www.ceskatelevize.cz/ivysilani/10123460450-na-vlne-prvni-republiky/207562230510001"},"v-0-2":{"premiere":"5. 11. 2009 - ČT2","title":"Historie.cs","partTitle":"Těšínské jablko sváru","description":"Spory o Těšínsko hrozily ve 20. století několikrát střetem mezi Československem a Polskem. Došlo i k ozbrojeným srážkám. Jaká byla historie tohoto území a vůbec celého Slezska.","link":"http://www.ceskatelevize.cz/ivysilani/10150778447-historie-cs/209452801400034"},"v-0-1":{"premiere":"7. 3. 2000 - ČT1","title":"Ta naše povaha česká","partTitle":"Masaryk - mýtus nebo kult?","description":"O politikovi milovaném i zatracovaném","link":"http://www.ceskatelevize.cz/ivysilani/1100627928-ta-nase-povaha-ceska/400213100011005-masaryk-mytus-nebo-kult"}}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = {"data":[{"date":"01-01","label":{"hint":"TOTO100LETÍ","image":"stoleti","date":"","title":"Poezie napříč<br>stoletím"},"lineData":["v-3-20","v-5-2","v-3-16","a-3-6","a-0-14"]},{"date":"01-16","label":{"hint":"1968","image":"rib","date":"","title":"Sebeupálení<br>Jana Palacha"},"lineData":["v-5-38","v-5-45","v-5-37","v-5-49","v-0-4","v-0-12","a-2-5"]},{"date":"02-06","label":{"hint":"TOTO100LETÍ","image":"stoleti","date":"","title":"ve sportu!"},"lineData":["v-0-9","v-1-33","v-3-38","v-4-19","v-5-35"]},{"date":"02-25","label":{"hint":"","image":"rib","date":"","title":"Únor 1948"},"lineData":["v-3-19","v-3-45","v-3-55","m-3-1","a-3-3"]},{"date":"03-10","label":{"hint":"","image":"rib","date":"10. března 1948","title":"Jan Masaryk"},"lineData":["v-3-43","a-3-2","a-3-22","v-3-19"]},{"date":"03-15","label":{"hint":"","image":"rib","date":"14.–16. března 1939","title":"Okupace Čech,<br>Moravy a Slezska"},"lineData":["v-2-12","v-2-28","a-2-23","v-1-32","m-1-2"]},{"date":"04-01","label":{"hint":"Výročí:","image":"rib","date":"1968","title":"Pražské jaro"},"lineData":["v-4-25","v-4-29","v-4-47","v-4-44","m-4-2"]},{"date":"04-17","label":{"hint":"EXPO 58","image":"rib","date":"1958","title":"Světová výstava<br>v Bruselu"},"lineData":["v-4-6","v-4-31","a-4-18","v-4-50"]},{"date":"05-01","label":{"hint":"Československá televize","image":"rib","date":"1. května 1953","title":"Zahájení<br>zkušebního<br>vysílání"},"lineData":["v-3-50","a-3-20","v-7-21","v-5-8"]},{"date":"05-15","label":{"hint":"TOTO100LETÍ","image":"stoleti","date":"","title":"Stavby<br>a stavitelství"},"lineData":["v-5-10","a-5-25","v-7-11","a-2-4","v-1-5","a-4-11"]},{"date":"05-27","label":{"hint":"Operace Anthropoid","image":"rib","date":"27. 5. 1942","title":"Atentát<br>na Reinharda<br>Heydricha"},"lineData":["v-2-5","a-2-12","m-2-1","a-2-13"]},{"date":"06-13","label":{"hint":"Evropská unie","image":"eu","date":"13.-14. červen 2003","title":"Referendum<br>o vstupu do EU"},"lineData":["v-6-44","a-7-20","v-7-7","v-6-46","v-6-18"]},{"date":"07-01","label":{"hint":"TOTO100LETÍ","image":"stoleti","date":"","title":"Cestování<br>a rekreace"},"lineData":["v-3-31","a-1-22","v-3-15","a-5-9","a-7-9"]},{"date":"07-09","label":{"hint":"Výročí:","image":"rib","date":"9. července 1998","title":"Opoziční<br>smlouva"},"lineData":["v-6-35","a-6-21","v-6-53","v-6-37"]},{"date":"08-01","label":{"hint":"TOTO100LETÍ","image":"stoleti","date":"","title":"Underground"},"lineData":["v-5-39","a-5-23","m-5-3","v-5-14","v-5-21","v-5-9","v-5-31"]},{"date":"08-21","label":{"hint":"Výročí:","image":"rib","date":"21. srpna 1968","title":"Invaze vojsk<br>Varšavské<br>smlouvy"},"lineData":["v-4-18","m-4-3","a-4-8","v-4-34","v-4-14","m-4-1","v-4-33"]},{"date":"09-03","label":{"hint":"Výročí:","image":"rib","date":"3. září 1948 ","title":"Úmrtí<br>Edvarda Beneše"},"lineData":["v-3-32","a-1-14","v-2-21","v-0-34"]},{"date":"09-29","label":{"hint":"Výročí:","image":"rib","date":"29. září 1938","title":"Podpis<br>Mnichovské<br>dohody"},"lineData":["v-2-34","a-1-21","v-2-14","v-1-3"]},{"date":"10-12","label":{"hint":"Zlatá mexická Čáslavská","image":"rib","date":"","title":"Letní olympijské<br>hry 1968"},"lineData":["v-4-19","v-4-51","a-4-3","a-4-19"]},{"date":"10-28","label":{"hint":"Století republiky","image":"rib","date":"28. 10. 1918","title":"Vznik<br>Československa"},"lineData":["a-0-5","a-0-9","v-0-4","v-0-3"]},{"date":"11-17","label":{"hint":"Sametová revoluce","image":"rib","date":"","title":"17. 11. 1989<br>- 29. 12. 1989"},"lineData":["v-5-37","a-5-31","v-5-42","m-6-1","v-5-36"]},{"date":"12-10","label":{"hint":"10. prosince","image":"stoleti","date":"","title":"Den lidských<br>práv"},"lineData":["v-5-61","a-7-24","a-5-23","v-7-49"]},{"date":"12-20","label":{"hint":"TOTO100LETÍ","image":"stoleti","date":"","title":"Poezie napříč<br>stoletím"},"lineData":["v-3-20","v-5-2","v-3-16","a-3-6","a-0-14"]}]}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Timeline_css__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Timeline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Timeline_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(1);
var STEP_PADDING=80;var Timeline=function Timeline(_ref){var categoryId=_ref.categoryId;var stops=__WEBPACK_IMPORTED_MODULE_5__constants__["m" /* TIMELINE */].map(function(year,index){var yearClass='year';if(categoryId.length>0){var id=Number(categoryId);if(index===id||index===id+1){yearClass=yearClass+' hilite';}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{key:year,className:'stop',style:{left:index*STEP_PADDING},to:__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* ROUTING */].CATEGORY+'/'+Math.min(index,7)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dot'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:yearClass},year),index<=7&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line-click',style:{width:STEP_PADDING}}));});// fill
var fillStyle={};if(categoryId.length>0){fillStyle.width=STEP_PADDING;fillStyle.left=Number(categoryId)*STEP_PADDING;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'timeline',style:{width:(__WEBPACK_IMPORTED_MODULE_5__constants__["m" /* TIMELINE */].length-1)*STEP_PADDING}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'line-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'line-fill',style:fillStyle})),stops);};var mapStateToProps=function mapStateToProps(state){return{categoryId:state.dataCategory.category};};Timeline.propTypes={categoryId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(Timeline));

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchResults_SearchResults__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchBox_css__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SearchBox_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchBox=function(_Component){_inherits(SearchBox,_Component);function SearchBox(props){_classCallCheck(this,SearchBox);var _this=_possibleConstructorReturn(this,(SearchBox.__proto__||Object.getPrototypeOf(SearchBox)).call(this,props));_this.state={searchTerm:'',focus:false,open:false};// ref
_this.inputRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();// bind
_this.handleClick=_this.handleClick.bind(_this);_this.handleInputClick=_this.handleInputClick.bind(_this);_this.handleBlur=_this.handleBlur.bind(_this);_this.handleChange=_this.handleChange.bind(_this);return _this;}// -------------------------------------------------------
// Input
// -------------------------------------------------------
_createClass(SearchBox,[{key:'handleBlur',value:function handleBlur(){var _this2=this;if(this.state.open){this.setState({focus:false});// try hide (if not already in focus again)
setTimeout(function(){if(!_this2.state.focus){_this2.setState({searchTerm:'',open:false});}},200);}}},{key:'handleChange',value:function handleChange(e){this.setState({searchTerm:e.target.value});}// -------------------------------------------------------
// Click
// -------------------------------------------------------
},{key:'handleClick',value:function handleClick(){var _this3=this;if(!this.state.open){this.setState({focus:true,open:true});setTimeout(function(){_this3.inputRef.current.focus();},100);}}},{key:'handleInputClick',value:function handleInputClick(){this.setState({focus:true});}// -------------------------------------------------------
// Render
// -------------------------------------------------------
},{key:'render',value:function render(){var open=this.state.open;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'search-box',className:open?'open':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'search-button',onClick:this.handleClick,className:open?'inactive':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATH */].IMG+'ico/ico-search.png',alt:'Hledat - ikona'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'search-input',value:this.state.searchTerm,type:'text',name:'Hledat',ref:this.inputRef,onBlur:this.handleBlur,onChange:this.handleChange,onClick:this.handleInputClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SearchResults_SearchResults__["a" /* default */],{term:this.state.searchTerm}));}}]);return SearchBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchBox);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchResults_css__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchResults_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchResults_css__);
var SearchResults=function SearchResults(props){var term=props.term;var results=term.length===0?[]:Object(__WEBPACK_IMPORTED_MODULE_2__api__["r" /* search */])(term).map(function(result){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'search-result',key:result[0],to:__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* ROUTING */].DETAIL+'/'+result[0]},result[1].title);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'search-results'},results);};/* harmony default export */ __webpack_exports__["a"] = (SearchResults);

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TopicsMenu_TopicsMenu__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SortingMenu_SortingMenu__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SubtopicsMenu_SubtopicsMenu__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CategoryItemsList_CategoryItemsList__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CategoryIntroVideo_CategoryIntroVideo__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CategoryPage_css__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CategoryPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CategoryPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryPage=function(_Component){_inherits(CategoryPage,_Component);function CategoryPage(){_classCallCheck(this,CategoryPage);return _possibleConstructorReturn(this,(CategoryPage.__proto__||Object.getPrototypeOf(CategoryPage)).apply(this,arguments));}_createClass(CategoryPage,[{key:'componentDidMount',value:function componentDidMount(){this.fetchData();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.match.params.categoryId!==prevProps.match.params.categoryId){this.fetchData();window.scrollTo(0,0);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.resetCategoryData();}},{key:'fetchData',value:function fetchData(){this.props.fetchCategoryData(this.props.match.params.categoryId);this.props.saveLastLocation(this.props.match.url);}},{key:'render',value:function render(){var detailActive=this.props.detailActive;var categoryId=this.props.match.params.categoryId;var categoryData=__WEBPACK_IMPORTED_MODULE_9__constants__["f" /* MAIN_SECTIONS */][categoryId];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'header-image',src:__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* PATH */].IMG+'title/title-'+categoryId+'.png',alt:categoryData.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'category-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CategoryIntroVideo_CategoryIntroVideo__["a" /* default */],{category:categoryId,detailActive:detailActive}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TopicsMenu_TopicsMenu__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SubtopicsMenu_SubtopicsMenu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SortingMenu_SortingMenu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CategoryItemsList_CategoryItemsList__["a" /* default */],null));}}]);return CategoryPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{detailActive:state.dataDetail.active,category:state.dataDetail.category};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCategoryData:function fetchCategoryData(categoryId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions__["f" /* fetchCategoryData */])(categoryId));},resetCategoryData:function resetCategoryData(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions__["j" /* resetCategoryData */])());},saveLastLocation:function saveLastLocation(lastLocation){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions__["k" /* saveLastLocation */])(lastLocation));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CategoryPage));

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TopicsMenu_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TopicsMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TopicsMenu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_TextHelper__ = __webpack_require__(21);
var topicScroll=function topicScroll(){// todo - currently disabled
// document.getElementById('subtopic-menu').scrollIntoView();
};var TopicsMenu=function TopicsMenu(_ref){var category=_ref.category,categoryData=_ref.categoryData,actualTopic=_ref.actualTopic,switchTopic=_ref.switchTopic;var topics=[__WEBPACK_IMPORTED_MODULE_4__constants__["o" /* TOPIC_ALL */]];var counter={};// count items for each topic
categoryData.forEach(function(item){item[1].topic.forEach(function(topic){if(topic.length>0){var topicIndex=__WEBPACK_IMPORTED_MODULE_4__constants__["n" /* TOPICS */].indexOf(topic);if(topicIndex>=0){if(!counter[topicIndex]){counter[topicIndex]=1;}else{counter[topicIndex]+=1;}}}});});for(var i=0;i<__WEBPACK_IMPORTED_MODULE_4__constants__["n" /* TOPICS */].length;i+=1){if(counter[i]){topics.push(__WEBPACK_IMPORTED_MODULE_4__constants__["n" /* TOPICS */][i]);}}// create elements
var topicElements=topics.map(function(topic){var btnClass='topic';if(topic===actualTopic){btnClass=btnClass+' selected';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:encodeURIComponent(topic),className:btnClass,onClick:function onClick(){switchTopic(topic);topicScroll();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico',src:__WEBPACK_IMPORTED_MODULE_4__constants__["g" /* PATH */].IMG+'ico/topic/ico-topic-'+__WEBPACK_IMPORTED_MODULE_4__constants__["n" /* TOPICS */].indexOf(topic)+'.png',alt:topic}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},__WEBPACK_IMPORTED_MODULE_5__utils_TextHelper__["a" /* formatText */](topic).toUpperCase()));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topics-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'deco-top',src:__WEBPACK_IMPORTED_MODULE_4__constants__["g" /* PATH */].IMG+'deco/deco-top-'+category+'.png',alt:categoryData.title}),topicElements);};var mapStateToProps=function mapStateToProps(state){return{category:state.dataCategory.category,categoryData:state.dataCategory.data,actualTopic:state.dataCategory.topic};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{switchTopic:function switchTopic(topic){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions__["c" /* changeTopic */])(topic));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TopicsMenu));

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SortingMenu_css__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SortingMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SortingMenu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SortingButton_SortingButton__ = __webpack_require__(283);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SortingMenu=function(_Component){_inherits(SortingMenu,_Component);function SortingMenu(){_classCallCheck(this,SortingMenu);return _possibleConstructorReturn(this,(SortingMenu.__proto__||Object.getPrototypeOf(SortingMenu)).apply(this,arguments));}_createClass(SortingMenu,[{key:'getSortButton',value:function getSortButton(buttonId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SortingButton_SortingButton__["a" /* default */],{buttonId:buttonId,sorting:this.props.sorting,sortingSwitch:this.props.changeCategorySorting});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort-section title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},'Dle n\xE1zvu'),this.getSortButton(0),this.getSortButton(1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},'Dle data'),this.getSortButton(2),this.getSortButton(3)));}}]);return SortingMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{sorting:state.dataCategory.sorting};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{changeCategorySorting:function changeCategorySorting(sorting){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions__["a" /* changeCategorySorting */])(sorting));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SortingMenu));

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortingButton_css__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortingButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SortingButton_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SortingButton=function(_React$Component){_inherits(SortingButton,_React$Component);function SortingButton(props){_classCallCheck(this,SortingButton);var _this=_possibleConstructorReturn(this,(SortingButton.__proto__||Object.getPrototypeOf(SortingButton)).call(this,props));_this.handleClick=_this.handleClick.bind(_this);return _this;}_createClass(SortingButton,[{key:'handleClick',value:function handleClick(){this.props.sortingSwitch(this.props.buttonId);}},{key:'render',value:function render(){var _props=this.props,buttonId=_props.buttonId,sorting=_props.sorting;var btnClass='btn-sort '+(buttonId===sorting?'selected':'unselected')+' '+(buttonId%2===0?'dn':'up');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:btnClass,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ico/ico-sort.png',alt:buttonId%2===0?'Sestupně':'Vzestupně'}));}}]);return SortingButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SortingButton);

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubtopicsMenu_css__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubtopicsMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SubtopicsMenu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(1);
// todo - probably move to components - and handle redux stuff in page element
var SubtopicsMenu=function SubtopicsMenu(_ref){var actualSubtopic=_ref.actualSubtopic,visibleData=_ref.visibleData,switchSubtopic=_ref.switchSubtopic;var subtopics=[__WEBPACK_IMPORTED_MODULE_4__constants__["k" /* SUBTOPIC_ALL */]];visibleData.forEach(function(item){item[1].subtopic.forEach(function(subtopic){if(subtopic.length>0&&subtopics.indexOf(subtopic)===-1){subtopics.push(subtopic);}});});// create elements
var subtopicElements=subtopics.map(function(subtopic){var btnClass='subtopic';if(subtopic===actualSubtopic){btnClass=btnClass+' selected';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:encodeURIComponent(subtopic),className:btnClass,onClick:function onClick(){return switchSubtopic(subtopic);}},subtopic);});// try to hide menu
var menuClass='subtopic-menu';if(subtopics.length===1){menuClass=menuClass+' disabled';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'subtopic-menu',className:menuClass},subtopicElements);};var mapStateToProps=function mapStateToProps(state){return{actualSubtopic:state.dataCategory.subtopic,visibleData:state.dataCategory.visibleData};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{switchSubtopic:function switchSubtopic(subtopic){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions__["b" /* changeSubtopic */])(subtopic));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SubtopicsMenu));

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListItem_ListItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryItemsList_css__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryItemsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CategoryItemsList_css__);
var sortRegExp=/"|„|\(/g;var CategoryItemsList=function CategoryItemsList(_ref){var visibleData=_ref.visibleData,actualSubtopic=_ref.actualSubtopic,sorting=_ref.sorting,grid=_ref.grid;var dataArray=visibleData.filter(function(item){return actualSubtopic===__WEBPACK_IMPORTED_MODULE_3__constants__["k" /* SUBTOPIC_ALL */]||item[1].subtopic.indexOf(actualSubtopic)!==-1;});if(sorting<=1){// title
dataArray.sort(function(a,b){var at=a[1].title.replace(sortRegExp,'');var bt=b[1].title.replace(sortRegExp,'');return at.localeCompare(bt)*(sorting===0?1:-1);});}else{// date
dataArray.sort(function(a,b){var at=a[1].date;var bt=b[1].date;var ret=0;if(at<bt){ret=-1;}else if(at>bt){ret=1;}return ret*(sorting===2?1:-1);});}var items=dataArray.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ListItem_ListItem__["a" /* default */],{key:item[0],grid:grid,itemData:item});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'category-items-list'},items);};var mapStateToProps=function mapStateToProps(state){return{visibleData:state.dataCategory.visibleData,actualSubtopic:state.dataCategory.subtopic,sorting:state.dataCategory.sorting,grid:state.resize.grid};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(CategoryItemsList));

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryIntroVideo_css__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryIntroVideo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CategoryIntroVideo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryIntroVideo=function(_Component){_inherits(CategoryIntroVideo,_Component);function CategoryIntroVideo(props){_classCallCheck(this,CategoryIntroVideo);var _this=_possibleConstructorReturn(this,(CategoryIntroVideo.__proto__||Object.getPrototypeOf(CategoryIntroVideo)).call(this,props));_this.state={videoActive:false};return _this;}// -------------------------------------------------------
// Component
// -------------------------------------------------------
_createClass(CategoryIntroVideo,[{key:'componentWillMount',value:function componentWillMount(){this.checkActiveState(this.props);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.checkActiveState(nextProps);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return this.props.category!==nextProps.category||!this.state.videoActive&&nextState.videoActive;}// -------------------------------------------------------
// Played
// -------------------------------------------------------
},{key:'checkActiveState',value:function checkActiveState(props){this.setState({videoActive:!props.detailActive&&__WEBPACK_IMPORTED_MODULE_3__api__["b" /* getHash */]().length>0&&props.introPlayed.indexOf(props.category)===-1});}},{key:'trySavePlayed',value:function trySavePlayed(){var _props=this.props,category=_props.category,introPlayed=_props.introPlayed;if(introPlayed.indexOf(category)===-1){this.props.detailIntroPlayed(category);}}// -------------------------------------------------------
// Render
// -------------------------------------------------------
},{key:'render',value:function render(){var _this2=this;var category=this.props.category;var videoActive=this.state.videoActive;var categoryData=__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* MAIN_SECTIONS */][category];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro-video-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro-video'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-frame-cont'},!videoActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'video-start-btn',onClick:function onClick(){_this2.setState({videoActive:true});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'thumb',src:__WEBPACK_IMPORTED_MODULE_3__api__["s" /* videoImageUrl */]({bonus:categoryData.video}),alt:'Intro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ico/ico-play.png',alt:'P\u0159ehr\xE1t'})),videoActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{className:'video-frame',title:categoryData.title,src:__WEBPACK_IMPORTED_MODULE_3__api__["n" /* getVideoSource */]({bonus:categoryData.video}),onLoad:function onLoad(){return _this2.trySavePlayed();},allowFullScreen:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},categoryData.range),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},categoryData.title)));}}]);return CategoryIntroVideo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{introPlayed:state.dataDetail.introPlayed};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{detailIntroPlayed:function detailIntroPlayed(category){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions__["e" /* detailIntroPlayed */])(category));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CategoryIntroVideo));

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_TextHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemDetail_css__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemDetail_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ItemDetail_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ItemDetail=function(_Component){_inherits(ItemDetail,_Component);function ItemDetail(props){_classCallCheck(this,ItemDetail);var _this=_possibleConstructorReturn(this,(ItemDetail.__proto__||Object.getPrototypeOf(ItemDetail)).call(this,props));_this.state={infoVisible:false,closeBg:false,articleChecked:false,videoActive:false,fetching:true,detailData:null};_this.handleScroll=_this.handleScroll.bind(_this);_this.checkArticle=_this.checkArticle.bind(_this);return _this;}// -------------------------------------------------------
// Component
// -------------------------------------------------------
_createClass(ItemDetail,[{key:'componentDidMount',value:function componentDidMount(){window.scrollTo(0,0);this.props.detailActive(true);window.addEventListener('scroll',this.handleScroll);this.dataUpdate();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// todo - just quick not optimal solution - revise
if(prevProps.match.params.detailId!==this.props.match.params.detailId){this.dataUpdate();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.detailActive(false);window.removeEventListener('scroll',this.handleScroll);}// -------------------------------------------------------
// Video
// -------------------------------------------------------
},{key:'getContentVideo',value:function getContentVideo(){var _this2=this;var detailId=this.props.match.params.detailId;var detailData=this.state.detailData;var isMemory=detailData.type===__WEBPACK_IMPORTED_MODULE_7__constants__["e" /* ITEM_TYPE */].MEMORY;var hasInfo=detailData.type===__WEBPACK_IMPORTED_MODULE_7__constants__["e" /* ITEM_TYPE */].VIDEO&&detailData.idec.length>0;var infoData=__WEBPACK_IMPORTED_MODULE_4__api__["f" /* getInfo */](detailId);var closeIcoClass='ico';if(this.state.closeBg){closeIcoClass=closeIcoClass+' show-bg';}// tags
var tags=detailData.tags.map(function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{key:encodeURIComponent(tag),className:'tag',to:__WEBPACK_IMPORTED_MODULE_7__constants__["i" /* ROUTING */].TAG+'/'+tag,onClick:function onClick(){setTimeout(function(){// todo - quick workaround
window.scrollTo(0,0);},100);}},tag);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'detail-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'stamp-category',to:__WEBPACK_IMPORTED_MODULE_7__constants__["i" /* ROUTING */].CATEGORY+'/'+detailData.category},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].IMG+'ico/stamps/stamp-'+detailData.category+'.png',alt:'Kategorie'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},__WEBPACK_IMPORTED_MODULE_7__constants__["f" /* MAIN_SECTIONS */][detailData.category].range),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_7__constants__["f" /* MAIN_SECTIONS */][detailData.category].title)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-close',onClick:function onClick(e){return _this2.back(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:closeIcoClass,src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].IMG+'ico/ico-close.png',alt:'Zav\u0159\xEDt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'detail-content'},isMemory&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ico-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico-memory',src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].IMG+'ico/ico-memory-detail.png',alt:'pam\u011B\u0165 n\xE1roda'})),detailData.timeline.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},detailData.timeline),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_5__utils_TextHelper__["a" /* formatText */](detailData.title)),isMemory&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'memory-name'},detailData.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'memory-date'},detailData.date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_5__utils_TextHelper__["a" /* formatText */](detailData.desc)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-frame-cont'},!this.state.videoActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'video-start-btn',onClick:function onClick(){return _this2.setState({videoActive:true});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'thumb',src:__WEBPACK_IMPORTED_MODULE_4__api__["s" /* videoImageUrl */](detailData),alt:detailData.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico',src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].IMG+'ico/ico-play.png',alt:'P\u0159ehr\xE1t'})),this.state.videoActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{className:'video-frame',title:detailData.title,src:__WEBPACK_IMPORTED_MODULE_4__api__["n" /* getVideoSource */](detailData),allowFullScreen:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags'},tags),hasInfo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-info',onClick:function onClick(){return _this2.infoSwitch();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].IMG+'ico/ico-info.png',alt:'Info'}))),hasInfo&&this.state.infoVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Video z po\u0159adu:'),infoData.title&&infoData.title.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-show'},infoData.title),infoData.partTitle&&infoData.partTitle.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-part'},infoData.partTitle),infoData.description&&infoData.description.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,infoData.description),detailData.director&&detailData.director.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Re\u017Eie'),detailData.director),infoData.premiere&&infoData.premiere.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Premi\xE9ra'),infoData.premiere),infoData.link&&infoData.link.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show-link',href:infoData.link,target:'_blank',rel:'noopener noreferrer'},'Str\xE1nka po\u0159adu')),isMemory&&detailData.link.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'memory-link-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'memory-link',href:detailData.link,target:'_blank',rel:'noopener noreferrer'},'V\xEDce o pam\u011Btn\xEDkovi'))));}// -------------------------------------------------------
// Vysilani
// -------------------------------------------------------
// todo - quite similar to video - somehow merge
},{key:'getContentVysilani',value:function getContentVysilani(){var _this3=this;var detailData=this.state.detailData;var closeIcoClass='ico';if(this.state.closeBg){closeIcoClass=closeIcoClass+' show-bg';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'detail-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-close',onClick:function onClick(e){return _this3.back(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:closeIcoClass,src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].IMG+'ico/ico-close.png',alt:'Zav\u0159\xEDt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'detail-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},detailData.date+' - '+detailData.time+' '+detailData.channel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_5__utils_TextHelper__["a" /* formatText */](detailData.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_5__utils_TextHelper__["a" /* formatText */](detailData.desc)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-frame-cont'},!this.state.videoActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'video-start-btn',onClick:function onClick(){return _this3.setState({videoActive:true});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'thumb',src:__WEBPACK_IMPORTED_MODULE_4__api__["s" /* videoImageUrl */](detailData),alt:detailData.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico',src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].IMG+'ico/ico-play.png',alt:'P\u0159ehr\xE1t'})),this.state.videoActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{className:'video-frame',title:detailData.title,src:__WEBPACK_IMPORTED_MODULE_4__api__["n" /* getVideoSource */](detailData),allowFullScreen:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-bar center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link',href:detailData.webURL,target:'_blank'},'Str\xE1nka po\u0159adu'))));}// -------------------------------------------------------
// Article
// -------------------------------------------------------
},{key:'getContentArticle',value:function getContentArticle(){var _this4=this;var detailData=this.state.detailData;var articleStyle={visibility:this.state.articleChecked?'visible':'hidden'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'article-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-close',onClick:function onClick(e){return _this4.back(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].IMG+'ico/ico-close.png',alt:'Zav\u0159\xEDt'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'article-frame-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'article-loader'},'NA\u010C\xCDT\xC1M'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{className:'article-frame',title:detailData.title,src:detailData.link,ref:function ref(articleFrame){_this4.articleFrame=articleFrame;},onLoad:this.checkArticle,style:articleStyle,allowFullScreen:true})));}},{key:'checkArticle',value:function checkArticle(){// note - ugly but necessary workaround
if(!this.state.articleChecked){this.setState({articleChecked:true});var currentSrc=this.articleFrame.src;this.articleFrame.src=currentSrc;}}// -------------------------------------------------------
// Infographic
// -------------------------------------------------------
},{key:'getContentInfographic',value:function getContentInfographic(){var _this5=this;var detailData=this.state.detailData;// todo - repeating code (also for video)
var closeIcoClass='ico';if(this.state.closeBg){closeIcoClass=closeIcoClass+' show-bg';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'graph-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-close',onClick:function onClick(e){return _this5.back(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:closeIcoClass,src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].IMG+'ico/ico-close.png',alt:'Zav\u0159\xEDt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'infographic',src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].DATA+'infographic/'+detailData.image_id+'.jpg',alt:detailData.title}));}// -------------------------------------------------------
// Data
// -------------------------------------------------------
},{key:'dataError',value:function dataError(){// todo - probably render some 'not found' content
this.props.history.push(this.props.lastLocation);}},{key:'dataUpdate',value:function dataUpdate(){var _this6=this;var detailId=this.props.match.params.detailId;// reset to default
this.setState({fetching:true,detailData:null});// load data
__WEBPACK_IMPORTED_MODULE_4__api__["g" /* getItemData */](detailId).then(function(data){if(data!==undefined){_this6.setState({fetching:false,detailData:data});}else{_this6.dataError();}}).catch(function(){_this6.dataError();});}// -------------------------------------------------------
// Scroll
// -------------------------------------------------------
},{key:'handleScroll',value:function handleScroll(){// note - not ideal - but currently ok for this purpose
var showBg=document.documentElement.scrollTop!==0;if(this.state.closeBg!==showBg){this.setState({closeBg:showBg});}}// -------------------------------------------------------
// Back
// -------------------------------------------------------
},{key:'back',value:function back(e){e.stopPropagation();this.props.history.push(this.props.lastLocation);}// -------------------------------------------------------
// Info
// -------------------------------------------------------
},{key:'infoSwitch',value:function infoSwitch(){this.setState(function(prevState){return{infoVisible:!prevState.infoVisible};});}// -------------------------------------------------------
// Render
// -------------------------------------------------------
},{key:'render',value:function render(){if(!this.state.fetching){// set content by type
switch(this.state.detailData.type){case __WEBPACK_IMPORTED_MODULE_7__constants__["e" /* ITEM_TYPE */].VIDEO:case __WEBPACK_IMPORTED_MODULE_7__constants__["e" /* ITEM_TYPE */].MEMORY:return this.getContentVideo();case __WEBPACK_IMPORTED_MODULE_7__constants__["e" /* ITEM_TYPE */].VYSILANI:return this.getContentVysilani();case __WEBPACK_IMPORTED_MODULE_7__constants__["e" /* ITEM_TYPE */].ARTICLE:return this.getContentArticle();case __WEBPACK_IMPORTED_MODULE_7__constants__["e" /* ITEM_TYPE */].INFOGRAPHIC:return this.getContentInfographic();default:// todo - set backup content?
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'.');}}// todo - probably show some proper fetching animation
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'.');}}]);return ItemDetail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{lastLocation:state.dataDetail.lastLocation,menuOverlay:state.resize.menuOverlay,width:state.resize.width};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{detailActive:function detailActive(isActive){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions__["d" /* detailActive */])(isActive));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ItemDetail)));

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackEvent; });
// ---------------------------------------------------
// Event
// ---------------------------------------------------
var trackEvent=function trackEvent(eName,eValue){if(typeof window.dpAnalytics!=='undefined'){window.dpAnalytics.trackEvent('TOTO100LETÍ',eName,eValue);}};

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Home_css__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Home_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Home_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HomeLine_HomeLine__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HomeLineProgram_HomeLineProgram__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HomeFoot_HomeFoot__ = __webpack_require__(304);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=function(_Component){_inherits(Home,_Component);function Home(){_classCallCheck(this,Home);return _possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).apply(this,arguments));}_createClass(Home,[{key:'componentDidMount',value:function componentDidMount(){window.scrollTo(0,0);this.props.saveLastLocation(this.props.match.url);}},{key:'render',value:function render(){var _props=this.props,menuVisible=_props.menuVisible,menuOverlay=_props.menuOverlay;// calc grid
var grid=1;for(var i=0;i<__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* HOME_RESIZE_LIMITS */].GRID.length;i+=1){// calc width
var checkWidth=this.props.width;if(menuVisible&&!menuOverlay){checkWidth-=__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* HOME_RESIZE_LIMITS */].MENU;}// check
if(checkWidth>__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* HOME_RESIZE_LIMITS */].GRID[i][0]){grid=__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* HOME_RESIZE_LIMITS */].GRID[i][1];break;}}// set lines
var sectionLines=__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* MAIN_SECTIONS */].map(function(section,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HomeLine_HomeLine__["a" /* default */],{key:section.range,grid:grid,lineId:index});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'wrap-home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'logo-prix',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'homepage/logo-prix.png',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'header-cover',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'homepage/header.png',alt:'\xDAvod'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HomeLine_HomeLine__["a" /* default */],{grid:grid,lineId:__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* HOME_TOPIC_ID */]}),sectionLines,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__HomeLineProgram_HomeLineProgram__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__HomeFoot_HomeFoot__["a" /* default */],null));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{width:state.resize.width,menuVisible:state.resize.menuVisible,menuOverlay:state.resize.menuOverlay};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{saveLastLocation:function saveLastLocation(lastLocation){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions__["k" /* saveLastLocation */])(lastLocation));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Home));

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HomeLine_css__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HomeLine_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HomeLine_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HomeLineItem_HomeLineItem__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_TextHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// todo - show some 'fetching' state? or at least set final height
var HomeLine=function(_Component){_inherits(HomeLine,_Component);function HomeLine(props){_classCallCheck(this,HomeLine);var _this=_possibleConstructorReturn(this,(HomeLine.__proto__||Object.getPrototypeOf(HomeLine)).call(this,props));_this.state={fetching:true,labelData:{},lineContent:[],linePosition:0,lineEnd:false};_this.arrowClickLeft=_this.arrowClickLeft.bind(_this);_this.arrowClickRight=_this.arrowClickRight.bind(_this);return _this;}// -------------------------------------------------------
// Component
// -------------------------------------------------------
_createClass(HomeLine,[{key:'componentDidMount',value:function componentDidMount(){this.fetchLineData();}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(this.state.lineContent.length>0&&this.props.grid!==nextProps.grid){this.lineMoveUpdate(this.state.linePosition,this.getContentLength()-nextProps.grid);}return true;}// -------------------------------------------------------
// Label
// -------------------------------------------------------
},{key:'getTopicLabel',value:function getTopicLabel(){var _state$labelData=this.state.labelData,hint=_state$labelData.hint,image=_state$labelData.image,date=_state$labelData.date,title=_state$labelData.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hint-topic'},hint),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].DATA+'home/'+image+'.png',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date'},date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-topic',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_6__utils_TextHelper__["a" /* formatText */](title)}})));}},{key:'getNormalLabel',value:function getNormalLabel(){var _state$labelData2=this.state.labelData,range=_state$labelData2.range,title=_state$labelData2.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'label-wrap',to:__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* ROUTING */].CATEGORY+'/'+this.props.lineId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].IMG+'homepage/ico-home-line-'+this.props.lineId+'.png',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},range),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_6__utils_TextHelper__["a" /* formatText */](title))));}},{key:'getLabel',value:function getLabel(){if(this.props.lineId===__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* HOME_TOPIC_ID */]){return this.getTopicLabel();}return this.getNormalLabel();}// -------------------------------------------------------
// Content
// -------------------------------------------------------
},{key:'getContent',value:function getContent(){var _props=this.props,grid=_props.grid,lineId=_props.lineId;var lineOffset=-(100/grid)*this.state.linePosition+'%';// items
var items=this.state.lineContent.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HomeLineItem_HomeLineItem__["a" /* default */],{key:lineId+'-'+item[0],grid:grid,topic:lineId===__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* HOME_TOPIC_ID */],itemData:item,marginLeft:index===0?lineOffset:0});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items-wrap'},items,this.props.lineId!==__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* HOME_TOPIC_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HomeLineItem_HomeLineItem__["a" /* default */],{grid:grid,topic:false,itemData:this.getCategoryItemData(),marginLeft:0})));}},{key:'getCategoryItemData',value:function getCategoryItemData(){return['',{type:__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* ITEM_TYPE */].CATEGORY,categoryId:this.props.lineId}];}},{key:'getContentLength',value:function getContentLength(){if(this.props.lineId===__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* HOME_TOPIC_ID */]){return this.state.lineContent.length;}return this.state.lineContent.length+1;// +1 because of link at the end of each line
}// -------------------------------------------------------
// Arrows
// -------------------------------------------------------
},{key:'getArrowLeft',value:function getArrowLeft(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow-wrap left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrow',disabled:this.state.linePosition===0,onClick:this.arrowClickLeft},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].IMG+'homepage/home-arrow-'+(this.props.lineId===__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* HOME_TOPIC_ID */]?0:1)+'-L.png',alt:'P\u0159edchoz\xED'})));}},{key:'getArrowRight',value:function getArrowRight(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow-wrap right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrow',disabled:this.state.lineEnd,onClick:this.arrowClickRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].IMG+'homepage/home-arrow-'+(this.props.lineId===__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* HOME_TOPIC_ID */]?0:1)+'-R.png',alt:'Dal\u0161\xED'})));}},{key:'arrowClickLeft',value:function arrowClickLeft(){if(this.state.linePosition>0){this.lineMoveUpdate(this.state.linePosition-1,this.getContentLength()-this.props.grid);}}},{key:'arrowClickRight',value:function arrowClickRight(){if(!this.state.lineEnd){this.lineMoveUpdate(this.state.linePosition+1,this.getContentLength()-this.props.grid);}}},{key:'lineMoveUpdate',value:function lineMoveUpdate(newId,endId){var isEnd=newId>=endId;this.setState({linePosition:isEnd?endId:newId,lineEnd:isEnd});}// -------------------------------------------------------
// Fetch
// -------------------------------------------------------
},{key:'fetchLineData',value:function fetchLineData(){var _this2=this;var _props2=this.props,lineId=_props2.lineId,date=_props2.date;if(lineId<__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* HOME_TOPIC_ID */]){// static content
this.setState({fetching:false,labelData:__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* MAIN_SECTIONS */][lineId],lineContent:__WEBPACK_IMPORTED_MODULE_2__api__["c" /* getHomeLineData */](lineId)});}else{// topic
var topicData=__WEBPACK_IMPORTED_MODULE_2__api__["e" /* getHomeTopicLineData */](date);this.setState({fetching:false,labelData:topicData.label,lineContent:topicData.lineData},function(){// todo - small hack - kind of not really ideal
_this2.lineMoveUpdate(_this2.state.linePosition,_this2.getContentLength()-_this2.props.grid);});}}// -------------------------------------------------------
// Render
// -------------------------------------------------------
},{key:'render',value:function render(){var mainClass='home-line';if(this.props.lineId===__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* HOME_TOPIC_ID */]){mainClass=mainClass+' top-topic';}else{mainClass=mainClass+' category';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:mainClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrap'},!this.state.fetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.getLabel(),this.getArrowLeft(),this.getContent(),this.getArrowRight())));}}]);return HomeLine;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{date:state.resize.date};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps)(HomeLine));

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_TextHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HomeLineItem_css__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HomeLineItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__HomeLineItem_css__);
// todo - maybe find some way to extend ListItem (duplicate pieces of code)
var getLink=function getLink(itemClass,linkUrl,style,linkContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:itemClass,style:style,href:linkUrl,target:'_blank',rel:'noopener noreferrer'},linkContent);};var HomeLineItem=function HomeLineItem(_ref){var grid=_ref.grid,topic=_ref.topic,itemData=_ref.itemData,marginLeft=_ref.marginLeft;var imgUrl='';var ico='';var route='';var isCategory=false;var itemId=itemData[0];var mainData=itemData[1];// images
switch(mainData.type){case __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* ITEM_TYPE */].VIDEO:case __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* ITEM_TYPE */].MEMORY:ico='play';imgUrl=__WEBPACK_IMPORTED_MODULE_3__api__["s" /* videoImageUrl */](mainData);break;case __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* ITEM_TYPE */].ARTICLE:ico='read';imgUrl=__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'articles/'+mainData.image_id+'.jpg';break;case __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* ITEM_TYPE */].CATEGORY:isCategory=true;break;default:}// route
if(isCategory){route=__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ROUTING */].CATEGORY+'/'+mainData.categoryId;}else{route=__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ROUTING */].DETAIL+'/'+itemData[0];}// just for normal type
var titleClass='title';var topics=[];if(!isCategory){// title class
if(mainData.title.length>60){titleClass=titleClass+' longest';}else if(mainData.title.length>40){titleClass=titleClass+' long';}// topics
topics=mainData.topic.map(function(topicItem,index){var key=itemId+'-topic-'+index;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topic-bullet',key:key},topicItem);});}// content
var linkContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-cont'},isCategory&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'category-ico',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'homepage/ico-home-line-'+mainData.categoryId+'.png',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hint'},'Otev\u0159\xEDt celou kategorii')),!isCategory&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'thumb',src:imgUrl,alt:mainData.title}),ico.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ico/ico-'+ico+'.png',alt:'P\u0159ehr\xE1t'}))),!isCategory&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-wrap'},mainData.timeline.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date'},mainData.timeline)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:titleClass},__WEBPACK_IMPORTED_MODULE_4__utils_TextHelper__["a" /* formatText */](mainData.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topics'},topics)));// size
var style={width:100/grid+'%',marginLeft:marginLeft};// main class
var itemClass='home-list-item';if(topic){itemClass=itemClass+' topic-item';}// link
// todo - article ios hotfix - revise
if(mainData.type===__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* ITEM_TYPE */].ARTICLE&&__WEBPACK_IMPORTED_MODULE_3__api__["q" /* isIOs */]()){return getLink(itemClass,mainData.link,style,linkContent);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:itemClass,style:style,to:route},linkContent);};/* harmony default export */ __webpack_exports__["a"] = (HomeLineItem);

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HomeLineProgram_css__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HomeLineProgram_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HomeLineProgram_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeLineProgram=function(_Component){_inherits(HomeLineProgram,_Component);function HomeLineProgram(props){_classCallCheck(this,HomeLineProgram);var _this=_possibleConstructorReturn(this,(HomeLineProgram.__proto__||Object.getPrototypeOf(HomeLineProgram)).call(this,props));_this.state={lineContent:[]};return _this;}// -------------------------------------------------------
// Component
// -------------------------------------------------------
_createClass(HomeLineProgram,[{key:'componentDidMount',value:function componentDidMount(){this.fetchData();}// -------------------------------------------------------
// Tips
// -------------------------------------------------------
},{key:'getTip',value:function getTip(gridSize,tipData){var timeData=tipData.times[tipData.tipTimeKey];var dateArray=timeData.date.split('-');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:tipData.key,className:'tv-tip',href:'//www.ceskatelevize.cz/specialy/totostoleti/program-68#/detail/'+tipData.key+'/'+tipData.tipTimeKey,target:'_blank',style:{width:100/gridSize+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tip-in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time'},Number(dateArray[2])+'. '+Number(dateArray[1])+'. '+dateArray[0]+' v '+timeData.time),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},tipData.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico-play',src:__WEBPACK_IMPORTED_MODULE_4__constants__["g" /* PATH */].IMG+'ico/ico-program-video.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:tipData.programme.image.replace(/https:|http:/g,''),alt:'N\xE1hled'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__constants__["g" /* PATH */].IMG+'homepage/frame-program-video.png',alt:''}))));}// -------------------------------------------------------
// Fetch
// -------------------------------------------------------
},{key:'fetchData',value:function fetchData(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__api__["d" /* getHomeProgramLineData */]().then(function(data){_this2.setState({lineContent:data});}).catch(function(){// todo - solve error state
});}// -------------------------------------------------------
// Render
// -------------------------------------------------------
},{key:'render',value:function render(){var tips=[];if(this.state.lineContent.length>0){var gridSize=Math.min(Math.floor(this.props.width/295),5);// todo - move calculations out of render function
var startDay=new Date().getDay();// parse sunday
startDay=startDay===0?6:startDay-1;// parse length
if(startDay+gridSize>this.state.lineContent.length){startDay=this.state.lineContent.length-gridSize;}for(var i=0;i<gridSize;i+=1){tips.push(this.getTip(gridSize,this.state.lineContent[startDay+i]));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'program-tips-line'},tips.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'title-main',href:'//www.ceskatelevize.cz/specialy/totostoleti/program-68',target:'_blank',rel:'noopener noreferrer'},'TV Program 1968'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tips-wrap'},tips)));}}]);return HomeLineProgram;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{width:state.resize.width};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(HomeLineProgram));

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HomeFoot_css__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HomeFoot_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HomeFoot_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeFoot=function(_Component){_inherits(HomeFoot,_Component);function HomeFoot(){_classCallCheck(this,HomeFoot);return _possibleConstructorReturn(this,(HomeFoot.__proto__||Object.getPrototypeOf(HomeFoot)).apply(this,arguments));}_createClass(HomeFoot,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var imgLinkStyle={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'homepage/home-menu-sheet.png)'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-foot-line'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'img-link tv',href:'//www.ceskatelevize.cz/specialy/totostoleti/program-68',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-in',style:imgLinkStyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'img-link vysilani',to:__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ROUTING */].VYSILANI},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imgLinkStyle,className:'link-in'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'img-link anniversary',href:'//www.ceskatelevize.cz/porady/vyroci/',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-in',style:imgLinkStyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'img-link memory',to:__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ROUTING */].TAG+'/'+__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* TAG_MEMORY */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imgLinkStyle,className:'link-in'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'img-link school',to:__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ROUTING */].SCHOOL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imgLinkStyle,className:'link-in'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'img-link map',to:__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ROUTING */].MAP},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imgLinkStyle,className:'link-in'})));}}]);return HomeFoot;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HomeFoot);

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__About_css__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__About_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__About_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var About=function(_Component){_inherits(About,_Component);function About(){_classCallCheck(this,About);return _possibleConstructorReturn(this,(About.__proto__||Object.getPrototypeOf(About)).apply(this,arguments));}_createClass(About,[{key:'componentDidMount',value:function componentDidMount(){window.scrollTo(0,0);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'about'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'O projektu'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-wrap logo-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'about/logo-100.png',alt:'Toto100let\xED'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'Dramaturgie, produkce, grafika, webdesign, programov\xE1n\xED, re\u0161er\u0161e \u2013 Centrum dramaturgie nov\xFDch m\xE9di\xED \u010CT:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},'Eva Burachovi\u010Dov\xE1, Josef Duda, Ji\u0159\xED Koukal, Milan Mar\u010D\xE1k, Rebeka Maxov\xE1, Filip Smetana, Veronika Sou\u010Dkov\xE1, Kate\u0159ina Sudolsk\xE1, \u0160t\u011Bp\xE1nka Sunkov\xE1, Petr Vogl, Kristina Voln\xE1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'Re\u0161er\u0161e:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},'Mat\u011Bj \u010Cerm\xE1k, Mat\u011Bj Fixl, Tom\xE1\u0161 Kolich, Max Kyn\u010Dl, Daniel Kyselka, Karel Mat\u011Bjka, Jitka Nov\xE1kov\xE1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'Archiv \u010Cesk\xE9 televize:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},'Jakub Adamus, Edgar Holl\xE4nder, Marie Mrkusov\xE1, Iva Syslov\xE1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'\u010Cl\xE1nky \u010CT24:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},'t\xFDm redakce \u010CT 24, t\xFDm redakce \u010CT sport, Karel Tinl, Ale\u0161 M\u011B\u0159i\u010Dka'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'Odborn\xFD poradce:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},'Jakub Jare\u0161'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'Zn\u011Blky TOTO 100 LET\xCD:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Re\u017Eie:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Janek Jirk\u016F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'St\u0159ih:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Zden\u011Bk Durdil, Josef Karel Hlavat\xFD'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Produkce:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Magda G\xE4rtnerov\xE1, Zden\u011Bk Hala'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'V\xFDtvarnice:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Barbora Kafkov\xE1, Ad\xE9la Kostkanov\xE1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Sv\u011Btlo:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Karel Kaliban'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Kamera:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Petr Vejsl\xEDk')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'Nahr\xE1vky pam\u011Btn\xEDk\u016F:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},'Pam\u011B\u0165 n\xE1roda'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'logo-wrap logo-memory',href:'http://www.pametnaroda.cz/',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'about/logo-memory.png',alt:'Logo Pam\u011B\u0165 n\xE1roda'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'TOTO100LET\xCD ve \u0161kole:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},'\xDAstav pro studium totalitn\xEDch re\u017Eim\u016F, odd\u011Blen\xED vzd\u011Bl\xE1v\xE1n\xED'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'logo-wrap logo-ustr',href:'https://www.ustrcr.cz/',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'about/logo-ustr.png',alt:'Logo \xDASTR'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'logo-wrap logo-ustr',href:'http://dejepis21.cz/',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'about/logo-21.png',alt:'Logo D21'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'Budeme r\xE1di za va\u0161e dotazy a p\u0159ipom\xEDnky:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:toto100leti@ceskatelevize.cz'},'toto100leti@ceskatelevize.cz')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'link-source-list',to:__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ROUTING */].ARCHIVE_LIST},'Seznam pou\u017Eit\xFDch zdroj\u016F z archivu \u010CT')));}}]);return About;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (About);

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListItem_ListItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tag_css__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TagList_TagList__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tag=function(_Component){_inherits(Tag,_Component);function Tag(props){_classCallCheck(this,Tag);var _this=_possibleConstructorReturn(this,(Tag.__proto__||Object.getPrototypeOf(Tag)).call(this,props));_this.state={listOpen:false};return _this;}_createClass(Tag,[{key:'componentDidMount',value:function componentDidMount(){window.scrollTo(0,0);this.props.saveLastLocation(this.props.match.url);}},{key:'render',value:function render(){var _this2=this;var tag=this.props.match.params.tag;var dataArray=__WEBPACK_IMPORTED_MODULE_2__api__["k" /* getTagData */](tag).sort(function(a,b){var at=a[1].title.toUpperCase();var bt=b[1].title.toUpperCase();if(at<bt)return-1;else if(at>bt)return 1;return 0;});var items=dataArray.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ListItem_ListItem__["a" /* default */],{key:item[0],grid:_this2.props.grid,itemData:item});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tag-head'},tag),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-switch-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'tag-list-switch '+(this.state.listOpen?'open':''),onClick:function onClick(){_this2.setState(function(prevState){return{listOpen:!prevState.listOpen};});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sw-title'},'Seznam tag\u016F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ico-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico',src:__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* PATH */].IMG+'ico/ico-tags-list.png',alt:'Seznam tag\u016F'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TagList_TagList__["a" /* default */],{open:this.state.listOpen,currentTag:tag}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,items));}}]);return Tag;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{grid:state.resize.grid};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{saveLastLocation:function saveLastLocation(lastLocation){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions__["k" /* saveLastLocation */])(lastLocation));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Tag));

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TagList_css__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TagList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TagList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// todo - show some 'fetching' state?
var TagList=function(_Component){_inherits(TagList,_Component);function TagList(props){_classCallCheck(this,TagList);var _this=_possibleConstructorReturn(this,(TagList.__proto__||Object.getPrototypeOf(TagList)).call(this,props));_this.state={fetching:true,tags:[]};return _this;}_createClass(TagList,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__api__["l" /* getTagList */]().then(function(data){_this2.setState({fetching:false,tags:data});}).catch(function(){// todo - solve error state
});}},{key:'render',value:function render(){var _props=this.props,currentTag=_props.currentTag,open=_props.open;var tags=this.state.tags.map(function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{key:encodeURIComponent(tag),className:'tag '+(tag===currentTag?'selected':''),to:__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* ROUTING */].TAG+'/'+tag},tag);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrap-tags '+(open?'open':'closed')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag-list'},tags));}}]);return TagList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TagList);

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ArchiveList_css__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ArchiveList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ArchiveList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArchiveList=function(_Component){_inherits(ArchiveList,_Component);function ArchiveList(){_classCallCheck(this,ArchiveList);return _possibleConstructorReturn(this,(ArchiveList.__proto__||Object.getPrototypeOf(ArchiveList)).apply(this,arguments));}_createClass(ArchiveList,[{key:'componentDidMount',value:function componentDidMount(){window.scrollTo(0,0);}},{key:'render',value:function render(){var items=__WEBPACK_IMPORTED_MODULE_2__api__["m" /* getVideoData */]().map(function(item){var itemData=item[1];var itemInfo=__WEBPACK_IMPORTED_MODULE_2__api__["f" /* getInfo */](item[0]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'archive-item',key:item[0]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-main'},itemData.title),itemInfo.title&&itemInfo.title.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-show'},itemInfo.title),itemInfo.partTitle&&itemInfo.partTitle.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-part'},itemInfo.partTitle),itemInfo.description&&itemInfo.description.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,itemInfo.description),itemData.director&&itemData.director.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Re\u017Eie'),itemData.director),itemInfo.premiere&&itemInfo.premiere.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Premi\xE9ra'),itemInfo.premiere),itemInfo.link&&itemInfo.link.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show-link',href:itemInfo.link,target:'_blank',rel:'noopener noreferrer'},'Str\xE1nka po\u0159adu'));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'archive-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'Seznam pou\u017Eit\xFDch zdroj\u016F z archivu \u010CT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,items));}}]);return ArchiveList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ArchiveList);

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CtHead_css__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CtHead_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CtHead_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CtHead=function(_Component){_inherits(CtHead,_Component);function CtHead(props){_classCallCheck(this,CtHead);var _this=_possibleConstructorReturn(this,(CtHead.__proto__||Object.getPrototypeOf(CtHead)).call(this,props));_this.state={popMenuEnabled:false,popMenuVisible:false};_this.handleResize=_this.handleResize.bind(_this);return _this;}// -------------------------------------------------------
// Component
// -------------------------------------------------------
_createClass(CtHead,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.handleResize);// init resize
this.handleResize();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);}// -------------------------------------------------------
// Resize
// -------------------------------------------------------
},{key:'handleResize',value:function handleResize(){var winW=Math.max(document.documentElement.clientWidth,window.innerWidth||0);var menuEnbled=winW<=840;if(this.state.popMenuEnabled!==menuEnbled){if(!menuEnbled){this.setState({popMenuEnabled:menuEnbled,popMenuVisible:false});}else{this.setState({popMenuEnabled:menuEnbled});}}}// -------------------------------------------------------
// Menu switch
// -------------------------------------------------------
},{key:'popMenuSwitch',value:function popMenuSwitch(){this.setState(function(prevState){return{popMenuVisible:!prevState.popMenuVisible};});}// -------------------------------------------------------
// Render
// -------------------------------------------------------
},{key:'render',value:function render(){var _this2=this;var bgPattern=__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ct/wrapper-copyright.png';// styles
var popBtnStyle={display:this.state.popMenuEnabled?'block':'none'};var arrowStyle={display:this.state.popMenuVisible?'block':'none'};var popMenuStyle={display:this.state.popMenuEnabled?'block':'none',height:this.state.popMenuVisible?341:0,backgroundImage:'url('+bgPattern+')',backgroundRepeat:'repeat',backgroundColor:'#3c3c3c',transition:'height 0.3s',transitionTimingFunction:'ease-in-out'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ct-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/',title:'\u010Cesk\xE1 televize'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ct/logo-ceskatelevize.png',alt:'\u010Cesk\xE1 televize',title:'\u010Cesk\xE1 televize',className:'logo-min'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ct/logo-ceskatelevize-full.png',alt:'\u010Cesk\xE1 televize',title:'\u010Cesk\xE1 televize',className:'logo-full'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navigation-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'inlineMenu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/ct24/',title:'Zpravodajstv\xED'},'Zpravodajstv\xED')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/sport/',title:'Sport'},'Sport')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/ivysilani/',title:'iVys\xEDl\xE1n\xED'},'iVys\xEDl\xE1n\xED')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/tv-program/',title:'TV program'},'TV program')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/porady/a-z/',title:'Po\u0159ady A-Z'},'Po\u0159ady A\u2013Z')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//decko.ceskatelevize.cz/',title:'Pro d\u011Bti'},'Pro\xA0d\u011Bti')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/vse-o-ct/',title:'V\u0161e o \u010CT'},'V\u0161e o \u010CT'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'pop-menu',style:popBtnStyle,onClick:function onClick(){return _this2.popMenuSwitch();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ct/ct-menu.png',alt:'Menu'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'navigation-phone-menu-arrow',style:arrowStyle,src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ct/navigation-phone-menu-arrow.png',alt:'\u0160ipka'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navigation-phone-menu',style:popMenuStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/ct24/',title:'Zpravodajstv\xED'},'Zpravodajstv\xED')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/sport/',title:'Sport'},'Sport')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/ivysilani/',title:'iVys\xEDl\xE1n\xED'},'iVys\xEDl\xE1n\xED')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/tv-program/',title:'TV program'},'TV program')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/porady/a-z/',title:'Po\u0159ady A-Z'},'Po\u0159ady A\u2013Z')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//decko.ceskatelevize.cz/',title:'Pro d\u011Bti'},'Pro\xA0d\u011Bti')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//www.ceskatelevize.cz/vse-o-ct/',title:'V\u0161e o \u010CT'},'V\u0161e o \u010CT')))));}}]);return CtHead;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CtHead);

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListItem_ListItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__School_css__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__School_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__School_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_TextHelper__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// todo - show some 'fetching' state?
// todo - move intro texts to json file
var intro0='Materiály z databáze TOTO100LETÍ mohou zpestřit i výuku dějepisu nebo občanské výchovy. Využití pramenů a dobových materiálů přímo v hodině zvyšuje efektivitu výuky a do diskuze se zapojují i žáci, kteří jinak v hodinách dějepisu nebývají příliš aktivní.<br />Níže najdete několik námětů na vyučovací hodiny sestavené z videí, článků a dalších materiálů, které jsou spojeny do tematických celků. Principem námětů je doplnění vybraných materiálů o otázky, které poslouží jako podnět pro debatu ve třídě a u žáků prohloubí zájem o některé problémy českých soudobých dějin. Jednotlivá témata jsou pak spojena i didaktickými cíli, k jejichž naplnění by analýza materiálů měla vést.';var intro1='Přejeme hodně zvídavých a přemýšlivých studentů…';var School=function(_Component){_inherits(School,_Component);function School(props){_classCallCheck(this,School);var _this=_possibleConstructorReturn(this,(School.__proto__||Object.getPrototypeOf(School)).call(this,props));_this.state={fetching:true,list:[]};return _this;}_createClass(School,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.scrollTo(0,0);__WEBPACK_IMPORTED_MODULE_2__api__["i" /* getSchoolList */]().then(function(data){_this2.setState({fetching:false,list:data});}).catch(function(){// todo - solve error state
});}},{key:'render',value:function render(){var _this3=this;var items=this.state.list.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ListItem_ListItem__["a" /* default */],{key:item.id,grid:_this3.props.grid,itemData:[item.id,{id:item.id,type:__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* ITEM_TYPE */].SCHOOL_SHEET,title:item.title}]});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'school-head'},'TOTO100LET\xCD VE \u0160KOLE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'school-desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_6__utils_TextHelper__["a" /* formatText */](intro0)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_6__utils_TextHelper__["a" /* formatText */](intro1)}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,items));}}]);return School;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{grid:state.resize.grid};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(School));

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SchoolVideo_SchoolVideo__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SchoolDetail_css__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SchoolDetail_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SchoolDetail_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SchoolGallery_SchoolGallery__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SchoolArticle_SchoolArticle__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_TextHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SchoolImage_SchoolImage__ = __webpack_require__(327);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// todo - maybe split sections (head, sections, footer) to separate components
var SchoolDetail=function(_Component){_inherits(SchoolDetail,_Component);function SchoolDetail(props){_classCallCheck(this,SchoolDetail);var _this=_possibleConstructorReturn(this,(SchoolDetail.__proto__||Object.getPrototypeOf(SchoolDetail)).call(this,props));_this.state={fetching:true,activeVideoKey:'',data:{}};_this.handleVideoPlay=_this.handleVideoPlay.bind(_this);return _this;}_createClass(SchoolDetail,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.scrollTo(0,0);__WEBPACK_IMPORTED_MODULE_1__api__["j" /* getSchoolSheet */](this.props.match.params.sheetId).then(function(data){_this2.setState({fetching:false,data:data});}).catch(function(){// todo - solve error state
});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// for anchor-link function
var anchorPrev=prevProps.match.params.anchor;var anchorActual=this.props.match.params.anchor;if(anchorPrev!==anchorActual){if(anchorActual){// note - best/quickest that we can do in this case
// (using hash-router, which blocks normal anchor usage)
// scroll
document.getElementById(anchorActual).scrollIntoView();// reset prop
this.props.history.replace(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ROUTING */].SCHOOL_DETAIL+'/'+this.props.match.params.sheetId);}}}// -------------------------------------------------------
// Head
// -------------------------------------------------------
},{key:'getHead',value:function getHead(sheetId,headData){var bullets=headData.goals.map(function(goal,index){var key=sheetId+'-goal-'+index;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:key,dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_7__utils_TextHelper__["a" /* formatText */](goal)}});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_7__utils_TextHelper__["a" /* formatText */](headData.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'title-image',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].SCHOOL+'img/'+sheetId+'/title.jpg',alt:headData.title}),headData.photoSource.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'src'},headData.photoSource),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_7__utils_TextHelper__["a" /* formatText */](headData.desc)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bullets'},'Didaktick\xFD c\xEDl'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,bullets)));}// -------------------------------------------------------
// Sections
// -------------------------------------------------------
},{key:'getSectionPartText',value:function getSectionPartText(key,data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,className:'part text',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_7__utils_TextHelper__["a" /* formatText */](data)}});}},{key:'getSectionPartImage',value:function getSectionPartImage(sheetId,key,data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SchoolImage_SchoolImage__["a" /* default */],{key:key,sheetId:sheetId,sectionData:data});}},{key:'getSectionPartVideo',value:function getSectionPartVideo(key,data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SchoolVideo_SchoolVideo__["a" /* default */],{key:key,videoId:key,videoActive:this.state.activeVideoKey===key,videoData:data,onPlayClick:this.handleVideoPlay});}},{key:'getSectionPartBullets',value:function getSectionPartBullets(key,data){var bullets=data.map(function(bullet,index){var bulletKey=key+'-'+index;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:bulletKey,dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_7__utils_TextHelper__["a" /* formatText */](bullet)}});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'part bullets',key:key},bullets);}},{key:'getSectionPartGallery',value:function getSectionPartGallery(sheetId,key,data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SchoolGallery_SchoolGallery__["a" /* default */],{key:key,sheetId:sheetId,sectionData:data});}},{key:'getSectionPartArticle',value:function getSectionPartArticle(sheetId,key,data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SchoolArticle_SchoolArticle__["a" /* default */],{key:key,sheetId:sheetId,sectionData:data});}},{key:'getSectionPartDownload',value:function getSectionPartDownload(key,data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:key,className:'part download',href:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].SCHOOL+'download/'+data.file,target:'_blank'},data.title);}},{key:'getSectionPart',value:function getSectionPart(sheetId,partKey,partData){switch(partData.type){case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SCHOOL_PART_TYPE */].TEXT:return this.getSectionPartText(partKey,partData.data);case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SCHOOL_PART_TYPE */].IMAGE:return this.getSectionPartImage(sheetId,partKey,partData.data);case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SCHOOL_PART_TYPE */].VIDEO:return this.getSectionPartVideo(partKey,partData.data);case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SCHOOL_PART_TYPE */].BULLETS:return this.getSectionPartBullets(partKey,partData.data);case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SCHOOL_PART_TYPE */].GALLERY:return this.getSectionPartGallery(sheetId,partKey,partData.data);case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SCHOOL_PART_TYPE */].ARTICLE:return this.getSectionPartArticle(sheetId,partKey,partData.data);case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SCHOOL_PART_TYPE */].DOWNLOAD:return this.getSectionPartDownload(partKey,partData.data);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Undefined school section: '+partData.type);}}},{key:'getSectionParts',value:function getSectionParts(sheetId,sectionKey,partsData){var _this3=this;var parts=partsData.map(function(part,index){return _this3.getSectionPart(sheetId,sectionKey+'-'+index,part);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,parts);}},{key:'getSections',value:function getSections(sheetId,sectionsData){var _this4=this;var sections=sectionsData.map(function(section,index){var key=sheetId+'-sekce-'+index;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,id:key,className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_7__utils_TextHelper__["a" /* formatText */](section.title)),_this4.getSectionParts(sheetId,key,section.parts)));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sections'},sections);}// -------------------------------------------------------
// Foot
// -------------------------------------------------------
},{key:'getFootLink',value:function getFootLink(linkData){if(linkData.url){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:linkData.url,target:'_blank'},linkData.title);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_7__utils_TextHelper__["a" /* formatText */](linkData.title)}});}},{key:'getFootLinks',value:function getFootLinks(sheetId,linksData){var _this5=this;var links=linksData.map(function(link,index){var key=sheetId+'-foot-link-'+index;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:key},_this5.getFootLink(link),link.desc&&link.desc.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc'},__WEBPACK_IMPORTED_MODULE_7__utils_TextHelper__["a" /* formatText */](link.desc)));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,links);}},{key:'getFoot',value:function getFoot(sheetId,footData){var _this6=this;var sections=footData.map(function(section,index){var key=sheetId+'-foot-section-'+index;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},section.title),section.desc.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc'},__WEBPACK_IMPORTED_MODULE_7__utils_TextHelper__["a" /* formatText */](section.desc)),_this6.getFootLinks(sheetId,section.links));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section foot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrap'},sections));}// -------------------------------------------------------
// Handlers
// -------------------------------------------------------
},{key:'handleVideoPlay',value:function handleVideoPlay(videoId){this.setState({activeVideoKey:videoId});}// -------------------------------------------------------
// Render
// -------------------------------------------------------
},{key:'render',value:function render(){var data=this.state.data;var sheetId=this.props.match.params.sheetId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'school-detail'},!this.state.fetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.getHead(sheetId,data.head),this.getSections(sheetId,data.sections),this.getFoot(sheetId,data.footer)));}}]);return SchoolDetail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SchoolDetail);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SchoolVideo_css__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SchoolVideo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SchoolVideo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(1);
// todo - consider final folder hierarchy + name
var SchoolVideo=function SchoolVideo(_ref){var videoId=_ref.videoId,videoActive=_ref.videoActive,videoData=_ref.videoData,onPlayClick=_ref.onPlayClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'part school-video-frame'},!videoActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'video-start-btn',onClick:function onClick(){onPlayClick(videoId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'thumb',src:__WEBPACK_IMPORTED_MODULE_1__api__["s" /* videoImageUrl */](videoData),alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico',src:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].IMG+'ico/ico-play.png',alt:'P\u0159ehr\xE1t'})),videoActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{className:'video-frame',title:'Video',src:__WEBPACK_IMPORTED_MODULE_1__api__["n" /* getVideoSource */](videoData),allowFullScreen:true}));};/* harmony default export */ __webpack_exports__["a"] = (SchoolVideo);

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SchoolGallery_css__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SchoolGallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SchoolGallery_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolGallery=function(_Component){_inherits(SchoolGallery,_Component);function SchoolGallery(props){_classCallCheck(this,SchoolGallery);var _this=_possibleConstructorReturn(this,(SchoolGallery.__proto__||Object.getPrototypeOf(SchoolGallery)).call(this,props));_this.state={actualFrame:0};return _this;}// -------------------------------------------------------
// Image
// -------------------------------------------------------
_createClass(SchoolGallery,[{key:'getImage',value:function getImage(sheetId,name,actualFrame){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'gallery-image',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].SCHOOL+'img/'+sheetId+'/'+name+'-'+actualFrame+'.jpg',alt:'Galerie'});}// -------------------------------------------------------
// Navigation
// -------------------------------------------------------
},{key:'swapFrame',value:function swapFrame(direction){var length=this.props.sectionData.length;var newFrame=this.state.actualFrame+direction;if(newFrame<0){newFrame=length-1;}else if(newFrame===length){newFrame=0;}this.setState({actualFrame:newFrame});}// -------------------------------------------------------
// Render
// -------------------------------------------------------
},{key:'render',value:function render(){var _this2=this;var _props=this.props,sheetId=_props.sheetId,sectionData=_props.sectionData;var actualFrame=this.state.actualFrame;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'part gallery'},sectionData.full&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'zoom-link',href:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].SCHOOL+'img/'+sheetId+'/'+sectionData.baseName+'-'+actualFrame+'-full.jpg',target:'_blank'},this.getImage(sheetId,sectionData.baseName,actualFrame),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico-zoom',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ico/ico-zoom.png',alt:''})),!sectionData.full&&this.getImage(sheetId,sectionData.baseName,actualFrame),sectionData.source.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'source'},sectionData.source),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrow-btn left',onClick:function onClick(){return _this2.swapFrame(-1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ico/ico-arrow-left.png',alt:'P\u0159edchoz\xED'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress'},actualFrame+1+'/'+sectionData.length),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrow-btn right',onClick:function onClick(){return _this2.swapFrame(1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ico/ico-arrow-right.png',alt:'Dal\u0161\xED'}))));}}]);return SchoolGallery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SchoolGallery);

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SchoolArticle_css__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SchoolArticle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SchoolArticle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_TextHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(1);
// todo - try some research about code formatting
// todo ...and possible security problems with current "dangerous" usage
// todo ...(can some harmful code injected into website by modifying data files?)
var getImage=function getImage(sheetId,imageName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].SCHOOL+'img/'+sheetId+'/'+imageName+'.jpg',alt:'\u010Cl\xE1nek'});};var SchoolArticle=function SchoolArticle(_ref){var sheetId=_ref.sheetId,sectionData=_ref.sectionData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'part article'},sectionData.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-wrap'},sectionData.image.full&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'zoom-link',href:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].SCHOOL+'img/'+sheetId+'/'+sectionData.image.name+'-full.jpg',target:'_blank'},getImage(sheetId,sectionData.image.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico-zoom',src:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PATH */].IMG+'ico/ico-zoom.png',alt:''})),!sectionData.image.full&&getImage(sheetId,sectionData.image.name),sectionData.image.source.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'note'},sectionData.image.source)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_2__utils_TextHelper__["a" /* formatText */](sectionData.text)}}));};/* harmony default export */ __webpack_exports__["a"] = (SchoolArticle);

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SchoolImage_css__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SchoolImage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SchoolImage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
// todo - almost identical to article image - maybe can be stacked together
var getImage=function getImage(sheetId,imageName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].SCHOOL+'img/'+sheetId+'/'+imageName+'.jpg',alt:'Ilustra\u010Dn\xED obr\xE1zek'});};var SchoolImage=function SchoolImage(_ref){var sheetId=_ref.sheetId,sectionData=_ref.sectionData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'part image'},sectionData.full&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'zoom-link',href:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].SCHOOL+'img/'+sheetId+'/'+sectionData.name+'-full.jpg',target:'_blank'},getImage(sheetId,sectionData.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ico-zoom',src:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PATH */].IMG+'ico/ico-zoom.png',alt:''})),!sectionData.full&&getImage(sheetId,sectionData.name),sectionData.source.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'note',dangerouslySetInnerHTML:{__html:sectionData.source}}));};/* harmony default export */ __webpack_exports__["a"] = (SchoolImage);

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListItem_ListItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Vysilani_css__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Vysilani_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Vysilani_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Vysilani=function(_Component){_inherits(Vysilani,_Component);function Vysilani(props){_classCallCheck(this,Vysilani);var _this=_possibleConstructorReturn(this,(Vysilani.__proto__||Object.getPrototypeOf(Vysilani)).call(this,props));_this.state={fetching:true,// is this used for anything - or just list length is ok?
list:[],selectedFilter:0};return _this;}_createClass(Vysilani,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.scrollTo(0,0);__WEBPACK_IMPORTED_MODULE_4__api__["o" /* getVysilaniData */]().then(function(data){_this2.setState({fetching:false,list:data.array});}).catch(function(){// todo - solve error state
});this.props.saveLastLocation(this.props.match.url);}},{key:'render',value:function render(){var _this3=this;var selectedFilter=this.state.selectedFilter;var grid=this.props.grid;// items
var itemsArray=[];if(selectedFilter===0){itemsArray=this.state.list;}else{// apply filter
// todo - reference by 'selectedFilter' is not ideal - can be easily broken
itemsArray=this.state.list.filter(function(item){return item[1].tag.toUpperCase()===__WEBPACK_IMPORTED_MODULE_6__constants__["p" /* VYSILANI_FILTERS */][selectedFilter].name.toUpperCase();});}var items=itemsArray.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ListItem_ListItem__["a" /* default */],{key:item[0],grid:grid,itemData:item});});// filters
var filters=__WEBPACK_IMPORTED_MODULE_6__constants__["p" /* VYSILANI_FILTERS */].map(function(filter){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:filter.id,className:'filter '+(selectedFilter===filter.id?'selected':''),onClick:function onClick(){_this3.setState({selectedFilter:filter.id});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__constants__["g" /* PATH */].IMG+'ico/vysilani/filter-'+filter.id+'.png',alt:filter.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},filter.name));});// todo - items.length condition is not idea - probably add to separate function and return result
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'vysilani'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'vysilani-head'},'TOTO100LET\xCD ve Vys\xEDl\xE1n\xED \u010CT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'vysilani-filters'},filters),items.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,items),items.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-empty'},'Pro tuto kategorii nejsou moment\xE1ln\u011B dostupn\xE1 \u017E\xE1dn\xE1 videa.'));}}]);return Vysilani;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{grid:state.resize.grid};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{saveLastLocation:function saveLastLocation(lastLocation){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions__["k" /* saveLastLocation */])(lastLocation));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Vysilani));

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_maps__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_google_maps_lib_components_addons_MarkerClusterer__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_google_maps_lib_components_addons_MarkerClusterer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_google_maps_lib_components_addons_MarkerClusterer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Map_css__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Map_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Map_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MapMarker_MapMarker__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyMapComponent=Object(__WEBPACK_IMPORTED_MODULE_2_react_google_maps__["withScriptjs"])(Object(__WEBPACK_IMPORTED_MODULE_2_react_google_maps__["withGoogleMap"])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_maps__["GoogleMap"],{defaultZoom:7,options:{streetViewControl:false,clickableIcons:false,mapTypeControl:false,mapTypeId:'hybrid',minZoom:3,zoom:7,center:{lat:49.349852,lng:17.850232}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_google_maps_lib_components_addons_MarkerClusterer___default.a,{averageCenter:true,enableRetinaIcons:true,gridSize:60},props.markers.map(function(markerData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MapMarker_MapMarker__["a" /* default */],{key:markerData[0],markerData:markerData});})));}));// todo - show some 'fetching' state?
var Map=function(_Component){_inherits(Map,_Component);function Map(props){_classCallCheck(this,Map);var _this=_possibleConstructorReturn(this,(Map.__proto__||Object.getPrototypeOf(Map)).call(this,props));_this.state={fetching:true,markers:[]};return _this;}_createClass(Map,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;// todo - not ideal to have scrolling scattered around - ideally make some "scroll" handler
window.scrollTo(0,0);// todo - also kind of weird - check implementation
this.props.saveLastLocation(this.props.match.url);__WEBPACK_IMPORTED_MODULE_5__api__["h" /* getMapMarkersData */]().then(function(data){_this2.setState({fetching:false,markers:data});}).catch(function(){// todo - solve error state
});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'map-head'},'TOTO100LET\xCD NA MAP\u011A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyMapComponent,{markers:this.state.markers,googleMapURL:'https://maps.googleapis.com/maps/api/js?key=AIzaSyDTkV6VUT7BpuPJHXRzbihhiuP1MTr8q0Q&v=3.exp&libraries=geometry,drawing,places',loadingElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'100%'}}),containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'map-frame-cont '+(this.props.menuOverlay?'small':'')}),mapElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'detail-map'})}));}}]);return Map;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{menuOverlay:state.resize.menuOverlay};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{saveLastLocation:function saveLastLocation(lastLocation){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions__["k" /* saveLastLocation */])(lastLocation));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Map));

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(122)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(49)

var _bind3 = _interopRequireDefault(_bind2)

exports.withScriptjs = withScriptjs

var _invariant = __webpack_require__(13)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(155)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _recompose = __webpack_require__(156)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

var LOADING_STATE_NONE = "NONE"
var LOADING_STATE_BEGIN = "BEGIN"
var LOADING_STATE_LOADED = "LOADED"

function withScriptjs(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          loadingState: LOADING_STATE_NONE,
        }),
        (_this.isUnmounted = false),
        (_this.handleLoaded = (0, _bind3.default)(_this.handleLoaded, _this)),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "handleLoaded",
        value: function handleLoaded() {
          if (this.isUnmounted) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_LOADED,
          })
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            loadingElement = _props.loadingElement,
            googleMapURL = _props.googleMapURL

          ;(0, _invariant2.default)(
            !!loadingElement && !!googleMapURL,
            "Required props loadingElement or googleMapURL is missing. You need to provide both of them."
          )
        },
      },
      {
        key: "componentDidMount",
        value: function componentDidMount() {
          var loadingState = this.state.loadingState

          if (loadingState !== LOADING_STATE_NONE || !_canUseDom2.default) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_BEGIN,
          })
          // Don't load scriptjs as a dependency since we do not want this module be used on server side.
          // eslint-disable-next-line global-require
          var scriptjs = __webpack_require__(405)
          var googleMapURL = this.props.googleMapURL

          scriptjs(googleMapURL, this.handleLoaded)
        },
      },
      {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isUnmounted = true
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            loadingElement = _props2.loadingElement,
            googleMapURL = _props2.googleMapURL,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "loadingElement",
              "googleMapURL",
            ])
          var loadingState = this.state.loadingState

          if (loadingState === LOADING_STATE_LOADED) {
            return factory(restProps)
          } else {
            return loadingElement
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withScriptjs(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    loadingElement: _propTypes2.default.node.isRequired,
    googleMapURL: _propTypes2.default.string.isRequired,
  }

  return Container
}

exports.default = withScriptjs


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(334);
module.exports = __webpack_require__(18).Object.getPrototypeOf;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(38);
var $getPrototypeOf = __webpack_require__(123);

__webpack_require__(335)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(23);
var core = __webpack_require__(18);
var fails = __webpack_require__(34);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(338);
var $Object = __webpack_require__(18).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(23);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(25), 'Object', { defineProperty: __webpack_require__(24).f });


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(340), __esModule: true };

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128);
__webpack_require__(347);
module.exports = __webpack_require__(83).f('iterator');


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(78);
var defined = __webpack_require__(73);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(79);
var descriptor = __webpack_require__(39);
var setToStringTag = __webpack_require__(82);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(31)(IteratorPrototype, __webpack_require__(20)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var anObject = __webpack_require__(32);
var getKeys = __webpack_require__(47);

module.exports = __webpack_require__(25) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(35);
var toLength = __webpack_require__(133);
var toAbsoluteIndex = __webpack_require__(345);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(78);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(22).document;
module.exports = document && document.documentElement;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(348);
var global = __webpack_require__(22);
var hide = __webpack_require__(31);
var Iterators = __webpack_require__(40);
var TO_STRING_TAG = __webpack_require__(20)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(349);
var step = __webpack_require__(350);
var Iterators = __webpack_require__(40);
var toIObject = __webpack_require__(35);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(129)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(352), __esModule: true };

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(353);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
module.exports = __webpack_require__(18).Symbol;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(22);
var has = __webpack_require__(26);
var DESCRIPTORS = __webpack_require__(25);
var $export = __webpack_require__(23);
var redefine = __webpack_require__(130);
var META = __webpack_require__(354).KEY;
var $fails = __webpack_require__(34);
var shared = __webpack_require__(75);
var setToStringTag = __webpack_require__(82);
var uid = __webpack_require__(46);
var wks = __webpack_require__(20);
var wksExt = __webpack_require__(83);
var wksDefine = __webpack_require__(84);
var enumKeys = __webpack_require__(355);
var isArray = __webpack_require__(356);
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(33);
var toObject = __webpack_require__(38);
var toIObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(77);
var createDesc = __webpack_require__(39);
var _create = __webpack_require__(79);
var gOPNExt = __webpack_require__(357);
var $GOPD = __webpack_require__(135);
var $GOPS = __webpack_require__(85);
var $DP = __webpack_require__(24);
var $keys = __webpack_require__(47);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(134).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(48).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(45)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(31)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(46)('meta');
var isObject = __webpack_require__(33);
var has = __webpack_require__(26);
var setDesc = __webpack_require__(24).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(34)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(47);
var gOPS = __webpack_require__(85);
var pIE = __webpack_require__(48);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(80);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(35);
var gOPN = __webpack_require__(134).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 358 */
/***/ (function(module, exports) {



/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(84)('asyncIterator');


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(84)('observable');


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(362), __esModule: true };

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(363);
module.exports = __webpack_require__(18).Object.setPrototypeOf;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(23);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(364).set });


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(33);
var anObject = __webpack_require__(32);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(76)(Function.call, __webpack_require__(135).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(366), __esModule: true };

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(367);
var $Object = __webpack_require__(18).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(23);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(79) });


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(87);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(370),
    defineProperty = __webpack_require__(137),
    identity = __webpack_require__(41);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(50),
    isMasked = __webpack_require__(374),
    isObject = __webpack_require__(28),
    toSource = __webpack_require__(139);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(375);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(141),
    createBind = __webpack_require__(378),
    createCurry = __webpack_require__(379),
    createHybrid = __webpack_require__(144),
    createPartial = __webpack_require__(396),
    getData = __webpack_require__(148),
    mergeData = __webpack_require__(397),
    setData = __webpack_require__(151),
    setWrapToString = __webpack_require__(152),
    toInteger = __webpack_require__(398);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(52),
    root = __webpack_require__(15);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(87),
    createCtor = __webpack_require__(52),
    createHybrid = __webpack_require__(144),
    createRecurry = __webpack_require__(147),
    getHolder = __webpack_require__(91),
    replaceHolders = __webpack_require__(54),
    root = __webpack_require__(15);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(89),
    getData = __webpack_require__(148),
    getFuncName = __webpack_require__(383),
    lodash = __webpack_require__(385);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(384);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 384 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(89),
    LodashWrapper = __webpack_require__(149),
    baseLodash = __webpack_require__(90),
    isArray = __webpack_require__(19),
    isObjectLike = __webpack_require__(36),
    wrapperClone = __webpack_require__(386);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(89),
    LodashWrapper = __webpack_require__(149),
    copyArray = __webpack_require__(150);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(153),
    arrayIncludes = __webpack_require__(390);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(391);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(392),
    baseIsNaN = __webpack_require__(393),
    strictIndexOf = __webpack_require__(394);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(150),
    isIndex = __webpack_require__(53);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(87),
    createCtor = __webpack_require__(52),
    root = __webpack_require__(15);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(145),
    composeArgsRight = __webpack_require__(146),
    replaceHolders = __webpack_require__(54);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(399);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(154);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(401);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(122)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(49)

var _bind3 = _interopRequireDefault(_bind2)

exports.withGoogleMap = withGoogleMap

var _warning = __webpack_require__(157)

var _warning2 = _interopRequireDefault(_warning)

var _invariant = __webpack_require__(13)

var _invariant2 = _interopRequireDefault(_invariant)

var _recompose = __webpack_require__(156)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function withGoogleMap(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          map: null,
        }),
        (_this.handleComponentMount = (0, _bind3.default)(
          _this.handleComponentMount,
          _this
        )),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "getChildContext",
        value: function getChildContext() {
          return (0, _defineProperty3.default)(
            {},
            _constants.MAP,
            this.state.map
          )
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            containerElement = _props.containerElement,
            mapElement = _props.mapElement

          ;(0, _invariant2.default)(
            !!containerElement && !!mapElement,
            "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized."
          )
        },
      },
      {
        key: "handleComponentMount",
        value: function handleComponentMount(node) {
          if (this.state.map || node === null) {
            return
          }
          ;(0, _warning2.default)(
            "undefined" !== typeof google,
            "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168"
          )
          // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
          var map = new google.maps.Map(node)
          this.setState({ map: map })
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            containerElement = _props2.containerElement,
            mapElement = _props2.mapElement,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "containerElement",
              "mapElement",
            ])
          var map = this.state.map

          if (map) {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null, factory(restProps))
            )
          } else {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null)
            )
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withGoogleMap(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    containerElement: _propTypes2.default.node.isRequired,
    mapElement: _propTypes2.default.node.isRequired,
  }
  Container.childContextTypes = (0, _defineProperty3.default)(
    {},
    _constants.MAP,
    _propTypes2.default.object
  )

  return Container
}

exports.default = withGoogleMap


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GoogleMap = exports.Map = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _toConsumableArray2 = __webpack_require__(408)

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(13)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Map`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
 */
var Map = (exports.Map = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Map, _React$PureComponent)
  ;(0, _createClass3.default)(Map, [
    {
      key: "fitBounds",

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
      value: function fitBounds() {
        var _context$MAP

        return (_context$MAP = this.context[_constants.MAP]).fitBounds.apply(
          _context$MAP,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panBy",
      value: function panBy() {
        var _context$MAP2

        return (_context$MAP2 = this.context[_constants.MAP]).panBy.apply(
          _context$MAP2,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panTo",
      value: function panTo() {
        var _context$MAP3

        return (_context$MAP3 = this.context[_constants.MAP]).panTo.apply(
          _context$MAP3,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panToBounds",
      value: function panToBounds() {
        var _context$MAP4

        return (_context$MAP4 = this.context[_constants.MAP]).panToBounds.apply(
          _context$MAP4,
          arguments
        )
      },

      /*
     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
     */
    },
  ])

  function Map(props, context) {
    ;(0, _classCallCheck3.default)(this, Map)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(
        this,
        props,
        context
      )
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you wrap <GoogleMap> component with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      GoogleMap.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP]
    )
    return _this
  }

  ;(0, _createClass3.default)(Map, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the lat/lng bounds of the current viewport. If more than one copy of the world is visible, the bounds range in longitude from -180 to 180 degrees inclusive. If the map is not yet initialized (i.e. the mapType is still null), or center and zoom have not been set then the result is `null` or `undefined`.
       * @type LatLngBoundsnullundefined
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.context[_constants.MAP].getBounds()
      },

      /**
       * Returns the position displayed at the center of the map. Note that this `LatLng` object is _not_ wrapped. See `[LatLng](#LatLng)` for more information.
       * @type LatLngLatLngLatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.context[_constants.MAP].getCenter()
      },

      /**
       * Returns the clickability of the map icons. A map icon represents a point of interest, also known as a POI. If the returned value is true, then the icons are clickable on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickableIcons",
      value: function getClickableIcons() {
        return this.context[_constants.MAP].getClickableIcons()
      },

      /**
       *
       * @type Element
       * @public
       */
    },
    {
      key: "getDiv",
      value: function getDiv() {
        return this.context[_constants.MAP].getDiv()
      },

      /**
       * Returns the compass heading of aerial imagery. The heading value is measured in degrees (clockwise) from cardinal direction North.
       * @type number
       * @public
       */
    },
    {
      key: "getHeading",
      value: function getHeading() {
        return this.context[_constants.MAP].getHeading()
      },

      /**
       *
       * @type MapTypeId|string
       * @public
       */
    },
    {
      key: "getMapTypeId",
      value: function getMapTypeId() {
        return this.context[_constants.MAP].getMapTypeId()
      },

      /**
       * Returns the current `Projection`. If the map is not yet initialized (i.e. the mapType is still null) then the result is null. Listen to `projection_changed` and check its value to ensure it is not null.
       * @type ProjectionProjectionprojection_changed
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.context[_constants.MAP].getProjection()
      },

      /**
       * Returns the default `StreetViewPanorama` bound to the map, which may be a default panorama embedded within the map, or the panorama set using `setStreetView()`. Changes to the map's `streetViewControl` will be reflected in the display of such a bound panorama.
       * @type StreetViewPanoramaStreetViewPanoramasetStreetView()streetViewControl
       * @public
       */
    },
    {
      key: "getStreetView",
      value: function getStreetView() {
        return this.context[_constants.MAP].getStreetView()
      },

      /**
       * Returns the current angle of incidence of the map, in degrees from the viewport plane to the map plane. The result will be `0` for imagery taken directly overhead or `45` for 45° imagery. 45° imagery is only available for `satellite` and `hybrid` map types, within some locations, and at some zoom levels. **Note:** This method does not return the value set by `setTilt`. See `setTilt` for details.
       * @type number045satellitehybridsetTiltsetTilt
       * @public
       */
    },
    {
      key: "getTilt",
      value: function getTilt() {
        return this.context[_constants.MAP].getTilt()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return Map
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

Map.displayName = "GoogleMap"
Map.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapTypeRegistry
   * @type Array<[id:string, mapType:MapType|*]>
   */
  defaultExtraMapTypes: _propTypes2.default.arrayOf(
    _propTypes2.default.arrayOf(_propTypes2.default.any)
  ),

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultHeading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  defaultMapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  defaultStreetView: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultTilt: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  heading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  mapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  streetView: _propTypes2.default.any,

  /**
   * @type number
   */
  tilt: _propTypes2.default.number,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMapTypeIdChanged: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onTilesLoaded: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onHeadingChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIdle: _propTypes2.default.func,

  /**
   * function
   */
  onProjectionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onTiltChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
Map.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
var GoogleMap = (exports.GoogleMap = Map)

exports.default = Map

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMapTypeIdChanged: "maptypeid_changed",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onRightClick: "rightclick",
  onTilesLoaded: "tilesloaded",
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onProjectionChanged: "projection_changed",
  onResize: "resize",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  extraMapTypes: function extraMapTypes(instance, extra) {
    extra.forEach(function(it) {
      var _instance$mapTypes

      return (_instance$mapTypes = instance.mapTypes).set.apply(
        _instance$mapTypes,
        (0, _toConsumableArray3.default)(it)
      )
    })
  },
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  clickableIcons: function clickableIcons(instance, _clickableIcons) {
    instance.setClickableIcons(_clickableIcons)
  },
  heading: function heading(instance, _heading) {
    instance.setHeading(_heading)
  },
  mapTypeId: function mapTypeId(instance, _mapTypeId) {
    instance.setMapTypeId(_mapTypeId)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  streetView: function streetView(instance, _streetView) {
    instance.setStreetView(_streetView)
  },
  tilt: function tilt(instance, _tilt) {
    instance.setTilt(_tilt)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(409);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(410), __esModule: true };

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128);
__webpack_require__(411);
module.exports = __webpack_require__(18).Array.from;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(76);
var $export = __webpack_require__(23);
var toObject = __webpack_require__(38);
var call = __webpack_require__(412);
var isArrayIter = __webpack_require__(413);
var toLength = __webpack_require__(133);
var createProperty = __webpack_require__(414);
var getIterFn = __webpack_require__(415);

$export($export.S + $export.F * !__webpack_require__(417)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(32);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(40);
var ITERATOR = __webpack_require__(20)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(24);
var createDesc = __webpack_require__(39);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(416);
var ITERATOR = __webpack_require__(20)('iterator');
var Iterators = __webpack_require__(40);
module.exports = __webpack_require__(18).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(80);
var TAG = __webpack_require__(20)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(20)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(419),
    baseEach = __webpack_require__(158),
    baseIteratee = __webpack_require__(434),
    baseReduce = __webpack_require__(493),
    isArray = __webpack_require__(19);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(421),
    keys = __webpack_require__(56);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(422);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 422 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(424),
    isArguments = __webpack_require__(159),
    isArray = __webpack_require__(19),
    isBuffer = __webpack_require__(160),
    isIndex = __webpack_require__(53),
    isTypedArray = __webpack_require__(162);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    isObjectLike = __webpack_require__(36);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 426 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    isLength = __webpack_require__(92),
    isObjectLike = __webpack_require__(36);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 428 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(138);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(161)(module)))

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(163),
    nativeKeys = __webpack_require__(431);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(432);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(57);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(435),
    baseMatchesProperty = __webpack_require__(481),
    identity = __webpack_require__(41),
    isArray = __webpack_require__(19),
    property = __webpack_require__(490);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(436),
    getMatchData = __webpack_require__(480),
    matchesStrictComparable = __webpack_require__(168);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(164),
    baseIsEqual = __webpack_require__(165);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(59);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(59);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(59);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(59);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(58);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 444 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(58),
    Map = __webpack_require__(93),
    MapCache = __webpack_require__(94);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(448),
    ListCache = __webpack_require__(58),
    Map = __webpack_require__(93);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(449),
    hashDelete = __webpack_require__(450),
    hashGet = __webpack_require__(451),
    hashHas = __webpack_require__(452),
    hashSet = __webpack_require__(453);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(61);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(61);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(61);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(61);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(62);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 455 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(62);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(62);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(62);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(164),
    equalArrays = __webpack_require__(166),
    equalByTag = __webpack_require__(465),
    equalObjects = __webpack_require__(469),
    getTag = __webpack_require__(476),
    isArray = __webpack_require__(19),
    isBuffer = __webpack_require__(160),
    isTypedArray = __webpack_require__(162);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(94),
    setCacheAdd = __webpack_require__(461),
    setCacheHas = __webpack_require__(462);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 461 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 462 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    Uint8Array = __webpack_require__(466),
    eq = __webpack_require__(60),
    equalArrays = __webpack_require__(166),
    mapToArray = __webpack_require__(467),
    setToArray = __webpack_require__(468);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 467 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(470);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(471),
    getSymbols = __webpack_require__(473),
    keys = __webpack_require__(56);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(472),
    isArray = __webpack_require__(19);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 472 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(474),
    stubArray = __webpack_require__(475);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 474 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 475 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(477),
    Map = __webpack_require__(93),
    Promise = __webpack_require__(478),
    Set = __webpack_require__(479),
    WeakMap = __webpack_require__(143),
    baseGetTag = __webpack_require__(42),
    toSource = __webpack_require__(139);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(167),
    keys = __webpack_require__(56);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(165),
    get = __webpack_require__(482),
    hasIn = __webpack_require__(488),
    isKey = __webpack_require__(95),
    isStrictComparable = __webpack_require__(167),
    matchesStrictComparable = __webpack_require__(168),
    toKey = __webpack_require__(63);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(169);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(484);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(485);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(94);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    arrayMap = __webpack_require__(487),
    isArray = __webpack_require__(19),
    isSymbol = __webpack_require__(55);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(489),
    hasPath = __webpack_require__(172);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 489 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(491),
    basePropertyDeep = __webpack_require__(492),
    isKey = __webpack_require__(95),
    toKey = __webpack_require__(63);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 491 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(169);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 493 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(153),
    baseEach = __webpack_require__(158),
    castFunction = __webpack_require__(495),
    isArray = __webpack_require__(19);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(41);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(497);

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

module.exports = lowerFirst;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(498),
    hasUnicode = __webpack_require__(173),
    stringToArray = __webpack_require__(500),
    toString = __webpack_require__(171);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(499);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 499 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(501),
    hasUnicode = __webpack_require__(173),
    unicodeToArray = __webpack_require__(502);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 501 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(504),
    hasPath = __webpack_require__(172);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 504 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Circle = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Circle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Circle = (exports.Circle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Circle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
   */
  function Circle(props, context) {
    ;(0, _classCallCheck3.default)(this, Circle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Circle.__proto__ || (0, _getPrototypeOf2.default)(Circle)).call(
        this,
        props,
        context
      )
    )

    var circle = new google.maps.Circle()
    ;(0, _MapChildHelper.construct)(
      Circle.propTypes,
      updaterMap,
      _this.props,
      circle
    )
    circle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.CIRCLE, circle)
    return _this
  }

  ;(0, _createClass3.default)(Circle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.CIRCLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.CIRCLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var circle = this.state[_constants.CIRCLE]
        if (circle) {
          circle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this Circle.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.CIRCLE].getBounds()
      },

      /**
       * Returns the center of this circle.
       * @type LatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.state[_constants.CIRCLE].getCenter()
      },

      /**
       * Returns whether this circle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.CIRCLE].getDraggable()
      },

      /**
       * Returns whether this circle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.CIRCLE].getEditable()
      },

      /**
       * Returns the radius of this circle (in meters).
       * @type number
       * @public
       */
    },
    {
      key: "getRadius",
      value: function getRadius() {
        return this.state[_constants.CIRCLE].getRadius()
      },

      /**
       * Returns whether this circle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.CIRCLE].getVisible()
      },
    },
  ])
  return Circle
})(_react2.default.PureComponent))

Circle.propTypes = {
  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRadius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type number
   */
  radius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onRadiusChanged: _propTypes2.default.func,
}
Circle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Circle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onRadiusChanged: "radius_changed",
}

var updaterMap = {
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Marker = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _Marker$contextTypes /*
                           * -----------------------------------------------------------------------------
                           * This file is auto-generated from the corresponding file at `src/macros/`.
                           * Please **DO NOT** edit this file directly when creating PRs.
                           * -----------------------------------------------------------------------------
                           */
/* global google */

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Marker`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
 */
var Marker = (exports.Marker = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Marker, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
   */
  function Marker(props, context) {
    ;(0, _classCallCheck3.default)(this, Marker)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).call(
        this,
        props,
        context
      )
    )

    var marker = new google.maps.Marker()
    ;(0, _MapChildHelper.construct)(
      Marker.propTypes,
      updaterMap,
      _this.props,
      marker
    )
    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
    if (markerClusterer) {
      markerClusterer.addMarker(marker, !!_this.props.noRedraw)
    } else {
      marker.setMap(_this.context[_constants.MAP])
    }
    _this.state = (0, _defineProperty3.default)({}, _constants.MARKER, marker)
    return _this
  }

  ;(0, _createClass3.default)(Marker, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.ANCHOR,
          this.context[_constants.ANCHOR] || this.state[_constants.MARKER]
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.MARKER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.MARKER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var marker = this.state[_constants.MARKER]
        if (marker) {
          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
          if (markerClusterer) {
            markerClusterer.removeMarker(marker, !!this.props.noRedraw)
          }
          marker.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       *
       * @type Animation
       * @public
       */
    },
    {
      key: "getAnimation",
      value: function getAnimation() {
        return this.state[_constants.MARKER].getAnimation()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickable",
      value: function getClickable() {
        return this.state[_constants.MARKER].getClickable()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getCursor",
      value: function getCursor() {
        return this.state[_constants.MARKER].getCursor()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.MARKER].getDraggable()
      },

      /**
       *
       * @type string|Icon|Symbol
       * @public
       */
    },
    {
      key: "getIcon",
      value: function getIcon() {
        return this.state[_constants.MARKER].getIcon()
      },

      /**
       *
       * @type MarkerLabel
       * @public
       */
    },
    {
      key: "getLabel",
      value: function getLabel() {
        return this.state[_constants.MARKER].getLabel()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.MARKER].getOpacity()
      },

      /**
       *
       * @type MarkerPlace
       * @public
       */
    },
    {
      key: "getPlace",
      value: function getPlace() {
        return this.state[_constants.MARKER].getPlace()
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.MARKER].getPosition()
      },

      /**
       *
       * @type MarkerShape
       * @public
       */
    },
    {
      key: "getShape",
      value: function getShape() {
        return this.state[_constants.MARKER].getShape()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getTitle",
      value: function getTitle() {
        return this.state[_constants.MARKER].getTitle()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.MARKER].getVisible()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.MARKER].getZIndex()
      },
    },
  ])
  return Marker
})(_react2.default.PureComponent))

Marker.propTypes = {
  /**
   * For the 2nd argument of `MarkerCluster#addMarker`
   * @see https://github.com/mikesaidani/marker-clusterer-plus
   */
  noRedraw: _propTypes2.default.bool,

  /**
   * @type Animation
   */
  defaultAnimation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  defaultCursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  defaultIcon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  defaultLabel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  defaultPlace: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  defaultShape: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultTitle: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type Animation
   */
  animation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  cursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  icon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  label: _propTypes2.default.any,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  place: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  shape: _propTypes2.default.any,

  /**
   * @type string
   */
  title: _propTypes2.default.string,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onAnimationChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onClickableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCursorChanged: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onDraggableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onFlatChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIconChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onShapeChanged: _propTypes2.default.func,

  /**
   * function
   */
  onTitleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
Marker.contextTypes = ((_Marker$contextTypes = {}),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MARKER_CLUSTERER,
  _propTypes2.default.object
),
_Marker$contextTypes)
Marker.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.ANCHOR,
  _propTypes2.default.object
)
exports.default = Marker

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDrag: "drag",
  onDraggableChanged: "draggable_changed",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onPositionChanged: "position_changed",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation)
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable)
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon)
  },
  label: function label(instance, _label) {
    instance.setLabel(_label)
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  place: function place(instance, _place) {
    instance.setPlace(_place)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape)
  },
  title: function title(instance, _title) {
    instance.setTitle(_title)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polyline = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polyline`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polyline = (exports.Polyline = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polyline, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
   */
  function Polyline(props, context) {
    ;(0, _classCallCheck3.default)(this, Polyline)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polyline.__proto__ || (0, _getPrototypeOf2.default)(Polyline)).call(
        this,
        props,
        context
      )
    )

    var polyline = new google.maps.Polyline()
    ;(0, _MapChildHelper.construct)(
      Polyline.propTypes,
      updaterMap,
      _this.props,
      polyline
    )
    polyline.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.POLYLINE,
      polyline
    )
    return _this
  }

  ;(0, _createClass3.default)(Polyline, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYLINE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYLINE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polyline = this.state[_constants.POLYLINE]
        if (polyline) {
          polyline.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYLINE].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYLINE].getEditable()
      },

      /**
       * Retrieves the path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYLINE].getPath()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYLINE].getVisible()
      },
    },
  ])
  return Polyline
})(_react2.default.PureComponent))

Polyline.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polyline.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polyline

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polygon = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polygon`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polygon = (exports.Polygon = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polygon, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
   */
  function Polygon(props, context) {
    ;(0, _classCallCheck3.default)(this, Polygon)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polygon.__proto__ || (0, _getPrototypeOf2.default)(Polygon)).call(
        this,
        props,
        context
      )
    )

    var polygon = new google.maps.Polygon()
    ;(0, _MapChildHelper.construct)(
      Polygon.propTypes,
      updaterMap,
      _this.props,
      polygon
    )
    polygon.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.POLYGON, polygon)
    return _this
  }

  ;(0, _createClass3.default)(Polygon, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYGON],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYGON],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polygon = this.state[_constants.POLYGON]
        if (polygon) {
          polygon.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYGON].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYGON].getEditable()
      },

      /**
       * Retrieves the first path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYGON].getPath()
      },

      /**
       * Retrieves the paths for this polygon.
       * @type MVCArray<MVCArray<LatLng>>
       * @public
       */
    },
    {
      key: "getPaths",
      value: function getPaths() {
        return this.state[_constants.POLYGON].getPaths()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYGON].getVisible()
      },
    },
  ])
  return Polygon
})(_react2.default.PureComponent))

Polygon.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  defaultPaths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  paths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polygon.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polygon

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Rectangle = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Rectangle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Rectangle = (exports.Rectangle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Rectangle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
   */
  function Rectangle(props, context) {
    ;(0, _classCallCheck3.default)(this, Rectangle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Rectangle.__proto__ || (0, _getPrototypeOf2.default)(Rectangle)).call(
        this,
        props,
        context
      )
    )

    var rectangle = new google.maps.Rectangle()
    ;(0, _MapChildHelper.construct)(
      Rectangle.propTypes,
      updaterMap,
      _this.props,
      rectangle
    )
    rectangle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.RECTANGLE,
      rectangle
    )
    return _this
  }

  ;(0, _createClass3.default)(Rectangle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var rectangle = this.state[_constants.RECTANGLE]
        if (rectangle) {
          rectangle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the bounds of this rectangle.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.RECTANGLE].getBounds()
      },

      /**
       * Returns whether this rectangle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.RECTANGLE].getDraggable()
      },

      /**
       * Returns whether this rectangle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.RECTANGLE].getEditable()
      },

      /**
       * Returns whether this rectangle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.RECTANGLE].getVisible()
      },
    },
  ])
  return Rectangle
})(_react2.default.PureComponent))

Rectangle.propTypes = {
  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  defaultBounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  bounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Rectangle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Rectangle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onBoundsChanged: "bounds_changed",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.InfoWindow = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _InfoWindow$contextTy /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(13)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(155)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(65)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.InfoWindow`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
 */
var InfoWindow = (exports.InfoWindow = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(InfoWindow, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
   */
  function InfoWindow(props, context) {
    ;(0, _classCallCheck3.default)(this, InfoWindow)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (InfoWindow.__proto__ || (0, _getPrototypeOf2.default)(InfoWindow)).call(
        this,
        props,
        context
      )
    )

    var infoWindow = new google.maps.InfoWindow()
    ;(0, _MapChildHelper.construct)(
      InfoWindow.propTypes,
      updaterMap,
      _this.props,
      infoWindow
    )
    infoWindow.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.INFO_WINDOW,
      infoWindow
    )
    return _this
  }

  ;(0, _createClass3.default)(InfoWindow, [
    {
      key: "componentWillMount",
      value: function componentWillMount() {
        if (!_canUseDom2.default || this.containerElement) {
          return
        }
        if (_react2.default.version.match(/^16/)) {
          this.containerElement = document.createElement("div")
        }
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap
        )
        if (_react2.default.version.match(/^16/)) {
          this.state[_constants.INFO_WINDOW].setContent(this.containerElement)
          open(
            this.state[_constants.INFO_WINDOW],
            this.context[_constants.ANCHOR]
          )
          return
        }
        var content = document.createElement("div")
        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          content
        )
        this.state[_constants.INFO_WINDOW].setContent(content)
        open(
          this.state[_constants.INFO_WINDOW],
          this.context[_constants.ANCHOR]
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap,
          updaterMap,
          prevProps
        )
        if (_react2.default.version.match(/^16/)) {
          return
        }
        if (this.props.children !== prevProps.children) {
          _reactDom2.default.unstable_renderSubtreeIntoContainer(
            this,
            _react2.default.Children.only(this.props.children),
            this.state[_constants.INFO_WINDOW].getContent()
          )
        }
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var infoWindow = this.state[_constants.INFO_WINDOW]
        if (infoWindow) {
          if (
            !_react2.default.version.match(/^16/) &&
            infoWindow.getContent()
          ) {
            _reactDom2.default.unmountComponentAtNode(infoWindow.getContent())
          }
          infoWindow.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        if (_react2.default.version.match(/^16/)) {
          return _reactDom2.default.createPortal(
            _react2.default.Children.only(this.props.children),
            this.containerElement
          )
        }
        return false
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.INFO_WINDOW].getPosition()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.INFO_WINDOW].getZIndex()
      },
    },
  ])
  return InfoWindow
})(_react2.default.PureComponent))

InfoWindow.propTypes = {
  /**
   * @type InfoWindowOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type InfoWindowOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onDomReady: _propTypes2.default.func,

  /**
   * function
   */
  onContentChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
InfoWindow.contextTypes = ((_InfoWindow$contextTy = {}),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_InfoWindow$contextTy)
exports.default = InfoWindow

var open = function open(infoWindow, anchor) {
  if (anchor) {
    infoWindow.open(infoWindow.getMap(), anchor)
  } else if (infoWindow.getPosition()) {
    infoWindow.open(infoWindow.getMap())
  } else {
    ;(0, _invariant2.default)(
      false,
      "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."
    )
  }
}

var eventMap = {
  onCloseClick: "closeclick",
  onDomReady: "domready",
  onContentChanged: "content_changed",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.OverlayView = undefined

var _extends2 = __webpack_require__(512)

var _extends3 = _interopRequireDefault(_extends2)

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _delay2 = __webpack_require__(517)

var _delay3 = _interopRequireDefault(_delay2)

var _assign2 = __webpack_require__(519)

var _assign3 = _interopRequireDefault(_assign2)

var _bind2 = __webpack_require__(49)

var _bind3 = _interopRequireDefault(_bind2)

var _OverlayView$contextT /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(13)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(65)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _OverlayViewHelper = __webpack_require__(523)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.OverlayView`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
 */
var OverlayView = (exports.OverlayView = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(OverlayView, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  function OverlayView(props, context) {
    ;(0, _classCallCheck3.default)(this, OverlayView)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        OverlayView.__proto__ || (0, _getPrototypeOf2.default)(OverlayView)
      ).call(this, props, context)
    )

    var overlayView = new google.maps.OverlayView()
    // You must implement three methods: onAdd(), draw(), and onRemove().
    overlayView.onAdd = (0, _bind3.default)(_this.onAdd, _this)
    overlayView.draw = (0, _bind3.default)(_this.draw, _this)
    overlayView.onRemove = (0, _bind3.default)(_this.onRemove, _this)
    _this.onPositionElement = (0, _bind3.default)(
      _this.onPositionElement,
      _this
    )
    // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
    overlayView.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.OVERLAY_VIEW,
      overlayView
    )
    return _this
  }

  ;(0, _createClass3.default)(OverlayView, [
    {
      key: "onAdd",
      value: function onAdd() {
        this.containerElement = document.createElement("div")
        this.containerElement.style.position = "absolute"
      },
    },
    {
      key: "draw",
      value: function draw() {
        var mapPaneName = this.props.mapPaneName

        ;(0, _invariant2.default)(
          !!mapPaneName,
          "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s",
          mapPaneName
        )
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
        var mapPanes = this.state[_constants.OVERLAY_VIEW].getPanes()
        mapPanes[mapPaneName].appendChild(this.containerElement)

        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          this.containerElement,
          this.onPositionElement
        )
      },
    },
    {
      key: "onPositionElement",
      value: function onPositionElement() {
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
        var mapCanvasProjection = this.state[
          _constants.OVERLAY_VIEW
        ].getProjection()

        var offset = (0, _extends3.default)(
          {
            x: 0,
            y: 0,
          },
          (0, _OverlayViewHelper.getOffsetOverride)(
            this.containerElement,
            this.props
          )
        )
        var layoutStyles = (0, _OverlayViewHelper.getLayoutStyles)(
          mapCanvasProjection,
          offset,
          this.props
        )
        ;(0, _assign3.default)(this.containerElement.style, layoutStyles)
      },
    },
    {
      key: "onRemove",
      value: function onRemove() {
        this.containerElement.parentNode.removeChild(this.containerElement)
        _reactDom2.default.unmountComponentAtNode(this.containerElement)
        this.containerElement = null
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap,
          updaterMap,
          prevProps
        )
        ;(0, _delay3.default)(this.state[_constants.OVERLAY_VIEW].draw)
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var overlayView = this.state[_constants.OVERLAY_VIEW]
        if (overlayView) {
          overlayView.setMap(null)
          // You must implement three methods: onAdd(), draw(), and onRemove().
          overlayView.onAdd = null
          overlayView.draw = null
          overlayView.onRemove = null
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the panes in which this OverlayView can be rendered. The panes are not initialized until `onAdd` is called by the API.
       * @type MapPanesonAdd
       * @public
       */
    },
    {
      key: "getPanes",
      value: function getPanes() {
        return this.state[_constants.OVERLAY_VIEW].getPanes()
      },

      /**
       * Returns the `MapCanvasProjection` object associated with this `OverlayView`. The projection is not initialized until `onAdd` is called by the API.
       * @type MapCanvasProjectionMapCanvasProjectionOverlayViewonAdd
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.state[_constants.OVERLAY_VIEW].getProjection()
      },
    },
  ])
  return OverlayView
})(_react2.default.PureComponent))

OverlayView.FLOAT_PANE = "floatPane"
OverlayView.MAP_PANE = "mapPane"
OverlayView.MARKER_LAYER = "markerLayer"
OverlayView.OVERLAY_LAYER = "overlayLayer"
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget"
OverlayView.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  mapPaneName: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  position: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  bounds: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  getPixelPositionOffset: _propTypes2.default.func,
}
OverlayView.contextTypes = ((_OverlayView$contextT = {}),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_OverlayView$contextT)
exports.default = OverlayView

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(513);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(514), __esModule: true };

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(515);
module.exports = __webpack_require__(18).Object.assign;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(23);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(516) });


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(25);
var getKeys = __webpack_require__(47);
var gOPS = __webpack_require__(85);
var pIE = __webpack_require__(48);
var toObject = __webpack_require__(38);
var IObject = __webpack_require__(132);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(34)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(518),
    baseRest = __webpack_require__(86),
    toNumber = __webpack_require__(154);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(174),
    copyObject = __webpack_require__(520),
    createAssigner = __webpack_require__(521),
    isArrayLike = __webpack_require__(57),
    isPrototype = __webpack_require__(163),
    keys = __webpack_require__(56);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(174),
    baseAssignValue = __webpack_require__(175);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(86),
    isIterateeCall = __webpack_require__(522);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(60),
    isArrayLike = __webpack_require__(57),
    isIndex = __webpack_require__(53),
    isObject = __webpack_require__(28);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _isFunction2 = __webpack_require__(50)

var _isFunction3 = _interopRequireDefault(_isFunction2)

exports.getOffsetOverride = getOffsetOverride
exports.getLayoutStyles = getLayoutStyles

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function getOffsetOverride(containerElement, props) {
  var getPixelPositionOffset = props.getPixelPositionOffset
  //
  // Allows the component to control the visual position of the OverlayView
  // relative to the LatLng pixel position.
  //

  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
    return getPixelPositionOffset(
      containerElement.offsetWidth,
      containerElement.offsetHeight
    )
  } else {
    return {}
  }
}

function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng)
}

function createLatLngBounds(inst, Type) {
  return new Type(
    new google.maps.LatLng(inst.ne.lat, inst.ne.lng),
    new google.maps.LatLng(inst.sw.lat, inst.sw.lng)
  )
}

function ensureOfType(inst, type, factory) {
  if (inst instanceof type) {
    return inst
  } else {
    return factory(inst, type)
  }
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast())
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest())
  if (ne && sw) {
    return {
      left: sw.x + offset.x + "px",
      top: ne.y + offset.y + "px",
      width: ne.x - sw.x - offset.x + "px",
      height: sw.y - ne.y - offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection.fromLatLngToDivPixel(position)
  if (point) {
    var x = point.x,
      y = point.y

    return {
      left: x + offset.x + "px",
      top: y + offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStyles(mapCanvasProjection, offset, props) {
  if (props.bounds) {
    var bounds = ensureOfType(
      props.bounds,
      google.maps.LatLngBounds,
      createLatLngBounds
    )
    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds)
  } else {
    var position = ensureOfType(
      props.position,
      google.maps.LatLng,
      createLatLng
    )
    return getLayoutStylesByPosition(mapCanvasProjection, offset, position)
  }
}


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GroundOverlay = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _warning = __webpack_require__(157)

var _warning2 = _interopRequireDefault(_warning)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.GroundOverlay`
 *
 * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
 */
var GroundOverlay = (exports.GroundOverlay = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(GroundOverlay, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#GroundOverlay
   */
  function GroundOverlay(props, context) {
    ;(0, _classCallCheck3.default)(this, GroundOverlay)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        GroundOverlay.__proto__ || (0, _getPrototypeOf2.default)(GroundOverlay)
      ).call(this, props, context)
    )

    ;(0, _warning2.default)(
      !props.url || !props.bounds,
      "\nFor GroundOveray, url and bounds are passed in to constructor and are immutable\n after iinstantiated. This is the behavior of Google Maps JavaScript API v3 (\n See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay)\n Hence, use the corresponding two props provided by `react-google-maps`.\n They're prefixed with _default_ (defaultUrl, defaultBounds).\n\n In some cases, you'll need the GroundOverlay component to reflect the changes\n of url and bounds. You can leverage the React's key property to remount the\n component. Typically, just `key={url}` would serve your need.\n See https://github.com/tomchentw/react-google-maps/issues/655\n"
    )
    var groundOverlay = new google.maps.GroundOverlay(
      props.defaultUrl || props.url,
      props.defaultBounds || props.bounds
    )
    ;(0, _MapChildHelper.construct)(
      GroundOverlay.propTypes,
      updaterMap,
      _this.props,
      groundOverlay
    )
    groundOverlay.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.GROUND_LAYER,
      groundOverlay
    )
    return _this
  }

  ;(0, _createClass3.default)(GroundOverlay, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var GroundOverlay = this.state[_constants.GROUND_LAYER]
        if (GroundOverlay) {
          GroundOverlay.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this overlay.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.GROUND_LAYER].getBounds()
      },

      /**
       * Returns the opacity of this ground overlay.
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.GROUND_LAYER].getOpacity()
      },

      /**
       * Gets the url of the projected image.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.GROUND_LAYER].getUrl()
      },
    },
  ])
  return GroundOverlay
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */
/* global google */

GroundOverlay.propTypes = {
  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string /* v10.0.0 .isRequired */ /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   */,

  defaultBounds: _propTypes2.default.object /* v10.0.0 .isRequired */ /**
   * @type string
   * @deprecated use `defaultUrl` instead. It will be removed in v10.0.0
   */,

  url: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   * @deprecated use `defaultBounds` instead. It will be removed in v10.0.0
   */
  bounds: _propTypes2.default.object,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
GroundOverlay.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = GroundOverlay

var eventMap = {
  onDblClick: "dblclick",
  onClick: "click",
}

var updaterMap = {
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
}


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.DirectionsRenderer = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.DirectionsRenderer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var DirectionsRenderer = (exports.DirectionsRenderer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(DirectionsRenderer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
   */
  function DirectionsRenderer(props, context) {
    ;(0, _classCallCheck3.default)(this, DirectionsRenderer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        DirectionsRenderer.__proto__ ||
        (0, _getPrototypeOf2.default)(DirectionsRenderer)
      ).call(this, props, context)
    )

    var directionsRenderer = new google.maps.DirectionsRenderer()
    ;(0, _MapChildHelper.construct)(
      DirectionsRenderer.propTypes,
      updaterMap,
      _this.props,
      directionsRenderer
    )
    directionsRenderer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.DIRECTIONS_RENDERER,
      directionsRenderer
    )
    return _this
  }

  ;(0, _createClass3.default)(DirectionsRenderer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var directionsRenderer = this.state[_constants.DIRECTIONS_RENDERER]
        if (directionsRenderer) {
          directionsRenderer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the renderer's current set of directions.
       * @type DirectionsResult
       * @public
       */
    },
    {
      key: "getDirections",
      value: function getDirections() {
        return this.state[_constants.DIRECTIONS_RENDERER].getDirections()
      },

      /**
       * Returns the panel `<div>` in which the `DirectionsResult` is rendered.
       * @type Node<div>DirectionsResult
       * @public
       */
    },
    {
      key: "getPanel",
      value: function getPanel() {
        return this.state[_constants.DIRECTIONS_RENDERER].getPanel()
      },

      /**
       * Returns the current (zero-based) route index in use by this `DirectionsRenderer` object.
       * @type numberDirectionsRenderer
       * @public
       */
    },
    {
      key: "getRouteIndex",
      value: function getRouteIndex() {
        return this.state[_constants.DIRECTIONS_RENDERER].getRouteIndex()
      },
    },
  ])
  return DirectionsRenderer
})(_react2.default.PureComponent))

DirectionsRenderer.propTypes = {
  /**
   * @type DirectionsResult
   */
  defaultDirections: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type Node
   */
  defaultPanel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRouteIndex: _propTypes2.default.number,

  /**
   * @type DirectionsResult
   */
  directions: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type Node
   */
  panel: _propTypes2.default.any,

  /**
   * @type number
   */
  routeIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDirectionsChanged: _propTypes2.default.func,
}
DirectionsRenderer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = DirectionsRenderer

var eventMap = {
  onDirectionsChanged: "directions_changed",
}

var updaterMap = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel)
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex)
  },
}


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.FusionTablesLayer = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.FusionTablesLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var FusionTablesLayer = (exports.FusionTablesLayer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(FusionTablesLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
   */
  function FusionTablesLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, FusionTablesLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        FusionTablesLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(FusionTablesLayer)
      ).call(this, props, context)
    )

    var fusionTablesLayer = new google.maps.FusionTablesLayer()
    ;(0, _MapChildHelper.construct)(
      FusionTablesLayer.propTypes,
      updaterMap,
      _this.props,
      fusionTablesLayer
    )
    fusionTablesLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.FUSION_TABLES_LAYER,
      fusionTablesLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(FusionTablesLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var fusionTablesLayer = this.state[_constants.FUSION_TABLES_LAYER]
        if (fusionTablesLayer) {
          fusionTablesLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return FusionTablesLayer
})(_react2.default.PureComponent))

FusionTablesLayer.propTypes = {
  /**
   * @type FusionTablesLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type FusionTablesLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
FusionTablesLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = FusionTablesLayer

var eventMap = {
  onClick: "click",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.KmlLayer = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.KmlLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var KmlLayer = (exports.KmlLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(KmlLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
   */
  function KmlLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, KmlLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (KmlLayer.__proto__ || (0, _getPrototypeOf2.default)(KmlLayer)).call(
        this,
        props,
        context
      )
    )

    var kmlLayer = new google.maps.KmlLayer()
    ;(0, _MapChildHelper.construct)(
      KmlLayer.propTypes,
      updaterMap,
      _this.props,
      kmlLayer
    )
    kmlLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.KML_LAYER,
      kmlLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(KmlLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var kmlLayer = this.state[_constants.KML_LAYER]
        if (kmlLayer) {
          kmlLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Get the default viewport for the layer being displayed.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getDefaultViewport",
      value: function getDefaultViewport() {
        return this.state[_constants.KML_LAYER].getDefaultViewport()
      },

      /**
       * Get the metadata associated with this layer, as specified in the layer markup.
       * @type KmlLayerMetadata
       * @public
       */
    },
    {
      key: "getMetadata",
      value: function getMetadata() {
        return this.state[_constants.KML_LAYER].getMetadata()
      },

      /**
       * Get the status of the layer, set once the requested document has loaded.
       * @type KmlLayerStatus
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.state[_constants.KML_LAYER].getStatus()
      },

      /**
       * Gets the URL of the KML file being displayed.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.KML_LAYER].getUrl()
      },

      /**
       * Gets the z-index of the KML Layer.
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.KML_LAYER].getZIndex()
      },
    },
  ])
  return KmlLayer
})(_react2.default.PureComponent))

KmlLayer.propTypes = {
  /**
   * @type KmlLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type KmlLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  url: _propTypes2.default.string,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDefaultViewportChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,
}
KmlLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = KmlLayer

var eventMap = {
  onDefaultViewportChanged: "defaultviewport_changed",
  onClick: "click",
  onStatusChanged: "status_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  url: function url(instance, _url) {
    instance.setUrl(_url)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.TrafficLayer = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.TrafficLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var TrafficLayer = (exports.TrafficLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(TrafficLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
   */
  function TrafficLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, TrafficLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        TrafficLayer.__proto__ || (0, _getPrototypeOf2.default)(TrafficLayer)
      ).call(this, props, context)
    )

    var trafficLayer = new google.maps.TrafficLayer()
    ;(0, _MapChildHelper.construct)(
      TrafficLayer.propTypes,
      updaterMap,
      _this.props,
      trafficLayer
    )
    trafficLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.TRAFFIC_LAYER,
      trafficLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(TrafficLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var trafficLayer = this.state[_constants.TRAFFIC_LAYER]
        if (trafficLayer) {
          trafficLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return TrafficLayer
})(_react2.default.PureComponent))

TrafficLayer.propTypes = {
  /**
   * @type TrafficLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type TrafficLayerOptions
   */
  options: _propTypes2.default.any,
}
TrafficLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = TrafficLayer

var eventMap = {}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.StreetViewPanorama = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(13)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.StreetViewPanorama`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
 */
var StreetViewPanorama = (exports.StreetViewPanorama = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(StreetViewPanorama, _React$PureComponent)

  function StreetViewPanorama(props, context) {
    ;(0, _classCallCheck3.default)(this, StreetViewPanorama)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        StreetViewPanorama.__proto__ ||
        (0, _getPrototypeOf2.default)(StreetViewPanorama)
      ).call(this, props, context)
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you render <StreetViewPanorama> as a child of <GoogleMap> with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      StreetViewPanorama.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP].getStreetView()
    )
    return _this
  }

  ;(0, _createClass3.default)(StreetViewPanorama, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.MAP,
          this.context[_constants.MAP].getStreetView()
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var streetViewPanorama = this.context[_constants.MAP].getStreetView()
        if (streetViewPanorama) {
          streetViewPanorama.setVisible(false)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the set of navigation links for the Street View panorama.
       * @type Array<StreetViewLink>
       * @public
       */
    },
    {
      key: "getLinks",
      value: function getLinks() {
        return this.context[_constants.MAP].getLinks()
      },

      /**
       * Returns the StreetViewLocation of the current panorama.
       * @type StreetViewLocation
       * @public
       */
    },
    {
      key: "getLocation",
      value: function getLocation() {
        return this.context[_constants.MAP].getLocation()
      },

      /**
       * Returns the state of motion tracker. If true when the user physically moves the device and the browser supports it, the Street View Panorama tracks the physical movements.
       * @type boolean
       * @public
       */
    },
    {
      key: "getMotionTracking",
      value: function getMotionTracking() {
        return this.context[_constants.MAP].getMotionTracking()
      },

      /**
       * Returns the current panorama ID for the Street View panorama. This id is stable within the browser's current session only.
       * @type string
       * @public
       */
    },
    {
      key: "getPano",
      value: function getPano() {
        return this.context[_constants.MAP].getPano()
      },

      /**
       * Returns the heading and pitch of the photographer when this panorama was taken. For Street View panoramas on the road, this also reveals in which direction the car was travelling. This data is available after the `pano_changed` event.
       * @type StreetViewPovpano_changed
       * @public
       */
    },
    {
      key: "getPhotographerPov",
      value: function getPhotographerPov() {
        return this.context[_constants.MAP].getPhotographerPov()
      },

      /**
       * Returns the current `LatLng` position for the Street View panorama.
       * @type LatLngLatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.context[_constants.MAP].getPosition()
      },

      /**
       * Returns the current point of view for the Street View panorama.
       * @type StreetViewPov
       * @public
       */
    },
    {
      key: "getPov",
      value: function getPov() {
        return this.context[_constants.MAP].getPov()
      },

      /**
       * Returns the status of the panorama on completion of the `setPosition()` or `setPano()` request.
       * @type StreetViewStatussetPosition()setPano()
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.context[_constants.MAP].getStatus()
      },

      /**
       * Returns `true` if the panorama is visible. It does not specify whether Street View imagery is available at the specified position.
       * @type booleantrue
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.context[_constants.MAP].getVisible()
      },

      /**
       * Returns the zoom level of the panorama. Fully zoomed-out is level 0, where the field of view is 180 degrees. Zooming in increases the zoom level.
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return StreetViewPanorama
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

StreetViewPanorama.propTypes = {
  /**
   * @type Array<StreetViewLink>
   */
  defaultLinks: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultMotionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultPano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  defaultPov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type Array<StreetViewLink>
   */
  links: _propTypes2.default.any,

  /**
   * @type boolean
   */
  motionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  pano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  pov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onPanoChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPovChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
StreetViewPanorama.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
StreetViewPanorama.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = StreetViewPanorama

var eventMap = {
  onCloseClick: "closeclick",
  onPanoChanged: "pano_changed",
  onPositionChanged: "position_changed",
  onPovChanged: "pov_changed",
  onResize: "resize",
  onStatusChanged: "status_changed",
  onVisibleChanged: "visible_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  links: function links(instance, _links) {
    instance.setLinks(_links)
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.BicyclingLayer = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.BicyclingLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var BicyclingLayer = (exports.BicyclingLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(BicyclingLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
   */
  function BicyclingLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, BicyclingLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        BicyclingLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(BicyclingLayer)
      ).call(this, props, context)
    )

    var bicyclingLayer = new google.maps.BicyclingLayer()
    ;(0, _MapChildHelper.construct)(
      BicyclingLayer.propTypes,
      updaterMap,
      _this.props,
      bicyclingLayer
    )
    bicyclingLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.BICYCLING_LAYER,
      bicyclingLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(BicyclingLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var bicyclingLayer = this.state[_constants.BICYCLING_LAYER]
        if (bicyclingLayer) {
          bicyclingLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return BicyclingLayer
})(_react2.default.PureComponent))

BicyclingLayer.propTypes = {}
BicyclingLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = BicyclingLayer

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.MarkerClusterer = undefined

var _defineProperty2 = __webpack_require__(10)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(5)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(6)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(7)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(8)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(9)

var _inherits3 = _interopRequireDefault(_inherits2)

var _MarkerClusterer$chil

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _markerClustererPlus = __webpack_require__(532)

var _markerClustererPlus2 = _interopRequireDefault(_markerClustererPlus)

var _MapChildHelper = __webpack_require__(12)

var _constants = __webpack_require__(11)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `MarkerClusterer`
 *
 * @see https://github.com/mahnunchik/markerclustererplus/blob/master/docs/reference.html
 */
var MarkerClusterer = (exports.MarkerClusterer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(MarkerClusterer, _React$PureComponent)

  /*
   * @see https://github.com/mahnunchik/markerclustererplus/blob/master/docs/reference.html
   */
  function MarkerClusterer(props, context) {
    ;(0, _classCallCheck3.default)(this, MarkerClusterer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        MarkerClusterer.__proto__ ||
        (0, _getPrototypeOf2.default)(MarkerClusterer)
      ).call(this, props, context)
    )

    var markerClusterer = new _markerClustererPlus2.default()
    ;(0, _MapChildHelper.construct)(
      MarkerClusterer.propTypes,
      updaterMap,
      _this.props,
      markerClusterer
    )
    markerClusterer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.MARKER_CLUSTERER,
      markerClusterer
    )
    return _this
  }

  ;(0, _createClass3.default)(MarkerClusterer, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        var _ref

        var markerClusterer = this.state[_constants.MARKER_CLUSTERER]
        return (
          (_ref = {}),
          (0, _defineProperty3.default)(
            _ref,
            _constants.ANCHOR,
            markerClusterer
          ),
          (0, _defineProperty3.default)(
            _ref,
            _constants.MARKER_CLUSTERER,
            markerClusterer
          ),
          _ref
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.MARKER_CLUSTERER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.MARKER_CLUSTERER],
          eventMap,
          updaterMap,
          prevProps
        )
        this.state[_constants.MARKER_CLUSTERER].repaint()
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var markerClusterer = this.state[_constants.MARKER_CLUSTERER]
        if (markerClusterer) {
          markerClusterer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },
    },
  ])
  return MarkerClusterer
})(_react2.default.PureComponent))

MarkerClusterer.propTypes = {
  /**
   * @type boolean
   */
  defaultAverageCenter: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultBatchSizeIE: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultBatchSize: _propTypes2.default.number,

  /**
   * @type function
   */
  defaultCalculator: _propTypes2.default.func,

  /**
   * @type string
   */
  defaultClusterClass: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultEnableRetinaIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultGridSize: _propTypes2.default.number,

  /**
   * @type boolean
   */
  defaultIgnoreHidden: _propTypes2.default.bool,

  /**
   * @type string
   */
  defaultImageExtension: _propTypes2.default.string,

  /**
   * @type string
   */
  defaultImagePath: _propTypes2.default.string,

  /**
   * @type Array
   */
  defaultImageSizes: _propTypes2.default.array,

  /**
   * @type number
   */
  defaultMaxZoom: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultMinimumClusterSize: _propTypes2.default.number,

  /**
   * @type Array
   */
  defaultStyles: _propTypes2.default.array,

  /**
   * @type string
   */
  defaultTitle: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultZoomOnClick: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  averageCenter: _propTypes2.default.bool,

  /**
   * @type number
   */
  batchSizeIE: _propTypes2.default.number,

  /**
   * @type number
   */
  batchSize: _propTypes2.default.number,

  /**
   * @type function
   */
  calculator: _propTypes2.default.func,

  /**
   * @type string
   */
  clusterClass: _propTypes2.default.string,

  /**
   * @type boolean
   */
  enableRetinaIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  gridSize: _propTypes2.default.number,

  /**
   * @type boolean
   */
  ignoreHidden: _propTypes2.default.bool,

  /**
   * @type string
   */
  imageExtension: _propTypes2.default.string,

  /**
   * @type string
   */
  imagePath: _propTypes2.default.string,

  /**
   * @type Array
   */
  imageSizes: _propTypes2.default.array,

  /**
   * @type number
   */
  maxZoom: _propTypes2.default.number,

  /**
   * @type number
   */
  minimumClusterSize: _propTypes2.default.number,

  /**
   * @type Array
   */
  styles: _propTypes2.default.array,

  /**
   * @type string
   */
  title: _propTypes2.default.string,

  /**
   * @type boolean
   */
  zoomOnClick: _propTypes2.default.bool,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onClusteringBegin: _propTypes2.default.func,

  /**
   * function
   */
  onClusteringEnd: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,
}
MarkerClusterer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
MarkerClusterer.childContextTypes = ((_MarkerClusterer$chil = {}),
(0, _defineProperty3.default)(
  _MarkerClusterer$chil,
  _constants.ANCHOR,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _MarkerClusterer$chil,
  _constants.MARKER_CLUSTERER,
  _propTypes2.default.object
),
_MarkerClusterer$chil)
exports.default = MarkerClusterer

var eventMap = {
  onClick: "click",
  onClusteringBegin: "clusteringbegin",
  onClusteringEnd: "clusteringend",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
}

var updaterMap = {
  averageCenter: function averageCenter(instance, _averageCenter) {
    instance.setAverageCenter(_averageCenter)
  },
  batchSizeIE: function batchSizeIE(instance, _batchSizeIE) {
    instance.setBatchSizeIE(_batchSizeIE)
  },
  batchSize: function batchSize(instance, _batchSize) {
    instance.setBatchSize(_batchSize)
  },
  calculator: function calculator(instance, _calculator) {
    instance.setCalculator(_calculator)
  },
  clusterClass: function clusterClass(instance, _clusterClass) {
    instance.setClusterClass(_clusterClass)
  },
  enableRetinaIcons: function enableRetinaIcons(instance, _enableRetinaIcons) {
    instance.setEnableRetinaIcons(_enableRetinaIcons)
  },
  gridSize: function gridSize(instance, _gridSize) {
    instance.setGridSize(_gridSize)
  },
  ignoreHidden: function ignoreHidden(instance, _ignoreHidden) {
    instance.setIgnoreHidden(_ignoreHidden)
  },
  imageExtension: function imageExtension(instance, _imageExtension) {
    instance.setImageExtension(_imageExtension)
  },
  imagePath: function imagePath(instance, _imagePath) {
    instance.setImagePath(_imagePath)
  },
  imageSizes: function imageSizes(instance, _imageSizes) {
    instance.setImageSizes(_imageSizes)
  },
  maxZoom: function maxZoom(instance, _maxZoom) {
    instance.setMaxZoom(_maxZoom)
  },
  minimumClusterSize: function minimumClusterSize(
    instance,
    _minimumClusterSize
  ) {
    instance.setMinimumClusterSize(_minimumClusterSize)
  },
  styles: function styles(instance, _styles) {
    instance.setStyles(_styles)
  },
  title: function title(instance, _title) {
    instance.setTitle(_title)
  },
  zoomOnClick: function zoomOnClick(instance, _zoomOnClick) {
    instance.setZoomOnClick(_zoomOnClick)
  },
}


/***/ }),
/* 532 */
/***/ (function(module, exports) {

/**
 * @name MarkerClustererPlus for Google Maps V3
 * @version 2.1.2 [May 28, 2014]
 * @author Gary Little
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of markers.
 * <p>
 * This is an enhanced V3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >V2 MarkerClusterer</a> by Xiaoxi Wu. It is based on the
 * <a href="http://google-maps-utility-library-v3.googlecode.com/svn/tags/markerclusterer/"
 * >V3 MarkerClusterer</a> port by Luke Mahe. MarkerClustererPlus was created by Gary Little.
 * <p>
 * v2.0 release: MarkerClustererPlus v2.0 is backward compatible with MarkerClusterer v1.0. It
 *  adds support for the <code>ignoreHidden</code>, <code>title</code>, <code>batchSizeIE</code>,
 *  and <code>calculator</code> properties as well as support for four more events. It also allows
 *  greater control over the styling of the text that appears on the cluster marker. The
 *  documentation has been significantly improved and the overall code has been simplified and
 *  polished. Very large numbers of markers can now be managed without causing Javascript timeout
 *  errors on Internet Explorer. Note that the name of the <code>clusterclick</code> event has been
 *  deprecated. The new name is <code>click</code>, so please change your application code now.
 */

/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * @name ClusterIconStyle
 * @class This class represents the object for values in the <code>styles</code> array passed
 *  to the {@link MarkerClusterer} constructor. The element in this array that is used to
 *  style the cluster icon is determined by calling the <code>calculator</code> function.
 *
 * @property {string} url The URL of the cluster icon image file. Required.
 * @property {number} height The display height (in pixels) of the cluster icon. Required.
 * @property {number} width The display width (in pixels) of the cluster icon. Required.
 * @property {Array} [anchorText] The position (in pixels) from the center of the cluster icon to
 *  where the text label is to be centered and drawn. The format is <code>[yoffset, xoffset]</code>
 *  where <code>yoffset</code> increases as you go down from center and <code>xoffset</code>
 *  increases to the right of center. The default is <code>[0, 0]</code>.
 * @property {Array} [anchorIcon] The anchor position (in pixels) of the cluster icon. This is the
 *  spot on the cluster icon that is to be aligned with the cluster position. The format is
 *  <code>[yoffset, xoffset]</code> where <code>yoffset</code> increases as you go down and
 *  <code>xoffset</code> increases to the right of the top-left corner of the icon. The default
 *  anchor position is the center of the cluster icon.
 * @property {string} [textColor="black"] The color of the label text shown on the
 *  cluster icon.
 * @property {number} [textSize=11] The size (in pixels) of the label text shown on the
 *  cluster icon.
 * @property {string} [textDecoration="none"] The value of the CSS <code>text-decoration</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontWeight="bold"] The value of the CSS <code>font-weight</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontStyle="normal"] The value of the CSS <code>font-style</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontFamily="Arial,sans-serif"] The value of the CSS <code>font-family</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [backgroundPosition="0 0"] The position of the cluster icon image
 *  within the image defined by <code>url</code>. The format is <code>"xpos ypos"</code>
 *  (the same format as for the CSS <code>background-position</code> property). You must set
 *  this property appropriately when the image defined by <code>url</code> represents a sprite
 *  containing multiple images. Note that the position <i>must</i> be specified in px units.
 */
/**
 * @name ClusterIconInfo
 * @class This class is an object containing general information about a cluster icon. This is
 *  the object that a <code>calculator</code> function returns.
 *
 * @property {string} text The text of the label to be shown on the cluster icon.
 * @property {number} index The index plus 1 of the element in the <code>styles</code>
 *  array to be used to style the cluster icon.
 * @property {string} title The tooltip to display when the mouse moves over the cluster icon.
 *  If this value is <code>undefined</code> or <code>""</code>, <code>title</code> is set to the
 *  value of the <code>title</code> property passed to the MarkerClusterer.
 */
/**
 * A cluster icon.
 *
 * @constructor
 * @extends google.maps.OverlayView
 * @param {Cluster} cluster The cluster with which the icon is to be associated.
 * @param {Array} [styles] An array of {@link ClusterIconStyle} defining the cluster icons
 *  to use for various cluster sizes.
 * @private
 */
function ClusterIcon(cluster, styles) {
  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

  this.cluster_ = cluster;
  this.className_ = cluster.getMarkerClusterer().getClusterClass();
  this.styles_ = styles;
  this.center_ = null;
  this.div_ = null;
  this.sums_ = null;
  this.visible_ = false;

  this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
}


/**
 * Adds the icon to the DOM.
 */
ClusterIcon.prototype.onAdd = function () {
  var cClusterIcon = this;
  var cMouseDownInCluster;
  var cDraggingMapByCluster;

  this.div_ = document.createElement("div");
  this.div_.className = this.className_;
  if (this.visible_) {
    this.show();
  }

  this.getPanes().overlayMouseTarget.appendChild(this.div_);

  // Fix for Issue 157
  this.boundsChangedListener_ = google.maps.event.addListener(this.getMap(), "bounds_changed", function () {
    cDraggingMapByCluster = cMouseDownInCluster;
  });

  google.maps.event.addDomListener(this.div_, "mousedown", function () {
    cMouseDownInCluster = true;
    cDraggingMapByCluster = false;
  });

  google.maps.event.addDomListener(this.div_, "click", function (e) {
    cMouseDownInCluster = false;
    if (!cDraggingMapByCluster) {
      var theBounds;
      var mz;
      var mc = cClusterIcon.cluster_.getMarkerClusterer();
      /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */
      google.maps.event.trigger(mc, "click", cClusterIcon.cluster_);
      google.maps.event.trigger(mc, "clusterclick", cClusterIcon.cluster_); // deprecated name

      // The default click handler follows. Disable it by setting
      // the zoomOnClick property to false.
      if (mc.getZoomOnClick()) {
        // Zoom into the cluster.
        mz = mc.getMaxZoom();
        theBounds = cClusterIcon.cluster_.getBounds();
        mc.getMap().fitBounds(theBounds);
        // There is a fix for Issue 170 here:
        setTimeout(function () {
          mc.getMap().fitBounds(theBounds);
          // Don't zoom beyond the max zoom level
          if (mz !== null && (mc.getMap().getZoom() > mz)) {
            mc.getMap().setZoom(mz + 1);
          }
        }, 100);
      }

      // Prevent event propagation to the map:
      e.cancelBubble = true;
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
  });

  google.maps.event.addDomListener(this.div_, "mouseover", function () {
    var mc = cClusterIcon.cluster_.getMarkerClusterer();
    /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */
    google.maps.event.trigger(mc, "mouseover", cClusterIcon.cluster_);
  });

  google.maps.event.addDomListener(this.div_, "mouseout", function () {
    var mc = cClusterIcon.cluster_.getMarkerClusterer();
    /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */
    google.maps.event.trigger(mc, "mouseout", cClusterIcon.cluster_);
  });
};


/**
 * Removes the icon from the DOM.
 */
ClusterIcon.prototype.onRemove = function () {
  if (this.div_ && this.div_.parentNode) {
    this.hide();
    google.maps.event.removeListener(this.boundsChangedListener_);
    google.maps.event.clearInstanceListeners(this.div_);
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};


/**
 * Draws the icon.
 */
ClusterIcon.prototype.draw = function () {
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.top = pos.y + "px";
    this.div_.style.left = pos.x + "px";
  }
};


/**
 * Hides the icon.
 */
ClusterIcon.prototype.hide = function () {
  if (this.div_) {
    this.div_.style.display = "none";
  }
  this.visible_ = false;
};


/**
 * Positions and shows the icon.
 */
ClusterIcon.prototype.show = function () {
  if (this.div_) {
    var img = "";
    // NOTE: values must be specified in px units
    var bp = this.backgroundPosition_.split(" ");
    var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ""), 10);
    var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ""), 10);
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
    if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) {
      img += "clip: rect(" + (-1 * spriteV) + "px, " + ((-1 * spriteH) + this.width_) + "px, " +
          ((-1 * spriteV) + this.height_) + "px, " + (-1 * spriteH) + "px);";
    }
    img += "'>";
    this.div_.innerHTML = img + "<div style='" +
        "position: absolute;" +
        "top: " + this.anchorText_[0] + "px;" +
        "left: " + this.anchorText_[1] + "px;" +
        "color: " + this.textColor_ + ";" +
        "font-size: " + this.textSize_ + "px;" +
        "font-family: " + this.fontFamily_ + ";" +
        "font-weight: " + this.fontWeight_ + ";" +
        "font-style: " + this.fontStyle_ + ";" +
        "text-decoration: " + this.textDecoration_ + ";" +
        "text-align: center;" +
        "width: " + this.width_ + "px;" +
        "line-height:" + this.height_ + "px;" +
        "'>" + this.sums_.text + "</div>";
    if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
      this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
    } else {
      this.div_.title = this.sums_.title;
    }
    this.div_.style.display = "";
  }
  this.visible_ = true;
};


/**
 * Sets the icon styles to the appropriate element in the styles array.
 *
 * @param {ClusterIconInfo} sums The icon label text and styles index.
 */
ClusterIcon.prototype.useStyle = function (sums) {
  this.sums_ = sums;
  var index = Math.max(0, sums.index - 1);
  index = Math.min(this.styles_.length - 1, index);
  var style = this.styles_[index];
  this.url_ = style.url;
  this.height_ = style.height;
  this.width_ = style.width;
  this.anchorText_ = style.anchorText || [0, 0];
  this.anchorIcon_ = style.anchorIcon || [parseInt(this.height_ / 2, 10), parseInt(this.width_ / 2, 10)];
  this.textColor_ = style.textColor || "black";
  this.textSize_ = style.textSize || 11;
  this.textDecoration_ = style.textDecoration || "none";
  this.fontWeight_ = style.fontWeight || "bold";
  this.fontStyle_ = style.fontStyle || "normal";
  this.fontFamily_ = style.fontFamily || "Arial,sans-serif";
  this.backgroundPosition_ = style.backgroundPosition || "0 0";
};


/**
 * Sets the position at which to center the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function (center) {
  this.center_ = center;
};


/**
 * Creates the cssText style parameter based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position of the icon.
 * @return {string} The CSS style text.
 */
ClusterIcon.prototype.createCss = function (pos) {
  var style = [];
  style.push("cursor: pointer;");
  style.push("position: absolute; top: " + pos.y + "px; left: " + pos.x + "px;");
  style.push("width: " + this.width_ + "px; height: " + this.height_ + "px;");
  return style.join("");
};


/**
 * Returns the position at which to place the DIV depending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 */
ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
  var pos = this.getProjection().fromLatLngToDivPixel(latlng);
  pos.x -= this.anchorIcon_[1];
  pos.y -= this.anchorIcon_[0];
  pos.x = parseInt(pos.x, 10);
  pos.y = parseInt(pos.y, 10);
  return pos;
};


/**
 * Creates a single cluster that manages a group of proximate markers.
 *  Used internally, do not call this constructor directly.
 * @constructor
 * @param {MarkerClusterer} mc The <code>MarkerClusterer</code> object with which this
 *  cluster is associated.
 */
function Cluster(mc) {
  this.markerClusterer_ = mc;
  this.map_ = mc.getMap();
  this.gridSize_ = mc.getGridSize();
  this.minClusterSize_ = mc.getMinimumClusterSize();
  this.averageCenter_ = mc.getAverageCenter();
  this.markers_ = [];
  this.center_ = null;
  this.bounds_ = null;
  this.clusterIcon_ = new ClusterIcon(this, mc.getStyles());
}


/**
 * Returns the number of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {number} The number of markers in the cluster.
 */
Cluster.prototype.getSize = function () {
  return this.markers_.length;
};


/**
 * Returns the array of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {Array} The array of markers in the cluster.
 */
Cluster.prototype.getMarkers = function () {
  return this.markers_;
};


/**
 * Returns the center of the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {google.maps.LatLng} The center of the cluster.
 */
Cluster.prototype.getCenter = function () {
  return this.center_;
};


/**
 * Returns the map with which the cluster is associated.
 *
 * @return {google.maps.Map} The map.
 * @ignore
 */
Cluster.prototype.getMap = function () {
  return this.map_;
};


/**
 * Returns the <code>MarkerClusterer</code> object with which the cluster is associated.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 * @ignore
 */
Cluster.prototype.getMarkerClusterer = function () {
  return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 * @ignore
 */
Cluster.prototype.getBounds = function () {
  var i;
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  var markers = this.getMarkers();
  for (i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }
  return bounds;
};


/**
 * Removes the cluster from the map.
 *
 * @ignore
 */
Cluster.prototype.remove = function () {
  this.clusterIcon_.setMap(null);
  this.markers_ = [];
  delete this.markers_;
};


/**
 * Adds a marker to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to be added.
 * @return {boolean} True if the marker was added.
 * @ignore
 */
Cluster.prototype.addMarker = function (marker) {
  var i;
  var mCount;
  var mz;

  if (this.isMarkerAlreadyAdded_(marker)) {
    return false;
  }

  if (!this.center_) {
    this.center_ = marker.getPosition();
    this.calculateBounds_();
  } else {
    if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
  }

  marker.isAdded = true;
  this.markers_.push(marker);

  mCount = this.markers_.length;
  mz = this.markerClusterer_.getMaxZoom();
  if (mz !== null && this.map_.getZoom() > mz) {
    // Zoomed in past max zoom, so show the marker.
    if (marker.getMap() !== this.map_) {
      marker.setMap(this.map_);
    }
  } else if (mCount < this.minClusterSize_) {
    // Min cluster size not reached so show the marker.
    if (marker.getMap() !== this.map_) {
      marker.setMap(this.map_);
    }
  } else if (mCount === this.minClusterSize_) {
    // Hide the markers that were showing.
    for (i = 0; i < mCount; i++) {
      this.markers_[i].setMap(null);
    }
  } else {
    marker.setMap(null);
  }

  this.updateIcon_();
  return true;
};


/**
 * Determines if a marker lies within the cluster's bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 * @ignore
 */
Cluster.prototype.isMarkerInClusterBounds = function (marker) {
  return this.bounds_.contains(marker.getPosition());
};


/**
 * Calculates the extended bounds of the cluster with the grid.
 */
Cluster.prototype.calculateBounds_ = function () {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Updates the cluster icon.
 */
Cluster.prototype.updateIcon_ = function () {
  var mCount = this.markers_.length;
  var mz = this.markerClusterer_.getMaxZoom();

  if (mz !== null && this.map_.getZoom() > mz) {
    this.clusterIcon_.hide();
    return;
  }

  if (mCount < this.minClusterSize_) {
    // Min cluster size not yet reached.
    this.clusterIcon_.hide();
    return;
  }

  var numStyles = this.markerClusterer_.getStyles().length;
  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
  this.clusterIcon_.setCenter(this.center_);
  this.clusterIcon_.useStyle(sums);
  this.clusterIcon_.show();
};


/**
 * Determines if a marker has already been added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker has already been added.
 */
Cluster.prototype.isMarkerAlreadyAdded_ = function (marker) {
  var i;
  if (this.markers_.indexOf) {
    return this.markers_.indexOf(marker) !== -1;
  } else {
    for (i = 0; i < this.markers_.length; i++) {
      if (marker === this.markers_[i]) {
        return true;
      }
    }
  }
  return false;
};


/**
 * @name MarkerClustererOptions
 * @class This class represents the optional parameter passed to
 *  the {@link MarkerClusterer} constructor.
 * @property {number} [gridSize=60] The grid size of a cluster in pixels. The grid is a square.
 * @property {number} [maxZoom=null] The maximum zoom level at which clustering is enabled or
 *  <code>null</code> if clustering is to be enabled at all zoom levels.
 * @property {boolean} [zoomOnClick=true] Whether to zoom the map when a cluster marker is
 *  clicked. You may want to set this to <code>false</code> if you have installed a handler
 *  for the <code>click</code> event and it deals with zooming on its own.
 * @property {boolean} [averageCenter=false] Whether the position of a cluster marker should be
 *  the average position of all markers in the cluster. If set to <code>false</code>, the
 *  cluster marker is positioned at the location of the first marker added to the cluster.
 * @property {number} [minimumClusterSize=2] The minimum number of markers needed in a cluster
 *  before the markers are hidden and a cluster marker appears.
 * @property {boolean} [ignoreHidden=false] Whether to ignore hidden markers in clusters. You
 *  may want to set this to <code>true</code> to ensure that hidden markers are not included
 *  in the marker count that appears on a cluster marker (this count is the value of the
 *  <code>text</code> property of the result returned by the default <code>calculator</code>).
 *  If set to <code>true</code> and you change the visibility of a marker being clustered, be
 *  sure to also call <code>MarkerClusterer.repaint()</code>.
 * @property {string} [title=""] The tooltip to display when the mouse moves over a cluster
 *  marker. (Alternatively, you can use a custom <code>calculator</code> function to specify a
 *  different tooltip for each cluster marker.)
 * @property {function} [calculator=MarkerClusterer.CALCULATOR] The function used to determine
 *  the text to be displayed on a cluster marker and the index indicating which style to use
 *  for the cluster marker. The input parameters for the function are (1) the array of markers
 *  represented by a cluster marker and (2) the number of cluster icon styles. It returns a
 *  {@link ClusterIconInfo} object. The default <code>calculator</code> returns a
 *  <code>text</code> property which is the number of markers in the cluster and an
 *  <code>index</code> property which is one higher than the lowest integer such that
 *  <code>10^i</code> exceeds the number of markers in the cluster, or the size of the styles
 *  array, whichever is less. The <code>styles</code> array element used has an index of
 *  <code>index</code> minus 1. For example, the default <code>calculator</code> returns a
 *  <code>text</code> value of <code>"125"</code> and an <code>index</code> of <code>3</code>
 *  for a cluster icon representing 125 markers so the element used in the <code>styles</code>
 *  array is <code>2</code>. A <code>calculator</code> may also return a <code>title</code>
 *  property that contains the text of the tooltip to be used for the cluster marker. If
 *   <code>title</code> is not defined, the tooltip is set to the value of the <code>title</code>
 *   property for the MarkerClusterer.
 * @property {string} [clusterClass="cluster"] The name of the CSS class defining general styles
 *  for the cluster markers. Use this class to define CSS styles that are not set up by the code
 *  that processes the <code>styles</code> array.
 * @property {Array} [styles] An array of {@link ClusterIconStyle} elements defining the styles
 *  of the cluster markers to be used. The element to be used to style a given cluster marker
 *  is determined by the function defined by the <code>calculator</code> property.
 *  The default is an array of {@link ClusterIconStyle} elements whose properties are derived
 *  from the values for <code>imagePath</code>, <code>imageExtension</code>, and
 *  <code>imageSizes</code>.
 * @property {boolean} [enableRetinaIcons=false] Whether to allow the use of cluster icons that
 * have sizes that are some multiple (typically double) of their actual display size. Icons such
 * as these look better when viewed on high-resolution monitors such as Apple's Retina displays.
 * Note: if this property is <code>true</code>, sprites cannot be used as cluster icons.
 * @property {number} [batchSize=MarkerClusterer.BATCH_SIZE] Set this property to the
 *  number of markers to be processed in a single batch when using a browser other than
 *  Internet Explorer (for Internet Explorer, use the batchSizeIE property instead).
 * @property {number} [batchSizeIE=MarkerClusterer.BATCH_SIZE_IE] When Internet Explorer is
 *  being used, markers are processed in several batches with a small delay inserted between
 *  each batch in an attempt to avoid Javascript timeout errors. Set this property to the
 *  number of markers to be processed in a single batch; select as high a number as you can
 *  without causing a timeout error in the browser. This number might need to be as low as 100
 *  if 15,000 markers are being managed, for example.
 * @property {string} [imagePath=MarkerClusterer.IMAGE_PATH]
 *  The full URL of the root name of the group of image files to use for cluster icons.
 *  The complete file name is of the form <code>imagePath</code>n.<code>imageExtension</code>
 *  where n is the image file number (1, 2, etc.).
 * @property {string} [imageExtension=MarkerClusterer.IMAGE_EXTENSION]
 *  The extension name for the cluster icon image files (e.g., <code>"png"</code> or
 *  <code>"jpg"</code>).
 * @property {Array} [imageSizes=MarkerClusterer.IMAGE_SIZES]
 *  An array of numbers containing the widths of the group of
 *  <code>imagePath</code>n.<code>imageExtension</code> image files.
 *  (The images are assumed to be square.)
 */
/**
 * Creates a MarkerClusterer object with the options specified in {@link MarkerClustererOptions}.
 * @constructor
 * @extends google.maps.OverlayView
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>} [opt_markers] The markers to be added to the cluster.
 * @param {MarkerClustererOptions} [opt_options] The optional parameters.
 */
function MarkerClusterer(map, opt_markers, opt_options) {
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  this.extend(MarkerClusterer, google.maps.OverlayView);

  opt_markers = opt_markers || [];
  opt_options = opt_options || {};

  this.markers_ = [];
  this.clusters_ = [];
  this.listeners_ = [];
  this.activeMap_ = null;
  this.ready_ = false;

  this.gridSize_ = opt_options.gridSize || 60;
  this.minClusterSize_ = opt_options.minimumClusterSize || 2;
  this.maxZoom_ = opt_options.maxZoom || null;
  this.styles_ = opt_options.styles || [];
  this.title_ = opt_options.title || "";
  this.zoomOnClick_ = true;
  if (opt_options.zoomOnClick !== undefined) {
    this.zoomOnClick_ = opt_options.zoomOnClick;
  }
  this.averageCenter_ = false;
  if (opt_options.averageCenter !== undefined) {
    this.averageCenter_ = opt_options.averageCenter;
  }
  this.ignoreHidden_ = false;
  if (opt_options.ignoreHidden !== undefined) {
    this.ignoreHidden_ = opt_options.ignoreHidden;
  }
  this.enableRetinaIcons_ = false;
  if (opt_options.enableRetinaIcons !== undefined) {
    this.enableRetinaIcons_ = opt_options.enableRetinaIcons;
  }
  this.imagePath_ = opt_options.imagePath || MarkerClusterer.IMAGE_PATH;
  this.imageExtension_ = opt_options.imageExtension || MarkerClusterer.IMAGE_EXTENSION;
  this.imageSizes_ = opt_options.imageSizes || MarkerClusterer.IMAGE_SIZES;
  this.calculator_ = opt_options.calculator || MarkerClusterer.CALCULATOR;
  this.batchSize_ = opt_options.batchSize || MarkerClusterer.BATCH_SIZE;
  this.batchSizeIE_ = opt_options.batchSizeIE || MarkerClusterer.BATCH_SIZE_IE;
  this.clusterClass_ = opt_options.clusterClass || "cluster";

  if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) {
    // Try to avoid IE timeout when processing a huge number of markers:
    this.batchSize_ = this.batchSizeIE_;
  }

  this.setupStyles_();

  this.addMarkers(opt_markers, true);
  this.setMap(map); // Note: this causes onAdd to be called
}


/**
 * Implementation of the onAdd interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function () {
  var cMarkerClusterer = this;

  this.activeMap_ = this.getMap();
  this.ready_ = true;

  this.repaint();

  // Add the map event listeners
  this.listeners_ = [
    google.maps.event.addListener(this.getMap(), "zoom_changed", function () {
      cMarkerClusterer.resetViewport_(false);
      // Workaround for this Google bug: when map is at level 0 and "-" of
      // zoom slider is clicked, a "zoom_changed" event is fired even though
      // the map doesn't zoom out any further. In this situation, no "idle"
      // event is triggered so the cluster markers that have been removed
      // do not get redrawn. Same goes for a zoom in at maxZoom.
      if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) {
        google.maps.event.trigger(this, "idle");
      }
    }),
    google.maps.event.addListener(this.getMap(), "idle", function () {
      cMarkerClusterer.redraw_();
    })
  ];
};


/**
 * Implementation of the onRemove interface method.
 * Removes map event listeners and all cluster icons from the DOM.
 * All managed markers are also put back on the map.
 * @ignore
 */
MarkerClusterer.prototype.onRemove = function () {
  var i;

  // Put all the managed markers back on the map:
  for (i = 0; i < this.markers_.length; i++) {
    if (this.markers_[i].getMap() !== this.activeMap_) {
      this.markers_[i].setMap(this.activeMap_);
    }
  }

  // Remove all clusters:
  for (i = 0; i < this.clusters_.length; i++) {
    this.clusters_[i].remove();
  }
  this.clusters_ = [];

  // Remove map event listeners:
  for (i = 0; i < this.listeners_.length; i++) {
    google.maps.event.removeListener(this.listeners_[i]);
  }
  this.listeners_ = [];

  this.activeMap_ = null;
  this.ready_ = false;
};


/**
 * Implementation of the draw interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function () {};


/**
 * Sets up the styles object.
 */
MarkerClusterer.prototype.setupStyles_ = function () {
  var i, size;
  if (this.styles_.length > 0) {
    return;
  }

  for (i = 0; i < this.imageSizes_.length; i++) {
    size = this.imageSizes_[i];
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + "." + this.imageExtension_,
      height: size,
      width: size
    });
  }
};


/**
 *  Fits the map to the bounds of the markers managed by the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function () {
  var i;
  var markers = this.getMarkers();
  var bounds = new google.maps.LatLngBounds();
  for (i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }

  this.getMap().fitBounds(bounds);
};


/**
 * Returns the value of the <code>gridSize</code> property.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function () {
  return this.gridSize_;
};


/**
 * Sets the value of the <code>gridSize</code> property.
 *
 * @param {number} gridSize The grid size.
 */
MarkerClusterer.prototype.setGridSize = function (gridSize) {
  this.gridSize_ = gridSize;
};


/**
 * Returns the value of the <code>minimumClusterSize</code> property.
 *
 * @return {number} The minimum cluster size.
 */
MarkerClusterer.prototype.getMinimumClusterSize = function () {
  return this.minClusterSize_;
};

/**
 * Sets the value of the <code>minimumClusterSize</code> property.
 *
 * @param {number} minimumClusterSize The minimum cluster size.
 */
MarkerClusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
  this.minClusterSize_ = minimumClusterSize;
};


/**
 *  Returns the value of the <code>maxZoom</code> property.
 *
 *  @return {number} The maximum zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function () {
  return this.maxZoom_;
};


/**
 *  Sets the value of the <code>maxZoom</code> property.
 *
 *  @param {number} maxZoom The maximum zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
  this.maxZoom_ = maxZoom;
};


/**
 *  Returns the value of the <code>styles</code> property.
 *
 *  @return {Array} The array of styles defining the cluster markers to be used.
 */
MarkerClusterer.prototype.getStyles = function () {
  return this.styles_;
};


/**
 *  Sets the value of the <code>styles</code> property.
 *
 *  @param {Array.<ClusterIconStyle>} styles The array of styles to use.
 */
MarkerClusterer.prototype.setStyles = function (styles) {
  this.styles_ = styles;
};


/**
 * Returns the value of the <code>title</code> property.
 *
 * @return {string} The content of the title text.
 */
MarkerClusterer.prototype.getTitle = function () {
  return this.title_;
};


/**
 *  Sets the value of the <code>title</code> property.
 *
 *  @param {string} title The value of the title property.
 */
MarkerClusterer.prototype.setTitle = function (title) {
  this.title_ = title;
};


/**
 * Returns the value of the <code>zoomOnClick</code> property.
 *
 * @return {boolean} True if zoomOnClick property is set.
 */
MarkerClusterer.prototype.getZoomOnClick = function () {
  return this.zoomOnClick_;
};


/**
 *  Sets the value of the <code>zoomOnClick</code> property.
 *
 *  @param {boolean} zoomOnClick The value of the zoomOnClick property.
 */
MarkerClusterer.prototype.setZoomOnClick = function (zoomOnClick) {
  this.zoomOnClick_ = zoomOnClick;
};


/**
 * Returns the value of the <code>averageCenter</code> property.
 *
 * @return {boolean} True if averageCenter property is set.
 */
MarkerClusterer.prototype.getAverageCenter = function () {
  return this.averageCenter_;
};


/**
 *  Sets the value of the <code>averageCenter</code> property.
 *
 *  @param {boolean} averageCenter The value of the averageCenter property.
 */
MarkerClusterer.prototype.setAverageCenter = function (averageCenter) {
  this.averageCenter_ = averageCenter;
};


/**
 * Returns the value of the <code>ignoreHidden</code> property.
 *
 * @return {boolean} True if ignoreHidden property is set.
 */
MarkerClusterer.prototype.getIgnoreHidden = function () {
  return this.ignoreHidden_;
};


/**
 *  Sets the value of the <code>ignoreHidden</code> property.
 *
 *  @param {boolean} ignoreHidden The value of the ignoreHidden property.
 */
MarkerClusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
  this.ignoreHidden_ = ignoreHidden;
};


/**
 * Returns the value of the <code>enableRetinaIcons</code> property.
 *
 * @return {boolean} True if enableRetinaIcons property is set.
 */
MarkerClusterer.prototype.getEnableRetinaIcons = function () {
  return this.enableRetinaIcons_;
};


/**
 *  Sets the value of the <code>enableRetinaIcons</code> property.
 *
 *  @param {boolean} enableRetinaIcons The value of the enableRetinaIcons property.
 */
MarkerClusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
  this.enableRetinaIcons_ = enableRetinaIcons;
};


/**
 * Returns the value of the <code>imageExtension</code> property.
 *
 * @return {string} The value of the imageExtension property.
 */
MarkerClusterer.prototype.getImageExtension = function () {
  return this.imageExtension_;
};


/**
 *  Sets the value of the <code>imageExtension</code> property.
 *
 *  @param {string} imageExtension The value of the imageExtension property.
 */
MarkerClusterer.prototype.setImageExtension = function (imageExtension) {
  this.imageExtension_ = imageExtension;
};


/**
 * Returns the value of the <code>imagePath</code> property.
 *
 * @return {string} The value of the imagePath property.
 */
MarkerClusterer.prototype.getImagePath = function () {
  return this.imagePath_;
};


/**
 *  Sets the value of the <code>imagePath</code> property.
 *
 *  @param {string} imagePath The value of the imagePath property.
 */
MarkerClusterer.prototype.setImagePath = function (imagePath) {
  this.imagePath_ = imagePath;
};


/**
 * Returns the value of the <code>imageSizes</code> property.
 *
 * @return {Array} The value of the imageSizes property.
 */
MarkerClusterer.prototype.getImageSizes = function () {
  return this.imageSizes_;
};


/**
 *  Sets the value of the <code>imageSizes</code> property.
 *
 *  @param {Array} imageSizes The value of the imageSizes property.
 */
MarkerClusterer.prototype.setImageSizes = function (imageSizes) {
  this.imageSizes_ = imageSizes;
};


/**
 * Returns the value of the <code>calculator</code> property.
 *
 * @return {function} the value of the calculator property.
 */
MarkerClusterer.prototype.getCalculator = function () {
  return this.calculator_;
};


/**
 * Sets the value of the <code>calculator</code> property.
 *
 * @param {function(Array.<google.maps.Marker>, number)} calculator The value
 *  of the calculator property.
 */
MarkerClusterer.prototype.setCalculator = function (calculator) {
  this.calculator_ = calculator;
};


/**
 * Returns the value of the <code>batchSizeIE</code> property.
 *
 * @return {number} the value of the batchSizeIE property.
 */
MarkerClusterer.prototype.getBatchSizeIE = function () {
  return this.batchSizeIE_;
};


/**
 * Sets the value of the <code>batchSizeIE</code> property.
 *
 *  @param {number} batchSizeIE The value of the batchSizeIE property.
 */
MarkerClusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
  this.batchSizeIE_ = batchSizeIE;
};


/**
 * Returns the value of the <code>clusterClass</code> property.
 *
 * @return {string} the value of the clusterClass property.
 */
MarkerClusterer.prototype.getClusterClass = function () {
  return this.clusterClass_;
};


/**
 * Sets the value of the <code>clusterClass</code> property.
 *
 *  @param {string} clusterClass The value of the clusterClass property.
 */
MarkerClusterer.prototype.setClusterClass = function (clusterClass) {
  this.clusterClass_ = clusterClass;
};


/**
 *  Returns the array of markers managed by the clusterer.
 *
 *  @return {Array} The array of markers managed by the clusterer.
 */
MarkerClusterer.prototype.getMarkers = function () {
  return this.markers_;
};


/**
 *  Returns the number of markers managed by the clusterer.
 *
 *  @return {number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function () {
  return this.markers_.length;
};


/**
 * Returns the current array of clusters formed by the clusterer.
 *
 * @return {Array} The array of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getClusters = function () {
  return this.clusters_;
};


/**
 * Returns the number of clusters formed by the clusterer.
 *
 * @return {number} The number of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getTotalClusters = function () {
  return this.clusters_.length;
};


/**
 * Adds a marker to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
  this.pushMarkerTo_(marker);
  if (!opt_nodraw) {
    this.redraw_();
  }
};


/**
 * Adds an array of markers to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
  var key;
  for (key in markers) {
    if (markers.hasOwnProperty(key)) {
      this.pushMarkerTo_(markers[key]);
    }
  }  
  if (!opt_nodraw) {
    this.redraw_();
  }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
  // If the marker is draggable add a listener so we can update the clusters on the dragend:
  if (marker.getDraggable()) {
    var cMarkerClusterer = this;
    google.maps.event.addListener(marker, "dragend", function () {
      if (cMarkerClusterer.ready_) {
        this.isAdded = false;
        cMarkerClusterer.repaint();
      }
    });
  }
  marker.isAdded = false;
  this.markers_.push(marker);
};


/**
 * Removes a marker from the cluster.  The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if the
 *  marker was removed from the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if the marker was removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
  var removed = this.removeMarker_(marker);

  if (!opt_nodraw && removed) {
    this.repaint();
  }

  return removed;
};


/**
 * Removes an array of markers from the cluster. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if markers
 *  were removed from the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if markers were removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
  var i, r;
  var removed = false;

  for (i = 0; i < markers.length; i++) {
    r = this.removeMarker_(markers[i]);
    removed = removed || r;
  }

  if (!opt_nodraw && removed) {
    this.repaint();
  }

  return removed;
};


/**
 * Removes a marker and returns true if removed, false if not.
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 */
MarkerClusterer.prototype.removeMarker_ = function (marker) {
  var i;
  var index = -1;
  if (this.markers_.indexOf) {
    index = this.markers_.indexOf(marker);
  } else {
    for (i = 0; i < this.markers_.length; i++) {
      if (marker === this.markers_[i]) {
        index = i;
        break;
      }
    }
  }

  if (index === -1) {
    // Marker is not in our list of markers, so do nothing:
    return false;
  }

  marker.setMap(null);
  this.markers_.splice(index, 1); // Remove the marker from the list of managed markers
  return true;
};


/**
 * Removes all clusters and markers from the map and also removes all markers
 *  managed by the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function () {
  this.resetViewport_(true);
  this.markers_ = [];
};


/**
 * Recalculates and redraws all the marker clusters from scratch.
 *  Call this after changing any properties.
 */
MarkerClusterer.prototype.repaint = function () {
  var oldClusters = this.clusters_.slice();
  this.clusters_ = [];
  this.resetViewport_(false);
  this.redraw_();

  // Remove the old clusters.
  // Do it in a timeout to prevent blinking effect.
  setTimeout(function () {
    var i;
    for (i = 0; i < oldClusters.length; i++) {
      oldClusters[i].remove();
    }
  }, 0);
};


/**
 * Returns the current bounds extended by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 * @ignore
 */
MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
  var projection = this.getProjection();

  // Turn the bounds into latlng.
  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng());
  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng());

  // Convert the points to pixels and the extend out by the grid size.
  var trPix = projection.fromLatLngToDivPixel(tr);
  trPix.x += this.gridSize_;
  trPix.y -= this.gridSize_;

  var blPix = projection.fromLatLngToDivPixel(bl);
  blPix.x -= this.gridSize_;
  blPix.y += this.gridSize_;

  // Convert the pixel points back to LatLng
  var ne = projection.fromDivPixelToLatLng(trPix);
  var sw = projection.fromDivPixelToLatLng(blPix);

  // Extend the bounds to contain the new bounds.
  bounds.extend(ne);
  bounds.extend(sw);

  return bounds;
};


/**
 * Redraws all the clusters.
 */
MarkerClusterer.prototype.redraw_ = function () {
  this.createClusters_(0);
};


/**
 * Removes all clusters from the map. The markers are also removed from the map
 *  if <code>opt_hide</code> is set to <code>true</code>.
 *
 * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
 *  from the map.
 */
MarkerClusterer.prototype.resetViewport_ = function (opt_hide) {
  var i, marker;
  // Remove all the clusters
  for (i = 0; i < this.clusters_.length; i++) {
    this.clusters_[i].remove();
  }
  this.clusters_ = [];

  // Reset the markers to not be added and to be removed from the map.
  for (i = 0; i < this.markers_.length; i++) {
    marker = this.markers_[i];
    marker.isAdded = false;
    if (opt_hide) {
      marker.setMap(null);
    }
  }
};


/**
 * Calculates the distance between two latlng locations in km.
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
  var R = 6371; // Radius of the Earth in km
  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
};


/**
 * Determines if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
  return bounds.contains(marker.getPosition());
};


/**
 * Adds a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
  var i, d, cluster, center;
  var distance = 40000; // Some large number
  var clusterToAddTo = null;
  for (i = 0; i < this.clusters_.length; i++) {
    cluster = this.clusters_[i];
    center = cluster.getCenter();
    if (center) {
      d = this.distanceBetweenPoints_(center, marker.getPosition());
      if (d < distance) {
        distance = d;
        clusterToAddTo = cluster;
      }
    }
  }

  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
    clusterToAddTo.addMarker(marker);
  } else {
    cluster = new Cluster(this);
    cluster.addMarker(marker);
    this.clusters_.push(cluster);
  }
};


/**
 * Creates the clusters. This is done in batches to avoid timeout errors
 *  in some browsers when there is a huge number of markers.
 *
 * @param {number} iFirst The index of the first marker in the batch of
 *  markers to be added to clusters.
 */
MarkerClusterer.prototype.createClusters_ = function (iFirst) {
  var i, marker;
  var mapBounds;
  var cMarkerClusterer = this;
  if (!this.ready_) {
    return;
  }

  // Cancel previous batch processing if we're working on the first batch:
  if (iFirst === 0) {
    /**
     * This event is fired when the <code>MarkerClusterer</code> begins
     *  clustering markers.
     * @name MarkerClusterer#clusteringbegin
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */
    google.maps.event.trigger(this, "clusteringbegin", this);

    if (typeof this.timerRefStatic !== "undefined") {
      clearTimeout(this.timerRefStatic);
      delete this.timerRefStatic;
    }
  }

  // Get our current map view bounds.
  // Create a new bounds object so we don't affect the map.
  //
  // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
  if (this.getMap().getZoom() > 3) {
    mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),
      this.getMap().getBounds().getNorthEast());
  } else {
    mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
  }
  var bounds = this.getExtendedBounds(mapBounds);

  var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);

  for (i = iFirst; i < iLast; i++) {
    marker = this.markers_[i];
    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
      if (!this.ignoreHidden_ || (this.ignoreHidden_ && marker.getVisible())) {
        this.addToClosestCluster_(marker);
      }
    }
  }

  if (iLast < this.markers_.length) {
    this.timerRefStatic = setTimeout(function () {
      cMarkerClusterer.createClusters_(iLast);
    }, 0);
  } else {
    delete this.timerRefStatic;

    /**
     * This event is fired when the <code>MarkerClusterer</code> stops
     *  clustering markers.
     * @name MarkerClusterer#clusteringend
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */
    google.maps.event.trigger(this, "clusteringend", this);
  }
};


/**
 * Extends an object's prototype by another's.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function (obj1, obj2) {
  return (function (object) {
    var property;
    for (property in object.prototype) {
      this.prototype[property] = object.prototype[property];
    }
    return this;
  }).apply(obj1, [obj2]);
};


/**
 * The default function for determining the label text and style
 * for a cluster icon.
 *
 * @param {Array.<google.maps.Marker>} markers The array of markers represented by the cluster.
 * @param {number} numStyles The number of marker styles available.
 * @return {ClusterIconInfo} The information resource for the cluster.
 * @constant
 * @ignore
 */
MarkerClusterer.CALCULATOR = function (markers, numStyles) {
  var index = 0;
  var title = "";
  var count = markers.length.toString();

  var dv = count;
  while (dv !== 0) {
    dv = parseInt(dv / 10, 10);
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index,
    title: title
  };
};


/**
 * The number of markers to process in one batch.
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE = 2000;


/**
 * The number of markers to process in one batch (IE only).
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE_IE = 500;


/**
 * The default root name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_PATH = "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m";


/**
 * The default extension name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_EXTENSION = "png";


/**
 * The default array of sizes for the marker cluster images.
 *
 * @type {Array.<number>}
 * @constant
 */
MarkerClusterer.IMAGE_SIZES = [53, 56, 66, 78, 90];

module.exports = MarkerClusterer


/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapMarker_css__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapMarker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MapMarker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ItemsHelper__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// todo - show some 'fetching' state?
var MapMarker=function(_Component){_inherits(MapMarker,_Component);function MapMarker(props){_classCallCheck(this,MapMarker);var _this=_possibleConstructorReturn(this,(MapMarker.__proto__||Object.getPrototypeOf(MapMarker)).call(this,props));_this.state={isOpen:false};_this.toggleOpen=_this.toggleOpen.bind(_this);return _this;}_createClass(MapMarker,[{key:'toggleOpen',value:function toggleOpen(){this.setState(function(prevState){return{isOpen:!prevState.isOpen};});}},{key:'render',value:function render(){var markerData=this.props.markerData;var look=__WEBPACK_IMPORTED_MODULE_3__utils_ItemsHelper__["a" /* getItemLook */](markerData[1]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["Marker"],{key:markerData[0],icon:__WEBPACK_IMPORTED_MODULE_4__constants__["g" /* PATH */].IMG+'ico/ico-map-marker.png',position:{lat:markerData[1].gpsn,lng:markerData[1].gpse},onClick:this.toggleOpen},this.state.isOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["InfoWindow"],{onCloseClick:this.toggleOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'mi-wrap',href:'#'+__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* ROUTING */].DETAIL+'/'+markerData[0]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mi-img-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mi-thumb',src:look.imgUrl,alt:markerData[1].title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mi-ico',src:__WEBPACK_IMPORTED_MODULE_4__constants__["g" /* PATH */].IMG+'ico/ico-'+look.ico+'.png',alt:'Otev\u0159\xEDt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mi-date'},markerData[1].timeline),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mi-title'},markerData[1].title))));}}]);return MapMarker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MapMarker);

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToTopBtn_css__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToTopBtn_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ToTopBtn_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ToTopBtn=function(_Component){_inherits(ToTopBtn,_Component);function ToTopBtn(props){_classCallCheck(this,ToTopBtn);var _this=_possibleConstructorReturn(this,(ToTopBtn.__proto__||Object.getPrototypeOf(ToTopBtn)).call(this,props));_this.handleScroll=_this.handleScroll.bind(_this);return _this;}// -------------------------------------------------------
// Component
// -------------------------------------------------------
_createClass(ToTopBtn,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('scroll',this.handleScroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.handleScroll);}// -------------------------------------------------------
// Scroll
// -------------------------------------------------------
},{key:'handleScroll',value:function handleScroll(){if(!this.props.detailActive){var showUp=document.documentElement.scrollTop>200;if(showUp!==this.props.showUpBtn){this.props.showUpBtnUpdate(showUp);}}}// -------------------------------------------------------
// Render
// -------------------------------------------------------
},{key:'render',value:function render(){var showUpBtn=this.props.showUpBtn;// up style
var upStyle={pointerEvents:showUpBtn,bottom:showUpBtn?15:0,opacity:showUpBtn?1:0,transition:'opacity 0.2s, bottom 0.2s'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'btn-up',style:upStyle,onClick:function onClick(){return window.scrollTo(0,0);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__constants__["g" /* PATH */].IMG+'ico/ico-up.png',alt:'Nahoru'}));}}]);return ToTopBtn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{detailActive:state.dataDetail.active,showUpBtn:state.resize.showUpBtn// todo - maybe can be just internal state
};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showUpBtnUpdate:function showUpBtnUpdate(showUpBtn){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions__["l" /* showUpBtnUpdate */])(showUpBtn));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ToTopBtn));

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

if(!Object.entries)Object.entries=function(obj){var ownProps=Object.keys(obj),i=ownProps.length,resArray=new Array(i);// preallocate the Array
while(i--){resArray[i]=[ownProps[i],obj[ownProps[i]]];}return resArray;};

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.acb949f9.js